/**
 * Generated by orval v7.8.0 🍺
 * Do not edit manually.
 * CRUD API
 * API for CRUD operations on PostgreSQL database tables
 * OpenAPI spec version: 1.0.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import { defaultInstance } from './httpClient';
export interface UserType {
  id?: number;
  name?: string;
  is_register?: boolean;
  is_new_rol_request?: boolean;
}

export interface User {
  id?: number;
  user_type_id?: number;
  references?: string;
  photo_url?: string;
  name?: string;
  last_name?: string;
  invitation_id?: number;
  tel?: string;
  email?: string;
  user_type?: string;
  cognitoid?: string;
  idnum?: string;
  idtype?: string;
  address?: string;
  nationality?: string;
  pictureidtype?: string;
  prefix?: string;
  role?: string;
  status?: string;
  pictureidback?: string;
  birthdate?: string;
  create_date?: string;
  nickname?: string;
  title?: string;
  job_title?: string;
  preferred_email_code?: string;
  address1_id?: number;
  address2_id?: number;
  address3_id?: number;
  code?: string;
  internal_email_address?: string;
  is_disabled?: number;
  setup_user?: number;
  user_stateid?: number;
  access_mode?: string;
  invite_status_code?: string;
  push_notification_id?: string;
  unique?: string;
}

export interface InvitationStatus {
  id?: number;
  name?: string;
}

export interface AccessCardStatus {
  id?: number;
  name?: number;
}

export interface Contact {
  id?: number;
  user_id?: number;
  first_name?: string;
  last_name?: string;
  suffix?: string;
  yomi_first_name?: string;
  yomi_last_name?: string;
  middle_name?: string;
  birth_date?: number;
  anniversary?: number;
  description?: number;
  gender_code?: number;
  has_children?: number;
  family_status_code?: number;
  email_address1?: number;
  email_address2?: number;
  number_of_children?: number;
  childrens_names?: number;
  mobile_phone?: number;
  telephone1?: number;
  telephone2?: number;
  telephone3?: number;
  usertype?: number;
  foreign?: string;
}

export interface DocumentType {
  id?: number;
  name?: string;
}

export interface Document {
  id?: number;
  user_id?: number;
  document_type_id?: number;
  references?: string;
  name?: string;
  number?: string;
  expiry_date?: string;
  is_main_id?: boolean;
  document_front_url?: string;
  document_back_url?: string;
  country_of_issue?: string;
}

export interface EstateType {
  id?: number;
  name?: string;
}

export interface EstateGroup {
  id?: number;
  name?: string;
}

export interface GateType {
  id?: number;
  name?: string;
}

export interface Category {
  id?: number;
  name?: string;
  description?: string;
  hidden?: number;
  parent_id?: number;
}

export interface Currency {
  id?: number;
  status_code?: string;
  currency_symbol?: string;
  currency_name?: string;
  iso_currency_code?: string;
  created_by?: number;
  currency_precision?: number;
  exchange_rate?: number;
}

export interface Country {
  id?: number;
  name?: string;
  iso_code?: string;
  abbr?: string;
  currency_id?: number;
  currencycreated_by?: number;
  unique?: string;
  foreign?: string;
}

export interface State {
  id?: number;
  country_id?: number;
  name?: string;
  abbr?: string;
  countrycurrency_id?: number;
  countrycurrencycreated_by?: number;
  foreign?: string;
}

export interface City {
  id?: number;
  state_id?: number;
  references?: string;
  name?: string;
  zip_code?: string;
  state_code?: string;
  unique?: string;
}

export interface Zone {
  id?: number;
  name?: string;
  city_id?: number;
  citystate_id?: number;
  foreign?: string;
}

export interface Address {
  id?: number;
  name?: string;
  address_number?: number;
  address_type?: string;
  line1?: string;
  line2?: string;
  line3?: string;
  postal_code?: string;
  city_id?: number;
  state_id?: number;
  country_id?: number;
  contact_id?: number;
  estate_id?: number;
  zone_id?: number;
  references?: string;
  estate_group_id?: number;
  status?: string;
  check?: string;
}

export interface Contract {
  id?: number;
  created_on_behalf_by?: number;
  modified_on_behalf_by?: number;
  user_id?: number;
  version_number?: number;
  email_address?: string;
  title?: string;
  active_on?: string;
  billing_user_id?: number;
  billing_end_on?: number;
  billing_frequency_code?: string;
  billing_start_on?: string;
  bill_to_address?: string;
  cancel_on?: string;
  contract_number?: string;
  contract_service_level_code?: string;
  duration?: number;
  expires_on?: string;
  transaction_currency_id?: number;
  exchange_rate?: number;
  net_price_base?: number;
  originating_contract?: number;
  services_address?: number;
  references?: string;
  status_code?: string;
  total_discount?: number;
  total_price?: number;
  total_price_base?: number;
  use_discount_as_percentage?: number;
  contact_id?: number;
  created_by?: number;
  modified_by?: number;
}

export interface Estate {
  id?: number;
  estate_type_id?: number;
  references?: string;
  estate_group_id?: number;
  zone_id?: number;
  name?: string;
  estate_access_typeid?: number;
  user_type_id?: number;
  status?: string;
  show_in_app?: boolean;
}

export interface UserState {
  id?: number;
  state_id?: number;
  references?: string;
  user_id?: number;
}

export interface Building {
  id?: number;
  name?: string;
  description?: string;
  estate_id?: number;
  references?: string;
}

export interface Floor {
  id?: number;
  number?: string;
  building_id?: number;
  references?: string;
}

export interface Section {
  id?: number;
  name?: string;
  floor_id?: number;
  references?: string;
}

export interface Gate {
  id?: number;
  gate_type_id?: number;
  references?: string;
  name?: string;
  code?: string;
  zone_id?: number;
}

export interface EntryLog {
  id?: number;
  access_card_id?: number;
  gate_id?: number;
  references?: string;
}

export interface AccessType {
  id?: number;
  name?: string;
  gate_id?: number;
  references?: string;
}

export interface AccessCard {
  id?: number;
  access_card_type_id?: number;
  references?: string;
  code?: string;
  start_date?: string;
  end_date?: string;
  user_access_cardusertype?: number;
  user_access_carduser_id?: number;
}

export interface UserAccessCard {
  id?: number;
  access_card_id?: number;
  references?: string;
  user_id?: number;
}

export interface AccessCardStatusEvent {
  id?: number;
  access_card_id?: number;
  references?: string;
  access_card_status_id?: number;
}

export interface EstateAccessType {
  id?: number;
  estate_id?: number;
  references?: string;
  access_card_id?: number;
}

export interface Schedule {
  id?: number;
  user_id?: number;
  bookable_resource_id?: number;
  effective_from?: string;
  effective_to?: string;
  end_period?: string;
  hours_per_day?: number;
  name?: string;
  start_period?: string;
  total_hours?: number;
  working_days?: string;
  status_code?: string;
  resourcebusiness_id?: number;
  resourcebusiness_unitaddress_id?: number;
}

export interface Resource {
  id?: number;
  name?: string;
  is_disabled?: number;
  business_id?: string;
}

export interface Customer {
  id?: number;
  created_by?: number;
  modified_by?: number;
  user_id?: number;
  account_number?: number;
  anniversary?: string;
  awards?: string;
  billingaddress?: string;
  birth_date?: string;
  contact_id?: number;
  references?: string;
  user_type_id?: number;
  department?: number;
  description?: string;
  facebook_profile?: string;
  family_status?: string;
  first_name?: string;
  gender?: string;
  has_children?: number;
  has_pets?: number;
  hobbies?: string;
  home_phone?: string;
  instagram_handle?: string;
  language?: string;
  last_name?: string;
  nationality?: string;
  notes?: string;
  number_of_children?: number;
  nick_name?: string;
  preferred_name?: string;
  satisfaction_score?: string;
  tags?: string;
  website_url?: string;
  twitter_handle?: string;
  work_address?: string;
  home_address?: string;
  state_code?: string;
  work_phone?: string;
}

export interface CustomerBusiness {
  id?: number;
  customer_id?: number;
  references?: string;
  business_id?: string;
}

export interface ServiceContract {
  id?: number;
  service_id?: number;
  contract_id?: number;
  name?: string;
}

export interface Product {
  id?: number;
  name?: string;
  description?: string;
  weight?: string;
  available_on?: string;
  updated_at?: string;
  product_class_id?: number;
  attribute?: string;
  business_id?: string;
}

export interface ProductVariant {
  id?: number;
  product_id?: number;
  references?: string;
  unique?: string;
}

export interface ProductType {
  id?: number;
  name?: string;
}

export interface Productclass {
  id?: number;
  name?: string;
  has_variant?: number;
  is_shipping_required?: number;
  product_type_id?: number;
  references?: string;
}

export interface ProductCategories {
  id?: number;
  product_id?: number;
  references?: string;
  category_id?: number;
}

export interface ProductAttribute {
  id?: number;
  name?: string;
}

export interface ProductclassProductAttribute {
  id?: number;
  productclass_id?: number;
  references?: string;
  product_attribute_id?: number;
}

export interface AttributeChoiceValue {
  id?: number;
  attribute_id?: number;
  references?: string;
  name?: string;
}

export interface ProductImage {
  id?: number;
  image?: string;
  ppoi?: string;
  product_id?: number;
}

export interface VariantImage {
  id?: number;
  image_id?: number;
  references?: string;
  variant_id?: number;
}

export interface StockLocation {
  id?: number;
  name?: string;
}

export interface Stock {
  id?: number;
  qty?: number;
  cost_price?: number;
  variant_id?: number;
  quantity_allocated?: number;
  location_id?: number;
  references?: string;
  product_variantproduct_id?: number;
  foreign?: string;
}

export interface InvitationType {
  id?: number;
  name?: string;
  duration_limit_days?: number;
  max_adults?: number;
  max_children?: number;
  max_guests_per_day?: number;
  external_gate_rules?: string;
  internal_gate_rules?: string;
}

export interface Invitation {
  id?: number;
  details?: string;
  code?: string;
  contact_id?: number;
  estate_id?: number;
  access_card_id?: number;
  created_on_behalf_by?: number;
  created_by?: number;
  modified_by?: number;
  type_id?: number;
  references?: string;
  invitation_from?: string;
  invitation_to?: string;
  host_user_id?: number;
  on?: string;
  status_id?: number;
  children_count?: number;
  create_date?: string;
  edit_date?: string;
  main_guest_user_id?: number;
  qr_id?: string;
  legacy_code?: string;
  legacy_id?: number;
  business_id?: string;
}

export interface InvitationStatusEvent {
  id?: number;
  invitation_id?: number;
  references?: string;
  invitation_status_id?: number;
}

export interface Guest {
  id?: number;
  invitation_id?: number;
  references?: string;
  guest_user_id?: number;
}

export interface Companion {
  id?: number;
  invitation_id?: number;
  references?: string;
  guest_user_id?: number;
  main_guest_user_id?: number;
}

export interface UserEstateStatus {
  id?: number;
  name?: string;
  description?: string;
}

export interface LegalDocuments {
  id?: number;
  document_type?: string;
  check?: string;
  language?: string;
  title?: string;
  body?: string;
}

export interface Author {
  id?: number;
  first_name?: string;
  last_name?: string;
  email?: string;
}

export type AdsActionLinkObject = { [key: string]: unknown };

export interface Ads {
  id?: number;
  title_es?: string;
  title_en?: string;
  short_description_es?: string;
  short_description_en?: string;
  art_img_url?: string;
  background_color?: string;
  creation_date?: string;
  publish_date?: string;
  expiration_date?: string;
  status?: string;
  check?: string;
  user_types_ids?: number;
  action_link_object?: AdsActionLinkObject;
  priority?: number;
}

export interface BusinessCategory {
  id?: number;
  name?: string;
  priority?: number;
}

export interface BusinessType {
  id?: number;
  name?: string;
  business_category_id?: number;
  references?: string;
}

export interface BusinessUnit {
  id?: number;
  type?: number;
  references?: string;
  estate_id?: number;
  name?: string;
  description?: string;
  web_site_url?: string;
  email_address?: string;
  parent_business_unit_id?: number;
  is_disabled?: number;
  disabled_reason?: string;
  exchange_rate?: number;
  picture?: string;
  address_id?: number;
  unique?: string;
}

export type BusinessAvailability = { [key: string]: unknown };

export interface Business {
  name?: string;
  estate_id?: number;
  references?: string;
  description?: string;
  phone_number?: string;
  logo_url?: string;
  background_img_url?: string;
  schedule_mon?: string;
  schedule_tue?: string;
  schedule_wed?: string;
  schedule_thu?: string;
  schedule_fri?: string;
  schedule_sat?: string;
  schedule_sun?: string;
  user_types_ids?: number;
  business_type_id?: number;
  img_gallery_url?: string;
  website_url?: string;
  instagram_url?: string;
  x_url?: string;
  facebook_url?: string;
  business_category_id?: number;
  description_es?: string;
  description_en?: string;
  email?: string;
  booking_id?: number;
  is_active?: boolean;
  id?: string;
  api_key?: string;
  availability?: BusinessAvailability;
}

export interface ArticleGroup {
  id?: number;
  name?: string;
}

export interface ArticleType {
  id?: number;
  name?: string;
  article_group_id?: number;
  references?: string;
}

export type ArticleActionLinkObject = { [key: string]: unknown };

export interface Article {
  id?: number;
  type?: string;
  title_es?: string;
  title_en?: string;
  content_es?: string;
  content_en?: string;
  author_id?: number;
  references?: string;
  art_img_url?: string;
  creation_date?: string;
  publish_date?: string;
  expiration_date?: string;
  status?: string;
  check?: string;
  user_types_ids?: number;
  article_type_id?: number;
  action_link_object?: ArticleActionLinkObject;
}

export type NotificationActionLinkObject = { [key: string]: unknown };

export interface Notification {
  id?: number;
  status?: string;
  check?: string;
  title?: string;
  type?: string;
  short_description?: string;
  recipients?: string;
  article_id?: number;
  references?: string;
  action_link_object?: NotificationActionLinkObject;
}

export interface UserNotificationActivity {
  id?: number;
  user_id?: number;
  notification_id?: number;
  references?: string;
  status?: string;
  check?: string;
  read_timestamp?: string;
  unique?: string;
}

export interface Sponsorship {
  id?: number;
  start_date?: string;
  end_date?: string;
  promo_urls?: string;
  short_description_es?: string;
  short_description_en?: string;
  title_es?: string;
  title_en?: string;
  priority?: number;
  business_id?: string;
}

export interface UserBusinessViewed {
  id?: number;
  user_id?: number;
  viewed_timestamp?: string;
  business_id?: string;
  references?: string;
  on?: string;
}

export interface BusinessAccessType {
  id?: number;
  name?: string;
  external_gate_rules?: string;
  internal_gate_rules?: string;
}

export interface BusinessAccessStatus {
  id?: number;
  name?: string;
}

export interface BusinessGuest {
  id?: number;
  guest_user_id?: number;
  main_guest_user_id?: number;
  business_access_id?: string;
}

export interface BusinessAccessChannel {
  id?: number;
  description?: string;
  name?: string;
}

export interface EventType {
  id?: number;
  name?: string;
}

export interface EventGroup {
  id?: number;
  name?: string;
}

export type AccessSettingsSettings = { [key: string]: unknown };

export interface AccessSettings {
  id?: number;
  settings?: AccessSettingsSettings;
}

export interface Event {
  id?: string;
  event_type_id?: number;
  references?: string;
  event_group_id?: number;
  name_es?: string;
  short_description_es?: string;
  address?: string;
  description_en?: string;
  start_date?: string;
  end_date?: string;
  capacity?: number;
  short_description_en?: string;
  name_en?: string;
  active?: boolean;
  logo_url?: string;
  background_img_url?: string;
  instagram_url?: string;
  website_url?: string;
  description_es?: string;
  phone_number?: string;
  access_settings_id?: number;
  pin_code?: string;
  business_id?: string;
  on?: string;
  banner_mobile_url?: string;
  status?: EventStatus;
  published_at?: string;
  published_by?: string;
}

export type EventStatus = typeof EventStatus[keyof typeof EventStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EventStatus = {
  draft: 'draft',
  published: 'published',
  archived: 'archived',
} as const;

export type BusinessAccessMainGuest = { [key: string]: unknown };

export type BusinessAccessBusinessGuests = { [key: string]: unknown };

export interface BusinessAccess {
  business_id?: string;
  created_by?: string;
  modified_by?: number;
  business_access_type_id?: number;
  references?: string;
  start_date?: string;
  end_date?: string;
  business_access_status_id?: number;
  create_date?: string;
  edit_date?: string;
  main_guest_user_id?: number;
  legacy_code?: string;
  legacy_id?: number;
  id_channel?: number;
  id?: string;
  event_id?: string;
  services_id?: number;
  main_guest?: BusinessAccessMainGuest;
  business_guests?: BusinessAccessBusinessGuests;
  children_count?: number;
}

export interface ServiceType {
  id?: number;
  name_en?: string;
  name_es?: string;
}

export interface ServiceGroup {
  id?: number;
  name_en?: string;
  name_es?: string;
}

export interface ServiceStatus {
  id?: number;
  status?: string;
}

export type ServiceOperatingHours = { [key: string]: unknown };

export type ServiceRestrictions = { [key: string]: unknown };

export type ServiceSettings = { [key: string]: unknown };

export type ServiceBookingOptions = { [key: string]: unknown };

export type ServiceDescriptionEn = { [key: string]: unknown };

export type ServiceDescriptionEs = { [key: string]: unknown };

export interface Service {
  status_id?: number;
  references?: string;
  service_type_id?: number;
  service_group_id?: number;
  name_en?: string;
  name_es?: string;
  start_date?: string;
  end_date?: string;
  availability?: number;
  logo_url?: string;
  background_img_url?: string;
  user_types_ids?: number;
  business_id?: string;
  operating_hours?: ServiceOperatingHours;
  restrictions?: ServiceRestrictions;
  max_capacity?: number;
  booking_window_start?: string;
  booking_window_end?: string;
  duration?: string;
  settings?: ServiceSettings;
  booking_options?: ServiceBookingOptions;
  description_en?: ServiceDescriptionEn;
  description_es?: ServiceDescriptionEs;
  id?: string;
  background_color?: string;
}

export interface UserContracts {
  id?: number;
  client_id?: string;
  debtor?: string;
  holder?: string;
  user_id?: number;
  on?: string;
  unique?: string;
}

export interface EventPhoneNumbers {
  id?: number;
  event_id?: string;
  references?: string;
  phone_number?: string;
  created_at?: string;
}

export interface EventTickets {
  id?: number;
  documentid?: string;
  name?: string;
  lastname?: string;
  address?: string;
  phonenumber?: string;
  qtyadults?: number;
  check?: string;
  qtychilds?: number;
  eventid?: string;
  references?: string;
  on?: string;
  created_at?: string;
  updated_at?: string;
  roleid?: number;
  stateid?: number;
  image?: string;
  delivered?: boolean;
}

export interface OpenCrudEndpoint {
  id?: number;
  name?: string;
  get?: boolean;
  put?: boolean;
  post?: boolean;
  delete?: boolean;
}

export interface CapCanaAccessCard {
  id?: number;
  first_name?: string;
  last_name?: string;
  id_type?: string;
  property_name?: string;
  property_number?: string;
  card_number?: string;
  functionality?: string;
  created_at?: string;
  updated_at?: string;
  is_valid?: boolean;
  status?: string;
}

export interface AdminUsers {
  id?: number;
  email?: string;
  role?: string;
  password?: string;
}

export interface Transaction {
  id?: string;
  cybersource_response?: string;
  email?: string;
  request?: string;
  created_at?: string;
  applied_in_cybersource?: boolean;
  applied_in_sap?: boolean;
  void_applied?: boolean;
  sap_response?: string;
  void_response?: string;
  status?: string;
  updated_at?: string;
  cybersource_request?: string;
  sap_request?: string;
  void_request?: string;
}

export interface BusinessMapping {
  id?: number;
  legacy_business_id?: number;
  business_id?: string;
  business_name?: string;
}

export type TransactionsMetadata = { [key: string]: unknown };

export interface Transactions {
  user_id?: number;
  gateway?: string;
  transaction_id?: string;
  status?: string;
  check?: string;
  amount?: number;
  currency?: string;
  payment_method?: string;
  metadata?: TransactionsMetadata;
  created_at?: string;
  updated_at?: string;
  id?: string;
  unique?: string;
}

export interface BookingStatus {
  id?: number;
  name?: string;
  description?: string;
}

export type BookingBookingOptions = { [key: string]: unknown };

export interface Booking {
  id?: string;
  business_id?: string;
  references?: string;
  main_user_id?: number;
  reservation_start?: string;
  status_id?: number;
  special_requests?: string;
  created_at?: string;
  updated_at?: string;
  confirmation_code?: string;
  notes?: string;
  service_id?: string;
  channel?: string;
  creation_user_id?: string;
  payment?: boolean;
  booking_options?: BookingBookingOptions;
  reservation_end?: string;
}

export type GetUserTypeParams = {
/**
 * Page number for pagination
 */
page?: number;
/**
 * Number of records per page
 */
limit?: number;
/**
 * Tables to join with format 'table1,field1,table2,field2'
 */
expand?: string;
/**
 * Field to order results by
 */
order_by?: string;
/**
 * Order direction (ASC or DESC)
 */
order_direction?: GetUserTypeOrderDirection;
};

export type GetUserTypeOrderDirection = typeof GetUserTypeOrderDirection[keyof typeof GetUserTypeOrderDirection];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetUserTypeOrderDirection = {
  ASC: 'ASC',
  DESC: 'DESC',
} as const;

export type GetUserType200 = {
  data?: UserType[];
  total_pages?: number;
  page?: number;
  total_elements?: number;
};

export type PostUserType200 = {
  data?: UserType[];
  message?: string;
};

export type GetUserTypeId200 = {
  data?: UserType;
};

export type PutUserTypeId200 = {
  data?: UserType[];
  message?: string;
};

export type PatchUserTypeId200 = {
  data?: UserType[];
  message?: string;
};

export type DeleteUserTypeId200 = {
  message?: string;
};

export type GetUserParams = {
/**
 * Page number for pagination
 */
page?: number;
/**
 * Number of records per page
 */
limit?: number;
/**
 * Tables to join with format 'table1,field1,table2,field2'
 */
expand?: string;
/**
 * Field to order results by
 */
order_by?: string;
/**
 * Order direction (ASC or DESC)
 */
order_direction?: GetUserOrderDirection;
};

export type GetUserOrderDirection = typeof GetUserOrderDirection[keyof typeof GetUserOrderDirection];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetUserOrderDirection = {
  ASC: 'ASC',
  DESC: 'DESC',
} as const;

export type GetUser200 = {
  data?: User[];
  total_pages?: number;
  page?: number;
  total_elements?: number;
};

export type PostUser200 = {
  data?: User[];
  message?: string;
};

export type GetUserId200 = {
  data?: User;
};

export type PutUserId200 = {
  data?: User[];
  message?: string;
};

export type PatchUserId200 = {
  data?: User[];
  message?: string;
};

export type DeleteUserId200 = {
  message?: string;
};

export type GetInvitationStatusParams = {
/**
 * Page number for pagination
 */
page?: number;
/**
 * Number of records per page
 */
limit?: number;
/**
 * Tables to join with format 'table1,field1,table2,field2'
 */
expand?: string;
/**
 * Field to order results by
 */
order_by?: string;
/**
 * Order direction (ASC or DESC)
 */
order_direction?: GetInvitationStatusOrderDirection;
};

export type GetInvitationStatusOrderDirection = typeof GetInvitationStatusOrderDirection[keyof typeof GetInvitationStatusOrderDirection];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetInvitationStatusOrderDirection = {
  ASC: 'ASC',
  DESC: 'DESC',
} as const;

export type GetInvitationStatus200 = {
  data?: InvitationStatus[];
  total_pages?: number;
  page?: number;
  total_elements?: number;
};

export type PostInvitationStatus200 = {
  data?: InvitationStatus[];
  message?: string;
};

export type GetInvitationStatusId200 = {
  data?: InvitationStatus;
};

export type PutInvitationStatusId200 = {
  data?: InvitationStatus[];
  message?: string;
};

export type PatchInvitationStatusId200 = {
  data?: InvitationStatus[];
  message?: string;
};

export type DeleteInvitationStatusId200 = {
  message?: string;
};

export type GetAccessCardStatusParams = {
/**
 * Page number for pagination
 */
page?: number;
/**
 * Number of records per page
 */
limit?: number;
/**
 * Tables to join with format 'table1,field1,table2,field2'
 */
expand?: string;
/**
 * Field to order results by
 */
order_by?: string;
/**
 * Order direction (ASC or DESC)
 */
order_direction?: GetAccessCardStatusOrderDirection;
};

export type GetAccessCardStatusOrderDirection = typeof GetAccessCardStatusOrderDirection[keyof typeof GetAccessCardStatusOrderDirection];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetAccessCardStatusOrderDirection = {
  ASC: 'ASC',
  DESC: 'DESC',
} as const;

export type GetAccessCardStatus200 = {
  data?: AccessCardStatus[];
  total_pages?: number;
  page?: number;
  total_elements?: number;
};

export type PostAccessCardStatus200 = {
  data?: AccessCardStatus[];
  message?: string;
};

export type GetAccessCardStatusId200 = {
  data?: AccessCardStatus;
};

export type PutAccessCardStatusId200 = {
  data?: AccessCardStatus[];
  message?: string;
};

export type PatchAccessCardStatusId200 = {
  data?: AccessCardStatus[];
  message?: string;
};

export type DeleteAccessCardStatusId200 = {
  message?: string;
};

export type GetContactParams = {
/**
 * Page number for pagination
 */
page?: number;
/**
 * Number of records per page
 */
limit?: number;
/**
 * Tables to join with format 'table1,field1,table2,field2'
 */
expand?: string;
/**
 * Field to order results by
 */
order_by?: string;
/**
 * Order direction (ASC or DESC)
 */
order_direction?: GetContactOrderDirection;
};

export type GetContactOrderDirection = typeof GetContactOrderDirection[keyof typeof GetContactOrderDirection];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetContactOrderDirection = {
  ASC: 'ASC',
  DESC: 'DESC',
} as const;

export type GetContact200 = {
  data?: Contact[];
  total_pages?: number;
  page?: number;
  total_elements?: number;
};

export type PostContact200 = {
  data?: Contact[];
  message?: string;
};

export type GetContactId200 = {
  data?: Contact;
};

export type PutContactId200 = {
  data?: Contact[];
  message?: string;
};

export type PatchContactId200 = {
  data?: Contact[];
  message?: string;
};

export type DeleteContactId200 = {
  message?: string;
};

export type GetDocumentTypeParams = {
/**
 * Page number for pagination
 */
page?: number;
/**
 * Number of records per page
 */
limit?: number;
/**
 * Tables to join with format 'table1,field1,table2,field2'
 */
expand?: string;
/**
 * Field to order results by
 */
order_by?: string;
/**
 * Order direction (ASC or DESC)
 */
order_direction?: GetDocumentTypeOrderDirection;
};

export type GetDocumentTypeOrderDirection = typeof GetDocumentTypeOrderDirection[keyof typeof GetDocumentTypeOrderDirection];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetDocumentTypeOrderDirection = {
  ASC: 'ASC',
  DESC: 'DESC',
} as const;

export type GetDocumentType200 = {
  data?: DocumentType[];
  total_pages?: number;
  page?: number;
  total_elements?: number;
};

export type PostDocumentType200 = {
  data?: DocumentType[];
  message?: string;
};

export type GetDocumentTypeId200 = {
  data?: DocumentType;
};

export type PutDocumentTypeId200 = {
  data?: DocumentType[];
  message?: string;
};

export type PatchDocumentTypeId200 = {
  data?: DocumentType[];
  message?: string;
};

export type DeleteDocumentTypeId200 = {
  message?: string;
};

export type GetDocumentParams = {
/**
 * Page number for pagination
 */
page?: number;
/**
 * Number of records per page
 */
limit?: number;
/**
 * Tables to join with format 'table1,field1,table2,field2'
 */
expand?: string;
/**
 * Field to order results by
 */
order_by?: string;
/**
 * Order direction (ASC or DESC)
 */
order_direction?: GetDocumentOrderDirection;
};

export type GetDocumentOrderDirection = typeof GetDocumentOrderDirection[keyof typeof GetDocumentOrderDirection];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetDocumentOrderDirection = {
  ASC: 'ASC',
  DESC: 'DESC',
} as const;

export type GetDocument200 = {
  data?: Document[];
  total_pages?: number;
  page?: number;
  total_elements?: number;
};

export type PostDocument200 = {
  data?: Document[];
  message?: string;
};

export type GetDocumentId200 = {
  data?: Document;
};

export type PutDocumentId200 = {
  data?: Document[];
  message?: string;
};

export type PatchDocumentId200 = {
  data?: Document[];
  message?: string;
};

export type DeleteDocumentId200 = {
  message?: string;
};

export type GetEstateTypeParams = {
/**
 * Page number for pagination
 */
page?: number;
/**
 * Number of records per page
 */
limit?: number;
/**
 * Tables to join with format 'table1,field1,table2,field2'
 */
expand?: string;
/**
 * Field to order results by
 */
order_by?: string;
/**
 * Order direction (ASC or DESC)
 */
order_direction?: GetEstateTypeOrderDirection;
};

export type GetEstateTypeOrderDirection = typeof GetEstateTypeOrderDirection[keyof typeof GetEstateTypeOrderDirection];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetEstateTypeOrderDirection = {
  ASC: 'ASC',
  DESC: 'DESC',
} as const;

export type GetEstateType200 = {
  data?: EstateType[];
  total_pages?: number;
  page?: number;
  total_elements?: number;
};

export type PostEstateType200 = {
  data?: EstateType[];
  message?: string;
};

export type GetEstateTypeId200 = {
  data?: EstateType;
};

export type PutEstateTypeId200 = {
  data?: EstateType[];
  message?: string;
};

export type PatchEstateTypeId200 = {
  data?: EstateType[];
  message?: string;
};

export type DeleteEstateTypeId200 = {
  message?: string;
};

export type GetEstateGroupParams = {
/**
 * Page number for pagination
 */
page?: number;
/**
 * Number of records per page
 */
limit?: number;
/**
 * Tables to join with format 'table1,field1,table2,field2'
 */
expand?: string;
/**
 * Field to order results by
 */
order_by?: string;
/**
 * Order direction (ASC or DESC)
 */
order_direction?: GetEstateGroupOrderDirection;
};

export type GetEstateGroupOrderDirection = typeof GetEstateGroupOrderDirection[keyof typeof GetEstateGroupOrderDirection];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetEstateGroupOrderDirection = {
  ASC: 'ASC',
  DESC: 'DESC',
} as const;

export type GetEstateGroup200 = {
  data?: EstateGroup[];
  total_pages?: number;
  page?: number;
  total_elements?: number;
};

export type PostEstateGroup200 = {
  data?: EstateGroup[];
  message?: string;
};

export type GetEstateGroupId200 = {
  data?: EstateGroup;
};

export type PutEstateGroupId200 = {
  data?: EstateGroup[];
  message?: string;
};

export type PatchEstateGroupId200 = {
  data?: EstateGroup[];
  message?: string;
};

export type DeleteEstateGroupId200 = {
  message?: string;
};

export type GetGateTypeParams = {
/**
 * Page number for pagination
 */
page?: number;
/**
 * Number of records per page
 */
limit?: number;
/**
 * Tables to join with format 'table1,field1,table2,field2'
 */
expand?: string;
/**
 * Field to order results by
 */
order_by?: string;
/**
 * Order direction (ASC or DESC)
 */
order_direction?: GetGateTypeOrderDirection;
};

export type GetGateTypeOrderDirection = typeof GetGateTypeOrderDirection[keyof typeof GetGateTypeOrderDirection];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetGateTypeOrderDirection = {
  ASC: 'ASC',
  DESC: 'DESC',
} as const;

export type GetGateType200 = {
  data?: GateType[];
  total_pages?: number;
  page?: number;
  total_elements?: number;
};

export type PostGateType200 = {
  data?: GateType[];
  message?: string;
};

export type GetGateTypeId200 = {
  data?: GateType;
};

export type PutGateTypeId200 = {
  data?: GateType[];
  message?: string;
};

export type PatchGateTypeId200 = {
  data?: GateType[];
  message?: string;
};

export type DeleteGateTypeId200 = {
  message?: string;
};

export type GetCategoryParams = {
/**
 * Page number for pagination
 */
page?: number;
/**
 * Number of records per page
 */
limit?: number;
/**
 * Tables to join with format 'table1,field1,table2,field2'
 */
expand?: string;
/**
 * Field to order results by
 */
order_by?: string;
/**
 * Order direction (ASC or DESC)
 */
order_direction?: GetCategoryOrderDirection;
};

export type GetCategoryOrderDirection = typeof GetCategoryOrderDirection[keyof typeof GetCategoryOrderDirection];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetCategoryOrderDirection = {
  ASC: 'ASC',
  DESC: 'DESC',
} as const;

export type GetCategory200 = {
  data?: Category[];
  total_pages?: number;
  page?: number;
  total_elements?: number;
};

export type PostCategory200 = {
  data?: Category[];
  message?: string;
};

export type GetCategoryId200 = {
  data?: Category;
};

export type PutCategoryId200 = {
  data?: Category[];
  message?: string;
};

export type PatchCategoryId200 = {
  data?: Category[];
  message?: string;
};

export type DeleteCategoryId200 = {
  message?: string;
};

export type GetCurrencyParams = {
/**
 * Page number for pagination
 */
page?: number;
/**
 * Number of records per page
 */
limit?: number;
/**
 * Tables to join with format 'table1,field1,table2,field2'
 */
expand?: string;
/**
 * Field to order results by
 */
order_by?: string;
/**
 * Order direction (ASC or DESC)
 */
order_direction?: GetCurrencyOrderDirection;
};

export type GetCurrencyOrderDirection = typeof GetCurrencyOrderDirection[keyof typeof GetCurrencyOrderDirection];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetCurrencyOrderDirection = {
  ASC: 'ASC',
  DESC: 'DESC',
} as const;

export type GetCurrency200 = {
  data?: Currency[];
  total_pages?: number;
  page?: number;
  total_elements?: number;
};

export type PostCurrency200 = {
  data?: Currency[];
  message?: string;
};

export type GetCurrencyId200 = {
  data?: Currency;
};

export type PutCurrencyId200 = {
  data?: Currency[];
  message?: string;
};

export type PatchCurrencyId200 = {
  data?: Currency[];
  message?: string;
};

export type DeleteCurrencyId200 = {
  message?: string;
};

export type GetCountryParams = {
/**
 * Page number for pagination
 */
page?: number;
/**
 * Number of records per page
 */
limit?: number;
/**
 * Tables to join with format 'table1,field1,table2,field2'
 */
expand?: string;
/**
 * Field to order results by
 */
order_by?: string;
/**
 * Order direction (ASC or DESC)
 */
order_direction?: GetCountryOrderDirection;
};

export type GetCountryOrderDirection = typeof GetCountryOrderDirection[keyof typeof GetCountryOrderDirection];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetCountryOrderDirection = {
  ASC: 'ASC',
  DESC: 'DESC',
} as const;

export type GetCountry200 = {
  data?: Country[];
  total_pages?: number;
  page?: number;
  total_elements?: number;
};

export type PostCountry200 = {
  data?: Country[];
  message?: string;
};

export type GetCountryId200 = {
  data?: Country;
};

export type PutCountryId200 = {
  data?: Country[];
  message?: string;
};

export type PatchCountryId200 = {
  data?: Country[];
  message?: string;
};

export type DeleteCountryId200 = {
  message?: string;
};

export type GetStateParams = {
/**
 * Page number for pagination
 */
page?: number;
/**
 * Number of records per page
 */
limit?: number;
/**
 * Tables to join with format 'table1,field1,table2,field2'
 */
expand?: string;
/**
 * Field to order results by
 */
order_by?: string;
/**
 * Order direction (ASC or DESC)
 */
order_direction?: GetStateOrderDirection;
};

export type GetStateOrderDirection = typeof GetStateOrderDirection[keyof typeof GetStateOrderDirection];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetStateOrderDirection = {
  ASC: 'ASC',
  DESC: 'DESC',
} as const;

export type GetState200 = {
  data?: State[];
  total_pages?: number;
  page?: number;
  total_elements?: number;
};

export type PostState200 = {
  data?: State[];
  message?: string;
};

export type GetStateId200 = {
  data?: State;
};

export type PutStateId200 = {
  data?: State[];
  message?: string;
};

export type PatchStateId200 = {
  data?: State[];
  message?: string;
};

export type DeleteStateId200 = {
  message?: string;
};

export type GetCityParams = {
/**
 * Page number for pagination
 */
page?: number;
/**
 * Number of records per page
 */
limit?: number;
/**
 * Tables to join with format 'table1,field1,table2,field2'
 */
expand?: string;
/**
 * Field to order results by
 */
order_by?: string;
/**
 * Order direction (ASC or DESC)
 */
order_direction?: GetCityOrderDirection;
};

export type GetCityOrderDirection = typeof GetCityOrderDirection[keyof typeof GetCityOrderDirection];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetCityOrderDirection = {
  ASC: 'ASC',
  DESC: 'DESC',
} as const;

export type GetCity200 = {
  data?: City[];
  total_pages?: number;
  page?: number;
  total_elements?: number;
};

export type PostCity200 = {
  data?: City[];
  message?: string;
};

export type GetCityId200 = {
  data?: City;
};

export type PutCityId200 = {
  data?: City[];
  message?: string;
};

export type PatchCityId200 = {
  data?: City[];
  message?: string;
};

export type DeleteCityId200 = {
  message?: string;
};

export type GetZoneParams = {
/**
 * Page number for pagination
 */
page?: number;
/**
 * Number of records per page
 */
limit?: number;
/**
 * Tables to join with format 'table1,field1,table2,field2'
 */
expand?: string;
/**
 * Field to order results by
 */
order_by?: string;
/**
 * Order direction (ASC or DESC)
 */
order_direction?: GetZoneOrderDirection;
};

export type GetZoneOrderDirection = typeof GetZoneOrderDirection[keyof typeof GetZoneOrderDirection];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetZoneOrderDirection = {
  ASC: 'ASC',
  DESC: 'DESC',
} as const;

export type GetZone200 = {
  data?: Zone[];
  total_pages?: number;
  page?: number;
  total_elements?: number;
};

export type PostZone200 = {
  data?: Zone[];
  message?: string;
};

export type GetZoneId200 = {
  data?: Zone;
};

export type PutZoneId200 = {
  data?: Zone[];
  message?: string;
};

export type PatchZoneId200 = {
  data?: Zone[];
  message?: string;
};

export type DeleteZoneId200 = {
  message?: string;
};

export type GetAddressParams = {
/**
 * Page number for pagination
 */
page?: number;
/**
 * Number of records per page
 */
limit?: number;
/**
 * Tables to join with format 'table1,field1,table2,field2'
 */
expand?: string;
/**
 * Field to order results by
 */
order_by?: string;
/**
 * Order direction (ASC or DESC)
 */
order_direction?: GetAddressOrderDirection;
};

export type GetAddressOrderDirection = typeof GetAddressOrderDirection[keyof typeof GetAddressOrderDirection];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetAddressOrderDirection = {
  ASC: 'ASC',
  DESC: 'DESC',
} as const;

export type GetAddress200 = {
  data?: Address[];
  total_pages?: number;
  page?: number;
  total_elements?: number;
};

export type PostAddress200 = {
  data?: Address[];
  message?: string;
};

export type GetAddressId200 = {
  data?: Address;
};

export type PutAddressId200 = {
  data?: Address[];
  message?: string;
};

export type PatchAddressId200 = {
  data?: Address[];
  message?: string;
};

export type DeleteAddressId200 = {
  message?: string;
};

export type GetContractParams = {
/**
 * Page number for pagination
 */
page?: number;
/**
 * Number of records per page
 */
limit?: number;
/**
 * Tables to join with format 'table1,field1,table2,field2'
 */
expand?: string;
/**
 * Field to order results by
 */
order_by?: string;
/**
 * Order direction (ASC or DESC)
 */
order_direction?: GetContractOrderDirection;
};

export type GetContractOrderDirection = typeof GetContractOrderDirection[keyof typeof GetContractOrderDirection];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetContractOrderDirection = {
  ASC: 'ASC',
  DESC: 'DESC',
} as const;

export type GetContract200 = {
  data?: Contract[];
  total_pages?: number;
  page?: number;
  total_elements?: number;
};

export type PostContract200 = {
  data?: Contract[];
  message?: string;
};

export type GetContractId200 = {
  data?: Contract;
};

export type PutContractId200 = {
  data?: Contract[];
  message?: string;
};

export type PatchContractId200 = {
  data?: Contract[];
  message?: string;
};

export type DeleteContractId200 = {
  message?: string;
};

export type GetEstateParams = {
/**
 * Page number for pagination
 */
page?: number;
/**
 * Number of records per page
 */
limit?: number;
/**
 * Tables to join with format 'table1,field1,table2,field2'
 */
expand?: string;
/**
 * Field to order results by
 */
order_by?: string;
/**
 * Order direction (ASC or DESC)
 */
order_direction?: GetEstateOrderDirection;
/**
 * Filter estates by estate group ID
 */
estate_group_id?: number;
};

export type GetEstateOrderDirection = typeof GetEstateOrderDirection[keyof typeof GetEstateOrderDirection];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetEstateOrderDirection = {
  ASC: 'ASC',
  DESC: 'DESC',
} as const;

export type GetEstate200 = {
  data?: Estate[];
  total_pages?: number;
  page?: number;
  total_elements?: number;
};

export type PostEstate200 = {
  data?: Estate[];
  message?: string;
};

export type GetEstateId200 = {
  data?: Estate;
};

export type PutEstateId200 = {
  data?: Estate[];
  message?: string;
};

export type PatchEstateId200 = {
  data?: Estate[];
  message?: string;
};

export type DeleteEstateId200 = {
  message?: string;
};

export type GetUserStateParams = {
/**
 * Page number for pagination
 */
page?: number;
/**
 * Number of records per page
 */
limit?: number;
/**
 * Tables to join with format 'table1,field1,table2,field2'
 */
expand?: string;
/**
 * Field to order results by
 */
order_by?: string;
/**
 * Order direction (ASC or DESC)
 */
order_direction?: GetUserStateOrderDirection;
};

export type GetUserStateOrderDirection = typeof GetUserStateOrderDirection[keyof typeof GetUserStateOrderDirection];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetUserStateOrderDirection = {
  ASC: 'ASC',
  DESC: 'DESC',
} as const;

export type GetUserState200 = {
  data?: UserState[];
  total_pages?: number;
  page?: number;
  total_elements?: number;
};

export type PostUserState200 = {
  data?: UserState[];
  message?: string;
};

export type GetUserStateId200 = {
  data?: UserState;
};

export type PutUserStateId200 = {
  data?: UserState[];
  message?: string;
};

export type PatchUserStateId200 = {
  data?: UserState[];
  message?: string;
};

export type DeleteUserStateId200 = {
  message?: string;
};

export type GetBuildingParams = {
/**
 * Page number for pagination
 */
page?: number;
/**
 * Number of records per page
 */
limit?: number;
/**
 * Tables to join with format 'table1,field1,table2,field2'
 */
expand?: string;
/**
 * Field to order results by
 */
order_by?: string;
/**
 * Order direction (ASC or DESC)
 */
order_direction?: GetBuildingOrderDirection;
};

export type GetBuildingOrderDirection = typeof GetBuildingOrderDirection[keyof typeof GetBuildingOrderDirection];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetBuildingOrderDirection = {
  ASC: 'ASC',
  DESC: 'DESC',
} as const;

export type GetBuilding200 = {
  data?: Building[];
  total_pages?: number;
  page?: number;
  total_elements?: number;
};

export type PostBuilding200 = {
  data?: Building[];
  message?: string;
};

export type GetBuildingId200 = {
  data?: Building;
};

export type PutBuildingId200 = {
  data?: Building[];
  message?: string;
};

export type PatchBuildingId200 = {
  data?: Building[];
  message?: string;
};

export type DeleteBuildingId200 = {
  message?: string;
};

export type GetFloorParams = {
/**
 * Page number for pagination
 */
page?: number;
/**
 * Number of records per page
 */
limit?: number;
/**
 * Tables to join with format 'table1,field1,table2,field2'
 */
expand?: string;
/**
 * Field to order results by
 */
order_by?: string;
/**
 * Order direction (ASC or DESC)
 */
order_direction?: GetFloorOrderDirection;
};

export type GetFloorOrderDirection = typeof GetFloorOrderDirection[keyof typeof GetFloorOrderDirection];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetFloorOrderDirection = {
  ASC: 'ASC',
  DESC: 'DESC',
} as const;

export type GetFloor200 = {
  data?: Floor[];
  total_pages?: number;
  page?: number;
  total_elements?: number;
};

export type PostFloor200 = {
  data?: Floor[];
  message?: string;
};

export type GetFloorId200 = {
  data?: Floor;
};

export type PutFloorId200 = {
  data?: Floor[];
  message?: string;
};

export type PatchFloorId200 = {
  data?: Floor[];
  message?: string;
};

export type DeleteFloorId200 = {
  message?: string;
};

export type GetSectionParams = {
/**
 * Page number for pagination
 */
page?: number;
/**
 * Number of records per page
 */
limit?: number;
/**
 * Tables to join with format 'table1,field1,table2,field2'
 */
expand?: string;
/**
 * Field to order results by
 */
order_by?: string;
/**
 * Order direction (ASC or DESC)
 */
order_direction?: GetSectionOrderDirection;
};

export type GetSectionOrderDirection = typeof GetSectionOrderDirection[keyof typeof GetSectionOrderDirection];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetSectionOrderDirection = {
  ASC: 'ASC',
  DESC: 'DESC',
} as const;

export type GetSection200 = {
  data?: Section[];
  total_pages?: number;
  page?: number;
  total_elements?: number;
};

export type PostSection200 = {
  data?: Section[];
  message?: string;
};

export type GetSectionId200 = {
  data?: Section;
};

export type PutSectionId200 = {
  data?: Section[];
  message?: string;
};

export type PatchSectionId200 = {
  data?: Section[];
  message?: string;
};

export type DeleteSectionId200 = {
  message?: string;
};

export type GetGateParams = {
/**
 * Page number for pagination
 */
page?: number;
/**
 * Number of records per page
 */
limit?: number;
/**
 * Tables to join with format 'table1,field1,table2,field2'
 */
expand?: string;
/**
 * Field to order results by
 */
order_by?: string;
/**
 * Order direction (ASC or DESC)
 */
order_direction?: GetGateOrderDirection;
};

export type GetGateOrderDirection = typeof GetGateOrderDirection[keyof typeof GetGateOrderDirection];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetGateOrderDirection = {
  ASC: 'ASC',
  DESC: 'DESC',
} as const;

export type GetGate200 = {
  data?: Gate[];
  total_pages?: number;
  page?: number;
  total_elements?: number;
};

export type PostGate200 = {
  data?: Gate[];
  message?: string;
};

export type GetGateId200 = {
  data?: Gate;
};

export type PutGateId200 = {
  data?: Gate[];
  message?: string;
};

export type PatchGateId200 = {
  data?: Gate[];
  message?: string;
};

export type DeleteGateId200 = {
  message?: string;
};

export type GetEntryLogParams = {
/**
 * Page number for pagination
 */
page?: number;
/**
 * Number of records per page
 */
limit?: number;
/**
 * Tables to join with format 'table1,field1,table2,field2'
 */
expand?: string;
/**
 * Field to order results by
 */
order_by?: string;
/**
 * Order direction (ASC or DESC)
 */
order_direction?: GetEntryLogOrderDirection;
};

export type GetEntryLogOrderDirection = typeof GetEntryLogOrderDirection[keyof typeof GetEntryLogOrderDirection];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetEntryLogOrderDirection = {
  ASC: 'ASC',
  DESC: 'DESC',
} as const;

export type GetEntryLog200 = {
  data?: EntryLog[];
  total_pages?: number;
  page?: number;
  total_elements?: number;
};

export type PostEntryLog200 = {
  data?: EntryLog[];
  message?: string;
};

export type GetEntryLogId200 = {
  data?: EntryLog;
};

export type PutEntryLogId200 = {
  data?: EntryLog[];
  message?: string;
};

export type PatchEntryLogId200 = {
  data?: EntryLog[];
  message?: string;
};

export type DeleteEntryLogId200 = {
  message?: string;
};

export type GetAccessTypeParams = {
/**
 * Page number for pagination
 */
page?: number;
/**
 * Number of records per page
 */
limit?: number;
/**
 * Tables to join with format 'table1,field1,table2,field2'
 */
expand?: string;
/**
 * Field to order results by
 */
order_by?: string;
/**
 * Order direction (ASC or DESC)
 */
order_direction?: GetAccessTypeOrderDirection;
};

export type GetAccessTypeOrderDirection = typeof GetAccessTypeOrderDirection[keyof typeof GetAccessTypeOrderDirection];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetAccessTypeOrderDirection = {
  ASC: 'ASC',
  DESC: 'DESC',
} as const;

export type GetAccessType200 = {
  data?: AccessType[];
  total_pages?: number;
  page?: number;
  total_elements?: number;
};

export type PostAccessType200 = {
  data?: AccessType[];
  message?: string;
};

export type GetAccessTypeId200 = {
  data?: AccessType;
};

export type PutAccessTypeId200 = {
  data?: AccessType[];
  message?: string;
};

export type PatchAccessTypeId200 = {
  data?: AccessType[];
  message?: string;
};

export type DeleteAccessTypeId200 = {
  message?: string;
};

export type GetAccessCardParams = {
/**
 * Page number for pagination
 */
page?: number;
/**
 * Number of records per page
 */
limit?: number;
/**
 * Tables to join with format 'table1,field1,table2,field2'
 */
expand?: string;
/**
 * Field to order results by
 */
order_by?: string;
/**
 * Order direction (ASC or DESC)
 */
order_direction?: GetAccessCardOrderDirection;
};

export type GetAccessCardOrderDirection = typeof GetAccessCardOrderDirection[keyof typeof GetAccessCardOrderDirection];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetAccessCardOrderDirection = {
  ASC: 'ASC',
  DESC: 'DESC',
} as const;

export type GetAccessCard200 = {
  data?: AccessCard[];
  total_pages?: number;
  page?: number;
  total_elements?: number;
};

export type PostAccessCard200 = {
  data?: AccessCard[];
  message?: string;
};

export type GetAccessCardId200 = {
  data?: AccessCard;
};

export type PutAccessCardId200 = {
  data?: AccessCard[];
  message?: string;
};

export type PatchAccessCardId200 = {
  data?: AccessCard[];
  message?: string;
};

export type DeleteAccessCardId200 = {
  message?: string;
};

export type GetUserAccessCardParams = {
/**
 * Page number for pagination
 */
page?: number;
/**
 * Number of records per page
 */
limit?: number;
/**
 * Tables to join with format 'table1,field1,table2,field2'
 */
expand?: string;
/**
 * Field to order results by
 */
order_by?: string;
/**
 * Order direction (ASC or DESC)
 */
order_direction?: GetUserAccessCardOrderDirection;
};

export type GetUserAccessCardOrderDirection = typeof GetUserAccessCardOrderDirection[keyof typeof GetUserAccessCardOrderDirection];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetUserAccessCardOrderDirection = {
  ASC: 'ASC',
  DESC: 'DESC',
} as const;

export type GetUserAccessCard200 = {
  data?: UserAccessCard[];
  total_pages?: number;
  page?: number;
  total_elements?: number;
};

export type PostUserAccessCard200 = {
  data?: UserAccessCard[];
  message?: string;
};

export type GetUserAccessCardId200 = {
  data?: UserAccessCard;
};

export type PutUserAccessCardId200 = {
  data?: UserAccessCard[];
  message?: string;
};

export type PatchUserAccessCardId200 = {
  data?: UserAccessCard[];
  message?: string;
};

export type DeleteUserAccessCardId200 = {
  message?: string;
};

export type GetAccessCardStatusEventParams = {
/**
 * Page number for pagination
 */
page?: number;
/**
 * Number of records per page
 */
limit?: number;
/**
 * Tables to join with format 'table1,field1,table2,field2'
 */
expand?: string;
/**
 * Field to order results by
 */
order_by?: string;
/**
 * Order direction (ASC or DESC)
 */
order_direction?: GetAccessCardStatusEventOrderDirection;
};

export type GetAccessCardStatusEventOrderDirection = typeof GetAccessCardStatusEventOrderDirection[keyof typeof GetAccessCardStatusEventOrderDirection];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetAccessCardStatusEventOrderDirection = {
  ASC: 'ASC',
  DESC: 'DESC',
} as const;

export type GetAccessCardStatusEvent200 = {
  data?: AccessCardStatusEvent[];
  total_pages?: number;
  page?: number;
  total_elements?: number;
};

export type PostAccessCardStatusEvent200 = {
  data?: AccessCardStatusEvent[];
  message?: string;
};

export type GetAccessCardStatusEventId200 = {
  data?: AccessCardStatusEvent;
};

export type PutAccessCardStatusEventId200 = {
  data?: AccessCardStatusEvent[];
  message?: string;
};

export type PatchAccessCardStatusEventId200 = {
  data?: AccessCardStatusEvent[];
  message?: string;
};

export type DeleteAccessCardStatusEventId200 = {
  message?: string;
};

export type GetEstateAccessTypeParams = {
/**
 * Page number for pagination
 */
page?: number;
/**
 * Number of records per page
 */
limit?: number;
/**
 * Tables to join with format 'table1,field1,table2,field2'
 */
expand?: string;
/**
 * Field to order results by
 */
order_by?: string;
/**
 * Order direction (ASC or DESC)
 */
order_direction?: GetEstateAccessTypeOrderDirection;
};

export type GetEstateAccessTypeOrderDirection = typeof GetEstateAccessTypeOrderDirection[keyof typeof GetEstateAccessTypeOrderDirection];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetEstateAccessTypeOrderDirection = {
  ASC: 'ASC',
  DESC: 'DESC',
} as const;

export type GetEstateAccessType200 = {
  data?: EstateAccessType[];
  total_pages?: number;
  page?: number;
  total_elements?: number;
};

export type PostEstateAccessType200 = {
  data?: EstateAccessType[];
  message?: string;
};

export type GetEstateAccessTypeId200 = {
  data?: EstateAccessType;
};

export type PutEstateAccessTypeId200 = {
  data?: EstateAccessType[];
  message?: string;
};

export type PatchEstateAccessTypeId200 = {
  data?: EstateAccessType[];
  message?: string;
};

export type DeleteEstateAccessTypeId200 = {
  message?: string;
};

export type GetScheduleParams = {
/**
 * Page number for pagination
 */
page?: number;
/**
 * Number of records per page
 */
limit?: number;
/**
 * Tables to join with format 'table1,field1,table2,field2'
 */
expand?: string;
/**
 * Field to order results by
 */
order_by?: string;
/**
 * Order direction (ASC or DESC)
 */
order_direction?: GetScheduleOrderDirection;
};

export type GetScheduleOrderDirection = typeof GetScheduleOrderDirection[keyof typeof GetScheduleOrderDirection];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetScheduleOrderDirection = {
  ASC: 'ASC',
  DESC: 'DESC',
} as const;

export type GetSchedule200 = {
  data?: Schedule[];
  total_pages?: number;
  page?: number;
  total_elements?: number;
};

export type PostSchedule200 = {
  data?: Schedule[];
  message?: string;
};

export type GetScheduleId200 = {
  data?: Schedule;
};

export type PutScheduleId200 = {
  data?: Schedule[];
  message?: string;
};

export type PatchScheduleId200 = {
  data?: Schedule[];
  message?: string;
};

export type DeleteScheduleId200 = {
  message?: string;
};

export type GetResourceParams = {
/**
 * Page number for pagination
 */
page?: number;
/**
 * Number of records per page
 */
limit?: number;
/**
 * Tables to join with format 'table1,field1,table2,field2'
 */
expand?: string;
/**
 * Field to order results by
 */
order_by?: string;
/**
 * Order direction (ASC or DESC)
 */
order_direction?: GetResourceOrderDirection;
};

export type GetResourceOrderDirection = typeof GetResourceOrderDirection[keyof typeof GetResourceOrderDirection];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetResourceOrderDirection = {
  ASC: 'ASC',
  DESC: 'DESC',
} as const;

export type GetResource200 = {
  data?: Resource[];
  total_pages?: number;
  page?: number;
  total_elements?: number;
};

export type PostResource200 = {
  data?: Resource[];
  message?: string;
};

export type GetResourceId200 = {
  data?: Resource;
};

export type PutResourceId200 = {
  data?: Resource[];
  message?: string;
};

export type PatchResourceId200 = {
  data?: Resource[];
  message?: string;
};

export type DeleteResourceId200 = {
  message?: string;
};

export type GetCustomerParams = {
/**
 * Page number for pagination
 */
page?: number;
/**
 * Number of records per page
 */
limit?: number;
/**
 * Tables to join with format 'table1,field1,table2,field2'
 */
expand?: string;
/**
 * Field to order results by
 */
order_by?: string;
/**
 * Order direction (ASC or DESC)
 */
order_direction?: GetCustomerOrderDirection;
};

export type GetCustomerOrderDirection = typeof GetCustomerOrderDirection[keyof typeof GetCustomerOrderDirection];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetCustomerOrderDirection = {
  ASC: 'ASC',
  DESC: 'DESC',
} as const;

export type GetCustomer200 = {
  data?: Customer[];
  total_pages?: number;
  page?: number;
  total_elements?: number;
};

export type PostCustomer200 = {
  data?: Customer[];
  message?: string;
};

export type GetCustomerId200 = {
  data?: Customer;
};

export type PutCustomerId200 = {
  data?: Customer[];
  message?: string;
};

export type PatchCustomerId200 = {
  data?: Customer[];
  message?: string;
};

export type DeleteCustomerId200 = {
  message?: string;
};

export type GetCustomerBusinessParams = {
/**
 * Page number for pagination
 */
page?: number;
/**
 * Number of records per page
 */
limit?: number;
/**
 * Tables to join with format 'table1,field1,table2,field2'
 */
expand?: string;
/**
 * Field to order results by
 */
order_by?: string;
/**
 * Order direction (ASC or DESC)
 */
order_direction?: GetCustomerBusinessOrderDirection;
};

export type GetCustomerBusinessOrderDirection = typeof GetCustomerBusinessOrderDirection[keyof typeof GetCustomerBusinessOrderDirection];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetCustomerBusinessOrderDirection = {
  ASC: 'ASC',
  DESC: 'DESC',
} as const;

export type GetCustomerBusiness200 = {
  data?: CustomerBusiness[];
  total_pages?: number;
  page?: number;
  total_elements?: number;
};

export type PostCustomerBusiness200 = {
  data?: CustomerBusiness[];
  message?: string;
};

export type GetCustomerBusinessId200 = {
  data?: CustomerBusiness;
};

export type PutCustomerBusinessId200 = {
  data?: CustomerBusiness[];
  message?: string;
};

export type PatchCustomerBusinessId200 = {
  data?: CustomerBusiness[];
  message?: string;
};

export type DeleteCustomerBusinessId200 = {
  message?: string;
};

export type GetServiceContractParams = {
/**
 * Page number for pagination
 */
page?: number;
/**
 * Number of records per page
 */
limit?: number;
/**
 * Tables to join with format 'table1,field1,table2,field2'
 */
expand?: string;
/**
 * Field to order results by
 */
order_by?: string;
/**
 * Order direction (ASC or DESC)
 */
order_direction?: GetServiceContractOrderDirection;
};

export type GetServiceContractOrderDirection = typeof GetServiceContractOrderDirection[keyof typeof GetServiceContractOrderDirection];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetServiceContractOrderDirection = {
  ASC: 'ASC',
  DESC: 'DESC',
} as const;

export type GetServiceContract200 = {
  data?: ServiceContract[];
  total_pages?: number;
  page?: number;
  total_elements?: number;
};

export type PostServiceContract200 = {
  data?: ServiceContract[];
  message?: string;
};

export type GetServiceContractId200 = {
  data?: ServiceContract;
};

export type PutServiceContractId200 = {
  data?: ServiceContract[];
  message?: string;
};

export type PatchServiceContractId200 = {
  data?: ServiceContract[];
  message?: string;
};

export type DeleteServiceContractId200 = {
  message?: string;
};

export type GetProductParams = {
/**
 * Page number for pagination
 */
page?: number;
/**
 * Number of records per page
 */
limit?: number;
/**
 * Tables to join with format 'table1,field1,table2,field2'
 */
expand?: string;
/**
 * Field to order results by
 */
order_by?: string;
/**
 * Order direction (ASC or DESC)
 */
order_direction?: GetProductOrderDirection;
};

export type GetProductOrderDirection = typeof GetProductOrderDirection[keyof typeof GetProductOrderDirection];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetProductOrderDirection = {
  ASC: 'ASC',
  DESC: 'DESC',
} as const;

export type GetProduct200 = {
  data?: Product[];
  total_pages?: number;
  page?: number;
  total_elements?: number;
};

export type PostProduct200 = {
  data?: Product[];
  message?: string;
};

export type GetProductId200 = {
  data?: Product;
};

export type PutProductId200 = {
  data?: Product[];
  message?: string;
};

export type PatchProductId200 = {
  data?: Product[];
  message?: string;
};

export type DeleteProductId200 = {
  message?: string;
};

export type GetProductVariantParams = {
/**
 * Page number for pagination
 */
page?: number;
/**
 * Number of records per page
 */
limit?: number;
/**
 * Tables to join with format 'table1,field1,table2,field2'
 */
expand?: string;
/**
 * Field to order results by
 */
order_by?: string;
/**
 * Order direction (ASC or DESC)
 */
order_direction?: GetProductVariantOrderDirection;
};

export type GetProductVariantOrderDirection = typeof GetProductVariantOrderDirection[keyof typeof GetProductVariantOrderDirection];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetProductVariantOrderDirection = {
  ASC: 'ASC',
  DESC: 'DESC',
} as const;

export type GetProductVariant200 = {
  data?: ProductVariant[];
  total_pages?: number;
  page?: number;
  total_elements?: number;
};

export type PostProductVariant200 = {
  data?: ProductVariant[];
  message?: string;
};

export type GetProductVariantId200 = {
  data?: ProductVariant;
};

export type PutProductVariantId200 = {
  data?: ProductVariant[];
  message?: string;
};

export type PatchProductVariantId200 = {
  data?: ProductVariant[];
  message?: string;
};

export type DeleteProductVariantId200 = {
  message?: string;
};

export type GetProductTypeParams = {
/**
 * Page number for pagination
 */
page?: number;
/**
 * Number of records per page
 */
limit?: number;
/**
 * Tables to join with format 'table1,field1,table2,field2'
 */
expand?: string;
/**
 * Field to order results by
 */
order_by?: string;
/**
 * Order direction (ASC or DESC)
 */
order_direction?: GetProductTypeOrderDirection;
};

export type GetProductTypeOrderDirection = typeof GetProductTypeOrderDirection[keyof typeof GetProductTypeOrderDirection];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetProductTypeOrderDirection = {
  ASC: 'ASC',
  DESC: 'DESC',
} as const;

export type GetProductType200 = {
  data?: ProductType[];
  total_pages?: number;
  page?: number;
  total_elements?: number;
};

export type PostProductType200 = {
  data?: ProductType[];
  message?: string;
};

export type GetProductTypeId200 = {
  data?: ProductType;
};

export type PutProductTypeId200 = {
  data?: ProductType[];
  message?: string;
};

export type PatchProductTypeId200 = {
  data?: ProductType[];
  message?: string;
};

export type DeleteProductTypeId200 = {
  message?: string;
};

export type GetProductclassParams = {
/**
 * Page number for pagination
 */
page?: number;
/**
 * Number of records per page
 */
limit?: number;
/**
 * Tables to join with format 'table1,field1,table2,field2'
 */
expand?: string;
/**
 * Field to order results by
 */
order_by?: string;
/**
 * Order direction (ASC or DESC)
 */
order_direction?: GetProductclassOrderDirection;
};

export type GetProductclassOrderDirection = typeof GetProductclassOrderDirection[keyof typeof GetProductclassOrderDirection];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetProductclassOrderDirection = {
  ASC: 'ASC',
  DESC: 'DESC',
} as const;

export type GetProductclass200 = {
  data?: Productclass[];
  total_pages?: number;
  page?: number;
  total_elements?: number;
};

export type PostProductclass200 = {
  data?: Productclass[];
  message?: string;
};

export type GetProductclassId200 = {
  data?: Productclass;
};

export type PutProductclassId200 = {
  data?: Productclass[];
  message?: string;
};

export type PatchProductclassId200 = {
  data?: Productclass[];
  message?: string;
};

export type DeleteProductclassId200 = {
  message?: string;
};

export type GetProductCategoriesParams = {
/**
 * Page number for pagination
 */
page?: number;
/**
 * Number of records per page
 */
limit?: number;
/**
 * Tables to join with format 'table1,field1,table2,field2'
 */
expand?: string;
/**
 * Field to order results by
 */
order_by?: string;
/**
 * Order direction (ASC or DESC)
 */
order_direction?: GetProductCategoriesOrderDirection;
};

export type GetProductCategoriesOrderDirection = typeof GetProductCategoriesOrderDirection[keyof typeof GetProductCategoriesOrderDirection];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetProductCategoriesOrderDirection = {
  ASC: 'ASC',
  DESC: 'DESC',
} as const;

export type GetProductCategories200 = {
  data?: ProductCategories[];
  total_pages?: number;
  page?: number;
  total_elements?: number;
};

export type PostProductCategories200 = {
  data?: ProductCategories[];
  message?: string;
};

export type GetProductCategoriesId200 = {
  data?: ProductCategories;
};

export type PutProductCategoriesId200 = {
  data?: ProductCategories[];
  message?: string;
};

export type PatchProductCategoriesId200 = {
  data?: ProductCategories[];
  message?: string;
};

export type DeleteProductCategoriesId200 = {
  message?: string;
};

export type GetProductAttributeParams = {
/**
 * Page number for pagination
 */
page?: number;
/**
 * Number of records per page
 */
limit?: number;
/**
 * Tables to join with format 'table1,field1,table2,field2'
 */
expand?: string;
/**
 * Field to order results by
 */
order_by?: string;
/**
 * Order direction (ASC or DESC)
 */
order_direction?: GetProductAttributeOrderDirection;
};

export type GetProductAttributeOrderDirection = typeof GetProductAttributeOrderDirection[keyof typeof GetProductAttributeOrderDirection];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetProductAttributeOrderDirection = {
  ASC: 'ASC',
  DESC: 'DESC',
} as const;

export type GetProductAttribute200 = {
  data?: ProductAttribute[];
  total_pages?: number;
  page?: number;
  total_elements?: number;
};

export type PostProductAttribute200 = {
  data?: ProductAttribute[];
  message?: string;
};

export type GetProductAttributeId200 = {
  data?: ProductAttribute;
};

export type PutProductAttributeId200 = {
  data?: ProductAttribute[];
  message?: string;
};

export type PatchProductAttributeId200 = {
  data?: ProductAttribute[];
  message?: string;
};

export type DeleteProductAttributeId200 = {
  message?: string;
};

export type GetProductclassProductAttributeParams = {
/**
 * Page number for pagination
 */
page?: number;
/**
 * Number of records per page
 */
limit?: number;
/**
 * Tables to join with format 'table1,field1,table2,field2'
 */
expand?: string;
/**
 * Field to order results by
 */
order_by?: string;
/**
 * Order direction (ASC or DESC)
 */
order_direction?: GetProductclassProductAttributeOrderDirection;
};

export type GetProductclassProductAttributeOrderDirection = typeof GetProductclassProductAttributeOrderDirection[keyof typeof GetProductclassProductAttributeOrderDirection];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetProductclassProductAttributeOrderDirection = {
  ASC: 'ASC',
  DESC: 'DESC',
} as const;

export type GetProductclassProductAttribute200 = {
  data?: ProductclassProductAttribute[];
  total_pages?: number;
  page?: number;
  total_elements?: number;
};

export type PostProductclassProductAttribute200 = {
  data?: ProductclassProductAttribute[];
  message?: string;
};

export type GetProductclassProductAttributeId200 = {
  data?: ProductclassProductAttribute;
};

export type PutProductclassProductAttributeId200 = {
  data?: ProductclassProductAttribute[];
  message?: string;
};

export type PatchProductclassProductAttributeId200 = {
  data?: ProductclassProductAttribute[];
  message?: string;
};

export type DeleteProductclassProductAttributeId200 = {
  message?: string;
};

export type GetAttributeChoiceValueParams = {
/**
 * Page number for pagination
 */
page?: number;
/**
 * Number of records per page
 */
limit?: number;
/**
 * Tables to join with format 'table1,field1,table2,field2'
 */
expand?: string;
/**
 * Field to order results by
 */
order_by?: string;
/**
 * Order direction (ASC or DESC)
 */
order_direction?: GetAttributeChoiceValueOrderDirection;
};

export type GetAttributeChoiceValueOrderDirection = typeof GetAttributeChoiceValueOrderDirection[keyof typeof GetAttributeChoiceValueOrderDirection];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetAttributeChoiceValueOrderDirection = {
  ASC: 'ASC',
  DESC: 'DESC',
} as const;

export type GetAttributeChoiceValue200 = {
  data?: AttributeChoiceValue[];
  total_pages?: number;
  page?: number;
  total_elements?: number;
};

export type PostAttributeChoiceValue200 = {
  data?: AttributeChoiceValue[];
  message?: string;
};

export type GetAttributeChoiceValueId200 = {
  data?: AttributeChoiceValue;
};

export type PutAttributeChoiceValueId200 = {
  data?: AttributeChoiceValue[];
  message?: string;
};

export type PatchAttributeChoiceValueId200 = {
  data?: AttributeChoiceValue[];
  message?: string;
};

export type DeleteAttributeChoiceValueId200 = {
  message?: string;
};

export type GetProductImageParams = {
/**
 * Page number for pagination
 */
page?: number;
/**
 * Number of records per page
 */
limit?: number;
/**
 * Tables to join with format 'table1,field1,table2,field2'
 */
expand?: string;
/**
 * Field to order results by
 */
order_by?: string;
/**
 * Order direction (ASC or DESC)
 */
order_direction?: GetProductImageOrderDirection;
};

export type GetProductImageOrderDirection = typeof GetProductImageOrderDirection[keyof typeof GetProductImageOrderDirection];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetProductImageOrderDirection = {
  ASC: 'ASC',
  DESC: 'DESC',
} as const;

export type GetProductImage200 = {
  data?: ProductImage[];
  total_pages?: number;
  page?: number;
  total_elements?: number;
};

export type PostProductImage200 = {
  data?: ProductImage[];
  message?: string;
};

export type GetProductImageId200 = {
  data?: ProductImage;
};

export type PutProductImageId200 = {
  data?: ProductImage[];
  message?: string;
};

export type PatchProductImageId200 = {
  data?: ProductImage[];
  message?: string;
};

export type DeleteProductImageId200 = {
  message?: string;
};

export type GetVariantImageParams = {
/**
 * Page number for pagination
 */
page?: number;
/**
 * Number of records per page
 */
limit?: number;
/**
 * Tables to join with format 'table1,field1,table2,field2'
 */
expand?: string;
/**
 * Field to order results by
 */
order_by?: string;
/**
 * Order direction (ASC or DESC)
 */
order_direction?: GetVariantImageOrderDirection;
};

export type GetVariantImageOrderDirection = typeof GetVariantImageOrderDirection[keyof typeof GetVariantImageOrderDirection];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetVariantImageOrderDirection = {
  ASC: 'ASC',
  DESC: 'DESC',
} as const;

export type GetVariantImage200 = {
  data?: VariantImage[];
  total_pages?: number;
  page?: number;
  total_elements?: number;
};

export type PostVariantImage200 = {
  data?: VariantImage[];
  message?: string;
};

export type GetVariantImageId200 = {
  data?: VariantImage;
};

export type PutVariantImageId200 = {
  data?: VariantImage[];
  message?: string;
};

export type PatchVariantImageId200 = {
  data?: VariantImage[];
  message?: string;
};

export type DeleteVariantImageId200 = {
  message?: string;
};

export type GetStockLocationParams = {
/**
 * Page number for pagination
 */
page?: number;
/**
 * Number of records per page
 */
limit?: number;
/**
 * Tables to join with format 'table1,field1,table2,field2'
 */
expand?: string;
/**
 * Field to order results by
 */
order_by?: string;
/**
 * Order direction (ASC or DESC)
 */
order_direction?: GetStockLocationOrderDirection;
};

export type GetStockLocationOrderDirection = typeof GetStockLocationOrderDirection[keyof typeof GetStockLocationOrderDirection];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetStockLocationOrderDirection = {
  ASC: 'ASC',
  DESC: 'DESC',
} as const;

export type GetStockLocation200 = {
  data?: StockLocation[];
  total_pages?: number;
  page?: number;
  total_elements?: number;
};

export type PostStockLocation200 = {
  data?: StockLocation[];
  message?: string;
};

export type GetStockLocationId200 = {
  data?: StockLocation;
};

export type PutStockLocationId200 = {
  data?: StockLocation[];
  message?: string;
};

export type PatchStockLocationId200 = {
  data?: StockLocation[];
  message?: string;
};

export type DeleteStockLocationId200 = {
  message?: string;
};

export type GetStockParams = {
/**
 * Page number for pagination
 */
page?: number;
/**
 * Number of records per page
 */
limit?: number;
/**
 * Tables to join with format 'table1,field1,table2,field2'
 */
expand?: string;
/**
 * Field to order results by
 */
order_by?: string;
/**
 * Order direction (ASC or DESC)
 */
order_direction?: GetStockOrderDirection;
};

export type GetStockOrderDirection = typeof GetStockOrderDirection[keyof typeof GetStockOrderDirection];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetStockOrderDirection = {
  ASC: 'ASC',
  DESC: 'DESC',
} as const;

export type GetStock200 = {
  data?: Stock[];
  total_pages?: number;
  page?: number;
  total_elements?: number;
};

export type PostStock200 = {
  data?: Stock[];
  message?: string;
};

export type GetStockId200 = {
  data?: Stock;
};

export type PutStockId200 = {
  data?: Stock[];
  message?: string;
};

export type PatchStockId200 = {
  data?: Stock[];
  message?: string;
};

export type DeleteStockId200 = {
  message?: string;
};

export type GetInvitationTypeParams = {
/**
 * Page number for pagination
 */
page?: number;
/**
 * Number of records per page
 */
limit?: number;
/**
 * Tables to join with format 'table1,field1,table2,field2'
 */
expand?: string;
/**
 * Field to order results by
 */
order_by?: string;
/**
 * Order direction (ASC or DESC)
 */
order_direction?: GetInvitationTypeOrderDirection;
};

export type GetInvitationTypeOrderDirection = typeof GetInvitationTypeOrderDirection[keyof typeof GetInvitationTypeOrderDirection];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetInvitationTypeOrderDirection = {
  ASC: 'ASC',
  DESC: 'DESC',
} as const;

export type GetInvitationType200 = {
  data?: InvitationType[];
  total_pages?: number;
  page?: number;
  total_elements?: number;
};

export type PostInvitationType200 = {
  data?: InvitationType[];
  message?: string;
};

export type GetInvitationTypeId200 = {
  data?: InvitationType;
};

export type PutInvitationTypeId200 = {
  data?: InvitationType[];
  message?: string;
};

export type PatchInvitationTypeId200 = {
  data?: InvitationType[];
  message?: string;
};

export type DeleteInvitationTypeId200 = {
  message?: string;
};

export type GetInvitationParams = {
/**
 * Page number for pagination
 */
page?: number;
/**
 * Number of records per page
 */
limit?: number;
/**
 * Tables to join with format 'table1,field1,table2,field2'
 */
expand?: string;
/**
 * Field to order results by
 */
order_by?: string;
/**
 * Order direction (ASC or DESC)
 */
order_direction?: GetInvitationOrderDirection;
};

export type GetInvitationOrderDirection = typeof GetInvitationOrderDirection[keyof typeof GetInvitationOrderDirection];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetInvitationOrderDirection = {
  ASC: 'ASC',
  DESC: 'DESC',
} as const;

export type GetInvitation200 = {
  data?: Invitation[];
  total_pages?: number;
  page?: number;
  total_elements?: number;
};

export type PostInvitation200 = {
  data?: Invitation[];
  message?: string;
};

export type GetInvitationId200 = {
  data?: Invitation;
};

export type PutInvitationId200 = {
  data?: Invitation[];
  message?: string;
};

export type PatchInvitationId200 = {
  data?: Invitation[];
  message?: string;
};

export type DeleteInvitationId200 = {
  message?: string;
};

export type GetInvitationStatusEventParams = {
/**
 * Page number for pagination
 */
page?: number;
/**
 * Number of records per page
 */
limit?: number;
/**
 * Tables to join with format 'table1,field1,table2,field2'
 */
expand?: string;
/**
 * Field to order results by
 */
order_by?: string;
/**
 * Order direction (ASC or DESC)
 */
order_direction?: GetInvitationStatusEventOrderDirection;
};

export type GetInvitationStatusEventOrderDirection = typeof GetInvitationStatusEventOrderDirection[keyof typeof GetInvitationStatusEventOrderDirection];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetInvitationStatusEventOrderDirection = {
  ASC: 'ASC',
  DESC: 'DESC',
} as const;

export type GetInvitationStatusEvent200 = {
  data?: InvitationStatusEvent[];
  total_pages?: number;
  page?: number;
  total_elements?: number;
};

export type PostInvitationStatusEvent200 = {
  data?: InvitationStatusEvent[];
  message?: string;
};

export type GetInvitationStatusEventId200 = {
  data?: InvitationStatusEvent;
};

export type PutInvitationStatusEventId200 = {
  data?: InvitationStatusEvent[];
  message?: string;
};

export type PatchInvitationStatusEventId200 = {
  data?: InvitationStatusEvent[];
  message?: string;
};

export type DeleteInvitationStatusEventId200 = {
  message?: string;
};

export type GetGuestParams = {
/**
 * Page number for pagination
 */
page?: number;
/**
 * Number of records per page
 */
limit?: number;
/**
 * Tables to join with format 'table1,field1,table2,field2'
 */
expand?: string;
/**
 * Field to order results by
 */
order_by?: string;
/**
 * Order direction (ASC or DESC)
 */
order_direction?: GetGuestOrderDirection;
};

export type GetGuestOrderDirection = typeof GetGuestOrderDirection[keyof typeof GetGuestOrderDirection];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetGuestOrderDirection = {
  ASC: 'ASC',
  DESC: 'DESC',
} as const;

export type GetGuest200 = {
  data?: Guest[];
  total_pages?: number;
  page?: number;
  total_elements?: number;
};

export type PostGuest200 = {
  data?: Guest[];
  message?: string;
};

export type GetGuestId200 = {
  data?: Guest;
};

export type PutGuestId200 = {
  data?: Guest[];
  message?: string;
};

export type PatchGuestId200 = {
  data?: Guest[];
  message?: string;
};

export type DeleteGuestId200 = {
  message?: string;
};

export type GetCompanionParams = {
/**
 * Page number for pagination
 */
page?: number;
/**
 * Number of records per page
 */
limit?: number;
/**
 * Tables to join with format 'table1,field1,table2,field2'
 */
expand?: string;
/**
 * Field to order results by
 */
order_by?: string;
/**
 * Order direction (ASC or DESC)
 */
order_direction?: GetCompanionOrderDirection;
};

export type GetCompanionOrderDirection = typeof GetCompanionOrderDirection[keyof typeof GetCompanionOrderDirection];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetCompanionOrderDirection = {
  ASC: 'ASC',
  DESC: 'DESC',
} as const;

export type GetCompanion200 = {
  data?: Companion[];
  total_pages?: number;
  page?: number;
  total_elements?: number;
};

export type PostCompanion200 = {
  data?: Companion[];
  message?: string;
};

export type GetCompanionId200 = {
  data?: Companion;
};

export type PutCompanionId200 = {
  data?: Companion[];
  message?: string;
};

export type PatchCompanionId200 = {
  data?: Companion[];
  message?: string;
};

export type DeleteCompanionId200 = {
  message?: string;
};

export type GetUserEstateStatusParams = {
/**
 * Page number for pagination
 */
page?: number;
/**
 * Number of records per page
 */
limit?: number;
/**
 * Tables to join with format 'table1,field1,table2,field2'
 */
expand?: string;
/**
 * Field to order results by
 */
order_by?: string;
/**
 * Order direction (ASC or DESC)
 */
order_direction?: GetUserEstateStatusOrderDirection;
};

export type GetUserEstateStatusOrderDirection = typeof GetUserEstateStatusOrderDirection[keyof typeof GetUserEstateStatusOrderDirection];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetUserEstateStatusOrderDirection = {
  ASC: 'ASC',
  DESC: 'DESC',
} as const;

export type GetUserEstateStatus200 = {
  data?: UserEstateStatus[];
  total_pages?: number;
  page?: number;
  total_elements?: number;
};

export type PostUserEstateStatus200 = {
  data?: UserEstateStatus[];
  message?: string;
};

export type GetUserEstateStatusId200 = {
  data?: UserEstateStatus;
};

export type PutUserEstateStatusId200 = {
  data?: UserEstateStatus[];
  message?: string;
};

export type PatchUserEstateStatusId200 = {
  data?: UserEstateStatus[];
  message?: string;
};

export type DeleteUserEstateStatusId200 = {
  message?: string;
};

export type GetLegalDocumentsParams = {
/**
 * Page number for pagination
 */
page?: number;
/**
 * Number of records per page
 */
limit?: number;
/**
 * Tables to join with format 'table1,field1,table2,field2'
 */
expand?: string;
/**
 * Field to order results by
 */
order_by?: string;
/**
 * Order direction (ASC or DESC)
 */
order_direction?: GetLegalDocumentsOrderDirection;
};

export type GetLegalDocumentsOrderDirection = typeof GetLegalDocumentsOrderDirection[keyof typeof GetLegalDocumentsOrderDirection];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetLegalDocumentsOrderDirection = {
  ASC: 'ASC',
  DESC: 'DESC',
} as const;

export type GetLegalDocuments200 = {
  data?: LegalDocuments[];
  total_pages?: number;
  page?: number;
  total_elements?: number;
};

export type PostLegalDocuments200 = {
  data?: LegalDocuments[];
  message?: string;
};

export type GetLegalDocumentsId200 = {
  data?: LegalDocuments;
};

export type PutLegalDocumentsId200 = {
  data?: LegalDocuments[];
  message?: string;
};

export type PatchLegalDocumentsId200 = {
  data?: LegalDocuments[];
  message?: string;
};

export type DeleteLegalDocumentsId200 = {
  message?: string;
};

export type GetAuthorParams = {
/**
 * Page number for pagination
 */
page?: number;
/**
 * Number of records per page
 */
limit?: number;
/**
 * Tables to join with format 'table1,field1,table2,field2'
 */
expand?: string;
/**
 * Field to order results by
 */
order_by?: string;
/**
 * Order direction (ASC or DESC)
 */
order_direction?: GetAuthorOrderDirection;
};

export type GetAuthorOrderDirection = typeof GetAuthorOrderDirection[keyof typeof GetAuthorOrderDirection];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetAuthorOrderDirection = {
  ASC: 'ASC',
  DESC: 'DESC',
} as const;

export type GetAuthor200 = {
  data?: Author[];
  total_pages?: number;
  page?: number;
  total_elements?: number;
};

export type PostAuthor200 = {
  data?: Author[];
  message?: string;
};

export type GetAuthorId200 = {
  data?: Author;
};

export type PutAuthorId200 = {
  data?: Author[];
  message?: string;
};

export type PatchAuthorId200 = {
  data?: Author[];
  message?: string;
};

export type DeleteAuthorId200 = {
  message?: string;
};

export type GetAdsParams = {
/**
 * Page number for pagination
 */
page?: number;
/**
 * Number of records per page
 */
limit?: number;
/**
 * Tables to join with format 'table1,field1,table2,field2'
 */
expand?: string;
/**
 * Field to order results by
 */
order_by?: string;
/**
 * Order direction (ASC or DESC)
 */
order_direction?: GetAdsOrderDirection;
};

export type GetAdsOrderDirection = typeof GetAdsOrderDirection[keyof typeof GetAdsOrderDirection];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetAdsOrderDirection = {
  ASC: 'ASC',
  DESC: 'DESC',
} as const;

export type GetAds200 = {
  data?: Ads[];
  total_pages?: number;
  page?: number;
  total_elements?: number;
};

export type PostAds200 = {
  data?: Ads[];
  message?: string;
};

export type GetAdsId200 = {
  data?: Ads;
};

export type PutAdsId200 = {
  data?: Ads[];
  message?: string;
};

export type PatchAdsId200 = {
  data?: Ads[];
  message?: string;
};

export type DeleteAdsId200 = {
  message?: string;
};

export type GetBusinessCategoryParams = {
/**
 * Page number for pagination
 */
page?: number;
/**
 * Number of records per page
 */
limit?: number;
/**
 * Tables to join with format 'table1,field1,table2,field2'
 */
expand?: string;
/**
 * Field to order results by
 */
order_by?: string;
/**
 * Order direction (ASC or DESC)
 */
order_direction?: GetBusinessCategoryOrderDirection;
};

export type GetBusinessCategoryOrderDirection = typeof GetBusinessCategoryOrderDirection[keyof typeof GetBusinessCategoryOrderDirection];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetBusinessCategoryOrderDirection = {
  ASC: 'ASC',
  DESC: 'DESC',
} as const;

export type GetBusinessCategory200 = {
  data?: BusinessCategory[];
  total_pages?: number;
  page?: number;
  total_elements?: number;
};

export type PostBusinessCategory200 = {
  data?: BusinessCategory[];
  message?: string;
};

export type GetBusinessCategoryId200 = {
  data?: BusinessCategory;
};

export type PutBusinessCategoryId200 = {
  data?: BusinessCategory[];
  message?: string;
};

export type PatchBusinessCategoryId200 = {
  data?: BusinessCategory[];
  message?: string;
};

export type DeleteBusinessCategoryId200 = {
  message?: string;
};

export type GetBusinessTypeParams = {
/**
 * Page number for pagination
 */
page?: number;
/**
 * Number of records per page
 */
limit?: number;
/**
 * Tables to join with format 'table1,field1,table2,field2'
 */
expand?: string;
/**
 * Field to order results by
 */
order_by?: string;
/**
 * Order direction (ASC or DESC)
 */
order_direction?: GetBusinessTypeOrderDirection;
};

export type GetBusinessTypeOrderDirection = typeof GetBusinessTypeOrderDirection[keyof typeof GetBusinessTypeOrderDirection];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetBusinessTypeOrderDirection = {
  ASC: 'ASC',
  DESC: 'DESC',
} as const;

export type GetBusinessType200 = {
  data?: BusinessType[];
  total_pages?: number;
  page?: number;
  total_elements?: number;
};

export type PostBusinessType200 = {
  data?: BusinessType[];
  message?: string;
};

export type GetBusinessTypeId200 = {
  data?: BusinessType;
};

export type PutBusinessTypeId200 = {
  data?: BusinessType[];
  message?: string;
};

export type PatchBusinessTypeId200 = {
  data?: BusinessType[];
  message?: string;
};

export type DeleteBusinessTypeId200 = {
  message?: string;
};

export type GetBusinessUnitParams = {
/**
 * Page number for pagination
 */
page?: number;
/**
 * Number of records per page
 */
limit?: number;
/**
 * Tables to join with format 'table1,field1,table2,field2'
 */
expand?: string;
/**
 * Field to order results by
 */
order_by?: string;
/**
 * Order direction (ASC or DESC)
 */
order_direction?: GetBusinessUnitOrderDirection;
};

export type GetBusinessUnitOrderDirection = typeof GetBusinessUnitOrderDirection[keyof typeof GetBusinessUnitOrderDirection];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetBusinessUnitOrderDirection = {
  ASC: 'ASC',
  DESC: 'DESC',
} as const;

export type GetBusinessUnit200 = {
  data?: BusinessUnit[];
  total_pages?: number;
  page?: number;
  total_elements?: number;
};

export type PostBusinessUnit200 = {
  data?: BusinessUnit[];
  message?: string;
};

export type GetBusinessUnitId200 = {
  data?: BusinessUnit;
};

export type PutBusinessUnitId200 = {
  data?: BusinessUnit[];
  message?: string;
};

export type PatchBusinessUnitId200 = {
  data?: BusinessUnit[];
  message?: string;
};

export type DeleteBusinessUnitId200 = {
  message?: string;
};

export type GetBusinessParams = {
/**
 * Page number for pagination
 */
page?: number;
/**
 * Number of records per page
 */
limit?: number;
/**
 * Tables to join with format 'table1,field1,table2,field2'
 */
expand?: string;
/**
 * Field to order results by
 */
order_by?: string;
/**
 * Order direction (ASC or DESC)
 */
order_direction?: GetBusinessOrderDirection;
};

export type GetBusinessOrderDirection = typeof GetBusinessOrderDirection[keyof typeof GetBusinessOrderDirection];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetBusinessOrderDirection = {
  ASC: 'ASC',
  DESC: 'DESC',
} as const;

export type GetBusiness200 = {
  data?: Business[];
  total_pages?: number;
  page?: number;
  total_elements?: number;
};

export type PostBusiness200 = {
  data?: Business[];
  message?: string;
};

export type GetBusinessId200 = {
  data?: Business;
};

export type PutBusinessId200 = {
  data?: Business[];
  message?: string;
};

export type PatchBusinessId200 = {
  data?: Business[];
  message?: string;
};

export type DeleteBusinessId200 = {
  message?: string;
};

export type GetArticleGroupParams = {
/**
 * Page number for pagination
 */
page?: number;
/**
 * Number of records per page
 */
limit?: number;
/**
 * Tables to join with format 'table1,field1,table2,field2'
 */
expand?: string;
/**
 * Field to order results by
 */
order_by?: string;
/**
 * Order direction (ASC or DESC)
 */
order_direction?: GetArticleGroupOrderDirection;
};

export type GetArticleGroupOrderDirection = typeof GetArticleGroupOrderDirection[keyof typeof GetArticleGroupOrderDirection];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetArticleGroupOrderDirection = {
  ASC: 'ASC',
  DESC: 'DESC',
} as const;

export type GetArticleGroup200 = {
  data?: ArticleGroup[];
  total_pages?: number;
  page?: number;
  total_elements?: number;
};

export type PostArticleGroup200 = {
  data?: ArticleGroup[];
  message?: string;
};

export type GetArticleGroupId200 = {
  data?: ArticleGroup;
};

export type PutArticleGroupId200 = {
  data?: ArticleGroup[];
  message?: string;
};

export type PatchArticleGroupId200 = {
  data?: ArticleGroup[];
  message?: string;
};

export type DeleteArticleGroupId200 = {
  message?: string;
};

export type GetArticleTypeParams = {
/**
 * Page number for pagination
 */
page?: number;
/**
 * Number of records per page
 */
limit?: number;
/**
 * Tables to join with format 'table1,field1,table2,field2'
 */
expand?: string;
/**
 * Field to order results by
 */
order_by?: string;
/**
 * Order direction (ASC or DESC)
 */
order_direction?: GetArticleTypeOrderDirection;
};

export type GetArticleTypeOrderDirection = typeof GetArticleTypeOrderDirection[keyof typeof GetArticleTypeOrderDirection];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetArticleTypeOrderDirection = {
  ASC: 'ASC',
  DESC: 'DESC',
} as const;

export type GetArticleType200 = {
  data?: ArticleType[];
  total_pages?: number;
  page?: number;
  total_elements?: number;
};

export type PostArticleType200 = {
  data?: ArticleType[];
  message?: string;
};

export type GetArticleTypeId200 = {
  data?: ArticleType;
};

export type PutArticleTypeId200 = {
  data?: ArticleType[];
  message?: string;
};

export type PatchArticleTypeId200 = {
  data?: ArticleType[];
  message?: string;
};

export type DeleteArticleTypeId200 = {
  message?: string;
};

export type GetArticleParams = {
/**
 * Page number for pagination
 */
page?: number;
/**
 * Number of records per page
 */
limit?: number;
/**
 * Tables to join with format 'table1,field1,table2,field2'
 */
expand?: string;
/**
 * Field to order results by
 */
order_by?: string;
/**
 * Order direction (ASC or DESC)
 */
order_direction?: GetArticleOrderDirection;
};

export type GetArticleOrderDirection = typeof GetArticleOrderDirection[keyof typeof GetArticleOrderDirection];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetArticleOrderDirection = {
  ASC: 'ASC',
  DESC: 'DESC',
} as const;

export type GetArticle200 = {
  data?: Article[];
  total_pages?: number;
  page?: number;
  total_elements?: number;
};

export type PostArticle200 = {
  data?: Article[];
  message?: string;
};

export type GetArticleId200 = {
  data?: Article;
};

export type PutArticleId200 = {
  data?: Article[];
  message?: string;
};

export type PatchArticleId200 = {
  data?: Article[];
  message?: string;
};

export type DeleteArticleId200 = {
  message?: string;
};

export type GetNotificationParams = {
/**
 * Page number for pagination
 */
page?: number;
/**
 * Number of records per page
 */
limit?: number;
/**
 * Tables to join with format 'table1,field1,table2,field2'
 */
expand?: string;
/**
 * Field to order results by
 */
order_by?: string;
/**
 * Order direction (ASC or DESC)
 */
order_direction?: GetNotificationOrderDirection;
};

export type GetNotificationOrderDirection = typeof GetNotificationOrderDirection[keyof typeof GetNotificationOrderDirection];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetNotificationOrderDirection = {
  ASC: 'ASC',
  DESC: 'DESC',
} as const;

export type GetNotification200 = {
  data?: Notification[];
  total_pages?: number;
  page?: number;
  total_elements?: number;
};

export type PostNotification200 = {
  data?: Notification[];
  message?: string;
};

export type GetNotificationId200 = {
  data?: Notification;
};

export type PutNotificationId200 = {
  data?: Notification[];
  message?: string;
};

export type PatchNotificationId200 = {
  data?: Notification[];
  message?: string;
};

export type DeleteNotificationId200 = {
  message?: string;
};

export type GetUserNotificationActivityParams = {
/**
 * Page number for pagination
 */
page?: number;
/**
 * Number of records per page
 */
limit?: number;
/**
 * Tables to join with format 'table1,field1,table2,field2'
 */
expand?: string;
/**
 * Field to order results by
 */
order_by?: string;
/**
 * Order direction (ASC or DESC)
 */
order_direction?: GetUserNotificationActivityOrderDirection;
};

export type GetUserNotificationActivityOrderDirection = typeof GetUserNotificationActivityOrderDirection[keyof typeof GetUserNotificationActivityOrderDirection];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetUserNotificationActivityOrderDirection = {
  ASC: 'ASC',
  DESC: 'DESC',
} as const;

export type GetUserNotificationActivity200 = {
  data?: UserNotificationActivity[];
  total_pages?: number;
  page?: number;
  total_elements?: number;
};

export type PostUserNotificationActivity200 = {
  data?: UserNotificationActivity[];
  message?: string;
};

export type GetUserNotificationActivityId200 = {
  data?: UserNotificationActivity;
};

export type PutUserNotificationActivityId200 = {
  data?: UserNotificationActivity[];
  message?: string;
};

export type PatchUserNotificationActivityId200 = {
  data?: UserNotificationActivity[];
  message?: string;
};

export type DeleteUserNotificationActivityId200 = {
  message?: string;
};

export type GetSponsorshipParams = {
/**
 * Page number for pagination
 */
page?: number;
/**
 * Number of records per page
 */
limit?: number;
/**
 * Tables to join with format 'table1,field1,table2,field2'
 */
expand?: string;
/**
 * Field to order results by
 */
order_by?: string;
/**
 * Order direction (ASC or DESC)
 */
order_direction?: GetSponsorshipOrderDirection;
};

export type GetSponsorshipOrderDirection = typeof GetSponsorshipOrderDirection[keyof typeof GetSponsorshipOrderDirection];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetSponsorshipOrderDirection = {
  ASC: 'ASC',
  DESC: 'DESC',
} as const;

export type GetSponsorship200 = {
  data?: Sponsorship[];
  total_pages?: number;
  page?: number;
  total_elements?: number;
};

export type PostSponsorship200 = {
  data?: Sponsorship[];
  message?: string;
};

export type GetSponsorshipId200 = {
  data?: Sponsorship;
};

export type PutSponsorshipId200 = {
  data?: Sponsorship[];
  message?: string;
};

export type PatchSponsorshipId200 = {
  data?: Sponsorship[];
  message?: string;
};

export type DeleteSponsorshipId200 = {
  message?: string;
};

export type GetUserBusinessViewedParams = {
/**
 * Page number for pagination
 */
page?: number;
/**
 * Number of records per page
 */
limit?: number;
/**
 * Tables to join with format 'table1,field1,table2,field2'
 */
expand?: string;
/**
 * Field to order results by
 */
order_by?: string;
/**
 * Order direction (ASC or DESC)
 */
order_direction?: GetUserBusinessViewedOrderDirection;
};

export type GetUserBusinessViewedOrderDirection = typeof GetUserBusinessViewedOrderDirection[keyof typeof GetUserBusinessViewedOrderDirection];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetUserBusinessViewedOrderDirection = {
  ASC: 'ASC',
  DESC: 'DESC',
} as const;

export type GetUserBusinessViewed200 = {
  data?: UserBusinessViewed[];
  total_pages?: number;
  page?: number;
  total_elements?: number;
};

export type PostUserBusinessViewed200 = {
  data?: UserBusinessViewed[];
  message?: string;
};

export type GetUserBusinessViewedId200 = {
  data?: UserBusinessViewed;
};

export type PutUserBusinessViewedId200 = {
  data?: UserBusinessViewed[];
  message?: string;
};

export type PatchUserBusinessViewedId200 = {
  data?: UserBusinessViewed[];
  message?: string;
};

export type DeleteUserBusinessViewedId200 = {
  message?: string;
};

export type GetBusinessAccessTypeParams = {
/**
 * Page number for pagination
 */
page?: number;
/**
 * Number of records per page
 */
limit?: number;
/**
 * Tables to join with format 'table1,field1,table2,field2'
 */
expand?: string;
/**
 * Field to order results by
 */
order_by?: string;
/**
 * Order direction (ASC or DESC)
 */
order_direction?: GetBusinessAccessTypeOrderDirection;
};

export type GetBusinessAccessTypeOrderDirection = typeof GetBusinessAccessTypeOrderDirection[keyof typeof GetBusinessAccessTypeOrderDirection];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetBusinessAccessTypeOrderDirection = {
  ASC: 'ASC',
  DESC: 'DESC',
} as const;

export type GetBusinessAccessType200 = {
  data?: BusinessAccessType[];
  total_pages?: number;
  page?: number;
  total_elements?: number;
};

export type PostBusinessAccessType200 = {
  data?: BusinessAccessType[];
  message?: string;
};

export type GetBusinessAccessTypeId200 = {
  data?: BusinessAccessType;
};

export type PutBusinessAccessTypeId200 = {
  data?: BusinessAccessType[];
  message?: string;
};

export type PatchBusinessAccessTypeId200 = {
  data?: BusinessAccessType[];
  message?: string;
};

export type DeleteBusinessAccessTypeId200 = {
  message?: string;
};

export type GetBusinessAccessStatusParams = {
/**
 * Page number for pagination
 */
page?: number;
/**
 * Number of records per page
 */
limit?: number;
/**
 * Tables to join with format 'table1,field1,table2,field2'
 */
expand?: string;
/**
 * Field to order results by
 */
order_by?: string;
/**
 * Order direction (ASC or DESC)
 */
order_direction?: GetBusinessAccessStatusOrderDirection;
};

export type GetBusinessAccessStatusOrderDirection = typeof GetBusinessAccessStatusOrderDirection[keyof typeof GetBusinessAccessStatusOrderDirection];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetBusinessAccessStatusOrderDirection = {
  ASC: 'ASC',
  DESC: 'DESC',
} as const;

export type GetBusinessAccessStatus200 = {
  data?: BusinessAccessStatus[];
  total_pages?: number;
  page?: number;
  total_elements?: number;
};

export type PostBusinessAccessStatus200 = {
  data?: BusinessAccessStatus[];
  message?: string;
};

export type GetBusinessAccessStatusId200 = {
  data?: BusinessAccessStatus;
};

export type PutBusinessAccessStatusId200 = {
  data?: BusinessAccessStatus[];
  message?: string;
};

export type PatchBusinessAccessStatusId200 = {
  data?: BusinessAccessStatus[];
  message?: string;
};

export type DeleteBusinessAccessStatusId200 = {
  message?: string;
};

export type GetBusinessGuestParams = {
/**
 * Page number for pagination
 */
page?: number;
/**
 * Number of records per page
 */
limit?: number;
/**
 * Tables to join with format 'table1,field1,table2,field2'
 */
expand?: string;
/**
 * Field to order results by
 */
order_by?: string;
/**
 * Order direction (ASC or DESC)
 */
order_direction?: GetBusinessGuestOrderDirection;
};

export type GetBusinessGuestOrderDirection = typeof GetBusinessGuestOrderDirection[keyof typeof GetBusinessGuestOrderDirection];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetBusinessGuestOrderDirection = {
  ASC: 'ASC',
  DESC: 'DESC',
} as const;

export type GetBusinessGuest200 = {
  data?: BusinessGuest[];
  total_pages?: number;
  page?: number;
  total_elements?: number;
};

export type PostBusinessGuest200 = {
  data?: BusinessGuest[];
  message?: string;
};

export type GetBusinessGuestId200 = {
  data?: BusinessGuest;
};

export type PutBusinessGuestId200 = {
  data?: BusinessGuest[];
  message?: string;
};

export type PatchBusinessGuestId200 = {
  data?: BusinessGuest[];
  message?: string;
};

export type DeleteBusinessGuestId200 = {
  message?: string;
};

export type GetBusinessAccessChannelParams = {
/**
 * Page number for pagination
 */
page?: number;
/**
 * Number of records per page
 */
limit?: number;
/**
 * Tables to join with format 'table1,field1,table2,field2'
 */
expand?: string;
/**
 * Field to order results by
 */
order_by?: string;
/**
 * Order direction (ASC or DESC)
 */
order_direction?: GetBusinessAccessChannelOrderDirection;
};

export type GetBusinessAccessChannelOrderDirection = typeof GetBusinessAccessChannelOrderDirection[keyof typeof GetBusinessAccessChannelOrderDirection];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetBusinessAccessChannelOrderDirection = {
  ASC: 'ASC',
  DESC: 'DESC',
} as const;

export type GetBusinessAccessChannel200 = {
  data?: BusinessAccessChannel[];
  total_pages?: number;
  page?: number;
  total_elements?: number;
};

export type PostBusinessAccessChannel200 = {
  data?: BusinessAccessChannel[];
  message?: string;
};

export type GetBusinessAccessChannelId200 = {
  data?: BusinessAccessChannel;
};

export type PutBusinessAccessChannelId200 = {
  data?: BusinessAccessChannel[];
  message?: string;
};

export type PatchBusinessAccessChannelId200 = {
  data?: BusinessAccessChannel[];
  message?: string;
};

export type DeleteBusinessAccessChannelId200 = {
  message?: string;
};

export type GetEventTypeParams = {
/**
 * Page number for pagination
 */
page?: number;
/**
 * Number of records per page
 */
limit?: number;
/**
 * Tables to join with format 'table1,field1,table2,field2'
 */
expand?: string;
/**
 * Field to order results by
 */
order_by?: string;
/**
 * Order direction (ASC or DESC)
 */
order_direction?: GetEventTypeOrderDirection;
};

export type GetEventTypeOrderDirection = typeof GetEventTypeOrderDirection[keyof typeof GetEventTypeOrderDirection];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetEventTypeOrderDirection = {
  ASC: 'ASC',
  DESC: 'DESC',
} as const;

export type GetEventType200 = {
  data?: EventType[];
  total_pages?: number;
  page?: number;
  total_elements?: number;
};

export type PostEventType200 = {
  data?: EventType[];
  message?: string;
};

export type GetEventTypeId200 = {
  data?: EventType;
};

export type PutEventTypeId200 = {
  data?: EventType[];
  message?: string;
};

export type PatchEventTypeId200 = {
  data?: EventType[];
  message?: string;
};

export type DeleteEventTypeId200 = {
  message?: string;
};

export type GetEventGroupParams = {
/**
 * Page number for pagination
 */
page?: number;
/**
 * Number of records per page
 */
limit?: number;
/**
 * Tables to join with format 'table1,field1,table2,field2'
 */
expand?: string;
/**
 * Field to order results by
 */
order_by?: string;
/**
 * Order direction (ASC or DESC)
 */
order_direction?: GetEventGroupOrderDirection;
};

export type GetEventGroupOrderDirection = typeof GetEventGroupOrderDirection[keyof typeof GetEventGroupOrderDirection];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetEventGroupOrderDirection = {
  ASC: 'ASC',
  DESC: 'DESC',
} as const;

export type GetEventGroup200 = {
  data?: EventGroup[];
  total_pages?: number;
  page?: number;
  total_elements?: number;
};

export type PostEventGroup200 = {
  data?: EventGroup[];
  message?: string;
};

export type GetEventGroupId200 = {
  data?: EventGroup;
};

export type PutEventGroupId200 = {
  data?: EventGroup[];
  message?: string;
};

export type PatchEventGroupId200 = {
  data?: EventGroup[];
  message?: string;
};

export type DeleteEventGroupId200 = {
  message?: string;
};

export type GetAccessSettingsParams = {
/**
 * Page number for pagination
 */
page?: number;
/**
 * Number of records per page
 */
limit?: number;
/**
 * Tables to join with format 'table1,field1,table2,field2'
 */
expand?: string;
/**
 * Field to order results by
 */
order_by?: string;
/**
 * Order direction (ASC or DESC)
 */
order_direction?: GetAccessSettingsOrderDirection;
};

export type GetAccessSettingsOrderDirection = typeof GetAccessSettingsOrderDirection[keyof typeof GetAccessSettingsOrderDirection];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetAccessSettingsOrderDirection = {
  ASC: 'ASC',
  DESC: 'DESC',
} as const;

export type GetAccessSettings200 = {
  data?: AccessSettings[];
  total_pages?: number;
  page?: number;
  total_elements?: number;
};

export type PostAccessSettings200 = {
  data?: AccessSettings[];
  message?: string;
};

export type GetAccessSettingsId200 = {
  data?: AccessSettings;
};

export type PutAccessSettingsId200 = {
  data?: AccessSettings[];
  message?: string;
};

export type PatchAccessSettingsId200 = {
  data?: AccessSettings[];
  message?: string;
};

export type DeleteAccessSettingsId200 = {
  message?: string;
};

export type GetEventParams = {
/**
 * Page number for pagination
 */
page?: number;
/**
 * Number of records per page
 */
limit?: number;
/**
 * Tables to join with format 'table1,field1,table2,field2'
 */
expand?: string;
/**
 * Field to order results by
 */
order_by?: string;
/**
 * Order direction (ASC or DESC)
 */
order_direction?: GetEventOrderDirection;
};

export type GetEventOrderDirection = typeof GetEventOrderDirection[keyof typeof GetEventOrderDirection];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetEventOrderDirection = {
  ASC: 'ASC',
  DESC: 'DESC',
} as const;

export type GetEvent200 = {
  data?: Event[];
  total_pages?: number;
  page?: number;
  total_elements?: number;
};

export type PostEvent200 = {
  data?: Event[];
  message?: string;
};

export type GetEventId200 = {
  data?: Event;
};

export type PutEventId200 = {
  data?: Event[];
  message?: string;
};

export type PatchEventId200 = {
  data?: Event[];
  message?: string;
};

export type DeleteEventId200 = {
  message?: string;
};

export type GetBusinessAccessParams = {
/**
 * Page number for pagination
 */
page?: number;
/**
 * Number of records per page
 */
limit?: number;
/**
 * Tables to join with format 'table1,field1,table2,field2'
 */
expand?: string;
/**
 * Field to order results by
 */
order_by?: string;
/**
 * Order direction (ASC or DESC)
 */
order_direction?: GetBusinessAccessOrderDirection;
};

export type GetBusinessAccessOrderDirection = typeof GetBusinessAccessOrderDirection[keyof typeof GetBusinessAccessOrderDirection];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetBusinessAccessOrderDirection = {
  ASC: 'ASC',
  DESC: 'DESC',
} as const;

export type GetBusinessAccess200 = {
  data?: BusinessAccess[];
  total_pages?: number;
  page?: number;
  total_elements?: number;
};

export type PostBusinessAccess200 = {
  data?: BusinessAccess[];
  message?: string;
};

export type GetBusinessAccessId200 = {
  data?: BusinessAccess;
};

export type PutBusinessAccessId200 = {
  data?: BusinessAccess[];
  message?: string;
};

export type PatchBusinessAccessId200 = {
  data?: BusinessAccess[];
  message?: string;
};

export type DeleteBusinessAccessId200 = {
  message?: string;
};

export type GetServiceTypeParams = {
/**
 * Page number for pagination
 */
page?: number;
/**
 * Number of records per page
 */
limit?: number;
/**
 * Tables to join with format 'table1,field1,table2,field2'
 */
expand?: string;
/**
 * Field to order results by
 */
order_by?: string;
/**
 * Order direction (ASC or DESC)
 */
order_direction?: GetServiceTypeOrderDirection;
};

export type GetServiceTypeOrderDirection = typeof GetServiceTypeOrderDirection[keyof typeof GetServiceTypeOrderDirection];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetServiceTypeOrderDirection = {
  ASC: 'ASC',
  DESC: 'DESC',
} as const;

export type GetServiceType200 = {
  data?: ServiceType[];
  total_pages?: number;
  page?: number;
  total_elements?: number;
};

export type PostServiceType200 = {
  data?: ServiceType[];
  message?: string;
};

export type GetServiceTypeId200 = {
  data?: ServiceType;
};

export type PutServiceTypeId200 = {
  data?: ServiceType[];
  message?: string;
};

export type PatchServiceTypeId200 = {
  data?: ServiceType[];
  message?: string;
};

export type DeleteServiceTypeId200 = {
  message?: string;
};

export type GetServiceGroupParams = {
/**
 * Page number for pagination
 */
page?: number;
/**
 * Number of records per page
 */
limit?: number;
/**
 * Tables to join with format 'table1,field1,table2,field2'
 */
expand?: string;
/**
 * Field to order results by
 */
order_by?: string;
/**
 * Order direction (ASC or DESC)
 */
order_direction?: GetServiceGroupOrderDirection;
};

export type GetServiceGroupOrderDirection = typeof GetServiceGroupOrderDirection[keyof typeof GetServiceGroupOrderDirection];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetServiceGroupOrderDirection = {
  ASC: 'ASC',
  DESC: 'DESC',
} as const;

export type GetServiceGroup200 = {
  data?: ServiceGroup[];
  total_pages?: number;
  page?: number;
  total_elements?: number;
};

export type PostServiceGroup200 = {
  data?: ServiceGroup[];
  message?: string;
};

export type GetServiceGroupId200 = {
  data?: ServiceGroup;
};

export type PutServiceGroupId200 = {
  data?: ServiceGroup[];
  message?: string;
};

export type PatchServiceGroupId200 = {
  data?: ServiceGroup[];
  message?: string;
};

export type DeleteServiceGroupId200 = {
  message?: string;
};

export type GetServiceStatusParams = {
/**
 * Page number for pagination
 */
page?: number;
/**
 * Number of records per page
 */
limit?: number;
/**
 * Tables to join with format 'table1,field1,table2,field2'
 */
expand?: string;
/**
 * Field to order results by
 */
order_by?: string;
/**
 * Order direction (ASC or DESC)
 */
order_direction?: GetServiceStatusOrderDirection;
};

export type GetServiceStatusOrderDirection = typeof GetServiceStatusOrderDirection[keyof typeof GetServiceStatusOrderDirection];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetServiceStatusOrderDirection = {
  ASC: 'ASC',
  DESC: 'DESC',
} as const;

export type GetServiceStatus200 = {
  data?: ServiceStatus[];
  total_pages?: number;
  page?: number;
  total_elements?: number;
};

export type PostServiceStatus200 = {
  data?: ServiceStatus[];
  message?: string;
};

export type GetServiceStatusId200 = {
  data?: ServiceStatus;
};

export type PutServiceStatusId200 = {
  data?: ServiceStatus[];
  message?: string;
};

export type PatchServiceStatusId200 = {
  data?: ServiceStatus[];
  message?: string;
};

export type DeleteServiceStatusId200 = {
  message?: string;
};

export type GetServiceParams = {
/**
 * Page number for pagination
 */
page?: number;
/**
 * Number of records per page
 */
limit?: number;
/**
 * Tables to join with format 'table1,field1,table2,field2'
 */
expand?: string;
/**
 * Field to order results by
 */
order_by?: string;
/**
 * Order direction (ASC or DESC)
 */
order_direction?: GetServiceOrderDirection;
};

export type GetServiceOrderDirection = typeof GetServiceOrderDirection[keyof typeof GetServiceOrderDirection];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetServiceOrderDirection = {
  ASC: 'ASC',
  DESC: 'DESC',
} as const;

export type GetService200 = {
  data?: Service[];
  total_pages?: number;
  page?: number;
  total_elements?: number;
};

export type PostService200 = {
  data?: Service[];
  message?: string;
};

export type GetServiceId200 = {
  data?: Service;
};

export type PutServiceId200 = {
  data?: Service[];
  message?: string;
};

export type PatchServiceId200 = {
  data?: Service[];
  message?: string;
};

export type DeleteServiceId200 = {
  message?: string;
};

export type GetUserContractsParams = {
/**
 * Page number for pagination
 */
page?: number;
/**
 * Number of records per page
 */
limit?: number;
/**
 * Tables to join with format 'table1,field1,table2,field2'
 */
expand?: string;
/**
 * Field to order results by
 */
order_by?: string;
/**
 * Order direction (ASC or DESC)
 */
order_direction?: GetUserContractsOrderDirection;
};

export type GetUserContractsOrderDirection = typeof GetUserContractsOrderDirection[keyof typeof GetUserContractsOrderDirection];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetUserContractsOrderDirection = {
  ASC: 'ASC',
  DESC: 'DESC',
} as const;

export type GetUserContracts200 = {
  data?: UserContracts[];
  total_pages?: number;
  page?: number;
  total_elements?: number;
};

export type PostUserContracts200 = {
  data?: UserContracts[];
  message?: string;
};

export type GetUserContractsId200 = {
  data?: UserContracts;
};

export type PutUserContractsId200 = {
  data?: UserContracts[];
  message?: string;
};

export type PatchUserContractsId200 = {
  data?: UserContracts[];
  message?: string;
};

export type DeleteUserContractsId200 = {
  message?: string;
};

export type GetEventPhoneNumbersParams = {
/**
 * Page number for pagination
 */
page?: number;
/**
 * Number of records per page
 */
limit?: number;
/**
 * Tables to join with format 'table1,field1,table2,field2'
 */
expand?: string;
/**
 * Field to order results by
 */
order_by?: string;
/**
 * Order direction (ASC or DESC)
 */
order_direction?: GetEventPhoneNumbersOrderDirection;
};

export type GetEventPhoneNumbersOrderDirection = typeof GetEventPhoneNumbersOrderDirection[keyof typeof GetEventPhoneNumbersOrderDirection];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetEventPhoneNumbersOrderDirection = {
  ASC: 'ASC',
  DESC: 'DESC',
} as const;

export type GetEventPhoneNumbers200 = {
  data?: EventPhoneNumbers[];
  total_pages?: number;
  page?: number;
  total_elements?: number;
};

export type PostEventPhoneNumbers200 = {
  data?: EventPhoneNumbers[];
  message?: string;
};

export type GetEventPhoneNumbersId200 = {
  data?: EventPhoneNumbers;
};

export type PutEventPhoneNumbersId200 = {
  data?: EventPhoneNumbers[];
  message?: string;
};

export type PatchEventPhoneNumbersId200 = {
  data?: EventPhoneNumbers[];
  message?: string;
};

export type DeleteEventPhoneNumbersId200 = {
  message?: string;
};

export type GetEventTicketsParams = {
/**
 * Page number for pagination
 */
page?: number;
/**
 * Number of records per page
 */
limit?: number;
/**
 * Tables to join with format 'table1,field1,table2,field2'
 */
expand?: string;
/**
 * Field to order results by
 */
order_by?: string;
/**
 * Order direction (ASC or DESC)
 */
order_direction?: GetEventTicketsOrderDirection;
};

export type GetEventTicketsOrderDirection = typeof GetEventTicketsOrderDirection[keyof typeof GetEventTicketsOrderDirection];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetEventTicketsOrderDirection = {
  ASC: 'ASC',
  DESC: 'DESC',
} as const;

export type GetEventTickets200 = {
  data?: EventTickets[];
  total_pages?: number;
  page?: number;
  total_elements?: number;
};

export type PostEventTickets200 = {
  data?: EventTickets[];
  message?: string;
};

export type GetEventTicketsId200 = {
  data?: EventTickets;
};

export type PutEventTicketsId200 = {
  data?: EventTickets[];
  message?: string;
};

export type PatchEventTicketsId200 = {
  data?: EventTickets[];
  message?: string;
};

export type DeleteEventTicketsId200 = {
  message?: string;
};

export type GetOpenCrudEndpointParams = {
/**
 * Page number for pagination
 */
page?: number;
/**
 * Number of records per page
 */
limit?: number;
/**
 * Tables to join with format 'table1,field1,table2,field2'
 */
expand?: string;
/**
 * Field to order results by
 */
order_by?: string;
/**
 * Order direction (ASC or DESC)
 */
order_direction?: GetOpenCrudEndpointOrderDirection;
};

export type GetOpenCrudEndpointOrderDirection = typeof GetOpenCrudEndpointOrderDirection[keyof typeof GetOpenCrudEndpointOrderDirection];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetOpenCrudEndpointOrderDirection = {
  ASC: 'ASC',
  DESC: 'DESC',
} as const;

export type GetOpenCrudEndpoint200 = {
  data?: OpenCrudEndpoint[];
  total_pages?: number;
  page?: number;
  total_elements?: number;
};

export type PostOpenCrudEndpoint200 = {
  data?: OpenCrudEndpoint[];
  message?: string;
};

export type GetOpenCrudEndpointId200 = {
  data?: OpenCrudEndpoint;
};

export type PutOpenCrudEndpointId200 = {
  data?: OpenCrudEndpoint[];
  message?: string;
};

export type PatchOpenCrudEndpointId200 = {
  data?: OpenCrudEndpoint[];
  message?: string;
};

export type DeleteOpenCrudEndpointId200 = {
  message?: string;
};

export type GetCapCanaAccessCardParams = {
/**
 * Page number for pagination
 */
page?: number;
/**
 * Number of records per page
 */
limit?: number;
/**
 * Tables to join with format 'table1,field1,table2,field2'
 */
expand?: string;
/**
 * Field to order results by
 */
order_by?: string;
/**
 * Order direction (ASC or DESC)
 */
order_direction?: GetCapCanaAccessCardOrderDirection;
};

export type GetCapCanaAccessCardOrderDirection = typeof GetCapCanaAccessCardOrderDirection[keyof typeof GetCapCanaAccessCardOrderDirection];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetCapCanaAccessCardOrderDirection = {
  ASC: 'ASC',
  DESC: 'DESC',
} as const;

export type GetCapCanaAccessCard200 = {
  data?: CapCanaAccessCard[];
  total_pages?: number;
  page?: number;
  total_elements?: number;
};

export type PostCapCanaAccessCard200 = {
  data?: CapCanaAccessCard[];
  message?: string;
};

export type GetCapCanaAccessCardId200 = {
  data?: CapCanaAccessCard;
};

export type PutCapCanaAccessCardId200 = {
  data?: CapCanaAccessCard[];
  message?: string;
};

export type PatchCapCanaAccessCardId200 = {
  data?: CapCanaAccessCard[];
  message?: string;
};

export type DeleteCapCanaAccessCardId200 = {
  message?: string;
};

export type GetAdminUsersParams = {
/**
 * Page number for pagination
 */
page?: number;
/**
 * Number of records per page
 */
limit?: number;
/**
 * Tables to join with format 'table1,field1,table2,field2'
 */
expand?: string;
/**
 * Field to order results by
 */
order_by?: string;
/**
 * Order direction (ASC or DESC)
 */
order_direction?: GetAdminUsersOrderDirection;
};

export type GetAdminUsersOrderDirection = typeof GetAdminUsersOrderDirection[keyof typeof GetAdminUsersOrderDirection];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetAdminUsersOrderDirection = {
  ASC: 'ASC',
  DESC: 'DESC',
} as const;

export type GetAdminUsers200 = {
  data?: AdminUsers[];
  total_pages?: number;
  page?: number;
  total_elements?: number;
};

export type PostAdminUsers200 = {
  data?: AdminUsers[];
  message?: string;
};

export type GetAdminUsersId200 = {
  data?: AdminUsers;
};

export type PutAdminUsersId200 = {
  data?: AdminUsers[];
  message?: string;
};

export type PatchAdminUsersId200 = {
  data?: AdminUsers[];
  message?: string;
};

export type DeleteAdminUsersId200 = {
  message?: string;
};

export type GetTransactionParams = {
/**
 * Page number for pagination
 */
page?: number;
/**
 * Number of records per page
 */
limit?: number;
/**
 * Tables to join with format 'table1,field1,table2,field2'
 */
expand?: string;
/**
 * Field to order results by
 */
order_by?: string;
/**
 * Order direction (ASC or DESC)
 */
order_direction?: GetTransactionOrderDirection;
};

export type GetTransactionOrderDirection = typeof GetTransactionOrderDirection[keyof typeof GetTransactionOrderDirection];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetTransactionOrderDirection = {
  ASC: 'ASC',
  DESC: 'DESC',
} as const;

export type GetTransaction200 = {
  data?: Transaction[];
  total_pages?: number;
  page?: number;
  total_elements?: number;
};

export type PostTransaction200 = {
  data?: Transaction[];
  message?: string;
};

export type GetTransactionId200 = {
  data?: Transaction;
};

export type PutTransactionId200 = {
  data?: Transaction[];
  message?: string;
};

export type PatchTransactionId200 = {
  data?: Transaction[];
  message?: string;
};

export type DeleteTransactionId200 = {
  message?: string;
};

export type GetBusinessMappingParams = {
/**
 * Page number for pagination
 */
page?: number;
/**
 * Number of records per page
 */
limit?: number;
/**
 * Tables to join with format 'table1,field1,table2,field2'
 */
expand?: string;
/**
 * Field to order results by
 */
order_by?: string;
/**
 * Order direction (ASC or DESC)
 */
order_direction?: GetBusinessMappingOrderDirection;
};

export type GetBusinessMappingOrderDirection = typeof GetBusinessMappingOrderDirection[keyof typeof GetBusinessMappingOrderDirection];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetBusinessMappingOrderDirection = {
  ASC: 'ASC',
  DESC: 'DESC',
} as const;

export type GetBusinessMapping200 = {
  data?: BusinessMapping[];
  total_pages?: number;
  page?: number;
  total_elements?: number;
};

export type PostBusinessMapping200 = {
  data?: BusinessMapping[];
  message?: string;
};

export type GetBusinessMappingId200 = {
  data?: BusinessMapping;
};

export type PutBusinessMappingId200 = {
  data?: BusinessMapping[];
  message?: string;
};

export type PatchBusinessMappingId200 = {
  data?: BusinessMapping[];
  message?: string;
};

export type DeleteBusinessMappingId200 = {
  message?: string;
};

export type GetTransactionsParams = {
/**
 * Page number for pagination
 */
page?: number;
/**
 * Number of records per page
 */
limit?: number;
/**
 * Tables to join with format 'table1,field1,table2,field2'
 */
expand?: string;
/**
 * Field to order results by
 */
order_by?: string;
/**
 * Order direction (ASC or DESC)
 */
order_direction?: GetTransactionsOrderDirection;
};

export type GetTransactionsOrderDirection = typeof GetTransactionsOrderDirection[keyof typeof GetTransactionsOrderDirection];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetTransactionsOrderDirection = {
  ASC: 'ASC',
  DESC: 'DESC',
} as const;

export type GetTransactions200 = {
  data?: Transactions[];
  total_pages?: number;
  page?: number;
  total_elements?: number;
};

export type PostTransactions200 = {
  data?: Transactions[];
  message?: string;
};

export type GetTransactionsId200 = {
  data?: Transactions;
};

export type PutTransactionsId200 = {
  data?: Transactions[];
  message?: string;
};

export type PatchTransactionsId200 = {
  data?: Transactions[];
  message?: string;
};

export type DeleteTransactionsId200 = {
  message?: string;
};

export type GetBookingStatusParams = {
/**
 * Page number for pagination
 */
page?: number;
/**
 * Number of records per page
 */
limit?: number;
/**
 * Tables to join with format 'table1,field1,table2,field2'
 */
expand?: string;
/**
 * Field to order results by
 */
order_by?: string;
/**
 * Order direction (ASC or DESC)
 */
order_direction?: GetBookingStatusOrderDirection;
};

export type GetBookingStatusOrderDirection = typeof GetBookingStatusOrderDirection[keyof typeof GetBookingStatusOrderDirection];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetBookingStatusOrderDirection = {
  ASC: 'ASC',
  DESC: 'DESC',
} as const;

export type GetBookingStatus200 = {
  data?: BookingStatus[];
  total_pages?: number;
  page?: number;
  total_elements?: number;
};

export type PostBookingStatus200 = {
  data?: BookingStatus[];
  message?: string;
};

export type GetBookingStatusId200 = {
  data?: BookingStatus;
};

export type PutBookingStatusId200 = {
  data?: BookingStatus[];
  message?: string;
};

export type PatchBookingStatusId200 = {
  data?: BookingStatus[];
  message?: string;
};

export type DeleteBookingStatusId200 = {
  message?: string;
};

export type GetBookingParams = {
/**
 * Page number for pagination
 */
page?: number;
/**
 * Number of records per page
 */
limit?: number;
/**
 * Tables to join with format 'table1,field1,table2,field2'
 */
expand?: string;
/**
 * Field to order results by
 */
order_by?: string;
/**
 * Order direction (ASC or DESC)
 */
order_direction?: GetBookingOrderDirection;
};

export type GetBookingOrderDirection = typeof GetBookingOrderDirection[keyof typeof GetBookingOrderDirection];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetBookingOrderDirection = {
  ASC: 'ASC',
  DESC: 'DESC',
} as const;

export type GetBooking200 = {
  data?: Booking[];
  total_pages?: number;
  page?: number;
  total_elements?: number;
};

export type PostBooking200 = {
  data?: Booking[];
  message?: string;
};

export type GetBookingId200 = {
  data?: Booking;
};

export type PutBookingId200 = {
  data?: Booking[];
  message?: string;
};

export type PatchBookingId200 = {
  data?: Booking[];
  message?: string;
};

export type DeleteBookingId200 = {
  message?: string;
};

/**
 * Returns a list of user_type records with pagination
 * @summary Get all user_type records
 */
export const getUserType = (
    params?: GetUserTypeParams,
 signal?: AbortSignal
) => {
      
      
      return defaultInstance<GetUserType200>(
      {url: `/user_type`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getGetUserTypeQueryKey = (params?: GetUserTypeParams,) => {
    return [`/user_type`, ...(params ? [params]: [])] as const;
    }

    
export const getGetUserTypeQueryOptions = <TData = Awaited<ReturnType<typeof getUserType>>, TError = void>(params?: GetUserTypeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserType>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUserTypeQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUserType>>> = ({ signal }) => getUserType(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getUserType>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetUserTypeQueryResult = NonNullable<Awaited<ReturnType<typeof getUserType>>>
export type GetUserTypeQueryError = void


export function useGetUserType<TData = Awaited<ReturnType<typeof getUserType>>, TError = void>(
 params: undefined |  GetUserTypeParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserType>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserType>>,
          TError,
          Awaited<ReturnType<typeof getUserType>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUserType<TData = Awaited<ReturnType<typeof getUserType>>, TError = void>(
 params?: GetUserTypeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserType>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserType>>,
          TError,
          Awaited<ReturnType<typeof getUserType>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUserType<TData = Awaited<ReturnType<typeof getUserType>>, TError = void>(
 params?: GetUserTypeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserType>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get all user_type records
 */

export function useGetUserType<TData = Awaited<ReturnType<typeof getUserType>>, TError = void>(
 params?: GetUserTypeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserType>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetUserTypeQueryOptions(params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Creates a new user_type record
 * @summary Create a new user_type record
 */
export const postUserType = (
    userType: UserType,
 signal?: AbortSignal
) => {
      
      
      return defaultInstance<PostUserType200>(
      {url: `/user_type`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: userType, signal
    },
      );
    }
  


export const getPostUserTypeMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postUserType>>, TError,{data: UserType}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postUserType>>, TError,{data: UserType}, TContext> => {
    
const mutationKey = ['postUserType'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postUserType>>, {data: UserType}> = (props) => {
          const {data} = props ?? {};

          return  postUserType(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostUserTypeMutationResult = NonNullable<Awaited<ReturnType<typeof postUserType>>>
    export type PostUserTypeMutationBody = UserType
    export type PostUserTypeMutationError = void

    /**
 * @summary Create a new user_type record
 */
export const usePostUserType = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postUserType>>, TError,{data: UserType}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postUserType>>,
        TError,
        {data: UserType},
        TContext
      > => {

      const mutationOptions = getPostUserTypeMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Returns a single user_type record by ID
 * @summary Get a specific user_type record
 */
export const getUserTypeId = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return defaultInstance<GetUserTypeId200>(
      {url: `/user_type/${id}`, method: 'GET', signal
    },
      );
    }
  

export const getGetUserTypeIdQueryKey = (id: string,) => {
    return [`/user_type/${id}`] as const;
    }

    
export const getGetUserTypeIdQueryOptions = <TData = Awaited<ReturnType<typeof getUserTypeId>>, TError = void>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserTypeId>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUserTypeIdQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUserTypeId>>> = ({ signal }) => getUserTypeId(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getUserTypeId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetUserTypeIdQueryResult = NonNullable<Awaited<ReturnType<typeof getUserTypeId>>>
export type GetUserTypeIdQueryError = void


export function useGetUserTypeId<TData = Awaited<ReturnType<typeof getUserTypeId>>, TError = void>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserTypeId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserTypeId>>,
          TError,
          Awaited<ReturnType<typeof getUserTypeId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUserTypeId<TData = Awaited<ReturnType<typeof getUserTypeId>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserTypeId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserTypeId>>,
          TError,
          Awaited<ReturnType<typeof getUserTypeId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUserTypeId<TData = Awaited<ReturnType<typeof getUserTypeId>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserTypeId>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get a specific user_type record
 */

export function useGetUserTypeId<TData = Awaited<ReturnType<typeof getUserTypeId>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserTypeId>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetUserTypeIdQueryOptions(id,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Updates an existing user_type record
 * @summary Update a user_type record
 */
export const putUserTypeId = (
    id: string,
    userType: UserType,
 ) => {
      
      
      return defaultInstance<PutUserTypeId200>(
      {url: `/user_type/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: userType
    },
      );
    }
  


export const getPutUserTypeIdMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putUserTypeId>>, TError,{id: string;data: UserType}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof putUserTypeId>>, TError,{id: string;data: UserType}, TContext> => {
    
const mutationKey = ['putUserTypeId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putUserTypeId>>, {id: string;data: UserType}> = (props) => {
          const {id,data} = props ?? {};

          return  putUserTypeId(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutUserTypeIdMutationResult = NonNullable<Awaited<ReturnType<typeof putUserTypeId>>>
    export type PutUserTypeIdMutationBody = UserType
    export type PutUserTypeIdMutationError = void

    /**
 * @summary Update a user_type record
 */
export const usePutUserTypeId = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putUserTypeId>>, TError,{id: string;data: UserType}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putUserTypeId>>,
        TError,
        {id: string;data: UserType},
        TContext
      > => {

      const mutationOptions = getPutUserTypeIdMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Partially updates an existing user_type record
 * @summary Partially update a user_type record
 */
export const patchUserTypeId = (
    id: string,
    userType: UserType,
 ) => {
      
      
      return defaultInstance<PatchUserTypeId200>(
      {url: `/user_type/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: userType
    },
      );
    }
  


export const getPatchUserTypeIdMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchUserTypeId>>, TError,{id: string;data: UserType}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof patchUserTypeId>>, TError,{id: string;data: UserType}, TContext> => {
    
const mutationKey = ['patchUserTypeId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchUserTypeId>>, {id: string;data: UserType}> = (props) => {
          const {id,data} = props ?? {};

          return  patchUserTypeId(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PatchUserTypeIdMutationResult = NonNullable<Awaited<ReturnType<typeof patchUserTypeId>>>
    export type PatchUserTypeIdMutationBody = UserType
    export type PatchUserTypeIdMutationError = void

    /**
 * @summary Partially update a user_type record
 */
export const usePatchUserTypeId = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchUserTypeId>>, TError,{id: string;data: UserType}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patchUserTypeId>>,
        TError,
        {id: string;data: UserType},
        TContext
      > => {

      const mutationOptions = getPatchUserTypeIdMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Deletes a user_type record
 * @summary Delete a user_type record
 */
export const deleteUserTypeId = (
    id: string,
 ) => {
      
      
      return defaultInstance<DeleteUserTypeId200>(
      {url: `/user_type/${id}`, method: 'DELETE'
    },
      );
    }
  


export const getDeleteUserTypeIdMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteUserTypeId>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteUserTypeId>>, TError,{id: string}, TContext> => {
    
const mutationKey = ['deleteUserTypeId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteUserTypeId>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteUserTypeId(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteUserTypeIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteUserTypeId>>>
    
    export type DeleteUserTypeIdMutationError = void

    /**
 * @summary Delete a user_type record
 */
export const useDeleteUserTypeId = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteUserTypeId>>, TError,{id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteUserTypeId>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getDeleteUserTypeIdMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Returns a list of user records with pagination
 * @summary Get all user records
 */
export const getUser = (
    params?: GetUserParams,
 signal?: AbortSignal
) => {
      
      
      return defaultInstance<GetUser200>(
      {url: `/user`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getGetUserQueryKey = (params?: GetUserParams,) => {
    return [`/user`, ...(params ? [params]: [])] as const;
    }

    
export const getGetUserQueryOptions = <TData = Awaited<ReturnType<typeof getUser>>, TError = void>(params?: GetUserParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUser>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUserQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUser>>> = ({ signal }) => getUser(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getUser>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetUserQueryResult = NonNullable<Awaited<ReturnType<typeof getUser>>>
export type GetUserQueryError = void


export function useGetUser<TData = Awaited<ReturnType<typeof getUser>>, TError = void>(
 params: undefined |  GetUserParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUser>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUser>>,
          TError,
          Awaited<ReturnType<typeof getUser>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUser<TData = Awaited<ReturnType<typeof getUser>>, TError = void>(
 params?: GetUserParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUser>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUser>>,
          TError,
          Awaited<ReturnType<typeof getUser>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUser<TData = Awaited<ReturnType<typeof getUser>>, TError = void>(
 params?: GetUserParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUser>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get all user records
 */

export function useGetUser<TData = Awaited<ReturnType<typeof getUser>>, TError = void>(
 params?: GetUserParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUser>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetUserQueryOptions(params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Creates a new user record
 * @summary Create a new user record
 */
export const postUser = (
    user: User,
 signal?: AbortSignal
) => {
      
      
      return defaultInstance<PostUser200>(
      {url: `/user`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: user, signal
    },
      );
    }
  


export const getPostUserMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postUser>>, TError,{data: User}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postUser>>, TError,{data: User}, TContext> => {
    
const mutationKey = ['postUser'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postUser>>, {data: User}> = (props) => {
          const {data} = props ?? {};

          return  postUser(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostUserMutationResult = NonNullable<Awaited<ReturnType<typeof postUser>>>
    export type PostUserMutationBody = User
    export type PostUserMutationError = void

    /**
 * @summary Create a new user record
 */
export const usePostUser = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postUser>>, TError,{data: User}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postUser>>,
        TError,
        {data: User},
        TContext
      > => {

      const mutationOptions = getPostUserMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Returns a single user record by ID
 * @summary Get a specific user record
 */
export const getUserId = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return defaultInstance<GetUserId200>(
      {url: `/user/${id}`, method: 'GET', signal
    },
      );
    }
  

export const getGetUserIdQueryKey = (id: string,) => {
    return [`/user/${id}`] as const;
    }

    
export const getGetUserIdQueryOptions = <TData = Awaited<ReturnType<typeof getUserId>>, TError = void>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserId>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUserIdQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUserId>>> = ({ signal }) => getUserId(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getUserId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetUserIdQueryResult = NonNullable<Awaited<ReturnType<typeof getUserId>>>
export type GetUserIdQueryError = void


export function useGetUserId<TData = Awaited<ReturnType<typeof getUserId>>, TError = void>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserId>>,
          TError,
          Awaited<ReturnType<typeof getUserId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUserId<TData = Awaited<ReturnType<typeof getUserId>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserId>>,
          TError,
          Awaited<ReturnType<typeof getUserId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUserId<TData = Awaited<ReturnType<typeof getUserId>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserId>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get a specific user record
 */

export function useGetUserId<TData = Awaited<ReturnType<typeof getUserId>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserId>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetUserIdQueryOptions(id,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Updates an existing user record
 * @summary Update a user record
 */
export const putUserId = (
    id: string,
    user: User,
 ) => {
      
      
      return defaultInstance<PutUserId200>(
      {url: `/user/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: user
    },
      );
    }
  


export const getPutUserIdMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putUserId>>, TError,{id: string;data: User}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof putUserId>>, TError,{id: string;data: User}, TContext> => {
    
const mutationKey = ['putUserId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putUserId>>, {id: string;data: User}> = (props) => {
          const {id,data} = props ?? {};

          return  putUserId(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutUserIdMutationResult = NonNullable<Awaited<ReturnType<typeof putUserId>>>
    export type PutUserIdMutationBody = User
    export type PutUserIdMutationError = void

    /**
 * @summary Update a user record
 */
export const usePutUserId = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putUserId>>, TError,{id: string;data: User}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putUserId>>,
        TError,
        {id: string;data: User},
        TContext
      > => {

      const mutationOptions = getPutUserIdMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Partially updates an existing user record
 * @summary Partially update a user record
 */
export const patchUserId = (
    id: string,
    user: User,
 ) => {
      
      
      return defaultInstance<PatchUserId200>(
      {url: `/user/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: user
    },
      );
    }
  


export const getPatchUserIdMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchUserId>>, TError,{id: string;data: User}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof patchUserId>>, TError,{id: string;data: User}, TContext> => {
    
const mutationKey = ['patchUserId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchUserId>>, {id: string;data: User}> = (props) => {
          const {id,data} = props ?? {};

          return  patchUserId(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PatchUserIdMutationResult = NonNullable<Awaited<ReturnType<typeof patchUserId>>>
    export type PatchUserIdMutationBody = User
    export type PatchUserIdMutationError = void

    /**
 * @summary Partially update a user record
 */
export const usePatchUserId = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchUserId>>, TError,{id: string;data: User}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patchUserId>>,
        TError,
        {id: string;data: User},
        TContext
      > => {

      const mutationOptions = getPatchUserIdMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Deletes a user record
 * @summary Delete a user record
 */
export const deleteUserId = (
    id: string,
 ) => {
      
      
      return defaultInstance<DeleteUserId200>(
      {url: `/user/${id}`, method: 'DELETE'
    },
      );
    }
  


export const getDeleteUserIdMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteUserId>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteUserId>>, TError,{id: string}, TContext> => {
    
const mutationKey = ['deleteUserId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteUserId>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteUserId(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteUserIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteUserId>>>
    
    export type DeleteUserIdMutationError = void

    /**
 * @summary Delete a user record
 */
export const useDeleteUserId = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteUserId>>, TError,{id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteUserId>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getDeleteUserIdMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Returns a list of invitation_status records with pagination
 * @summary Get all invitation_status records
 */
export const getInvitationStatus = (
    params?: GetInvitationStatusParams,
 signal?: AbortSignal
) => {
      
      
      return defaultInstance<GetInvitationStatus200>(
      {url: `/invitation_status`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getGetInvitationStatusQueryKey = (params?: GetInvitationStatusParams,) => {
    return [`/invitation_status`, ...(params ? [params]: [])] as const;
    }

    
export const getGetInvitationStatusQueryOptions = <TData = Awaited<ReturnType<typeof getInvitationStatus>>, TError = void>(params?: GetInvitationStatusParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInvitationStatus>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetInvitationStatusQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getInvitationStatus>>> = ({ signal }) => getInvitationStatus(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getInvitationStatus>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetInvitationStatusQueryResult = NonNullable<Awaited<ReturnType<typeof getInvitationStatus>>>
export type GetInvitationStatusQueryError = void


export function useGetInvitationStatus<TData = Awaited<ReturnType<typeof getInvitationStatus>>, TError = void>(
 params: undefined |  GetInvitationStatusParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInvitationStatus>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getInvitationStatus>>,
          TError,
          Awaited<ReturnType<typeof getInvitationStatus>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetInvitationStatus<TData = Awaited<ReturnType<typeof getInvitationStatus>>, TError = void>(
 params?: GetInvitationStatusParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInvitationStatus>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getInvitationStatus>>,
          TError,
          Awaited<ReturnType<typeof getInvitationStatus>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetInvitationStatus<TData = Awaited<ReturnType<typeof getInvitationStatus>>, TError = void>(
 params?: GetInvitationStatusParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInvitationStatus>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get all invitation_status records
 */

export function useGetInvitationStatus<TData = Awaited<ReturnType<typeof getInvitationStatus>>, TError = void>(
 params?: GetInvitationStatusParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInvitationStatus>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetInvitationStatusQueryOptions(params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Creates a new invitation_status record
 * @summary Create a new invitation_status record
 */
export const postInvitationStatus = (
    invitationStatus: InvitationStatus,
 signal?: AbortSignal
) => {
      
      
      return defaultInstance<PostInvitationStatus200>(
      {url: `/invitation_status`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: invitationStatus, signal
    },
      );
    }
  


export const getPostInvitationStatusMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postInvitationStatus>>, TError,{data: InvitationStatus}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postInvitationStatus>>, TError,{data: InvitationStatus}, TContext> => {
    
const mutationKey = ['postInvitationStatus'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postInvitationStatus>>, {data: InvitationStatus}> = (props) => {
          const {data} = props ?? {};

          return  postInvitationStatus(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostInvitationStatusMutationResult = NonNullable<Awaited<ReturnType<typeof postInvitationStatus>>>
    export type PostInvitationStatusMutationBody = InvitationStatus
    export type PostInvitationStatusMutationError = void

    /**
 * @summary Create a new invitation_status record
 */
export const usePostInvitationStatus = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postInvitationStatus>>, TError,{data: InvitationStatus}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postInvitationStatus>>,
        TError,
        {data: InvitationStatus},
        TContext
      > => {

      const mutationOptions = getPostInvitationStatusMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Returns a single invitation_status record by ID
 * @summary Get a specific invitation_status record
 */
export const getInvitationStatusId = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return defaultInstance<GetInvitationStatusId200>(
      {url: `/invitation_status/${id}`, method: 'GET', signal
    },
      );
    }
  

export const getGetInvitationStatusIdQueryKey = (id: string,) => {
    return [`/invitation_status/${id}`] as const;
    }

    
export const getGetInvitationStatusIdQueryOptions = <TData = Awaited<ReturnType<typeof getInvitationStatusId>>, TError = void>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInvitationStatusId>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetInvitationStatusIdQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getInvitationStatusId>>> = ({ signal }) => getInvitationStatusId(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getInvitationStatusId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetInvitationStatusIdQueryResult = NonNullable<Awaited<ReturnType<typeof getInvitationStatusId>>>
export type GetInvitationStatusIdQueryError = void


export function useGetInvitationStatusId<TData = Awaited<ReturnType<typeof getInvitationStatusId>>, TError = void>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInvitationStatusId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getInvitationStatusId>>,
          TError,
          Awaited<ReturnType<typeof getInvitationStatusId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetInvitationStatusId<TData = Awaited<ReturnType<typeof getInvitationStatusId>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInvitationStatusId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getInvitationStatusId>>,
          TError,
          Awaited<ReturnType<typeof getInvitationStatusId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetInvitationStatusId<TData = Awaited<ReturnType<typeof getInvitationStatusId>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInvitationStatusId>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get a specific invitation_status record
 */

export function useGetInvitationStatusId<TData = Awaited<ReturnType<typeof getInvitationStatusId>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInvitationStatusId>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetInvitationStatusIdQueryOptions(id,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Updates an existing invitation_status record
 * @summary Update a invitation_status record
 */
export const putInvitationStatusId = (
    id: string,
    invitationStatus: InvitationStatus,
 ) => {
      
      
      return defaultInstance<PutInvitationStatusId200>(
      {url: `/invitation_status/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: invitationStatus
    },
      );
    }
  


export const getPutInvitationStatusIdMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putInvitationStatusId>>, TError,{id: string;data: InvitationStatus}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof putInvitationStatusId>>, TError,{id: string;data: InvitationStatus}, TContext> => {
    
const mutationKey = ['putInvitationStatusId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putInvitationStatusId>>, {id: string;data: InvitationStatus}> = (props) => {
          const {id,data} = props ?? {};

          return  putInvitationStatusId(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutInvitationStatusIdMutationResult = NonNullable<Awaited<ReturnType<typeof putInvitationStatusId>>>
    export type PutInvitationStatusIdMutationBody = InvitationStatus
    export type PutInvitationStatusIdMutationError = void

    /**
 * @summary Update a invitation_status record
 */
export const usePutInvitationStatusId = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putInvitationStatusId>>, TError,{id: string;data: InvitationStatus}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putInvitationStatusId>>,
        TError,
        {id: string;data: InvitationStatus},
        TContext
      > => {

      const mutationOptions = getPutInvitationStatusIdMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Partially updates an existing invitation_status record
 * @summary Partially update a invitation_status record
 */
export const patchInvitationStatusId = (
    id: string,
    invitationStatus: InvitationStatus,
 ) => {
      
      
      return defaultInstance<PatchInvitationStatusId200>(
      {url: `/invitation_status/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: invitationStatus
    },
      );
    }
  


export const getPatchInvitationStatusIdMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchInvitationStatusId>>, TError,{id: string;data: InvitationStatus}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof patchInvitationStatusId>>, TError,{id: string;data: InvitationStatus}, TContext> => {
    
const mutationKey = ['patchInvitationStatusId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchInvitationStatusId>>, {id: string;data: InvitationStatus}> = (props) => {
          const {id,data} = props ?? {};

          return  patchInvitationStatusId(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PatchInvitationStatusIdMutationResult = NonNullable<Awaited<ReturnType<typeof patchInvitationStatusId>>>
    export type PatchInvitationStatusIdMutationBody = InvitationStatus
    export type PatchInvitationStatusIdMutationError = void

    /**
 * @summary Partially update a invitation_status record
 */
export const usePatchInvitationStatusId = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchInvitationStatusId>>, TError,{id: string;data: InvitationStatus}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patchInvitationStatusId>>,
        TError,
        {id: string;data: InvitationStatus},
        TContext
      > => {

      const mutationOptions = getPatchInvitationStatusIdMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Deletes a invitation_status record
 * @summary Delete a invitation_status record
 */
export const deleteInvitationStatusId = (
    id: string,
 ) => {
      
      
      return defaultInstance<DeleteInvitationStatusId200>(
      {url: `/invitation_status/${id}`, method: 'DELETE'
    },
      );
    }
  


export const getDeleteInvitationStatusIdMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteInvitationStatusId>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteInvitationStatusId>>, TError,{id: string}, TContext> => {
    
const mutationKey = ['deleteInvitationStatusId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteInvitationStatusId>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteInvitationStatusId(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteInvitationStatusIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteInvitationStatusId>>>
    
    export type DeleteInvitationStatusIdMutationError = void

    /**
 * @summary Delete a invitation_status record
 */
export const useDeleteInvitationStatusId = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteInvitationStatusId>>, TError,{id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteInvitationStatusId>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getDeleteInvitationStatusIdMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Returns a list of access_card_status records with pagination
 * @summary Get all access_card_status records
 */
export const getAccessCardStatus = (
    params?: GetAccessCardStatusParams,
 signal?: AbortSignal
) => {
      
      
      return defaultInstance<GetAccessCardStatus200>(
      {url: `/access_card_status`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getGetAccessCardStatusQueryKey = (params?: GetAccessCardStatusParams,) => {
    return [`/access_card_status`, ...(params ? [params]: [])] as const;
    }

    
export const getGetAccessCardStatusQueryOptions = <TData = Awaited<ReturnType<typeof getAccessCardStatus>>, TError = void>(params?: GetAccessCardStatusParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAccessCardStatus>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAccessCardStatusQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAccessCardStatus>>> = ({ signal }) => getAccessCardStatus(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAccessCardStatus>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAccessCardStatusQueryResult = NonNullable<Awaited<ReturnType<typeof getAccessCardStatus>>>
export type GetAccessCardStatusQueryError = void


export function useGetAccessCardStatus<TData = Awaited<ReturnType<typeof getAccessCardStatus>>, TError = void>(
 params: undefined |  GetAccessCardStatusParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAccessCardStatus>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAccessCardStatus>>,
          TError,
          Awaited<ReturnType<typeof getAccessCardStatus>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAccessCardStatus<TData = Awaited<ReturnType<typeof getAccessCardStatus>>, TError = void>(
 params?: GetAccessCardStatusParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAccessCardStatus>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAccessCardStatus>>,
          TError,
          Awaited<ReturnType<typeof getAccessCardStatus>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAccessCardStatus<TData = Awaited<ReturnType<typeof getAccessCardStatus>>, TError = void>(
 params?: GetAccessCardStatusParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAccessCardStatus>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get all access_card_status records
 */

export function useGetAccessCardStatus<TData = Awaited<ReturnType<typeof getAccessCardStatus>>, TError = void>(
 params?: GetAccessCardStatusParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAccessCardStatus>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAccessCardStatusQueryOptions(params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Creates a new access_card_status record
 * @summary Create a new access_card_status record
 */
export const postAccessCardStatus = (
    accessCardStatus: AccessCardStatus,
 signal?: AbortSignal
) => {
      
      
      return defaultInstance<PostAccessCardStatus200>(
      {url: `/access_card_status`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: accessCardStatus, signal
    },
      );
    }
  


export const getPostAccessCardStatusMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAccessCardStatus>>, TError,{data: AccessCardStatus}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postAccessCardStatus>>, TError,{data: AccessCardStatus}, TContext> => {
    
const mutationKey = ['postAccessCardStatus'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postAccessCardStatus>>, {data: AccessCardStatus}> = (props) => {
          const {data} = props ?? {};

          return  postAccessCardStatus(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostAccessCardStatusMutationResult = NonNullable<Awaited<ReturnType<typeof postAccessCardStatus>>>
    export type PostAccessCardStatusMutationBody = AccessCardStatus
    export type PostAccessCardStatusMutationError = void

    /**
 * @summary Create a new access_card_status record
 */
export const usePostAccessCardStatus = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAccessCardStatus>>, TError,{data: AccessCardStatus}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postAccessCardStatus>>,
        TError,
        {data: AccessCardStatus},
        TContext
      > => {

      const mutationOptions = getPostAccessCardStatusMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Returns a single access_card_status record by ID
 * @summary Get a specific access_card_status record
 */
export const getAccessCardStatusId = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return defaultInstance<GetAccessCardStatusId200>(
      {url: `/access_card_status/${id}`, method: 'GET', signal
    },
      );
    }
  

export const getGetAccessCardStatusIdQueryKey = (id: string,) => {
    return [`/access_card_status/${id}`] as const;
    }

    
export const getGetAccessCardStatusIdQueryOptions = <TData = Awaited<ReturnType<typeof getAccessCardStatusId>>, TError = void>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAccessCardStatusId>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAccessCardStatusIdQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAccessCardStatusId>>> = ({ signal }) => getAccessCardStatusId(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAccessCardStatusId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAccessCardStatusIdQueryResult = NonNullable<Awaited<ReturnType<typeof getAccessCardStatusId>>>
export type GetAccessCardStatusIdQueryError = void


export function useGetAccessCardStatusId<TData = Awaited<ReturnType<typeof getAccessCardStatusId>>, TError = void>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAccessCardStatusId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAccessCardStatusId>>,
          TError,
          Awaited<ReturnType<typeof getAccessCardStatusId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAccessCardStatusId<TData = Awaited<ReturnType<typeof getAccessCardStatusId>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAccessCardStatusId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAccessCardStatusId>>,
          TError,
          Awaited<ReturnType<typeof getAccessCardStatusId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAccessCardStatusId<TData = Awaited<ReturnType<typeof getAccessCardStatusId>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAccessCardStatusId>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get a specific access_card_status record
 */

export function useGetAccessCardStatusId<TData = Awaited<ReturnType<typeof getAccessCardStatusId>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAccessCardStatusId>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAccessCardStatusIdQueryOptions(id,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Updates an existing access_card_status record
 * @summary Update a access_card_status record
 */
export const putAccessCardStatusId = (
    id: string,
    accessCardStatus: AccessCardStatus,
 ) => {
      
      
      return defaultInstance<PutAccessCardStatusId200>(
      {url: `/access_card_status/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: accessCardStatus
    },
      );
    }
  


export const getPutAccessCardStatusIdMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putAccessCardStatusId>>, TError,{id: string;data: AccessCardStatus}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof putAccessCardStatusId>>, TError,{id: string;data: AccessCardStatus}, TContext> => {
    
const mutationKey = ['putAccessCardStatusId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putAccessCardStatusId>>, {id: string;data: AccessCardStatus}> = (props) => {
          const {id,data} = props ?? {};

          return  putAccessCardStatusId(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutAccessCardStatusIdMutationResult = NonNullable<Awaited<ReturnType<typeof putAccessCardStatusId>>>
    export type PutAccessCardStatusIdMutationBody = AccessCardStatus
    export type PutAccessCardStatusIdMutationError = void

    /**
 * @summary Update a access_card_status record
 */
export const usePutAccessCardStatusId = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putAccessCardStatusId>>, TError,{id: string;data: AccessCardStatus}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putAccessCardStatusId>>,
        TError,
        {id: string;data: AccessCardStatus},
        TContext
      > => {

      const mutationOptions = getPutAccessCardStatusIdMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Partially updates an existing access_card_status record
 * @summary Partially update a access_card_status record
 */
export const patchAccessCardStatusId = (
    id: string,
    accessCardStatus: AccessCardStatus,
 ) => {
      
      
      return defaultInstance<PatchAccessCardStatusId200>(
      {url: `/access_card_status/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: accessCardStatus
    },
      );
    }
  


export const getPatchAccessCardStatusIdMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchAccessCardStatusId>>, TError,{id: string;data: AccessCardStatus}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof patchAccessCardStatusId>>, TError,{id: string;data: AccessCardStatus}, TContext> => {
    
const mutationKey = ['patchAccessCardStatusId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchAccessCardStatusId>>, {id: string;data: AccessCardStatus}> = (props) => {
          const {id,data} = props ?? {};

          return  patchAccessCardStatusId(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PatchAccessCardStatusIdMutationResult = NonNullable<Awaited<ReturnType<typeof patchAccessCardStatusId>>>
    export type PatchAccessCardStatusIdMutationBody = AccessCardStatus
    export type PatchAccessCardStatusIdMutationError = void

    /**
 * @summary Partially update a access_card_status record
 */
export const usePatchAccessCardStatusId = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchAccessCardStatusId>>, TError,{id: string;data: AccessCardStatus}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patchAccessCardStatusId>>,
        TError,
        {id: string;data: AccessCardStatus},
        TContext
      > => {

      const mutationOptions = getPatchAccessCardStatusIdMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Deletes a access_card_status record
 * @summary Delete a access_card_status record
 */
export const deleteAccessCardStatusId = (
    id: string,
 ) => {
      
      
      return defaultInstance<DeleteAccessCardStatusId200>(
      {url: `/access_card_status/${id}`, method: 'DELETE'
    },
      );
    }
  


export const getDeleteAccessCardStatusIdMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAccessCardStatusId>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteAccessCardStatusId>>, TError,{id: string}, TContext> => {
    
const mutationKey = ['deleteAccessCardStatusId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteAccessCardStatusId>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteAccessCardStatusId(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteAccessCardStatusIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteAccessCardStatusId>>>
    
    export type DeleteAccessCardStatusIdMutationError = void

    /**
 * @summary Delete a access_card_status record
 */
export const useDeleteAccessCardStatusId = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAccessCardStatusId>>, TError,{id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteAccessCardStatusId>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getDeleteAccessCardStatusIdMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Returns a list of contact records with pagination
 * @summary Get all contact records
 */
export const getContact = (
    params?: GetContactParams,
 signal?: AbortSignal
) => {
      
      
      return defaultInstance<GetContact200>(
      {url: `/contact`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getGetContactQueryKey = (params?: GetContactParams,) => {
    return [`/contact`, ...(params ? [params]: [])] as const;
    }

    
export const getGetContactQueryOptions = <TData = Awaited<ReturnType<typeof getContact>>, TError = void>(params?: GetContactParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getContact>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetContactQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getContact>>> = ({ signal }) => getContact(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getContact>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetContactQueryResult = NonNullable<Awaited<ReturnType<typeof getContact>>>
export type GetContactQueryError = void


export function useGetContact<TData = Awaited<ReturnType<typeof getContact>>, TError = void>(
 params: undefined |  GetContactParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getContact>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getContact>>,
          TError,
          Awaited<ReturnType<typeof getContact>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetContact<TData = Awaited<ReturnType<typeof getContact>>, TError = void>(
 params?: GetContactParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getContact>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getContact>>,
          TError,
          Awaited<ReturnType<typeof getContact>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetContact<TData = Awaited<ReturnType<typeof getContact>>, TError = void>(
 params?: GetContactParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getContact>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get all contact records
 */

export function useGetContact<TData = Awaited<ReturnType<typeof getContact>>, TError = void>(
 params?: GetContactParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getContact>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetContactQueryOptions(params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Creates a new contact record
 * @summary Create a new contact record
 */
export const postContact = (
    contact: Contact,
 signal?: AbortSignal
) => {
      
      
      return defaultInstance<PostContact200>(
      {url: `/contact`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: contact, signal
    },
      );
    }
  


export const getPostContactMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postContact>>, TError,{data: Contact}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postContact>>, TError,{data: Contact}, TContext> => {
    
const mutationKey = ['postContact'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postContact>>, {data: Contact}> = (props) => {
          const {data} = props ?? {};

          return  postContact(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostContactMutationResult = NonNullable<Awaited<ReturnType<typeof postContact>>>
    export type PostContactMutationBody = Contact
    export type PostContactMutationError = void

    /**
 * @summary Create a new contact record
 */
export const usePostContact = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postContact>>, TError,{data: Contact}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postContact>>,
        TError,
        {data: Contact},
        TContext
      > => {

      const mutationOptions = getPostContactMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Returns a single contact record by ID
 * @summary Get a specific contact record
 */
export const getContactId = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return defaultInstance<GetContactId200>(
      {url: `/contact/${id}`, method: 'GET', signal
    },
      );
    }
  

export const getGetContactIdQueryKey = (id: string,) => {
    return [`/contact/${id}`] as const;
    }

    
export const getGetContactIdQueryOptions = <TData = Awaited<ReturnType<typeof getContactId>>, TError = void>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getContactId>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetContactIdQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getContactId>>> = ({ signal }) => getContactId(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getContactId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetContactIdQueryResult = NonNullable<Awaited<ReturnType<typeof getContactId>>>
export type GetContactIdQueryError = void


export function useGetContactId<TData = Awaited<ReturnType<typeof getContactId>>, TError = void>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getContactId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getContactId>>,
          TError,
          Awaited<ReturnType<typeof getContactId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetContactId<TData = Awaited<ReturnType<typeof getContactId>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getContactId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getContactId>>,
          TError,
          Awaited<ReturnType<typeof getContactId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetContactId<TData = Awaited<ReturnType<typeof getContactId>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getContactId>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get a specific contact record
 */

export function useGetContactId<TData = Awaited<ReturnType<typeof getContactId>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getContactId>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetContactIdQueryOptions(id,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Updates an existing contact record
 * @summary Update a contact record
 */
export const putContactId = (
    id: string,
    contact: Contact,
 ) => {
      
      
      return defaultInstance<PutContactId200>(
      {url: `/contact/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: contact
    },
      );
    }
  


export const getPutContactIdMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putContactId>>, TError,{id: string;data: Contact}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof putContactId>>, TError,{id: string;data: Contact}, TContext> => {
    
const mutationKey = ['putContactId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putContactId>>, {id: string;data: Contact}> = (props) => {
          const {id,data} = props ?? {};

          return  putContactId(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutContactIdMutationResult = NonNullable<Awaited<ReturnType<typeof putContactId>>>
    export type PutContactIdMutationBody = Contact
    export type PutContactIdMutationError = void

    /**
 * @summary Update a contact record
 */
export const usePutContactId = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putContactId>>, TError,{id: string;data: Contact}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putContactId>>,
        TError,
        {id: string;data: Contact},
        TContext
      > => {

      const mutationOptions = getPutContactIdMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Partially updates an existing contact record
 * @summary Partially update a contact record
 */
export const patchContactId = (
    id: string,
    contact: Contact,
 ) => {
      
      
      return defaultInstance<PatchContactId200>(
      {url: `/contact/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: contact
    },
      );
    }
  


export const getPatchContactIdMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchContactId>>, TError,{id: string;data: Contact}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof patchContactId>>, TError,{id: string;data: Contact}, TContext> => {
    
const mutationKey = ['patchContactId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchContactId>>, {id: string;data: Contact}> = (props) => {
          const {id,data} = props ?? {};

          return  patchContactId(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PatchContactIdMutationResult = NonNullable<Awaited<ReturnType<typeof patchContactId>>>
    export type PatchContactIdMutationBody = Contact
    export type PatchContactIdMutationError = void

    /**
 * @summary Partially update a contact record
 */
export const usePatchContactId = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchContactId>>, TError,{id: string;data: Contact}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patchContactId>>,
        TError,
        {id: string;data: Contact},
        TContext
      > => {

      const mutationOptions = getPatchContactIdMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Deletes a contact record
 * @summary Delete a contact record
 */
export const deleteContactId = (
    id: string,
 ) => {
      
      
      return defaultInstance<DeleteContactId200>(
      {url: `/contact/${id}`, method: 'DELETE'
    },
      );
    }
  


export const getDeleteContactIdMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteContactId>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteContactId>>, TError,{id: string}, TContext> => {
    
const mutationKey = ['deleteContactId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteContactId>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteContactId(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteContactIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteContactId>>>
    
    export type DeleteContactIdMutationError = void

    /**
 * @summary Delete a contact record
 */
export const useDeleteContactId = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteContactId>>, TError,{id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteContactId>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getDeleteContactIdMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Returns a list of document_type records with pagination
 * @summary Get all document_type records
 */
export const getDocumentType = (
    params?: GetDocumentTypeParams,
 signal?: AbortSignal
) => {
      
      
      return defaultInstance<GetDocumentType200>(
      {url: `/document_type`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getGetDocumentTypeQueryKey = (params?: GetDocumentTypeParams,) => {
    return [`/document_type`, ...(params ? [params]: [])] as const;
    }

    
export const getGetDocumentTypeQueryOptions = <TData = Awaited<ReturnType<typeof getDocumentType>>, TError = void>(params?: GetDocumentTypeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDocumentType>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDocumentTypeQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDocumentType>>> = ({ signal }) => getDocumentType(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getDocumentType>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetDocumentTypeQueryResult = NonNullable<Awaited<ReturnType<typeof getDocumentType>>>
export type GetDocumentTypeQueryError = void


export function useGetDocumentType<TData = Awaited<ReturnType<typeof getDocumentType>>, TError = void>(
 params: undefined |  GetDocumentTypeParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDocumentType>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDocumentType>>,
          TError,
          Awaited<ReturnType<typeof getDocumentType>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDocumentType<TData = Awaited<ReturnType<typeof getDocumentType>>, TError = void>(
 params?: GetDocumentTypeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDocumentType>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDocumentType>>,
          TError,
          Awaited<ReturnType<typeof getDocumentType>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDocumentType<TData = Awaited<ReturnType<typeof getDocumentType>>, TError = void>(
 params?: GetDocumentTypeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDocumentType>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get all document_type records
 */

export function useGetDocumentType<TData = Awaited<ReturnType<typeof getDocumentType>>, TError = void>(
 params?: GetDocumentTypeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDocumentType>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetDocumentTypeQueryOptions(params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Creates a new document_type record
 * @summary Create a new document_type record
 */
export const postDocumentType = (
    documentType: DocumentType,
 signal?: AbortSignal
) => {
      
      
      return defaultInstance<PostDocumentType200>(
      {url: `/document_type`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: documentType, signal
    },
      );
    }
  


export const getPostDocumentTypeMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postDocumentType>>, TError,{data: DocumentType}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postDocumentType>>, TError,{data: DocumentType}, TContext> => {
    
const mutationKey = ['postDocumentType'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postDocumentType>>, {data: DocumentType}> = (props) => {
          const {data} = props ?? {};

          return  postDocumentType(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostDocumentTypeMutationResult = NonNullable<Awaited<ReturnType<typeof postDocumentType>>>
    export type PostDocumentTypeMutationBody = DocumentType
    export type PostDocumentTypeMutationError = void

    /**
 * @summary Create a new document_type record
 */
export const usePostDocumentType = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postDocumentType>>, TError,{data: DocumentType}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postDocumentType>>,
        TError,
        {data: DocumentType},
        TContext
      > => {

      const mutationOptions = getPostDocumentTypeMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Returns a single document_type record by ID
 * @summary Get a specific document_type record
 */
export const getDocumentTypeId = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return defaultInstance<GetDocumentTypeId200>(
      {url: `/document_type/${id}`, method: 'GET', signal
    },
      );
    }
  

export const getGetDocumentTypeIdQueryKey = (id: string,) => {
    return [`/document_type/${id}`] as const;
    }

    
export const getGetDocumentTypeIdQueryOptions = <TData = Awaited<ReturnType<typeof getDocumentTypeId>>, TError = void>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDocumentTypeId>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDocumentTypeIdQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDocumentTypeId>>> = ({ signal }) => getDocumentTypeId(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getDocumentTypeId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetDocumentTypeIdQueryResult = NonNullable<Awaited<ReturnType<typeof getDocumentTypeId>>>
export type GetDocumentTypeIdQueryError = void


export function useGetDocumentTypeId<TData = Awaited<ReturnType<typeof getDocumentTypeId>>, TError = void>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDocumentTypeId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDocumentTypeId>>,
          TError,
          Awaited<ReturnType<typeof getDocumentTypeId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDocumentTypeId<TData = Awaited<ReturnType<typeof getDocumentTypeId>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDocumentTypeId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDocumentTypeId>>,
          TError,
          Awaited<ReturnType<typeof getDocumentTypeId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDocumentTypeId<TData = Awaited<ReturnType<typeof getDocumentTypeId>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDocumentTypeId>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get a specific document_type record
 */

export function useGetDocumentTypeId<TData = Awaited<ReturnType<typeof getDocumentTypeId>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDocumentTypeId>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetDocumentTypeIdQueryOptions(id,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Updates an existing document_type record
 * @summary Update a document_type record
 */
export const putDocumentTypeId = (
    id: string,
    documentType: DocumentType,
 ) => {
      
      
      return defaultInstance<PutDocumentTypeId200>(
      {url: `/document_type/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: documentType
    },
      );
    }
  


export const getPutDocumentTypeIdMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putDocumentTypeId>>, TError,{id: string;data: DocumentType}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof putDocumentTypeId>>, TError,{id: string;data: DocumentType}, TContext> => {
    
const mutationKey = ['putDocumentTypeId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putDocumentTypeId>>, {id: string;data: DocumentType}> = (props) => {
          const {id,data} = props ?? {};

          return  putDocumentTypeId(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutDocumentTypeIdMutationResult = NonNullable<Awaited<ReturnType<typeof putDocumentTypeId>>>
    export type PutDocumentTypeIdMutationBody = DocumentType
    export type PutDocumentTypeIdMutationError = void

    /**
 * @summary Update a document_type record
 */
export const usePutDocumentTypeId = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putDocumentTypeId>>, TError,{id: string;data: DocumentType}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putDocumentTypeId>>,
        TError,
        {id: string;data: DocumentType},
        TContext
      > => {

      const mutationOptions = getPutDocumentTypeIdMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Partially updates an existing document_type record
 * @summary Partially update a document_type record
 */
export const patchDocumentTypeId = (
    id: string,
    documentType: DocumentType,
 ) => {
      
      
      return defaultInstance<PatchDocumentTypeId200>(
      {url: `/document_type/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: documentType
    },
      );
    }
  


export const getPatchDocumentTypeIdMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchDocumentTypeId>>, TError,{id: string;data: DocumentType}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof patchDocumentTypeId>>, TError,{id: string;data: DocumentType}, TContext> => {
    
const mutationKey = ['patchDocumentTypeId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchDocumentTypeId>>, {id: string;data: DocumentType}> = (props) => {
          const {id,data} = props ?? {};

          return  patchDocumentTypeId(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PatchDocumentTypeIdMutationResult = NonNullable<Awaited<ReturnType<typeof patchDocumentTypeId>>>
    export type PatchDocumentTypeIdMutationBody = DocumentType
    export type PatchDocumentTypeIdMutationError = void

    /**
 * @summary Partially update a document_type record
 */
export const usePatchDocumentTypeId = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchDocumentTypeId>>, TError,{id: string;data: DocumentType}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patchDocumentTypeId>>,
        TError,
        {id: string;data: DocumentType},
        TContext
      > => {

      const mutationOptions = getPatchDocumentTypeIdMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Deletes a document_type record
 * @summary Delete a document_type record
 */
export const deleteDocumentTypeId = (
    id: string,
 ) => {
      
      
      return defaultInstance<DeleteDocumentTypeId200>(
      {url: `/document_type/${id}`, method: 'DELETE'
    },
      );
    }
  


export const getDeleteDocumentTypeIdMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteDocumentTypeId>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteDocumentTypeId>>, TError,{id: string}, TContext> => {
    
const mutationKey = ['deleteDocumentTypeId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteDocumentTypeId>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteDocumentTypeId(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteDocumentTypeIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteDocumentTypeId>>>
    
    export type DeleteDocumentTypeIdMutationError = void

    /**
 * @summary Delete a document_type record
 */
export const useDeleteDocumentTypeId = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteDocumentTypeId>>, TError,{id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteDocumentTypeId>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getDeleteDocumentTypeIdMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Returns a list of document records with pagination
 * @summary Get all document records
 */
export const getDocument = (
    params?: GetDocumentParams,
 signal?: AbortSignal
) => {
      
      
      return defaultInstance<GetDocument200>(
      {url: `/document`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getGetDocumentQueryKey = (params?: GetDocumentParams,) => {
    return [`/document`, ...(params ? [params]: [])] as const;
    }

    
export const getGetDocumentQueryOptions = <TData = Awaited<ReturnType<typeof getDocument>>, TError = void>(params?: GetDocumentParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDocument>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDocumentQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDocument>>> = ({ signal }) => getDocument(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getDocument>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetDocumentQueryResult = NonNullable<Awaited<ReturnType<typeof getDocument>>>
export type GetDocumentQueryError = void


export function useGetDocument<TData = Awaited<ReturnType<typeof getDocument>>, TError = void>(
 params: undefined |  GetDocumentParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDocument>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDocument>>,
          TError,
          Awaited<ReturnType<typeof getDocument>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDocument<TData = Awaited<ReturnType<typeof getDocument>>, TError = void>(
 params?: GetDocumentParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDocument>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDocument>>,
          TError,
          Awaited<ReturnType<typeof getDocument>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDocument<TData = Awaited<ReturnType<typeof getDocument>>, TError = void>(
 params?: GetDocumentParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDocument>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get all document records
 */

export function useGetDocument<TData = Awaited<ReturnType<typeof getDocument>>, TError = void>(
 params?: GetDocumentParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDocument>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetDocumentQueryOptions(params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Creates a new document record
 * @summary Create a new document record
 */
export const postDocument = (
    document: Document,
 signal?: AbortSignal
) => {
      
      
      return defaultInstance<PostDocument200>(
      {url: `/document`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: document, signal
    },
      );
    }
  


export const getPostDocumentMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postDocument>>, TError,{data: Document}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postDocument>>, TError,{data: Document}, TContext> => {
    
const mutationKey = ['postDocument'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postDocument>>, {data: Document}> = (props) => {
          const {data} = props ?? {};

          return  postDocument(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostDocumentMutationResult = NonNullable<Awaited<ReturnType<typeof postDocument>>>
    export type PostDocumentMutationBody = Document
    export type PostDocumentMutationError = void

    /**
 * @summary Create a new document record
 */
export const usePostDocument = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postDocument>>, TError,{data: Document}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postDocument>>,
        TError,
        {data: Document},
        TContext
      > => {

      const mutationOptions = getPostDocumentMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Returns a single document record by ID
 * @summary Get a specific document record
 */
export const getDocumentId = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return defaultInstance<GetDocumentId200>(
      {url: `/document/${id}`, method: 'GET', signal
    },
      );
    }
  

export const getGetDocumentIdQueryKey = (id: string,) => {
    return [`/document/${id}`] as const;
    }

    
export const getGetDocumentIdQueryOptions = <TData = Awaited<ReturnType<typeof getDocumentId>>, TError = void>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDocumentId>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDocumentIdQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDocumentId>>> = ({ signal }) => getDocumentId(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getDocumentId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetDocumentIdQueryResult = NonNullable<Awaited<ReturnType<typeof getDocumentId>>>
export type GetDocumentIdQueryError = void


export function useGetDocumentId<TData = Awaited<ReturnType<typeof getDocumentId>>, TError = void>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDocumentId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDocumentId>>,
          TError,
          Awaited<ReturnType<typeof getDocumentId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDocumentId<TData = Awaited<ReturnType<typeof getDocumentId>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDocumentId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDocumentId>>,
          TError,
          Awaited<ReturnType<typeof getDocumentId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDocumentId<TData = Awaited<ReturnType<typeof getDocumentId>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDocumentId>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get a specific document record
 */

export function useGetDocumentId<TData = Awaited<ReturnType<typeof getDocumentId>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDocumentId>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetDocumentIdQueryOptions(id,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Updates an existing document record
 * @summary Update a document record
 */
export const putDocumentId = (
    id: string,
    document: Document,
 ) => {
      
      
      return defaultInstance<PutDocumentId200>(
      {url: `/document/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: document
    },
      );
    }
  


export const getPutDocumentIdMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putDocumentId>>, TError,{id: string;data: Document}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof putDocumentId>>, TError,{id: string;data: Document}, TContext> => {
    
const mutationKey = ['putDocumentId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putDocumentId>>, {id: string;data: Document}> = (props) => {
          const {id,data} = props ?? {};

          return  putDocumentId(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutDocumentIdMutationResult = NonNullable<Awaited<ReturnType<typeof putDocumentId>>>
    export type PutDocumentIdMutationBody = Document
    export type PutDocumentIdMutationError = void

    /**
 * @summary Update a document record
 */
export const usePutDocumentId = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putDocumentId>>, TError,{id: string;data: Document}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putDocumentId>>,
        TError,
        {id: string;data: Document},
        TContext
      > => {

      const mutationOptions = getPutDocumentIdMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Partially updates an existing document record
 * @summary Partially update a document record
 */
export const patchDocumentId = (
    id: string,
    document: Document,
 ) => {
      
      
      return defaultInstance<PatchDocumentId200>(
      {url: `/document/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: document
    },
      );
    }
  


export const getPatchDocumentIdMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchDocumentId>>, TError,{id: string;data: Document}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof patchDocumentId>>, TError,{id: string;data: Document}, TContext> => {
    
const mutationKey = ['patchDocumentId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchDocumentId>>, {id: string;data: Document}> = (props) => {
          const {id,data} = props ?? {};

          return  patchDocumentId(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PatchDocumentIdMutationResult = NonNullable<Awaited<ReturnType<typeof patchDocumentId>>>
    export type PatchDocumentIdMutationBody = Document
    export type PatchDocumentIdMutationError = void

    /**
 * @summary Partially update a document record
 */
export const usePatchDocumentId = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchDocumentId>>, TError,{id: string;data: Document}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patchDocumentId>>,
        TError,
        {id: string;data: Document},
        TContext
      > => {

      const mutationOptions = getPatchDocumentIdMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Deletes a document record
 * @summary Delete a document record
 */
export const deleteDocumentId = (
    id: string,
 ) => {
      
      
      return defaultInstance<DeleteDocumentId200>(
      {url: `/document/${id}`, method: 'DELETE'
    },
      );
    }
  


export const getDeleteDocumentIdMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteDocumentId>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteDocumentId>>, TError,{id: string}, TContext> => {
    
const mutationKey = ['deleteDocumentId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteDocumentId>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteDocumentId(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteDocumentIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteDocumentId>>>
    
    export type DeleteDocumentIdMutationError = void

    /**
 * @summary Delete a document record
 */
export const useDeleteDocumentId = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteDocumentId>>, TError,{id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteDocumentId>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getDeleteDocumentIdMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Returns a list of estate_type records with pagination
 * @summary Get all estate_type records
 */
export const getEstateType = (
    params?: GetEstateTypeParams,
 signal?: AbortSignal
) => {
      
      
      return defaultInstance<GetEstateType200>(
      {url: `/estate_type`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getGetEstateTypeQueryKey = (params?: GetEstateTypeParams,) => {
    return [`/estate_type`, ...(params ? [params]: [])] as const;
    }

    
export const getGetEstateTypeQueryOptions = <TData = Awaited<ReturnType<typeof getEstateType>>, TError = void>(params?: GetEstateTypeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEstateType>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetEstateTypeQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getEstateType>>> = ({ signal }) => getEstateType(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getEstateType>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetEstateTypeQueryResult = NonNullable<Awaited<ReturnType<typeof getEstateType>>>
export type GetEstateTypeQueryError = void


export function useGetEstateType<TData = Awaited<ReturnType<typeof getEstateType>>, TError = void>(
 params: undefined |  GetEstateTypeParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEstateType>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEstateType>>,
          TError,
          Awaited<ReturnType<typeof getEstateType>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEstateType<TData = Awaited<ReturnType<typeof getEstateType>>, TError = void>(
 params?: GetEstateTypeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEstateType>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEstateType>>,
          TError,
          Awaited<ReturnType<typeof getEstateType>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEstateType<TData = Awaited<ReturnType<typeof getEstateType>>, TError = void>(
 params?: GetEstateTypeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEstateType>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get all estate_type records
 */

export function useGetEstateType<TData = Awaited<ReturnType<typeof getEstateType>>, TError = void>(
 params?: GetEstateTypeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEstateType>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetEstateTypeQueryOptions(params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Creates a new estate_type record
 * @summary Create a new estate_type record
 */
export const postEstateType = (
    estateType: EstateType,
 signal?: AbortSignal
) => {
      
      
      return defaultInstance<PostEstateType200>(
      {url: `/estate_type`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: estateType, signal
    },
      );
    }
  


export const getPostEstateTypeMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postEstateType>>, TError,{data: EstateType}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postEstateType>>, TError,{data: EstateType}, TContext> => {
    
const mutationKey = ['postEstateType'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postEstateType>>, {data: EstateType}> = (props) => {
          const {data} = props ?? {};

          return  postEstateType(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostEstateTypeMutationResult = NonNullable<Awaited<ReturnType<typeof postEstateType>>>
    export type PostEstateTypeMutationBody = EstateType
    export type PostEstateTypeMutationError = void

    /**
 * @summary Create a new estate_type record
 */
export const usePostEstateType = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postEstateType>>, TError,{data: EstateType}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postEstateType>>,
        TError,
        {data: EstateType},
        TContext
      > => {

      const mutationOptions = getPostEstateTypeMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Returns a single estate_type record by ID
 * @summary Get a specific estate_type record
 */
export const getEstateTypeId = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return defaultInstance<GetEstateTypeId200>(
      {url: `/estate_type/${id}`, method: 'GET', signal
    },
      );
    }
  

export const getGetEstateTypeIdQueryKey = (id: string,) => {
    return [`/estate_type/${id}`] as const;
    }

    
export const getGetEstateTypeIdQueryOptions = <TData = Awaited<ReturnType<typeof getEstateTypeId>>, TError = void>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEstateTypeId>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetEstateTypeIdQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getEstateTypeId>>> = ({ signal }) => getEstateTypeId(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getEstateTypeId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetEstateTypeIdQueryResult = NonNullable<Awaited<ReturnType<typeof getEstateTypeId>>>
export type GetEstateTypeIdQueryError = void


export function useGetEstateTypeId<TData = Awaited<ReturnType<typeof getEstateTypeId>>, TError = void>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEstateTypeId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEstateTypeId>>,
          TError,
          Awaited<ReturnType<typeof getEstateTypeId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEstateTypeId<TData = Awaited<ReturnType<typeof getEstateTypeId>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEstateTypeId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEstateTypeId>>,
          TError,
          Awaited<ReturnType<typeof getEstateTypeId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEstateTypeId<TData = Awaited<ReturnType<typeof getEstateTypeId>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEstateTypeId>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get a specific estate_type record
 */

export function useGetEstateTypeId<TData = Awaited<ReturnType<typeof getEstateTypeId>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEstateTypeId>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetEstateTypeIdQueryOptions(id,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Updates an existing estate_type record
 * @summary Update a estate_type record
 */
export const putEstateTypeId = (
    id: string,
    estateType: EstateType,
 ) => {
      
      
      return defaultInstance<PutEstateTypeId200>(
      {url: `/estate_type/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: estateType
    },
      );
    }
  


export const getPutEstateTypeIdMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putEstateTypeId>>, TError,{id: string;data: EstateType}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof putEstateTypeId>>, TError,{id: string;data: EstateType}, TContext> => {
    
const mutationKey = ['putEstateTypeId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putEstateTypeId>>, {id: string;data: EstateType}> = (props) => {
          const {id,data} = props ?? {};

          return  putEstateTypeId(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutEstateTypeIdMutationResult = NonNullable<Awaited<ReturnType<typeof putEstateTypeId>>>
    export type PutEstateTypeIdMutationBody = EstateType
    export type PutEstateTypeIdMutationError = void

    /**
 * @summary Update a estate_type record
 */
export const usePutEstateTypeId = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putEstateTypeId>>, TError,{id: string;data: EstateType}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putEstateTypeId>>,
        TError,
        {id: string;data: EstateType},
        TContext
      > => {

      const mutationOptions = getPutEstateTypeIdMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Partially updates an existing estate_type record
 * @summary Partially update a estate_type record
 */
export const patchEstateTypeId = (
    id: string,
    estateType: EstateType,
 ) => {
      
      
      return defaultInstance<PatchEstateTypeId200>(
      {url: `/estate_type/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: estateType
    },
      );
    }
  


export const getPatchEstateTypeIdMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchEstateTypeId>>, TError,{id: string;data: EstateType}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof patchEstateTypeId>>, TError,{id: string;data: EstateType}, TContext> => {
    
const mutationKey = ['patchEstateTypeId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchEstateTypeId>>, {id: string;data: EstateType}> = (props) => {
          const {id,data} = props ?? {};

          return  patchEstateTypeId(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PatchEstateTypeIdMutationResult = NonNullable<Awaited<ReturnType<typeof patchEstateTypeId>>>
    export type PatchEstateTypeIdMutationBody = EstateType
    export type PatchEstateTypeIdMutationError = void

    /**
 * @summary Partially update a estate_type record
 */
export const usePatchEstateTypeId = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchEstateTypeId>>, TError,{id: string;data: EstateType}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patchEstateTypeId>>,
        TError,
        {id: string;data: EstateType},
        TContext
      > => {

      const mutationOptions = getPatchEstateTypeIdMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Deletes a estate_type record
 * @summary Delete a estate_type record
 */
export const deleteEstateTypeId = (
    id: string,
 ) => {
      
      
      return defaultInstance<DeleteEstateTypeId200>(
      {url: `/estate_type/${id}`, method: 'DELETE'
    },
      );
    }
  


export const getDeleteEstateTypeIdMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteEstateTypeId>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteEstateTypeId>>, TError,{id: string}, TContext> => {
    
const mutationKey = ['deleteEstateTypeId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteEstateTypeId>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteEstateTypeId(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteEstateTypeIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteEstateTypeId>>>
    
    export type DeleteEstateTypeIdMutationError = void

    /**
 * @summary Delete a estate_type record
 */
export const useDeleteEstateTypeId = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteEstateTypeId>>, TError,{id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteEstateTypeId>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getDeleteEstateTypeIdMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Returns a list of estate_group records with pagination
 * @summary Get all estate_group records
 */
export const getEstateGroup = (
    params?: GetEstateGroupParams,
 signal?: AbortSignal
) => {
      
      
      return defaultInstance<GetEstateGroup200>(
      {url: `/estate_group`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getGetEstateGroupQueryKey = (params?: GetEstateGroupParams,) => {
    return [`/estate_group`, ...(params ? [params]: [])] as const;
    }

    
export const getGetEstateGroupQueryOptions = <TData = Awaited<ReturnType<typeof getEstateGroup>>, TError = void>(params?: GetEstateGroupParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEstateGroup>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetEstateGroupQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getEstateGroup>>> = ({ signal }) => getEstateGroup(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getEstateGroup>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetEstateGroupQueryResult = NonNullable<Awaited<ReturnType<typeof getEstateGroup>>>
export type GetEstateGroupQueryError = void


export function useGetEstateGroup<TData = Awaited<ReturnType<typeof getEstateGroup>>, TError = void>(
 params: undefined |  GetEstateGroupParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEstateGroup>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEstateGroup>>,
          TError,
          Awaited<ReturnType<typeof getEstateGroup>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEstateGroup<TData = Awaited<ReturnType<typeof getEstateGroup>>, TError = void>(
 params?: GetEstateGroupParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEstateGroup>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEstateGroup>>,
          TError,
          Awaited<ReturnType<typeof getEstateGroup>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEstateGroup<TData = Awaited<ReturnType<typeof getEstateGroup>>, TError = void>(
 params?: GetEstateGroupParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEstateGroup>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get all estate_group records
 */

export function useGetEstateGroup<TData = Awaited<ReturnType<typeof getEstateGroup>>, TError = void>(
 params?: GetEstateGroupParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEstateGroup>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetEstateGroupQueryOptions(params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Creates a new estate_group record
 * @summary Create a new estate_group record
 */
export const postEstateGroup = (
    estateGroup: EstateGroup,
 signal?: AbortSignal
) => {
      
      
      return defaultInstance<PostEstateGroup200>(
      {url: `/estate_group`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: estateGroup, signal
    },
      );
    }
  


export const getPostEstateGroupMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postEstateGroup>>, TError,{data: EstateGroup}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postEstateGroup>>, TError,{data: EstateGroup}, TContext> => {
    
const mutationKey = ['postEstateGroup'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postEstateGroup>>, {data: EstateGroup}> = (props) => {
          const {data} = props ?? {};

          return  postEstateGroup(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostEstateGroupMutationResult = NonNullable<Awaited<ReturnType<typeof postEstateGroup>>>
    export type PostEstateGroupMutationBody = EstateGroup
    export type PostEstateGroupMutationError = void

    /**
 * @summary Create a new estate_group record
 */
export const usePostEstateGroup = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postEstateGroup>>, TError,{data: EstateGroup}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postEstateGroup>>,
        TError,
        {data: EstateGroup},
        TContext
      > => {

      const mutationOptions = getPostEstateGroupMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Returns a single estate_group record by ID
 * @summary Get a specific estate_group record
 */
export const getEstateGroupId = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return defaultInstance<GetEstateGroupId200>(
      {url: `/estate_group/${id}`, method: 'GET', signal
    },
      );
    }
  

export const getGetEstateGroupIdQueryKey = (id: string,) => {
    return [`/estate_group/${id}`] as const;
    }

    
export const getGetEstateGroupIdQueryOptions = <TData = Awaited<ReturnType<typeof getEstateGroupId>>, TError = void>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEstateGroupId>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetEstateGroupIdQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getEstateGroupId>>> = ({ signal }) => getEstateGroupId(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getEstateGroupId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetEstateGroupIdQueryResult = NonNullable<Awaited<ReturnType<typeof getEstateGroupId>>>
export type GetEstateGroupIdQueryError = void


export function useGetEstateGroupId<TData = Awaited<ReturnType<typeof getEstateGroupId>>, TError = void>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEstateGroupId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEstateGroupId>>,
          TError,
          Awaited<ReturnType<typeof getEstateGroupId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEstateGroupId<TData = Awaited<ReturnType<typeof getEstateGroupId>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEstateGroupId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEstateGroupId>>,
          TError,
          Awaited<ReturnType<typeof getEstateGroupId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEstateGroupId<TData = Awaited<ReturnType<typeof getEstateGroupId>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEstateGroupId>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get a specific estate_group record
 */

export function useGetEstateGroupId<TData = Awaited<ReturnType<typeof getEstateGroupId>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEstateGroupId>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetEstateGroupIdQueryOptions(id,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Updates an existing estate_group record
 * @summary Update a estate_group record
 */
export const putEstateGroupId = (
    id: string,
    estateGroup: EstateGroup,
 ) => {
      
      
      return defaultInstance<PutEstateGroupId200>(
      {url: `/estate_group/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: estateGroup
    },
      );
    }
  


export const getPutEstateGroupIdMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putEstateGroupId>>, TError,{id: string;data: EstateGroup}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof putEstateGroupId>>, TError,{id: string;data: EstateGroup}, TContext> => {
    
const mutationKey = ['putEstateGroupId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putEstateGroupId>>, {id: string;data: EstateGroup}> = (props) => {
          const {id,data} = props ?? {};

          return  putEstateGroupId(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutEstateGroupIdMutationResult = NonNullable<Awaited<ReturnType<typeof putEstateGroupId>>>
    export type PutEstateGroupIdMutationBody = EstateGroup
    export type PutEstateGroupIdMutationError = void

    /**
 * @summary Update a estate_group record
 */
export const usePutEstateGroupId = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putEstateGroupId>>, TError,{id: string;data: EstateGroup}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putEstateGroupId>>,
        TError,
        {id: string;data: EstateGroup},
        TContext
      > => {

      const mutationOptions = getPutEstateGroupIdMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Partially updates an existing estate_group record
 * @summary Partially update a estate_group record
 */
export const patchEstateGroupId = (
    id: string,
    estateGroup: EstateGroup,
 ) => {
      
      
      return defaultInstance<PatchEstateGroupId200>(
      {url: `/estate_group/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: estateGroup
    },
      );
    }
  


export const getPatchEstateGroupIdMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchEstateGroupId>>, TError,{id: string;data: EstateGroup}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof patchEstateGroupId>>, TError,{id: string;data: EstateGroup}, TContext> => {
    
const mutationKey = ['patchEstateGroupId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchEstateGroupId>>, {id: string;data: EstateGroup}> = (props) => {
          const {id,data} = props ?? {};

          return  patchEstateGroupId(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PatchEstateGroupIdMutationResult = NonNullable<Awaited<ReturnType<typeof patchEstateGroupId>>>
    export type PatchEstateGroupIdMutationBody = EstateGroup
    export type PatchEstateGroupIdMutationError = void

    /**
 * @summary Partially update a estate_group record
 */
export const usePatchEstateGroupId = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchEstateGroupId>>, TError,{id: string;data: EstateGroup}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patchEstateGroupId>>,
        TError,
        {id: string;data: EstateGroup},
        TContext
      > => {

      const mutationOptions = getPatchEstateGroupIdMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Deletes a estate_group record
 * @summary Delete a estate_group record
 */
export const deleteEstateGroupId = (
    id: string,
 ) => {
      
      
      return defaultInstance<DeleteEstateGroupId200>(
      {url: `/estate_group/${id}`, method: 'DELETE'
    },
      );
    }
  


export const getDeleteEstateGroupIdMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteEstateGroupId>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteEstateGroupId>>, TError,{id: string}, TContext> => {
    
const mutationKey = ['deleteEstateGroupId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteEstateGroupId>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteEstateGroupId(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteEstateGroupIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteEstateGroupId>>>
    
    export type DeleteEstateGroupIdMutationError = void

    /**
 * @summary Delete a estate_group record
 */
export const useDeleteEstateGroupId = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteEstateGroupId>>, TError,{id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteEstateGroupId>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getDeleteEstateGroupIdMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Returns a list of gate_type records with pagination
 * @summary Get all gate_type records
 */
export const getGateType = (
    params?: GetGateTypeParams,
 signal?: AbortSignal
) => {
      
      
      return defaultInstance<GetGateType200>(
      {url: `/gate_type`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getGetGateTypeQueryKey = (params?: GetGateTypeParams,) => {
    return [`/gate_type`, ...(params ? [params]: [])] as const;
    }

    
export const getGetGateTypeQueryOptions = <TData = Awaited<ReturnType<typeof getGateType>>, TError = void>(params?: GetGateTypeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getGateType>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetGateTypeQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getGateType>>> = ({ signal }) => getGateType(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getGateType>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetGateTypeQueryResult = NonNullable<Awaited<ReturnType<typeof getGateType>>>
export type GetGateTypeQueryError = void


export function useGetGateType<TData = Awaited<ReturnType<typeof getGateType>>, TError = void>(
 params: undefined |  GetGateTypeParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getGateType>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getGateType>>,
          TError,
          Awaited<ReturnType<typeof getGateType>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetGateType<TData = Awaited<ReturnType<typeof getGateType>>, TError = void>(
 params?: GetGateTypeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getGateType>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getGateType>>,
          TError,
          Awaited<ReturnType<typeof getGateType>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetGateType<TData = Awaited<ReturnType<typeof getGateType>>, TError = void>(
 params?: GetGateTypeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getGateType>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get all gate_type records
 */

export function useGetGateType<TData = Awaited<ReturnType<typeof getGateType>>, TError = void>(
 params?: GetGateTypeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getGateType>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetGateTypeQueryOptions(params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Creates a new gate_type record
 * @summary Create a new gate_type record
 */
export const postGateType = (
    gateType: GateType,
 signal?: AbortSignal
) => {
      
      
      return defaultInstance<PostGateType200>(
      {url: `/gate_type`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: gateType, signal
    },
      );
    }
  


export const getPostGateTypeMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postGateType>>, TError,{data: GateType}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postGateType>>, TError,{data: GateType}, TContext> => {
    
const mutationKey = ['postGateType'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postGateType>>, {data: GateType}> = (props) => {
          const {data} = props ?? {};

          return  postGateType(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostGateTypeMutationResult = NonNullable<Awaited<ReturnType<typeof postGateType>>>
    export type PostGateTypeMutationBody = GateType
    export type PostGateTypeMutationError = void

    /**
 * @summary Create a new gate_type record
 */
export const usePostGateType = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postGateType>>, TError,{data: GateType}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postGateType>>,
        TError,
        {data: GateType},
        TContext
      > => {

      const mutationOptions = getPostGateTypeMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Returns a single gate_type record by ID
 * @summary Get a specific gate_type record
 */
export const getGateTypeId = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return defaultInstance<GetGateTypeId200>(
      {url: `/gate_type/${id}`, method: 'GET', signal
    },
      );
    }
  

export const getGetGateTypeIdQueryKey = (id: string,) => {
    return [`/gate_type/${id}`] as const;
    }

    
export const getGetGateTypeIdQueryOptions = <TData = Awaited<ReturnType<typeof getGateTypeId>>, TError = void>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getGateTypeId>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetGateTypeIdQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getGateTypeId>>> = ({ signal }) => getGateTypeId(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getGateTypeId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetGateTypeIdQueryResult = NonNullable<Awaited<ReturnType<typeof getGateTypeId>>>
export type GetGateTypeIdQueryError = void


export function useGetGateTypeId<TData = Awaited<ReturnType<typeof getGateTypeId>>, TError = void>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getGateTypeId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getGateTypeId>>,
          TError,
          Awaited<ReturnType<typeof getGateTypeId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetGateTypeId<TData = Awaited<ReturnType<typeof getGateTypeId>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getGateTypeId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getGateTypeId>>,
          TError,
          Awaited<ReturnType<typeof getGateTypeId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetGateTypeId<TData = Awaited<ReturnType<typeof getGateTypeId>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getGateTypeId>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get a specific gate_type record
 */

export function useGetGateTypeId<TData = Awaited<ReturnType<typeof getGateTypeId>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getGateTypeId>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetGateTypeIdQueryOptions(id,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Updates an existing gate_type record
 * @summary Update a gate_type record
 */
export const putGateTypeId = (
    id: string,
    gateType: GateType,
 ) => {
      
      
      return defaultInstance<PutGateTypeId200>(
      {url: `/gate_type/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: gateType
    },
      );
    }
  


export const getPutGateTypeIdMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putGateTypeId>>, TError,{id: string;data: GateType}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof putGateTypeId>>, TError,{id: string;data: GateType}, TContext> => {
    
const mutationKey = ['putGateTypeId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putGateTypeId>>, {id: string;data: GateType}> = (props) => {
          const {id,data} = props ?? {};

          return  putGateTypeId(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutGateTypeIdMutationResult = NonNullable<Awaited<ReturnType<typeof putGateTypeId>>>
    export type PutGateTypeIdMutationBody = GateType
    export type PutGateTypeIdMutationError = void

    /**
 * @summary Update a gate_type record
 */
export const usePutGateTypeId = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putGateTypeId>>, TError,{id: string;data: GateType}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putGateTypeId>>,
        TError,
        {id: string;data: GateType},
        TContext
      > => {

      const mutationOptions = getPutGateTypeIdMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Partially updates an existing gate_type record
 * @summary Partially update a gate_type record
 */
export const patchGateTypeId = (
    id: string,
    gateType: GateType,
 ) => {
      
      
      return defaultInstance<PatchGateTypeId200>(
      {url: `/gate_type/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: gateType
    },
      );
    }
  


export const getPatchGateTypeIdMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchGateTypeId>>, TError,{id: string;data: GateType}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof patchGateTypeId>>, TError,{id: string;data: GateType}, TContext> => {
    
const mutationKey = ['patchGateTypeId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchGateTypeId>>, {id: string;data: GateType}> = (props) => {
          const {id,data} = props ?? {};

          return  patchGateTypeId(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PatchGateTypeIdMutationResult = NonNullable<Awaited<ReturnType<typeof patchGateTypeId>>>
    export type PatchGateTypeIdMutationBody = GateType
    export type PatchGateTypeIdMutationError = void

    /**
 * @summary Partially update a gate_type record
 */
export const usePatchGateTypeId = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchGateTypeId>>, TError,{id: string;data: GateType}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patchGateTypeId>>,
        TError,
        {id: string;data: GateType},
        TContext
      > => {

      const mutationOptions = getPatchGateTypeIdMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Deletes a gate_type record
 * @summary Delete a gate_type record
 */
export const deleteGateTypeId = (
    id: string,
 ) => {
      
      
      return defaultInstance<DeleteGateTypeId200>(
      {url: `/gate_type/${id}`, method: 'DELETE'
    },
      );
    }
  


export const getDeleteGateTypeIdMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteGateTypeId>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteGateTypeId>>, TError,{id: string}, TContext> => {
    
const mutationKey = ['deleteGateTypeId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteGateTypeId>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteGateTypeId(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteGateTypeIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteGateTypeId>>>
    
    export type DeleteGateTypeIdMutationError = void

    /**
 * @summary Delete a gate_type record
 */
export const useDeleteGateTypeId = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteGateTypeId>>, TError,{id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteGateTypeId>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getDeleteGateTypeIdMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Returns a list of category records with pagination
 * @summary Get all category records
 */
export const getCategory = (
    params?: GetCategoryParams,
 signal?: AbortSignal
) => {
      
      
      return defaultInstance<GetCategory200>(
      {url: `/category`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getGetCategoryQueryKey = (params?: GetCategoryParams,) => {
    return [`/category`, ...(params ? [params]: [])] as const;
    }

    
export const getGetCategoryQueryOptions = <TData = Awaited<ReturnType<typeof getCategory>>, TError = void>(params?: GetCategoryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCategory>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCategoryQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCategory>>> = ({ signal }) => getCategory(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCategory>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetCategoryQueryResult = NonNullable<Awaited<ReturnType<typeof getCategory>>>
export type GetCategoryQueryError = void


export function useGetCategory<TData = Awaited<ReturnType<typeof getCategory>>, TError = void>(
 params: undefined |  GetCategoryParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCategory>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCategory>>,
          TError,
          Awaited<ReturnType<typeof getCategory>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCategory<TData = Awaited<ReturnType<typeof getCategory>>, TError = void>(
 params?: GetCategoryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCategory>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCategory>>,
          TError,
          Awaited<ReturnType<typeof getCategory>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCategory<TData = Awaited<ReturnType<typeof getCategory>>, TError = void>(
 params?: GetCategoryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCategory>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get all category records
 */

export function useGetCategory<TData = Awaited<ReturnType<typeof getCategory>>, TError = void>(
 params?: GetCategoryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCategory>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetCategoryQueryOptions(params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Creates a new category record
 * @summary Create a new category record
 */
export const postCategory = (
    category: Category,
 signal?: AbortSignal
) => {
      
      
      return defaultInstance<PostCategory200>(
      {url: `/category`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: category, signal
    },
      );
    }
  


export const getPostCategoryMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCategory>>, TError,{data: Category}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postCategory>>, TError,{data: Category}, TContext> => {
    
const mutationKey = ['postCategory'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postCategory>>, {data: Category}> = (props) => {
          const {data} = props ?? {};

          return  postCategory(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostCategoryMutationResult = NonNullable<Awaited<ReturnType<typeof postCategory>>>
    export type PostCategoryMutationBody = Category
    export type PostCategoryMutationError = void

    /**
 * @summary Create a new category record
 */
export const usePostCategory = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCategory>>, TError,{data: Category}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postCategory>>,
        TError,
        {data: Category},
        TContext
      > => {

      const mutationOptions = getPostCategoryMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Returns a single category record by ID
 * @summary Get a specific category record
 */
export const getCategoryId = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return defaultInstance<GetCategoryId200>(
      {url: `/category/${id}`, method: 'GET', signal
    },
      );
    }
  

export const getGetCategoryIdQueryKey = (id: string,) => {
    return [`/category/${id}`] as const;
    }

    
export const getGetCategoryIdQueryOptions = <TData = Awaited<ReturnType<typeof getCategoryId>>, TError = void>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCategoryId>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCategoryIdQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCategoryId>>> = ({ signal }) => getCategoryId(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCategoryId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetCategoryIdQueryResult = NonNullable<Awaited<ReturnType<typeof getCategoryId>>>
export type GetCategoryIdQueryError = void


export function useGetCategoryId<TData = Awaited<ReturnType<typeof getCategoryId>>, TError = void>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCategoryId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCategoryId>>,
          TError,
          Awaited<ReturnType<typeof getCategoryId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCategoryId<TData = Awaited<ReturnType<typeof getCategoryId>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCategoryId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCategoryId>>,
          TError,
          Awaited<ReturnType<typeof getCategoryId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCategoryId<TData = Awaited<ReturnType<typeof getCategoryId>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCategoryId>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get a specific category record
 */

export function useGetCategoryId<TData = Awaited<ReturnType<typeof getCategoryId>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCategoryId>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetCategoryIdQueryOptions(id,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Updates an existing category record
 * @summary Update a category record
 */
export const putCategoryId = (
    id: string,
    category: Category,
 ) => {
      
      
      return defaultInstance<PutCategoryId200>(
      {url: `/category/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: category
    },
      );
    }
  


export const getPutCategoryIdMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putCategoryId>>, TError,{id: string;data: Category}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof putCategoryId>>, TError,{id: string;data: Category}, TContext> => {
    
const mutationKey = ['putCategoryId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putCategoryId>>, {id: string;data: Category}> = (props) => {
          const {id,data} = props ?? {};

          return  putCategoryId(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutCategoryIdMutationResult = NonNullable<Awaited<ReturnType<typeof putCategoryId>>>
    export type PutCategoryIdMutationBody = Category
    export type PutCategoryIdMutationError = void

    /**
 * @summary Update a category record
 */
export const usePutCategoryId = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putCategoryId>>, TError,{id: string;data: Category}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putCategoryId>>,
        TError,
        {id: string;data: Category},
        TContext
      > => {

      const mutationOptions = getPutCategoryIdMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Partially updates an existing category record
 * @summary Partially update a category record
 */
export const patchCategoryId = (
    id: string,
    category: Category,
 ) => {
      
      
      return defaultInstance<PatchCategoryId200>(
      {url: `/category/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: category
    },
      );
    }
  


export const getPatchCategoryIdMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchCategoryId>>, TError,{id: string;data: Category}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof patchCategoryId>>, TError,{id: string;data: Category}, TContext> => {
    
const mutationKey = ['patchCategoryId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchCategoryId>>, {id: string;data: Category}> = (props) => {
          const {id,data} = props ?? {};

          return  patchCategoryId(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PatchCategoryIdMutationResult = NonNullable<Awaited<ReturnType<typeof patchCategoryId>>>
    export type PatchCategoryIdMutationBody = Category
    export type PatchCategoryIdMutationError = void

    /**
 * @summary Partially update a category record
 */
export const usePatchCategoryId = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchCategoryId>>, TError,{id: string;data: Category}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patchCategoryId>>,
        TError,
        {id: string;data: Category},
        TContext
      > => {

      const mutationOptions = getPatchCategoryIdMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Deletes a category record
 * @summary Delete a category record
 */
export const deleteCategoryId = (
    id: string,
 ) => {
      
      
      return defaultInstance<DeleteCategoryId200>(
      {url: `/category/${id}`, method: 'DELETE'
    },
      );
    }
  


export const getDeleteCategoryIdMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteCategoryId>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteCategoryId>>, TError,{id: string}, TContext> => {
    
const mutationKey = ['deleteCategoryId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteCategoryId>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteCategoryId(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteCategoryIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteCategoryId>>>
    
    export type DeleteCategoryIdMutationError = void

    /**
 * @summary Delete a category record
 */
export const useDeleteCategoryId = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteCategoryId>>, TError,{id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteCategoryId>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getDeleteCategoryIdMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Returns a list of currency records with pagination
 * @summary Get all currency records
 */
export const getCurrency = (
    params?: GetCurrencyParams,
 signal?: AbortSignal
) => {
      
      
      return defaultInstance<GetCurrency200>(
      {url: `/currency`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getGetCurrencyQueryKey = (params?: GetCurrencyParams,) => {
    return [`/currency`, ...(params ? [params]: [])] as const;
    }

    
export const getGetCurrencyQueryOptions = <TData = Awaited<ReturnType<typeof getCurrency>>, TError = void>(params?: GetCurrencyParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCurrency>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCurrencyQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCurrency>>> = ({ signal }) => getCurrency(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCurrency>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetCurrencyQueryResult = NonNullable<Awaited<ReturnType<typeof getCurrency>>>
export type GetCurrencyQueryError = void


export function useGetCurrency<TData = Awaited<ReturnType<typeof getCurrency>>, TError = void>(
 params: undefined |  GetCurrencyParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCurrency>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCurrency>>,
          TError,
          Awaited<ReturnType<typeof getCurrency>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCurrency<TData = Awaited<ReturnType<typeof getCurrency>>, TError = void>(
 params?: GetCurrencyParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCurrency>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCurrency>>,
          TError,
          Awaited<ReturnType<typeof getCurrency>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCurrency<TData = Awaited<ReturnType<typeof getCurrency>>, TError = void>(
 params?: GetCurrencyParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCurrency>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get all currency records
 */

export function useGetCurrency<TData = Awaited<ReturnType<typeof getCurrency>>, TError = void>(
 params?: GetCurrencyParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCurrency>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetCurrencyQueryOptions(params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Creates a new currency record
 * @summary Create a new currency record
 */
export const postCurrency = (
    currency: Currency,
 signal?: AbortSignal
) => {
      
      
      return defaultInstance<PostCurrency200>(
      {url: `/currency`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: currency, signal
    },
      );
    }
  


export const getPostCurrencyMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCurrency>>, TError,{data: Currency}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postCurrency>>, TError,{data: Currency}, TContext> => {
    
const mutationKey = ['postCurrency'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postCurrency>>, {data: Currency}> = (props) => {
          const {data} = props ?? {};

          return  postCurrency(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostCurrencyMutationResult = NonNullable<Awaited<ReturnType<typeof postCurrency>>>
    export type PostCurrencyMutationBody = Currency
    export type PostCurrencyMutationError = void

    /**
 * @summary Create a new currency record
 */
export const usePostCurrency = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCurrency>>, TError,{data: Currency}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postCurrency>>,
        TError,
        {data: Currency},
        TContext
      > => {

      const mutationOptions = getPostCurrencyMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Returns a single currency record by ID
 * @summary Get a specific currency record
 */
export const getCurrencyId = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return defaultInstance<GetCurrencyId200>(
      {url: `/currency/${id}`, method: 'GET', signal
    },
      );
    }
  

export const getGetCurrencyIdQueryKey = (id: string,) => {
    return [`/currency/${id}`] as const;
    }

    
export const getGetCurrencyIdQueryOptions = <TData = Awaited<ReturnType<typeof getCurrencyId>>, TError = void>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCurrencyId>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCurrencyIdQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCurrencyId>>> = ({ signal }) => getCurrencyId(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCurrencyId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetCurrencyIdQueryResult = NonNullable<Awaited<ReturnType<typeof getCurrencyId>>>
export type GetCurrencyIdQueryError = void


export function useGetCurrencyId<TData = Awaited<ReturnType<typeof getCurrencyId>>, TError = void>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCurrencyId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCurrencyId>>,
          TError,
          Awaited<ReturnType<typeof getCurrencyId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCurrencyId<TData = Awaited<ReturnType<typeof getCurrencyId>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCurrencyId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCurrencyId>>,
          TError,
          Awaited<ReturnType<typeof getCurrencyId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCurrencyId<TData = Awaited<ReturnType<typeof getCurrencyId>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCurrencyId>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get a specific currency record
 */

export function useGetCurrencyId<TData = Awaited<ReturnType<typeof getCurrencyId>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCurrencyId>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetCurrencyIdQueryOptions(id,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Updates an existing currency record
 * @summary Update a currency record
 */
export const putCurrencyId = (
    id: string,
    currency: Currency,
 ) => {
      
      
      return defaultInstance<PutCurrencyId200>(
      {url: `/currency/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: currency
    },
      );
    }
  


export const getPutCurrencyIdMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putCurrencyId>>, TError,{id: string;data: Currency}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof putCurrencyId>>, TError,{id: string;data: Currency}, TContext> => {
    
const mutationKey = ['putCurrencyId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putCurrencyId>>, {id: string;data: Currency}> = (props) => {
          const {id,data} = props ?? {};

          return  putCurrencyId(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutCurrencyIdMutationResult = NonNullable<Awaited<ReturnType<typeof putCurrencyId>>>
    export type PutCurrencyIdMutationBody = Currency
    export type PutCurrencyIdMutationError = void

    /**
 * @summary Update a currency record
 */
export const usePutCurrencyId = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putCurrencyId>>, TError,{id: string;data: Currency}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putCurrencyId>>,
        TError,
        {id: string;data: Currency},
        TContext
      > => {

      const mutationOptions = getPutCurrencyIdMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Partially updates an existing currency record
 * @summary Partially update a currency record
 */
export const patchCurrencyId = (
    id: string,
    currency: Currency,
 ) => {
      
      
      return defaultInstance<PatchCurrencyId200>(
      {url: `/currency/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: currency
    },
      );
    }
  


export const getPatchCurrencyIdMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchCurrencyId>>, TError,{id: string;data: Currency}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof patchCurrencyId>>, TError,{id: string;data: Currency}, TContext> => {
    
const mutationKey = ['patchCurrencyId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchCurrencyId>>, {id: string;data: Currency}> = (props) => {
          const {id,data} = props ?? {};

          return  patchCurrencyId(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PatchCurrencyIdMutationResult = NonNullable<Awaited<ReturnType<typeof patchCurrencyId>>>
    export type PatchCurrencyIdMutationBody = Currency
    export type PatchCurrencyIdMutationError = void

    /**
 * @summary Partially update a currency record
 */
export const usePatchCurrencyId = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchCurrencyId>>, TError,{id: string;data: Currency}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patchCurrencyId>>,
        TError,
        {id: string;data: Currency},
        TContext
      > => {

      const mutationOptions = getPatchCurrencyIdMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Deletes a currency record
 * @summary Delete a currency record
 */
export const deleteCurrencyId = (
    id: string,
 ) => {
      
      
      return defaultInstance<DeleteCurrencyId200>(
      {url: `/currency/${id}`, method: 'DELETE'
    },
      );
    }
  


export const getDeleteCurrencyIdMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteCurrencyId>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteCurrencyId>>, TError,{id: string}, TContext> => {
    
const mutationKey = ['deleteCurrencyId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteCurrencyId>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteCurrencyId(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteCurrencyIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteCurrencyId>>>
    
    export type DeleteCurrencyIdMutationError = void

    /**
 * @summary Delete a currency record
 */
export const useDeleteCurrencyId = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteCurrencyId>>, TError,{id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteCurrencyId>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getDeleteCurrencyIdMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Returns a list of country records with pagination
 * @summary Get all country records
 */
export const getCountry = (
    params?: GetCountryParams,
 signal?: AbortSignal
) => {
      
      
      return defaultInstance<GetCountry200>(
      {url: `/country`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getGetCountryQueryKey = (params?: GetCountryParams,) => {
    return [`/country`, ...(params ? [params]: [])] as const;
    }

    
export const getGetCountryQueryOptions = <TData = Awaited<ReturnType<typeof getCountry>>, TError = void>(params?: GetCountryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCountry>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCountryQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCountry>>> = ({ signal }) => getCountry(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCountry>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetCountryQueryResult = NonNullable<Awaited<ReturnType<typeof getCountry>>>
export type GetCountryQueryError = void


export function useGetCountry<TData = Awaited<ReturnType<typeof getCountry>>, TError = void>(
 params: undefined |  GetCountryParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCountry>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCountry>>,
          TError,
          Awaited<ReturnType<typeof getCountry>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCountry<TData = Awaited<ReturnType<typeof getCountry>>, TError = void>(
 params?: GetCountryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCountry>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCountry>>,
          TError,
          Awaited<ReturnType<typeof getCountry>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCountry<TData = Awaited<ReturnType<typeof getCountry>>, TError = void>(
 params?: GetCountryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCountry>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get all country records
 */

export function useGetCountry<TData = Awaited<ReturnType<typeof getCountry>>, TError = void>(
 params?: GetCountryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCountry>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetCountryQueryOptions(params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Creates a new country record
 * @summary Create a new country record
 */
export const postCountry = (
    country: Country,
 signal?: AbortSignal
) => {
      
      
      return defaultInstance<PostCountry200>(
      {url: `/country`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: country, signal
    },
      );
    }
  


export const getPostCountryMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCountry>>, TError,{data: Country}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postCountry>>, TError,{data: Country}, TContext> => {
    
const mutationKey = ['postCountry'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postCountry>>, {data: Country}> = (props) => {
          const {data} = props ?? {};

          return  postCountry(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostCountryMutationResult = NonNullable<Awaited<ReturnType<typeof postCountry>>>
    export type PostCountryMutationBody = Country
    export type PostCountryMutationError = void

    /**
 * @summary Create a new country record
 */
export const usePostCountry = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCountry>>, TError,{data: Country}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postCountry>>,
        TError,
        {data: Country},
        TContext
      > => {

      const mutationOptions = getPostCountryMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Returns a single country record by ID
 * @summary Get a specific country record
 */
export const getCountryId = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return defaultInstance<GetCountryId200>(
      {url: `/country/${id}`, method: 'GET', signal
    },
      );
    }
  

export const getGetCountryIdQueryKey = (id: string,) => {
    return [`/country/${id}`] as const;
    }

    
export const getGetCountryIdQueryOptions = <TData = Awaited<ReturnType<typeof getCountryId>>, TError = void>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCountryId>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCountryIdQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCountryId>>> = ({ signal }) => getCountryId(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCountryId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetCountryIdQueryResult = NonNullable<Awaited<ReturnType<typeof getCountryId>>>
export type GetCountryIdQueryError = void


export function useGetCountryId<TData = Awaited<ReturnType<typeof getCountryId>>, TError = void>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCountryId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCountryId>>,
          TError,
          Awaited<ReturnType<typeof getCountryId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCountryId<TData = Awaited<ReturnType<typeof getCountryId>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCountryId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCountryId>>,
          TError,
          Awaited<ReturnType<typeof getCountryId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCountryId<TData = Awaited<ReturnType<typeof getCountryId>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCountryId>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get a specific country record
 */

export function useGetCountryId<TData = Awaited<ReturnType<typeof getCountryId>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCountryId>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetCountryIdQueryOptions(id,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Updates an existing country record
 * @summary Update a country record
 */
export const putCountryId = (
    id: string,
    country: Country,
 ) => {
      
      
      return defaultInstance<PutCountryId200>(
      {url: `/country/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: country
    },
      );
    }
  


export const getPutCountryIdMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putCountryId>>, TError,{id: string;data: Country}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof putCountryId>>, TError,{id: string;data: Country}, TContext> => {
    
const mutationKey = ['putCountryId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putCountryId>>, {id: string;data: Country}> = (props) => {
          const {id,data} = props ?? {};

          return  putCountryId(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutCountryIdMutationResult = NonNullable<Awaited<ReturnType<typeof putCountryId>>>
    export type PutCountryIdMutationBody = Country
    export type PutCountryIdMutationError = void

    /**
 * @summary Update a country record
 */
export const usePutCountryId = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putCountryId>>, TError,{id: string;data: Country}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putCountryId>>,
        TError,
        {id: string;data: Country},
        TContext
      > => {

      const mutationOptions = getPutCountryIdMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Partially updates an existing country record
 * @summary Partially update a country record
 */
export const patchCountryId = (
    id: string,
    country: Country,
 ) => {
      
      
      return defaultInstance<PatchCountryId200>(
      {url: `/country/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: country
    },
      );
    }
  


export const getPatchCountryIdMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchCountryId>>, TError,{id: string;data: Country}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof patchCountryId>>, TError,{id: string;data: Country}, TContext> => {
    
const mutationKey = ['patchCountryId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchCountryId>>, {id: string;data: Country}> = (props) => {
          const {id,data} = props ?? {};

          return  patchCountryId(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PatchCountryIdMutationResult = NonNullable<Awaited<ReturnType<typeof patchCountryId>>>
    export type PatchCountryIdMutationBody = Country
    export type PatchCountryIdMutationError = void

    /**
 * @summary Partially update a country record
 */
export const usePatchCountryId = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchCountryId>>, TError,{id: string;data: Country}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patchCountryId>>,
        TError,
        {id: string;data: Country},
        TContext
      > => {

      const mutationOptions = getPatchCountryIdMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Deletes a country record
 * @summary Delete a country record
 */
export const deleteCountryId = (
    id: string,
 ) => {
      
      
      return defaultInstance<DeleteCountryId200>(
      {url: `/country/${id}`, method: 'DELETE'
    },
      );
    }
  


export const getDeleteCountryIdMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteCountryId>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteCountryId>>, TError,{id: string}, TContext> => {
    
const mutationKey = ['deleteCountryId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteCountryId>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteCountryId(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteCountryIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteCountryId>>>
    
    export type DeleteCountryIdMutationError = void

    /**
 * @summary Delete a country record
 */
export const useDeleteCountryId = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteCountryId>>, TError,{id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteCountryId>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getDeleteCountryIdMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Returns a list of state records with pagination
 * @summary Get all state records
 */
export const getState = (
    params?: GetStateParams,
 signal?: AbortSignal
) => {
      
      
      return defaultInstance<GetState200>(
      {url: `/state`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getGetStateQueryKey = (params?: GetStateParams,) => {
    return [`/state`, ...(params ? [params]: [])] as const;
    }

    
export const getGetStateQueryOptions = <TData = Awaited<ReturnType<typeof getState>>, TError = void>(params?: GetStateParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getState>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetStateQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getState>>> = ({ signal }) => getState(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getState>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetStateQueryResult = NonNullable<Awaited<ReturnType<typeof getState>>>
export type GetStateQueryError = void


export function useGetState<TData = Awaited<ReturnType<typeof getState>>, TError = void>(
 params: undefined |  GetStateParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getState>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getState>>,
          TError,
          Awaited<ReturnType<typeof getState>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetState<TData = Awaited<ReturnType<typeof getState>>, TError = void>(
 params?: GetStateParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getState>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getState>>,
          TError,
          Awaited<ReturnType<typeof getState>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetState<TData = Awaited<ReturnType<typeof getState>>, TError = void>(
 params?: GetStateParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getState>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get all state records
 */

export function useGetState<TData = Awaited<ReturnType<typeof getState>>, TError = void>(
 params?: GetStateParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getState>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetStateQueryOptions(params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Creates a new state record
 * @summary Create a new state record
 */
export const postState = (
    state: State,
 signal?: AbortSignal
) => {
      
      
      return defaultInstance<PostState200>(
      {url: `/state`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: state, signal
    },
      );
    }
  


export const getPostStateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postState>>, TError,{data: State}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postState>>, TError,{data: State}, TContext> => {
    
const mutationKey = ['postState'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postState>>, {data: State}> = (props) => {
          const {data} = props ?? {};

          return  postState(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostStateMutationResult = NonNullable<Awaited<ReturnType<typeof postState>>>
    export type PostStateMutationBody = State
    export type PostStateMutationError = void

    /**
 * @summary Create a new state record
 */
export const usePostState = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postState>>, TError,{data: State}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postState>>,
        TError,
        {data: State},
        TContext
      > => {

      const mutationOptions = getPostStateMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Returns a single state record by ID
 * @summary Get a specific state record
 */
export const getStateId = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return defaultInstance<GetStateId200>(
      {url: `/state/${id}`, method: 'GET', signal
    },
      );
    }
  

export const getGetStateIdQueryKey = (id: string,) => {
    return [`/state/${id}`] as const;
    }

    
export const getGetStateIdQueryOptions = <TData = Awaited<ReturnType<typeof getStateId>>, TError = void>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getStateId>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetStateIdQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getStateId>>> = ({ signal }) => getStateId(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getStateId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetStateIdQueryResult = NonNullable<Awaited<ReturnType<typeof getStateId>>>
export type GetStateIdQueryError = void


export function useGetStateId<TData = Awaited<ReturnType<typeof getStateId>>, TError = void>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getStateId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getStateId>>,
          TError,
          Awaited<ReturnType<typeof getStateId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetStateId<TData = Awaited<ReturnType<typeof getStateId>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getStateId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getStateId>>,
          TError,
          Awaited<ReturnType<typeof getStateId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetStateId<TData = Awaited<ReturnType<typeof getStateId>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getStateId>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get a specific state record
 */

export function useGetStateId<TData = Awaited<ReturnType<typeof getStateId>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getStateId>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetStateIdQueryOptions(id,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Updates an existing state record
 * @summary Update a state record
 */
export const putStateId = (
    id: string,
    state: State,
 ) => {
      
      
      return defaultInstance<PutStateId200>(
      {url: `/state/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: state
    },
      );
    }
  


export const getPutStateIdMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putStateId>>, TError,{id: string;data: State}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof putStateId>>, TError,{id: string;data: State}, TContext> => {
    
const mutationKey = ['putStateId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putStateId>>, {id: string;data: State}> = (props) => {
          const {id,data} = props ?? {};

          return  putStateId(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutStateIdMutationResult = NonNullable<Awaited<ReturnType<typeof putStateId>>>
    export type PutStateIdMutationBody = State
    export type PutStateIdMutationError = void

    /**
 * @summary Update a state record
 */
export const usePutStateId = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putStateId>>, TError,{id: string;data: State}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putStateId>>,
        TError,
        {id: string;data: State},
        TContext
      > => {

      const mutationOptions = getPutStateIdMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Partially updates an existing state record
 * @summary Partially update a state record
 */
export const patchStateId = (
    id: string,
    state: State,
 ) => {
      
      
      return defaultInstance<PatchStateId200>(
      {url: `/state/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: state
    },
      );
    }
  


export const getPatchStateIdMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchStateId>>, TError,{id: string;data: State}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof patchStateId>>, TError,{id: string;data: State}, TContext> => {
    
const mutationKey = ['patchStateId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchStateId>>, {id: string;data: State}> = (props) => {
          const {id,data} = props ?? {};

          return  patchStateId(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PatchStateIdMutationResult = NonNullable<Awaited<ReturnType<typeof patchStateId>>>
    export type PatchStateIdMutationBody = State
    export type PatchStateIdMutationError = void

    /**
 * @summary Partially update a state record
 */
export const usePatchStateId = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchStateId>>, TError,{id: string;data: State}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patchStateId>>,
        TError,
        {id: string;data: State},
        TContext
      > => {

      const mutationOptions = getPatchStateIdMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Deletes a state record
 * @summary Delete a state record
 */
export const deleteStateId = (
    id: string,
 ) => {
      
      
      return defaultInstance<DeleteStateId200>(
      {url: `/state/${id}`, method: 'DELETE'
    },
      );
    }
  


export const getDeleteStateIdMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteStateId>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteStateId>>, TError,{id: string}, TContext> => {
    
const mutationKey = ['deleteStateId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteStateId>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteStateId(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteStateIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteStateId>>>
    
    export type DeleteStateIdMutationError = void

    /**
 * @summary Delete a state record
 */
export const useDeleteStateId = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteStateId>>, TError,{id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteStateId>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getDeleteStateIdMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Returns a list of city records with pagination
 * @summary Get all city records
 */
export const getCity = (
    params?: GetCityParams,
 signal?: AbortSignal
) => {
      
      
      return defaultInstance<GetCity200>(
      {url: `/city`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getGetCityQueryKey = (params?: GetCityParams,) => {
    return [`/city`, ...(params ? [params]: [])] as const;
    }

    
export const getGetCityQueryOptions = <TData = Awaited<ReturnType<typeof getCity>>, TError = void>(params?: GetCityParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCity>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCityQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCity>>> = ({ signal }) => getCity(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCity>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetCityQueryResult = NonNullable<Awaited<ReturnType<typeof getCity>>>
export type GetCityQueryError = void


export function useGetCity<TData = Awaited<ReturnType<typeof getCity>>, TError = void>(
 params: undefined |  GetCityParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCity>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCity>>,
          TError,
          Awaited<ReturnType<typeof getCity>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCity<TData = Awaited<ReturnType<typeof getCity>>, TError = void>(
 params?: GetCityParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCity>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCity>>,
          TError,
          Awaited<ReturnType<typeof getCity>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCity<TData = Awaited<ReturnType<typeof getCity>>, TError = void>(
 params?: GetCityParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCity>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get all city records
 */

export function useGetCity<TData = Awaited<ReturnType<typeof getCity>>, TError = void>(
 params?: GetCityParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCity>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetCityQueryOptions(params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Creates a new city record
 * @summary Create a new city record
 */
export const postCity = (
    city: City,
 signal?: AbortSignal
) => {
      
      
      return defaultInstance<PostCity200>(
      {url: `/city`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: city, signal
    },
      );
    }
  


export const getPostCityMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCity>>, TError,{data: City}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postCity>>, TError,{data: City}, TContext> => {
    
const mutationKey = ['postCity'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postCity>>, {data: City}> = (props) => {
          const {data} = props ?? {};

          return  postCity(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostCityMutationResult = NonNullable<Awaited<ReturnType<typeof postCity>>>
    export type PostCityMutationBody = City
    export type PostCityMutationError = void

    /**
 * @summary Create a new city record
 */
export const usePostCity = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCity>>, TError,{data: City}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postCity>>,
        TError,
        {data: City},
        TContext
      > => {

      const mutationOptions = getPostCityMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Returns a single city record by ID
 * @summary Get a specific city record
 */
export const getCityId = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return defaultInstance<GetCityId200>(
      {url: `/city/${id}`, method: 'GET', signal
    },
      );
    }
  

export const getGetCityIdQueryKey = (id: string,) => {
    return [`/city/${id}`] as const;
    }

    
export const getGetCityIdQueryOptions = <TData = Awaited<ReturnType<typeof getCityId>>, TError = void>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCityId>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCityIdQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCityId>>> = ({ signal }) => getCityId(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCityId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetCityIdQueryResult = NonNullable<Awaited<ReturnType<typeof getCityId>>>
export type GetCityIdQueryError = void


export function useGetCityId<TData = Awaited<ReturnType<typeof getCityId>>, TError = void>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCityId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCityId>>,
          TError,
          Awaited<ReturnType<typeof getCityId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCityId<TData = Awaited<ReturnType<typeof getCityId>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCityId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCityId>>,
          TError,
          Awaited<ReturnType<typeof getCityId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCityId<TData = Awaited<ReturnType<typeof getCityId>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCityId>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get a specific city record
 */

export function useGetCityId<TData = Awaited<ReturnType<typeof getCityId>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCityId>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetCityIdQueryOptions(id,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Updates an existing city record
 * @summary Update a city record
 */
export const putCityId = (
    id: string,
    city: City,
 ) => {
      
      
      return defaultInstance<PutCityId200>(
      {url: `/city/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: city
    },
      );
    }
  


export const getPutCityIdMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putCityId>>, TError,{id: string;data: City}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof putCityId>>, TError,{id: string;data: City}, TContext> => {
    
const mutationKey = ['putCityId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putCityId>>, {id: string;data: City}> = (props) => {
          const {id,data} = props ?? {};

          return  putCityId(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutCityIdMutationResult = NonNullable<Awaited<ReturnType<typeof putCityId>>>
    export type PutCityIdMutationBody = City
    export type PutCityIdMutationError = void

    /**
 * @summary Update a city record
 */
export const usePutCityId = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putCityId>>, TError,{id: string;data: City}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putCityId>>,
        TError,
        {id: string;data: City},
        TContext
      > => {

      const mutationOptions = getPutCityIdMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Partially updates an existing city record
 * @summary Partially update a city record
 */
export const patchCityId = (
    id: string,
    city: City,
 ) => {
      
      
      return defaultInstance<PatchCityId200>(
      {url: `/city/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: city
    },
      );
    }
  


export const getPatchCityIdMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchCityId>>, TError,{id: string;data: City}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof patchCityId>>, TError,{id: string;data: City}, TContext> => {
    
const mutationKey = ['patchCityId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchCityId>>, {id: string;data: City}> = (props) => {
          const {id,data} = props ?? {};

          return  patchCityId(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PatchCityIdMutationResult = NonNullable<Awaited<ReturnType<typeof patchCityId>>>
    export type PatchCityIdMutationBody = City
    export type PatchCityIdMutationError = void

    /**
 * @summary Partially update a city record
 */
export const usePatchCityId = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchCityId>>, TError,{id: string;data: City}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patchCityId>>,
        TError,
        {id: string;data: City},
        TContext
      > => {

      const mutationOptions = getPatchCityIdMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Deletes a city record
 * @summary Delete a city record
 */
export const deleteCityId = (
    id: string,
 ) => {
      
      
      return defaultInstance<DeleteCityId200>(
      {url: `/city/${id}`, method: 'DELETE'
    },
      );
    }
  


export const getDeleteCityIdMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteCityId>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteCityId>>, TError,{id: string}, TContext> => {
    
const mutationKey = ['deleteCityId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteCityId>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteCityId(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteCityIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteCityId>>>
    
    export type DeleteCityIdMutationError = void

    /**
 * @summary Delete a city record
 */
export const useDeleteCityId = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteCityId>>, TError,{id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteCityId>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getDeleteCityIdMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Returns a list of zone records with pagination
 * @summary Get all zone records
 */
export const getZone = (
    params?: GetZoneParams,
 signal?: AbortSignal
) => {
      
      
      return defaultInstance<GetZone200>(
      {url: `/zone`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getGetZoneQueryKey = (params?: GetZoneParams,) => {
    return [`/zone`, ...(params ? [params]: [])] as const;
    }

    
export const getGetZoneQueryOptions = <TData = Awaited<ReturnType<typeof getZone>>, TError = void>(params?: GetZoneParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getZone>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetZoneQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getZone>>> = ({ signal }) => getZone(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getZone>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetZoneQueryResult = NonNullable<Awaited<ReturnType<typeof getZone>>>
export type GetZoneQueryError = void


export function useGetZone<TData = Awaited<ReturnType<typeof getZone>>, TError = void>(
 params: undefined |  GetZoneParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getZone>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getZone>>,
          TError,
          Awaited<ReturnType<typeof getZone>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetZone<TData = Awaited<ReturnType<typeof getZone>>, TError = void>(
 params?: GetZoneParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getZone>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getZone>>,
          TError,
          Awaited<ReturnType<typeof getZone>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetZone<TData = Awaited<ReturnType<typeof getZone>>, TError = void>(
 params?: GetZoneParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getZone>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get all zone records
 */

export function useGetZone<TData = Awaited<ReturnType<typeof getZone>>, TError = void>(
 params?: GetZoneParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getZone>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetZoneQueryOptions(params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Creates a new zone record
 * @summary Create a new zone record
 */
export const postZone = (
    zone: Zone,
 signal?: AbortSignal
) => {
      
      
      return defaultInstance<PostZone200>(
      {url: `/zone`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: zone, signal
    },
      );
    }
  


export const getPostZoneMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postZone>>, TError,{data: Zone}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postZone>>, TError,{data: Zone}, TContext> => {
    
const mutationKey = ['postZone'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postZone>>, {data: Zone}> = (props) => {
          const {data} = props ?? {};

          return  postZone(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostZoneMutationResult = NonNullable<Awaited<ReturnType<typeof postZone>>>
    export type PostZoneMutationBody = Zone
    export type PostZoneMutationError = void

    /**
 * @summary Create a new zone record
 */
export const usePostZone = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postZone>>, TError,{data: Zone}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postZone>>,
        TError,
        {data: Zone},
        TContext
      > => {

      const mutationOptions = getPostZoneMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Returns a single zone record by ID
 * @summary Get a specific zone record
 */
export const getZoneId = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return defaultInstance<GetZoneId200>(
      {url: `/zone/${id}`, method: 'GET', signal
    },
      );
    }
  

export const getGetZoneIdQueryKey = (id: string,) => {
    return [`/zone/${id}`] as const;
    }

    
export const getGetZoneIdQueryOptions = <TData = Awaited<ReturnType<typeof getZoneId>>, TError = void>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getZoneId>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetZoneIdQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getZoneId>>> = ({ signal }) => getZoneId(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getZoneId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetZoneIdQueryResult = NonNullable<Awaited<ReturnType<typeof getZoneId>>>
export type GetZoneIdQueryError = void


export function useGetZoneId<TData = Awaited<ReturnType<typeof getZoneId>>, TError = void>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getZoneId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getZoneId>>,
          TError,
          Awaited<ReturnType<typeof getZoneId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetZoneId<TData = Awaited<ReturnType<typeof getZoneId>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getZoneId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getZoneId>>,
          TError,
          Awaited<ReturnType<typeof getZoneId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetZoneId<TData = Awaited<ReturnType<typeof getZoneId>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getZoneId>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get a specific zone record
 */

export function useGetZoneId<TData = Awaited<ReturnType<typeof getZoneId>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getZoneId>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetZoneIdQueryOptions(id,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Updates an existing zone record
 * @summary Update a zone record
 */
export const putZoneId = (
    id: string,
    zone: Zone,
 ) => {
      
      
      return defaultInstance<PutZoneId200>(
      {url: `/zone/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: zone
    },
      );
    }
  


export const getPutZoneIdMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putZoneId>>, TError,{id: string;data: Zone}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof putZoneId>>, TError,{id: string;data: Zone}, TContext> => {
    
const mutationKey = ['putZoneId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putZoneId>>, {id: string;data: Zone}> = (props) => {
          const {id,data} = props ?? {};

          return  putZoneId(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutZoneIdMutationResult = NonNullable<Awaited<ReturnType<typeof putZoneId>>>
    export type PutZoneIdMutationBody = Zone
    export type PutZoneIdMutationError = void

    /**
 * @summary Update a zone record
 */
export const usePutZoneId = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putZoneId>>, TError,{id: string;data: Zone}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putZoneId>>,
        TError,
        {id: string;data: Zone},
        TContext
      > => {

      const mutationOptions = getPutZoneIdMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Partially updates an existing zone record
 * @summary Partially update a zone record
 */
export const patchZoneId = (
    id: string,
    zone: Zone,
 ) => {
      
      
      return defaultInstance<PatchZoneId200>(
      {url: `/zone/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: zone
    },
      );
    }
  


export const getPatchZoneIdMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchZoneId>>, TError,{id: string;data: Zone}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof patchZoneId>>, TError,{id: string;data: Zone}, TContext> => {
    
const mutationKey = ['patchZoneId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchZoneId>>, {id: string;data: Zone}> = (props) => {
          const {id,data} = props ?? {};

          return  patchZoneId(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PatchZoneIdMutationResult = NonNullable<Awaited<ReturnType<typeof patchZoneId>>>
    export type PatchZoneIdMutationBody = Zone
    export type PatchZoneIdMutationError = void

    /**
 * @summary Partially update a zone record
 */
export const usePatchZoneId = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchZoneId>>, TError,{id: string;data: Zone}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patchZoneId>>,
        TError,
        {id: string;data: Zone},
        TContext
      > => {

      const mutationOptions = getPatchZoneIdMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Deletes a zone record
 * @summary Delete a zone record
 */
export const deleteZoneId = (
    id: string,
 ) => {
      
      
      return defaultInstance<DeleteZoneId200>(
      {url: `/zone/${id}`, method: 'DELETE'
    },
      );
    }
  


export const getDeleteZoneIdMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteZoneId>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteZoneId>>, TError,{id: string}, TContext> => {
    
const mutationKey = ['deleteZoneId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteZoneId>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteZoneId(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteZoneIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteZoneId>>>
    
    export type DeleteZoneIdMutationError = void

    /**
 * @summary Delete a zone record
 */
export const useDeleteZoneId = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteZoneId>>, TError,{id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteZoneId>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getDeleteZoneIdMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Returns a list of address records with pagination
 * @summary Get all address records
 */
export const getAddress = (
    params?: GetAddressParams,
 signal?: AbortSignal
) => {
      
      
      return defaultInstance<GetAddress200>(
      {url: `/address`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getGetAddressQueryKey = (params?: GetAddressParams,) => {
    return [`/address`, ...(params ? [params]: [])] as const;
    }

    
export const getGetAddressQueryOptions = <TData = Awaited<ReturnType<typeof getAddress>>, TError = void>(params?: GetAddressParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAddress>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAddressQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAddress>>> = ({ signal }) => getAddress(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAddress>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAddressQueryResult = NonNullable<Awaited<ReturnType<typeof getAddress>>>
export type GetAddressQueryError = void


export function useGetAddress<TData = Awaited<ReturnType<typeof getAddress>>, TError = void>(
 params: undefined |  GetAddressParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAddress>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAddress>>,
          TError,
          Awaited<ReturnType<typeof getAddress>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAddress<TData = Awaited<ReturnType<typeof getAddress>>, TError = void>(
 params?: GetAddressParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAddress>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAddress>>,
          TError,
          Awaited<ReturnType<typeof getAddress>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAddress<TData = Awaited<ReturnType<typeof getAddress>>, TError = void>(
 params?: GetAddressParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAddress>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get all address records
 */

export function useGetAddress<TData = Awaited<ReturnType<typeof getAddress>>, TError = void>(
 params?: GetAddressParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAddress>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAddressQueryOptions(params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Creates a new address record
 * @summary Create a new address record
 */
export const postAddress = (
    address: Address,
 signal?: AbortSignal
) => {
      
      
      return defaultInstance<PostAddress200>(
      {url: `/address`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: address, signal
    },
      );
    }
  


export const getPostAddressMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAddress>>, TError,{data: Address}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postAddress>>, TError,{data: Address}, TContext> => {
    
const mutationKey = ['postAddress'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postAddress>>, {data: Address}> = (props) => {
          const {data} = props ?? {};

          return  postAddress(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostAddressMutationResult = NonNullable<Awaited<ReturnType<typeof postAddress>>>
    export type PostAddressMutationBody = Address
    export type PostAddressMutationError = void

    /**
 * @summary Create a new address record
 */
export const usePostAddress = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAddress>>, TError,{data: Address}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postAddress>>,
        TError,
        {data: Address},
        TContext
      > => {

      const mutationOptions = getPostAddressMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Returns a single address record by ID
 * @summary Get a specific address record
 */
export const getAddressId = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return defaultInstance<GetAddressId200>(
      {url: `/address/${id}`, method: 'GET', signal
    },
      );
    }
  

export const getGetAddressIdQueryKey = (id: string,) => {
    return [`/address/${id}`] as const;
    }

    
export const getGetAddressIdQueryOptions = <TData = Awaited<ReturnType<typeof getAddressId>>, TError = void>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAddressId>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAddressIdQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAddressId>>> = ({ signal }) => getAddressId(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAddressId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAddressIdQueryResult = NonNullable<Awaited<ReturnType<typeof getAddressId>>>
export type GetAddressIdQueryError = void


export function useGetAddressId<TData = Awaited<ReturnType<typeof getAddressId>>, TError = void>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAddressId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAddressId>>,
          TError,
          Awaited<ReturnType<typeof getAddressId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAddressId<TData = Awaited<ReturnType<typeof getAddressId>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAddressId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAddressId>>,
          TError,
          Awaited<ReturnType<typeof getAddressId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAddressId<TData = Awaited<ReturnType<typeof getAddressId>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAddressId>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get a specific address record
 */

export function useGetAddressId<TData = Awaited<ReturnType<typeof getAddressId>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAddressId>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAddressIdQueryOptions(id,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Updates an existing address record
 * @summary Update a address record
 */
export const putAddressId = (
    id: string,
    address: Address,
 ) => {
      
      
      return defaultInstance<PutAddressId200>(
      {url: `/address/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: address
    },
      );
    }
  


export const getPutAddressIdMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putAddressId>>, TError,{id: string;data: Address}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof putAddressId>>, TError,{id: string;data: Address}, TContext> => {
    
const mutationKey = ['putAddressId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putAddressId>>, {id: string;data: Address}> = (props) => {
          const {id,data} = props ?? {};

          return  putAddressId(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutAddressIdMutationResult = NonNullable<Awaited<ReturnType<typeof putAddressId>>>
    export type PutAddressIdMutationBody = Address
    export type PutAddressIdMutationError = void

    /**
 * @summary Update a address record
 */
export const usePutAddressId = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putAddressId>>, TError,{id: string;data: Address}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putAddressId>>,
        TError,
        {id: string;data: Address},
        TContext
      > => {

      const mutationOptions = getPutAddressIdMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Partially updates an existing address record
 * @summary Partially update a address record
 */
export const patchAddressId = (
    id: string,
    address: Address,
 ) => {
      
      
      return defaultInstance<PatchAddressId200>(
      {url: `/address/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: address
    },
      );
    }
  


export const getPatchAddressIdMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchAddressId>>, TError,{id: string;data: Address}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof patchAddressId>>, TError,{id: string;data: Address}, TContext> => {
    
const mutationKey = ['patchAddressId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchAddressId>>, {id: string;data: Address}> = (props) => {
          const {id,data} = props ?? {};

          return  patchAddressId(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PatchAddressIdMutationResult = NonNullable<Awaited<ReturnType<typeof patchAddressId>>>
    export type PatchAddressIdMutationBody = Address
    export type PatchAddressIdMutationError = void

    /**
 * @summary Partially update a address record
 */
export const usePatchAddressId = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchAddressId>>, TError,{id: string;data: Address}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patchAddressId>>,
        TError,
        {id: string;data: Address},
        TContext
      > => {

      const mutationOptions = getPatchAddressIdMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Deletes a address record
 * @summary Delete a address record
 */
export const deleteAddressId = (
    id: string,
 ) => {
      
      
      return defaultInstance<DeleteAddressId200>(
      {url: `/address/${id}`, method: 'DELETE'
    },
      );
    }
  


export const getDeleteAddressIdMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAddressId>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteAddressId>>, TError,{id: string}, TContext> => {
    
const mutationKey = ['deleteAddressId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteAddressId>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteAddressId(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteAddressIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteAddressId>>>
    
    export type DeleteAddressIdMutationError = void

    /**
 * @summary Delete a address record
 */
export const useDeleteAddressId = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAddressId>>, TError,{id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteAddressId>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getDeleteAddressIdMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Returns a list of contract records with pagination
 * @summary Get all contract records
 */
export const getContract = (
    params?: GetContractParams,
 signal?: AbortSignal
) => {
      
      
      return defaultInstance<GetContract200>(
      {url: `/contract`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getGetContractQueryKey = (params?: GetContractParams,) => {
    return [`/contract`, ...(params ? [params]: [])] as const;
    }

    
export const getGetContractQueryOptions = <TData = Awaited<ReturnType<typeof getContract>>, TError = void>(params?: GetContractParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getContract>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetContractQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getContract>>> = ({ signal }) => getContract(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getContract>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetContractQueryResult = NonNullable<Awaited<ReturnType<typeof getContract>>>
export type GetContractQueryError = void


export function useGetContract<TData = Awaited<ReturnType<typeof getContract>>, TError = void>(
 params: undefined |  GetContractParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getContract>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getContract>>,
          TError,
          Awaited<ReturnType<typeof getContract>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetContract<TData = Awaited<ReturnType<typeof getContract>>, TError = void>(
 params?: GetContractParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getContract>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getContract>>,
          TError,
          Awaited<ReturnType<typeof getContract>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetContract<TData = Awaited<ReturnType<typeof getContract>>, TError = void>(
 params?: GetContractParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getContract>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get all contract records
 */

export function useGetContract<TData = Awaited<ReturnType<typeof getContract>>, TError = void>(
 params?: GetContractParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getContract>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetContractQueryOptions(params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Creates a new contract record
 * @summary Create a new contract record
 */
export const postContract = (
    contract: Contract,
 signal?: AbortSignal
) => {
      
      
      return defaultInstance<PostContract200>(
      {url: `/contract`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: contract, signal
    },
      );
    }
  


export const getPostContractMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postContract>>, TError,{data: Contract}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postContract>>, TError,{data: Contract}, TContext> => {
    
const mutationKey = ['postContract'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postContract>>, {data: Contract}> = (props) => {
          const {data} = props ?? {};

          return  postContract(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostContractMutationResult = NonNullable<Awaited<ReturnType<typeof postContract>>>
    export type PostContractMutationBody = Contract
    export type PostContractMutationError = void

    /**
 * @summary Create a new contract record
 */
export const usePostContract = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postContract>>, TError,{data: Contract}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postContract>>,
        TError,
        {data: Contract},
        TContext
      > => {

      const mutationOptions = getPostContractMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Returns a single contract record by ID
 * @summary Get a specific contract record
 */
export const getContractId = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return defaultInstance<GetContractId200>(
      {url: `/contract/${id}`, method: 'GET', signal
    },
      );
    }
  

export const getGetContractIdQueryKey = (id: string,) => {
    return [`/contract/${id}`] as const;
    }

    
export const getGetContractIdQueryOptions = <TData = Awaited<ReturnType<typeof getContractId>>, TError = void>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getContractId>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetContractIdQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getContractId>>> = ({ signal }) => getContractId(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getContractId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetContractIdQueryResult = NonNullable<Awaited<ReturnType<typeof getContractId>>>
export type GetContractIdQueryError = void


export function useGetContractId<TData = Awaited<ReturnType<typeof getContractId>>, TError = void>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getContractId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getContractId>>,
          TError,
          Awaited<ReturnType<typeof getContractId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetContractId<TData = Awaited<ReturnType<typeof getContractId>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getContractId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getContractId>>,
          TError,
          Awaited<ReturnType<typeof getContractId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetContractId<TData = Awaited<ReturnType<typeof getContractId>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getContractId>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get a specific contract record
 */

export function useGetContractId<TData = Awaited<ReturnType<typeof getContractId>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getContractId>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetContractIdQueryOptions(id,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Updates an existing contract record
 * @summary Update a contract record
 */
export const putContractId = (
    id: string,
    contract: Contract,
 ) => {
      
      
      return defaultInstance<PutContractId200>(
      {url: `/contract/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: contract
    },
      );
    }
  


export const getPutContractIdMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putContractId>>, TError,{id: string;data: Contract}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof putContractId>>, TError,{id: string;data: Contract}, TContext> => {
    
const mutationKey = ['putContractId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putContractId>>, {id: string;data: Contract}> = (props) => {
          const {id,data} = props ?? {};

          return  putContractId(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutContractIdMutationResult = NonNullable<Awaited<ReturnType<typeof putContractId>>>
    export type PutContractIdMutationBody = Contract
    export type PutContractIdMutationError = void

    /**
 * @summary Update a contract record
 */
export const usePutContractId = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putContractId>>, TError,{id: string;data: Contract}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putContractId>>,
        TError,
        {id: string;data: Contract},
        TContext
      > => {

      const mutationOptions = getPutContractIdMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Partially updates an existing contract record
 * @summary Partially update a contract record
 */
export const patchContractId = (
    id: string,
    contract: Contract,
 ) => {
      
      
      return defaultInstance<PatchContractId200>(
      {url: `/contract/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: contract
    },
      );
    }
  


export const getPatchContractIdMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchContractId>>, TError,{id: string;data: Contract}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof patchContractId>>, TError,{id: string;data: Contract}, TContext> => {
    
const mutationKey = ['patchContractId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchContractId>>, {id: string;data: Contract}> = (props) => {
          const {id,data} = props ?? {};

          return  patchContractId(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PatchContractIdMutationResult = NonNullable<Awaited<ReturnType<typeof patchContractId>>>
    export type PatchContractIdMutationBody = Contract
    export type PatchContractIdMutationError = void

    /**
 * @summary Partially update a contract record
 */
export const usePatchContractId = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchContractId>>, TError,{id: string;data: Contract}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patchContractId>>,
        TError,
        {id: string;data: Contract},
        TContext
      > => {

      const mutationOptions = getPatchContractIdMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Deletes a contract record
 * @summary Delete a contract record
 */
export const deleteContractId = (
    id: string,
 ) => {
      
      
      return defaultInstance<DeleteContractId200>(
      {url: `/contract/${id}`, method: 'DELETE'
    },
      );
    }
  


export const getDeleteContractIdMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteContractId>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteContractId>>, TError,{id: string}, TContext> => {
    
const mutationKey = ['deleteContractId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteContractId>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteContractId(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteContractIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteContractId>>>
    
    export type DeleteContractIdMutationError = void

    /**
 * @summary Delete a contract record
 */
export const useDeleteContractId = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteContractId>>, TError,{id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteContractId>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getDeleteContractIdMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Returns a list of estate records with pagination
 * @summary Get all estate records
 */
export const getEstate = (
    params?: GetEstateParams,
 signal?: AbortSignal
) => {
      
      
      return defaultInstance<GetEstate200>(
      {url: `/estate`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getGetEstateQueryKey = (params?: GetEstateParams,) => {
    return [`/estate`, ...(params ? [params]: [])] as const;
    }

    
export const getGetEstateQueryOptions = <TData = Awaited<ReturnType<typeof getEstate>>, TError = void>(params?: GetEstateParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEstate>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetEstateQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getEstate>>> = ({ signal }) => getEstate(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getEstate>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetEstateQueryResult = NonNullable<Awaited<ReturnType<typeof getEstate>>>
export type GetEstateQueryError = void


export function useGetEstate<TData = Awaited<ReturnType<typeof getEstate>>, TError = void>(
 params: undefined |  GetEstateParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEstate>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEstate>>,
          TError,
          Awaited<ReturnType<typeof getEstate>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEstate<TData = Awaited<ReturnType<typeof getEstate>>, TError = void>(
 params?: GetEstateParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEstate>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEstate>>,
          TError,
          Awaited<ReturnType<typeof getEstate>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEstate<TData = Awaited<ReturnType<typeof getEstate>>, TError = void>(
 params?: GetEstateParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEstate>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get all estate records
 */

export function useGetEstate<TData = Awaited<ReturnType<typeof getEstate>>, TError = void>(
 params?: GetEstateParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEstate>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetEstateQueryOptions(params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Creates a new estate record
 * @summary Create a new estate record
 */
export const postEstate = (
    estate: Estate,
 signal?: AbortSignal
) => {
      
      
      return defaultInstance<PostEstate200>(
      {url: `/estate`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: estate, signal
    },
      );
    }
  


export const getPostEstateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postEstate>>, TError,{data: Estate}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postEstate>>, TError,{data: Estate}, TContext> => {
    
const mutationKey = ['postEstate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postEstate>>, {data: Estate}> = (props) => {
          const {data} = props ?? {};

          return  postEstate(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostEstateMutationResult = NonNullable<Awaited<ReturnType<typeof postEstate>>>
    export type PostEstateMutationBody = Estate
    export type PostEstateMutationError = void

    /**
 * @summary Create a new estate record
 */
export const usePostEstate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postEstate>>, TError,{data: Estate}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postEstate>>,
        TError,
        {data: Estate},
        TContext
      > => {

      const mutationOptions = getPostEstateMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Returns a single estate record by ID
 * @summary Get a specific estate record
 */
export const getEstateId = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return defaultInstance<GetEstateId200>(
      {url: `/estate/${id}`, method: 'GET', signal
    },
      );
    }
  

export const getGetEstateIdQueryKey = (id: string,) => {
    return [`/estate/${id}`] as const;
    }

    
export const getGetEstateIdQueryOptions = <TData = Awaited<ReturnType<typeof getEstateId>>, TError = void>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEstateId>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetEstateIdQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getEstateId>>> = ({ signal }) => getEstateId(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getEstateId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetEstateIdQueryResult = NonNullable<Awaited<ReturnType<typeof getEstateId>>>
export type GetEstateIdQueryError = void


export function useGetEstateId<TData = Awaited<ReturnType<typeof getEstateId>>, TError = void>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEstateId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEstateId>>,
          TError,
          Awaited<ReturnType<typeof getEstateId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEstateId<TData = Awaited<ReturnType<typeof getEstateId>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEstateId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEstateId>>,
          TError,
          Awaited<ReturnType<typeof getEstateId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEstateId<TData = Awaited<ReturnType<typeof getEstateId>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEstateId>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get a specific estate record
 */

export function useGetEstateId<TData = Awaited<ReturnType<typeof getEstateId>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEstateId>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetEstateIdQueryOptions(id,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Updates an existing estate record
 * @summary Update a estate record
 */
export const putEstateId = (
    id: string,
    estate: Estate,
 ) => {
      
      
      return defaultInstance<PutEstateId200>(
      {url: `/estate/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: estate
    },
      );
    }
  


export const getPutEstateIdMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putEstateId>>, TError,{id: string;data: Estate}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof putEstateId>>, TError,{id: string;data: Estate}, TContext> => {
    
const mutationKey = ['putEstateId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putEstateId>>, {id: string;data: Estate}> = (props) => {
          const {id,data} = props ?? {};

          return  putEstateId(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutEstateIdMutationResult = NonNullable<Awaited<ReturnType<typeof putEstateId>>>
    export type PutEstateIdMutationBody = Estate
    export type PutEstateIdMutationError = void

    /**
 * @summary Update a estate record
 */
export const usePutEstateId = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putEstateId>>, TError,{id: string;data: Estate}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putEstateId>>,
        TError,
        {id: string;data: Estate},
        TContext
      > => {

      const mutationOptions = getPutEstateIdMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Partially updates an existing estate record
 * @summary Partially update a estate record
 */
export const patchEstateId = (
    id: string,
    estate: Estate,
 ) => {
      
      
      return defaultInstance<PatchEstateId200>(
      {url: `/estate/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: estate
    },
      );
    }
  


export const getPatchEstateIdMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchEstateId>>, TError,{id: string;data: Estate}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof patchEstateId>>, TError,{id: string;data: Estate}, TContext> => {
    
const mutationKey = ['patchEstateId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchEstateId>>, {id: string;data: Estate}> = (props) => {
          const {id,data} = props ?? {};

          return  patchEstateId(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PatchEstateIdMutationResult = NonNullable<Awaited<ReturnType<typeof patchEstateId>>>
    export type PatchEstateIdMutationBody = Estate
    export type PatchEstateIdMutationError = void

    /**
 * @summary Partially update a estate record
 */
export const usePatchEstateId = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchEstateId>>, TError,{id: string;data: Estate}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patchEstateId>>,
        TError,
        {id: string;data: Estate},
        TContext
      > => {

      const mutationOptions = getPatchEstateIdMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Deletes a estate record
 * @summary Delete a estate record
 */
export const deleteEstateId = (
    id: string,
 ) => {
      
      
      return defaultInstance<DeleteEstateId200>(
      {url: `/estate/${id}`, method: 'DELETE'
    },
      );
    }
  


export const getDeleteEstateIdMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteEstateId>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteEstateId>>, TError,{id: string}, TContext> => {
    
const mutationKey = ['deleteEstateId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteEstateId>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteEstateId(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteEstateIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteEstateId>>>
    
    export type DeleteEstateIdMutationError = void

    /**
 * @summary Delete a estate record
 */
export const useDeleteEstateId = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteEstateId>>, TError,{id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteEstateId>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getDeleteEstateIdMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Returns a list of user_state records with pagination
 * @summary Get all user_state records
 */
export const getUserState = (
    params?: GetUserStateParams,
 signal?: AbortSignal
) => {
      
      
      return defaultInstance<GetUserState200>(
      {url: `/user_state`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getGetUserStateQueryKey = (params?: GetUserStateParams,) => {
    return [`/user_state`, ...(params ? [params]: [])] as const;
    }

    
export const getGetUserStateQueryOptions = <TData = Awaited<ReturnType<typeof getUserState>>, TError = void>(params?: GetUserStateParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserState>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUserStateQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUserState>>> = ({ signal }) => getUserState(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getUserState>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetUserStateQueryResult = NonNullable<Awaited<ReturnType<typeof getUserState>>>
export type GetUserStateQueryError = void


export function useGetUserState<TData = Awaited<ReturnType<typeof getUserState>>, TError = void>(
 params: undefined |  GetUserStateParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserState>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserState>>,
          TError,
          Awaited<ReturnType<typeof getUserState>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUserState<TData = Awaited<ReturnType<typeof getUserState>>, TError = void>(
 params?: GetUserStateParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserState>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserState>>,
          TError,
          Awaited<ReturnType<typeof getUserState>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUserState<TData = Awaited<ReturnType<typeof getUserState>>, TError = void>(
 params?: GetUserStateParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserState>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get all user_state records
 */

export function useGetUserState<TData = Awaited<ReturnType<typeof getUserState>>, TError = void>(
 params?: GetUserStateParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserState>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetUserStateQueryOptions(params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Creates a new user_state record
 * @summary Create a new user_state record
 */
export const postUserState = (
    userState: UserState,
 signal?: AbortSignal
) => {
      
      
      return defaultInstance<PostUserState200>(
      {url: `/user_state`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: userState, signal
    },
      );
    }
  


export const getPostUserStateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postUserState>>, TError,{data: UserState}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postUserState>>, TError,{data: UserState}, TContext> => {
    
const mutationKey = ['postUserState'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postUserState>>, {data: UserState}> = (props) => {
          const {data} = props ?? {};

          return  postUserState(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostUserStateMutationResult = NonNullable<Awaited<ReturnType<typeof postUserState>>>
    export type PostUserStateMutationBody = UserState
    export type PostUserStateMutationError = void

    /**
 * @summary Create a new user_state record
 */
export const usePostUserState = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postUserState>>, TError,{data: UserState}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postUserState>>,
        TError,
        {data: UserState},
        TContext
      > => {

      const mutationOptions = getPostUserStateMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Returns a single user_state record by ID
 * @summary Get a specific user_state record
 */
export const getUserStateId = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return defaultInstance<GetUserStateId200>(
      {url: `/user_state/${id}`, method: 'GET', signal
    },
      );
    }
  

export const getGetUserStateIdQueryKey = (id: string,) => {
    return [`/user_state/${id}`] as const;
    }

    
export const getGetUserStateIdQueryOptions = <TData = Awaited<ReturnType<typeof getUserStateId>>, TError = void>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserStateId>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUserStateIdQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUserStateId>>> = ({ signal }) => getUserStateId(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getUserStateId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetUserStateIdQueryResult = NonNullable<Awaited<ReturnType<typeof getUserStateId>>>
export type GetUserStateIdQueryError = void


export function useGetUserStateId<TData = Awaited<ReturnType<typeof getUserStateId>>, TError = void>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserStateId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserStateId>>,
          TError,
          Awaited<ReturnType<typeof getUserStateId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUserStateId<TData = Awaited<ReturnType<typeof getUserStateId>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserStateId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserStateId>>,
          TError,
          Awaited<ReturnType<typeof getUserStateId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUserStateId<TData = Awaited<ReturnType<typeof getUserStateId>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserStateId>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get a specific user_state record
 */

export function useGetUserStateId<TData = Awaited<ReturnType<typeof getUserStateId>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserStateId>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetUserStateIdQueryOptions(id,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Updates an existing user_state record
 * @summary Update a user_state record
 */
export const putUserStateId = (
    id: string,
    userState: UserState,
 ) => {
      
      
      return defaultInstance<PutUserStateId200>(
      {url: `/user_state/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: userState
    },
      );
    }
  


export const getPutUserStateIdMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putUserStateId>>, TError,{id: string;data: UserState}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof putUserStateId>>, TError,{id: string;data: UserState}, TContext> => {
    
const mutationKey = ['putUserStateId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putUserStateId>>, {id: string;data: UserState}> = (props) => {
          const {id,data} = props ?? {};

          return  putUserStateId(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutUserStateIdMutationResult = NonNullable<Awaited<ReturnType<typeof putUserStateId>>>
    export type PutUserStateIdMutationBody = UserState
    export type PutUserStateIdMutationError = void

    /**
 * @summary Update a user_state record
 */
export const usePutUserStateId = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putUserStateId>>, TError,{id: string;data: UserState}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putUserStateId>>,
        TError,
        {id: string;data: UserState},
        TContext
      > => {

      const mutationOptions = getPutUserStateIdMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Partially updates an existing user_state record
 * @summary Partially update a user_state record
 */
export const patchUserStateId = (
    id: string,
    userState: UserState,
 ) => {
      
      
      return defaultInstance<PatchUserStateId200>(
      {url: `/user_state/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: userState
    },
      );
    }
  


export const getPatchUserStateIdMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchUserStateId>>, TError,{id: string;data: UserState}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof patchUserStateId>>, TError,{id: string;data: UserState}, TContext> => {
    
const mutationKey = ['patchUserStateId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchUserStateId>>, {id: string;data: UserState}> = (props) => {
          const {id,data} = props ?? {};

          return  patchUserStateId(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PatchUserStateIdMutationResult = NonNullable<Awaited<ReturnType<typeof patchUserStateId>>>
    export type PatchUserStateIdMutationBody = UserState
    export type PatchUserStateIdMutationError = void

    /**
 * @summary Partially update a user_state record
 */
export const usePatchUserStateId = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchUserStateId>>, TError,{id: string;data: UserState}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patchUserStateId>>,
        TError,
        {id: string;data: UserState},
        TContext
      > => {

      const mutationOptions = getPatchUserStateIdMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Deletes a user_state record
 * @summary Delete a user_state record
 */
export const deleteUserStateId = (
    id: string,
 ) => {
      
      
      return defaultInstance<DeleteUserStateId200>(
      {url: `/user_state/${id}`, method: 'DELETE'
    },
      );
    }
  


export const getDeleteUserStateIdMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteUserStateId>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteUserStateId>>, TError,{id: string}, TContext> => {
    
const mutationKey = ['deleteUserStateId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteUserStateId>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteUserStateId(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteUserStateIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteUserStateId>>>
    
    export type DeleteUserStateIdMutationError = void

    /**
 * @summary Delete a user_state record
 */
export const useDeleteUserStateId = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteUserStateId>>, TError,{id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteUserStateId>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getDeleteUserStateIdMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Returns a list of building records with pagination
 * @summary Get all building records
 */
export const getBuilding = (
    params?: GetBuildingParams,
 signal?: AbortSignal
) => {
      
      
      return defaultInstance<GetBuilding200>(
      {url: `/building`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getGetBuildingQueryKey = (params?: GetBuildingParams,) => {
    return [`/building`, ...(params ? [params]: [])] as const;
    }

    
export const getGetBuildingQueryOptions = <TData = Awaited<ReturnType<typeof getBuilding>>, TError = void>(params?: GetBuildingParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBuilding>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetBuildingQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getBuilding>>> = ({ signal }) => getBuilding(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getBuilding>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetBuildingQueryResult = NonNullable<Awaited<ReturnType<typeof getBuilding>>>
export type GetBuildingQueryError = void


export function useGetBuilding<TData = Awaited<ReturnType<typeof getBuilding>>, TError = void>(
 params: undefined |  GetBuildingParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBuilding>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBuilding>>,
          TError,
          Awaited<ReturnType<typeof getBuilding>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBuilding<TData = Awaited<ReturnType<typeof getBuilding>>, TError = void>(
 params?: GetBuildingParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBuilding>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBuilding>>,
          TError,
          Awaited<ReturnType<typeof getBuilding>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBuilding<TData = Awaited<ReturnType<typeof getBuilding>>, TError = void>(
 params?: GetBuildingParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBuilding>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get all building records
 */

export function useGetBuilding<TData = Awaited<ReturnType<typeof getBuilding>>, TError = void>(
 params?: GetBuildingParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBuilding>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetBuildingQueryOptions(params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Creates a new building record
 * @summary Create a new building record
 */
export const postBuilding = (
    building: Building,
 signal?: AbortSignal
) => {
      
      
      return defaultInstance<PostBuilding200>(
      {url: `/building`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: building, signal
    },
      );
    }
  


export const getPostBuildingMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postBuilding>>, TError,{data: Building}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postBuilding>>, TError,{data: Building}, TContext> => {
    
const mutationKey = ['postBuilding'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postBuilding>>, {data: Building}> = (props) => {
          const {data} = props ?? {};

          return  postBuilding(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostBuildingMutationResult = NonNullable<Awaited<ReturnType<typeof postBuilding>>>
    export type PostBuildingMutationBody = Building
    export type PostBuildingMutationError = void

    /**
 * @summary Create a new building record
 */
export const usePostBuilding = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postBuilding>>, TError,{data: Building}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postBuilding>>,
        TError,
        {data: Building},
        TContext
      > => {

      const mutationOptions = getPostBuildingMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Returns a single building record by ID
 * @summary Get a specific building record
 */
export const getBuildingId = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return defaultInstance<GetBuildingId200>(
      {url: `/building/${id}`, method: 'GET', signal
    },
      );
    }
  

export const getGetBuildingIdQueryKey = (id: string,) => {
    return [`/building/${id}`] as const;
    }

    
export const getGetBuildingIdQueryOptions = <TData = Awaited<ReturnType<typeof getBuildingId>>, TError = void>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBuildingId>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetBuildingIdQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getBuildingId>>> = ({ signal }) => getBuildingId(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getBuildingId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetBuildingIdQueryResult = NonNullable<Awaited<ReturnType<typeof getBuildingId>>>
export type GetBuildingIdQueryError = void


export function useGetBuildingId<TData = Awaited<ReturnType<typeof getBuildingId>>, TError = void>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBuildingId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBuildingId>>,
          TError,
          Awaited<ReturnType<typeof getBuildingId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBuildingId<TData = Awaited<ReturnType<typeof getBuildingId>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBuildingId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBuildingId>>,
          TError,
          Awaited<ReturnType<typeof getBuildingId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBuildingId<TData = Awaited<ReturnType<typeof getBuildingId>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBuildingId>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get a specific building record
 */

export function useGetBuildingId<TData = Awaited<ReturnType<typeof getBuildingId>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBuildingId>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetBuildingIdQueryOptions(id,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Updates an existing building record
 * @summary Update a building record
 */
export const putBuildingId = (
    id: string,
    building: Building,
 ) => {
      
      
      return defaultInstance<PutBuildingId200>(
      {url: `/building/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: building
    },
      );
    }
  


export const getPutBuildingIdMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putBuildingId>>, TError,{id: string;data: Building}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof putBuildingId>>, TError,{id: string;data: Building}, TContext> => {
    
const mutationKey = ['putBuildingId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putBuildingId>>, {id: string;data: Building}> = (props) => {
          const {id,data} = props ?? {};

          return  putBuildingId(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutBuildingIdMutationResult = NonNullable<Awaited<ReturnType<typeof putBuildingId>>>
    export type PutBuildingIdMutationBody = Building
    export type PutBuildingIdMutationError = void

    /**
 * @summary Update a building record
 */
export const usePutBuildingId = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putBuildingId>>, TError,{id: string;data: Building}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putBuildingId>>,
        TError,
        {id: string;data: Building},
        TContext
      > => {

      const mutationOptions = getPutBuildingIdMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Partially updates an existing building record
 * @summary Partially update a building record
 */
export const patchBuildingId = (
    id: string,
    building: Building,
 ) => {
      
      
      return defaultInstance<PatchBuildingId200>(
      {url: `/building/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: building
    },
      );
    }
  


export const getPatchBuildingIdMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchBuildingId>>, TError,{id: string;data: Building}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof patchBuildingId>>, TError,{id: string;data: Building}, TContext> => {
    
const mutationKey = ['patchBuildingId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchBuildingId>>, {id: string;data: Building}> = (props) => {
          const {id,data} = props ?? {};

          return  patchBuildingId(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PatchBuildingIdMutationResult = NonNullable<Awaited<ReturnType<typeof patchBuildingId>>>
    export type PatchBuildingIdMutationBody = Building
    export type PatchBuildingIdMutationError = void

    /**
 * @summary Partially update a building record
 */
export const usePatchBuildingId = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchBuildingId>>, TError,{id: string;data: Building}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patchBuildingId>>,
        TError,
        {id: string;data: Building},
        TContext
      > => {

      const mutationOptions = getPatchBuildingIdMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Deletes a building record
 * @summary Delete a building record
 */
export const deleteBuildingId = (
    id: string,
 ) => {
      
      
      return defaultInstance<DeleteBuildingId200>(
      {url: `/building/${id}`, method: 'DELETE'
    },
      );
    }
  


export const getDeleteBuildingIdMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteBuildingId>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteBuildingId>>, TError,{id: string}, TContext> => {
    
const mutationKey = ['deleteBuildingId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteBuildingId>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteBuildingId(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteBuildingIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteBuildingId>>>
    
    export type DeleteBuildingIdMutationError = void

    /**
 * @summary Delete a building record
 */
export const useDeleteBuildingId = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteBuildingId>>, TError,{id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteBuildingId>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getDeleteBuildingIdMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Returns a list of floor records with pagination
 * @summary Get all floor records
 */
export const getFloor = (
    params?: GetFloorParams,
 signal?: AbortSignal
) => {
      
      
      return defaultInstance<GetFloor200>(
      {url: `/floor`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getGetFloorQueryKey = (params?: GetFloorParams,) => {
    return [`/floor`, ...(params ? [params]: [])] as const;
    }

    
export const getGetFloorQueryOptions = <TData = Awaited<ReturnType<typeof getFloor>>, TError = void>(params?: GetFloorParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFloor>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetFloorQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getFloor>>> = ({ signal }) => getFloor(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getFloor>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetFloorQueryResult = NonNullable<Awaited<ReturnType<typeof getFloor>>>
export type GetFloorQueryError = void


export function useGetFloor<TData = Awaited<ReturnType<typeof getFloor>>, TError = void>(
 params: undefined |  GetFloorParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFloor>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getFloor>>,
          TError,
          Awaited<ReturnType<typeof getFloor>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetFloor<TData = Awaited<ReturnType<typeof getFloor>>, TError = void>(
 params?: GetFloorParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFloor>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getFloor>>,
          TError,
          Awaited<ReturnType<typeof getFloor>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetFloor<TData = Awaited<ReturnType<typeof getFloor>>, TError = void>(
 params?: GetFloorParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFloor>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get all floor records
 */

export function useGetFloor<TData = Awaited<ReturnType<typeof getFloor>>, TError = void>(
 params?: GetFloorParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFloor>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetFloorQueryOptions(params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Creates a new floor record
 * @summary Create a new floor record
 */
export const postFloor = (
    floor: Floor,
 signal?: AbortSignal
) => {
      
      
      return defaultInstance<PostFloor200>(
      {url: `/floor`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: floor, signal
    },
      );
    }
  


export const getPostFloorMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postFloor>>, TError,{data: Floor}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postFloor>>, TError,{data: Floor}, TContext> => {
    
const mutationKey = ['postFloor'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postFloor>>, {data: Floor}> = (props) => {
          const {data} = props ?? {};

          return  postFloor(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostFloorMutationResult = NonNullable<Awaited<ReturnType<typeof postFloor>>>
    export type PostFloorMutationBody = Floor
    export type PostFloorMutationError = void

    /**
 * @summary Create a new floor record
 */
export const usePostFloor = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postFloor>>, TError,{data: Floor}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postFloor>>,
        TError,
        {data: Floor},
        TContext
      > => {

      const mutationOptions = getPostFloorMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Returns a single floor record by ID
 * @summary Get a specific floor record
 */
export const getFloorId = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return defaultInstance<GetFloorId200>(
      {url: `/floor/${id}`, method: 'GET', signal
    },
      );
    }
  

export const getGetFloorIdQueryKey = (id: string,) => {
    return [`/floor/${id}`] as const;
    }

    
export const getGetFloorIdQueryOptions = <TData = Awaited<ReturnType<typeof getFloorId>>, TError = void>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFloorId>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetFloorIdQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getFloorId>>> = ({ signal }) => getFloorId(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getFloorId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetFloorIdQueryResult = NonNullable<Awaited<ReturnType<typeof getFloorId>>>
export type GetFloorIdQueryError = void


export function useGetFloorId<TData = Awaited<ReturnType<typeof getFloorId>>, TError = void>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFloorId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getFloorId>>,
          TError,
          Awaited<ReturnType<typeof getFloorId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetFloorId<TData = Awaited<ReturnType<typeof getFloorId>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFloorId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getFloorId>>,
          TError,
          Awaited<ReturnType<typeof getFloorId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetFloorId<TData = Awaited<ReturnType<typeof getFloorId>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFloorId>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get a specific floor record
 */

export function useGetFloorId<TData = Awaited<ReturnType<typeof getFloorId>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFloorId>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetFloorIdQueryOptions(id,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Updates an existing floor record
 * @summary Update a floor record
 */
export const putFloorId = (
    id: string,
    floor: Floor,
 ) => {
      
      
      return defaultInstance<PutFloorId200>(
      {url: `/floor/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: floor
    },
      );
    }
  


export const getPutFloorIdMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putFloorId>>, TError,{id: string;data: Floor}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof putFloorId>>, TError,{id: string;data: Floor}, TContext> => {
    
const mutationKey = ['putFloorId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putFloorId>>, {id: string;data: Floor}> = (props) => {
          const {id,data} = props ?? {};

          return  putFloorId(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutFloorIdMutationResult = NonNullable<Awaited<ReturnType<typeof putFloorId>>>
    export type PutFloorIdMutationBody = Floor
    export type PutFloorIdMutationError = void

    /**
 * @summary Update a floor record
 */
export const usePutFloorId = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putFloorId>>, TError,{id: string;data: Floor}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putFloorId>>,
        TError,
        {id: string;data: Floor},
        TContext
      > => {

      const mutationOptions = getPutFloorIdMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Partially updates an existing floor record
 * @summary Partially update a floor record
 */
export const patchFloorId = (
    id: string,
    floor: Floor,
 ) => {
      
      
      return defaultInstance<PatchFloorId200>(
      {url: `/floor/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: floor
    },
      );
    }
  


export const getPatchFloorIdMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchFloorId>>, TError,{id: string;data: Floor}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof patchFloorId>>, TError,{id: string;data: Floor}, TContext> => {
    
const mutationKey = ['patchFloorId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchFloorId>>, {id: string;data: Floor}> = (props) => {
          const {id,data} = props ?? {};

          return  patchFloorId(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PatchFloorIdMutationResult = NonNullable<Awaited<ReturnType<typeof patchFloorId>>>
    export type PatchFloorIdMutationBody = Floor
    export type PatchFloorIdMutationError = void

    /**
 * @summary Partially update a floor record
 */
export const usePatchFloorId = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchFloorId>>, TError,{id: string;data: Floor}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patchFloorId>>,
        TError,
        {id: string;data: Floor},
        TContext
      > => {

      const mutationOptions = getPatchFloorIdMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Deletes a floor record
 * @summary Delete a floor record
 */
export const deleteFloorId = (
    id: string,
 ) => {
      
      
      return defaultInstance<DeleteFloorId200>(
      {url: `/floor/${id}`, method: 'DELETE'
    },
      );
    }
  


export const getDeleteFloorIdMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteFloorId>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteFloorId>>, TError,{id: string}, TContext> => {
    
const mutationKey = ['deleteFloorId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteFloorId>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteFloorId(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteFloorIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteFloorId>>>
    
    export type DeleteFloorIdMutationError = void

    /**
 * @summary Delete a floor record
 */
export const useDeleteFloorId = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteFloorId>>, TError,{id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteFloorId>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getDeleteFloorIdMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Returns a list of section records with pagination
 * @summary Get all section records
 */
export const getSection = (
    params?: GetSectionParams,
 signal?: AbortSignal
) => {
      
      
      return defaultInstance<GetSection200>(
      {url: `/section`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getGetSectionQueryKey = (params?: GetSectionParams,) => {
    return [`/section`, ...(params ? [params]: [])] as const;
    }

    
export const getGetSectionQueryOptions = <TData = Awaited<ReturnType<typeof getSection>>, TError = void>(params?: GetSectionParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSection>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSectionQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSection>>> = ({ signal }) => getSection(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSection>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetSectionQueryResult = NonNullable<Awaited<ReturnType<typeof getSection>>>
export type GetSectionQueryError = void


export function useGetSection<TData = Awaited<ReturnType<typeof getSection>>, TError = void>(
 params: undefined |  GetSectionParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSection>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSection>>,
          TError,
          Awaited<ReturnType<typeof getSection>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSection<TData = Awaited<ReturnType<typeof getSection>>, TError = void>(
 params?: GetSectionParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSection>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSection>>,
          TError,
          Awaited<ReturnType<typeof getSection>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSection<TData = Awaited<ReturnType<typeof getSection>>, TError = void>(
 params?: GetSectionParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSection>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get all section records
 */

export function useGetSection<TData = Awaited<ReturnType<typeof getSection>>, TError = void>(
 params?: GetSectionParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSection>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetSectionQueryOptions(params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Creates a new section record
 * @summary Create a new section record
 */
export const postSection = (
    section: Section,
 signal?: AbortSignal
) => {
      
      
      return defaultInstance<PostSection200>(
      {url: `/section`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: section, signal
    },
      );
    }
  


export const getPostSectionMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postSection>>, TError,{data: Section}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postSection>>, TError,{data: Section}, TContext> => {
    
const mutationKey = ['postSection'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postSection>>, {data: Section}> = (props) => {
          const {data} = props ?? {};

          return  postSection(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostSectionMutationResult = NonNullable<Awaited<ReturnType<typeof postSection>>>
    export type PostSectionMutationBody = Section
    export type PostSectionMutationError = void

    /**
 * @summary Create a new section record
 */
export const usePostSection = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postSection>>, TError,{data: Section}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postSection>>,
        TError,
        {data: Section},
        TContext
      > => {

      const mutationOptions = getPostSectionMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Returns a single section record by ID
 * @summary Get a specific section record
 */
export const getSectionId = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return defaultInstance<GetSectionId200>(
      {url: `/section/${id}`, method: 'GET', signal
    },
      );
    }
  

export const getGetSectionIdQueryKey = (id: string,) => {
    return [`/section/${id}`] as const;
    }

    
export const getGetSectionIdQueryOptions = <TData = Awaited<ReturnType<typeof getSectionId>>, TError = void>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSectionId>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSectionIdQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSectionId>>> = ({ signal }) => getSectionId(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSectionId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetSectionIdQueryResult = NonNullable<Awaited<ReturnType<typeof getSectionId>>>
export type GetSectionIdQueryError = void


export function useGetSectionId<TData = Awaited<ReturnType<typeof getSectionId>>, TError = void>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSectionId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSectionId>>,
          TError,
          Awaited<ReturnType<typeof getSectionId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSectionId<TData = Awaited<ReturnType<typeof getSectionId>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSectionId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSectionId>>,
          TError,
          Awaited<ReturnType<typeof getSectionId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSectionId<TData = Awaited<ReturnType<typeof getSectionId>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSectionId>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get a specific section record
 */

export function useGetSectionId<TData = Awaited<ReturnType<typeof getSectionId>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSectionId>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetSectionIdQueryOptions(id,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Updates an existing section record
 * @summary Update a section record
 */
export const putSectionId = (
    id: string,
    section: Section,
 ) => {
      
      
      return defaultInstance<PutSectionId200>(
      {url: `/section/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: section
    },
      );
    }
  


export const getPutSectionIdMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putSectionId>>, TError,{id: string;data: Section}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof putSectionId>>, TError,{id: string;data: Section}, TContext> => {
    
const mutationKey = ['putSectionId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putSectionId>>, {id: string;data: Section}> = (props) => {
          const {id,data} = props ?? {};

          return  putSectionId(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutSectionIdMutationResult = NonNullable<Awaited<ReturnType<typeof putSectionId>>>
    export type PutSectionIdMutationBody = Section
    export type PutSectionIdMutationError = void

    /**
 * @summary Update a section record
 */
export const usePutSectionId = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putSectionId>>, TError,{id: string;data: Section}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putSectionId>>,
        TError,
        {id: string;data: Section},
        TContext
      > => {

      const mutationOptions = getPutSectionIdMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Partially updates an existing section record
 * @summary Partially update a section record
 */
export const patchSectionId = (
    id: string,
    section: Section,
 ) => {
      
      
      return defaultInstance<PatchSectionId200>(
      {url: `/section/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: section
    },
      );
    }
  


export const getPatchSectionIdMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchSectionId>>, TError,{id: string;data: Section}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof patchSectionId>>, TError,{id: string;data: Section}, TContext> => {
    
const mutationKey = ['patchSectionId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchSectionId>>, {id: string;data: Section}> = (props) => {
          const {id,data} = props ?? {};

          return  patchSectionId(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PatchSectionIdMutationResult = NonNullable<Awaited<ReturnType<typeof patchSectionId>>>
    export type PatchSectionIdMutationBody = Section
    export type PatchSectionIdMutationError = void

    /**
 * @summary Partially update a section record
 */
export const usePatchSectionId = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchSectionId>>, TError,{id: string;data: Section}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patchSectionId>>,
        TError,
        {id: string;data: Section},
        TContext
      > => {

      const mutationOptions = getPatchSectionIdMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Deletes a section record
 * @summary Delete a section record
 */
export const deleteSectionId = (
    id: string,
 ) => {
      
      
      return defaultInstance<DeleteSectionId200>(
      {url: `/section/${id}`, method: 'DELETE'
    },
      );
    }
  


export const getDeleteSectionIdMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteSectionId>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteSectionId>>, TError,{id: string}, TContext> => {
    
const mutationKey = ['deleteSectionId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteSectionId>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteSectionId(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteSectionIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteSectionId>>>
    
    export type DeleteSectionIdMutationError = void

    /**
 * @summary Delete a section record
 */
export const useDeleteSectionId = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteSectionId>>, TError,{id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteSectionId>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getDeleteSectionIdMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Returns a list of gate records with pagination
 * @summary Get all gate records
 */
export const getGate = (
    params?: GetGateParams,
 signal?: AbortSignal
) => {
      
      
      return defaultInstance<GetGate200>(
      {url: `/gate`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getGetGateQueryKey = (params?: GetGateParams,) => {
    return [`/gate`, ...(params ? [params]: [])] as const;
    }

    
export const getGetGateQueryOptions = <TData = Awaited<ReturnType<typeof getGate>>, TError = void>(params?: GetGateParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getGate>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetGateQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getGate>>> = ({ signal }) => getGate(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getGate>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetGateQueryResult = NonNullable<Awaited<ReturnType<typeof getGate>>>
export type GetGateQueryError = void


export function useGetGate<TData = Awaited<ReturnType<typeof getGate>>, TError = void>(
 params: undefined |  GetGateParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getGate>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getGate>>,
          TError,
          Awaited<ReturnType<typeof getGate>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetGate<TData = Awaited<ReturnType<typeof getGate>>, TError = void>(
 params?: GetGateParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getGate>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getGate>>,
          TError,
          Awaited<ReturnType<typeof getGate>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetGate<TData = Awaited<ReturnType<typeof getGate>>, TError = void>(
 params?: GetGateParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getGate>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get all gate records
 */

export function useGetGate<TData = Awaited<ReturnType<typeof getGate>>, TError = void>(
 params?: GetGateParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getGate>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetGateQueryOptions(params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Creates a new gate record
 * @summary Create a new gate record
 */
export const postGate = (
    gate: Gate,
 signal?: AbortSignal
) => {
      
      
      return defaultInstance<PostGate200>(
      {url: `/gate`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: gate, signal
    },
      );
    }
  


export const getPostGateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postGate>>, TError,{data: Gate}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postGate>>, TError,{data: Gate}, TContext> => {
    
const mutationKey = ['postGate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postGate>>, {data: Gate}> = (props) => {
          const {data} = props ?? {};

          return  postGate(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostGateMutationResult = NonNullable<Awaited<ReturnType<typeof postGate>>>
    export type PostGateMutationBody = Gate
    export type PostGateMutationError = void

    /**
 * @summary Create a new gate record
 */
export const usePostGate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postGate>>, TError,{data: Gate}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postGate>>,
        TError,
        {data: Gate},
        TContext
      > => {

      const mutationOptions = getPostGateMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Returns a single gate record by ID
 * @summary Get a specific gate record
 */
export const getGateId = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return defaultInstance<GetGateId200>(
      {url: `/gate/${id}`, method: 'GET', signal
    },
      );
    }
  

export const getGetGateIdQueryKey = (id: string,) => {
    return [`/gate/${id}`] as const;
    }

    
export const getGetGateIdQueryOptions = <TData = Awaited<ReturnType<typeof getGateId>>, TError = void>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getGateId>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetGateIdQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getGateId>>> = ({ signal }) => getGateId(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getGateId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetGateIdQueryResult = NonNullable<Awaited<ReturnType<typeof getGateId>>>
export type GetGateIdQueryError = void


export function useGetGateId<TData = Awaited<ReturnType<typeof getGateId>>, TError = void>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getGateId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getGateId>>,
          TError,
          Awaited<ReturnType<typeof getGateId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetGateId<TData = Awaited<ReturnType<typeof getGateId>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getGateId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getGateId>>,
          TError,
          Awaited<ReturnType<typeof getGateId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetGateId<TData = Awaited<ReturnType<typeof getGateId>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getGateId>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get a specific gate record
 */

export function useGetGateId<TData = Awaited<ReturnType<typeof getGateId>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getGateId>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetGateIdQueryOptions(id,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Updates an existing gate record
 * @summary Update a gate record
 */
export const putGateId = (
    id: string,
    gate: Gate,
 ) => {
      
      
      return defaultInstance<PutGateId200>(
      {url: `/gate/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: gate
    },
      );
    }
  


export const getPutGateIdMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putGateId>>, TError,{id: string;data: Gate}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof putGateId>>, TError,{id: string;data: Gate}, TContext> => {
    
const mutationKey = ['putGateId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putGateId>>, {id: string;data: Gate}> = (props) => {
          const {id,data} = props ?? {};

          return  putGateId(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutGateIdMutationResult = NonNullable<Awaited<ReturnType<typeof putGateId>>>
    export type PutGateIdMutationBody = Gate
    export type PutGateIdMutationError = void

    /**
 * @summary Update a gate record
 */
export const usePutGateId = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putGateId>>, TError,{id: string;data: Gate}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putGateId>>,
        TError,
        {id: string;data: Gate},
        TContext
      > => {

      const mutationOptions = getPutGateIdMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Partially updates an existing gate record
 * @summary Partially update a gate record
 */
export const patchGateId = (
    id: string,
    gate: Gate,
 ) => {
      
      
      return defaultInstance<PatchGateId200>(
      {url: `/gate/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: gate
    },
      );
    }
  


export const getPatchGateIdMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchGateId>>, TError,{id: string;data: Gate}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof patchGateId>>, TError,{id: string;data: Gate}, TContext> => {
    
const mutationKey = ['patchGateId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchGateId>>, {id: string;data: Gate}> = (props) => {
          const {id,data} = props ?? {};

          return  patchGateId(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PatchGateIdMutationResult = NonNullable<Awaited<ReturnType<typeof patchGateId>>>
    export type PatchGateIdMutationBody = Gate
    export type PatchGateIdMutationError = void

    /**
 * @summary Partially update a gate record
 */
export const usePatchGateId = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchGateId>>, TError,{id: string;data: Gate}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patchGateId>>,
        TError,
        {id: string;data: Gate},
        TContext
      > => {

      const mutationOptions = getPatchGateIdMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Deletes a gate record
 * @summary Delete a gate record
 */
export const deleteGateId = (
    id: string,
 ) => {
      
      
      return defaultInstance<DeleteGateId200>(
      {url: `/gate/${id}`, method: 'DELETE'
    },
      );
    }
  


export const getDeleteGateIdMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteGateId>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteGateId>>, TError,{id: string}, TContext> => {
    
const mutationKey = ['deleteGateId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteGateId>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteGateId(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteGateIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteGateId>>>
    
    export type DeleteGateIdMutationError = void

    /**
 * @summary Delete a gate record
 */
export const useDeleteGateId = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteGateId>>, TError,{id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteGateId>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getDeleteGateIdMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Returns a list of entry_log records with pagination
 * @summary Get all entry_log records
 */
export const getEntryLog = (
    params?: GetEntryLogParams,
 signal?: AbortSignal
) => {
      
      
      return defaultInstance<GetEntryLog200>(
      {url: `/entry_log`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getGetEntryLogQueryKey = (params?: GetEntryLogParams,) => {
    return [`/entry_log`, ...(params ? [params]: [])] as const;
    }

    
export const getGetEntryLogQueryOptions = <TData = Awaited<ReturnType<typeof getEntryLog>>, TError = void>(params?: GetEntryLogParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEntryLog>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetEntryLogQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getEntryLog>>> = ({ signal }) => getEntryLog(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getEntryLog>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetEntryLogQueryResult = NonNullable<Awaited<ReturnType<typeof getEntryLog>>>
export type GetEntryLogQueryError = void


export function useGetEntryLog<TData = Awaited<ReturnType<typeof getEntryLog>>, TError = void>(
 params: undefined |  GetEntryLogParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEntryLog>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEntryLog>>,
          TError,
          Awaited<ReturnType<typeof getEntryLog>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEntryLog<TData = Awaited<ReturnType<typeof getEntryLog>>, TError = void>(
 params?: GetEntryLogParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEntryLog>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEntryLog>>,
          TError,
          Awaited<ReturnType<typeof getEntryLog>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEntryLog<TData = Awaited<ReturnType<typeof getEntryLog>>, TError = void>(
 params?: GetEntryLogParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEntryLog>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get all entry_log records
 */

export function useGetEntryLog<TData = Awaited<ReturnType<typeof getEntryLog>>, TError = void>(
 params?: GetEntryLogParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEntryLog>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetEntryLogQueryOptions(params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Creates a new entry_log record
 * @summary Create a new entry_log record
 */
export const postEntryLog = (
    entryLog: EntryLog,
 signal?: AbortSignal
) => {
      
      
      return defaultInstance<PostEntryLog200>(
      {url: `/entry_log`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: entryLog, signal
    },
      );
    }
  


export const getPostEntryLogMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postEntryLog>>, TError,{data: EntryLog}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postEntryLog>>, TError,{data: EntryLog}, TContext> => {
    
const mutationKey = ['postEntryLog'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postEntryLog>>, {data: EntryLog}> = (props) => {
          const {data} = props ?? {};

          return  postEntryLog(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostEntryLogMutationResult = NonNullable<Awaited<ReturnType<typeof postEntryLog>>>
    export type PostEntryLogMutationBody = EntryLog
    export type PostEntryLogMutationError = void

    /**
 * @summary Create a new entry_log record
 */
export const usePostEntryLog = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postEntryLog>>, TError,{data: EntryLog}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postEntryLog>>,
        TError,
        {data: EntryLog},
        TContext
      > => {

      const mutationOptions = getPostEntryLogMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Returns a single entry_log record by ID
 * @summary Get a specific entry_log record
 */
export const getEntryLogId = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return defaultInstance<GetEntryLogId200>(
      {url: `/entry_log/${id}`, method: 'GET', signal
    },
      );
    }
  

export const getGetEntryLogIdQueryKey = (id: string,) => {
    return [`/entry_log/${id}`] as const;
    }

    
export const getGetEntryLogIdQueryOptions = <TData = Awaited<ReturnType<typeof getEntryLogId>>, TError = void>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEntryLogId>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetEntryLogIdQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getEntryLogId>>> = ({ signal }) => getEntryLogId(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getEntryLogId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetEntryLogIdQueryResult = NonNullable<Awaited<ReturnType<typeof getEntryLogId>>>
export type GetEntryLogIdQueryError = void


export function useGetEntryLogId<TData = Awaited<ReturnType<typeof getEntryLogId>>, TError = void>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEntryLogId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEntryLogId>>,
          TError,
          Awaited<ReturnType<typeof getEntryLogId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEntryLogId<TData = Awaited<ReturnType<typeof getEntryLogId>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEntryLogId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEntryLogId>>,
          TError,
          Awaited<ReturnType<typeof getEntryLogId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEntryLogId<TData = Awaited<ReturnType<typeof getEntryLogId>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEntryLogId>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get a specific entry_log record
 */

export function useGetEntryLogId<TData = Awaited<ReturnType<typeof getEntryLogId>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEntryLogId>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetEntryLogIdQueryOptions(id,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Updates an existing entry_log record
 * @summary Update a entry_log record
 */
export const putEntryLogId = (
    id: string,
    entryLog: EntryLog,
 ) => {
      
      
      return defaultInstance<PutEntryLogId200>(
      {url: `/entry_log/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: entryLog
    },
      );
    }
  


export const getPutEntryLogIdMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putEntryLogId>>, TError,{id: string;data: EntryLog}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof putEntryLogId>>, TError,{id: string;data: EntryLog}, TContext> => {
    
const mutationKey = ['putEntryLogId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putEntryLogId>>, {id: string;data: EntryLog}> = (props) => {
          const {id,data} = props ?? {};

          return  putEntryLogId(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutEntryLogIdMutationResult = NonNullable<Awaited<ReturnType<typeof putEntryLogId>>>
    export type PutEntryLogIdMutationBody = EntryLog
    export type PutEntryLogIdMutationError = void

    /**
 * @summary Update a entry_log record
 */
export const usePutEntryLogId = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putEntryLogId>>, TError,{id: string;data: EntryLog}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putEntryLogId>>,
        TError,
        {id: string;data: EntryLog},
        TContext
      > => {

      const mutationOptions = getPutEntryLogIdMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Partially updates an existing entry_log record
 * @summary Partially update a entry_log record
 */
export const patchEntryLogId = (
    id: string,
    entryLog: EntryLog,
 ) => {
      
      
      return defaultInstance<PatchEntryLogId200>(
      {url: `/entry_log/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: entryLog
    },
      );
    }
  


export const getPatchEntryLogIdMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchEntryLogId>>, TError,{id: string;data: EntryLog}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof patchEntryLogId>>, TError,{id: string;data: EntryLog}, TContext> => {
    
const mutationKey = ['patchEntryLogId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchEntryLogId>>, {id: string;data: EntryLog}> = (props) => {
          const {id,data} = props ?? {};

          return  patchEntryLogId(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PatchEntryLogIdMutationResult = NonNullable<Awaited<ReturnType<typeof patchEntryLogId>>>
    export type PatchEntryLogIdMutationBody = EntryLog
    export type PatchEntryLogIdMutationError = void

    /**
 * @summary Partially update a entry_log record
 */
export const usePatchEntryLogId = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchEntryLogId>>, TError,{id: string;data: EntryLog}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patchEntryLogId>>,
        TError,
        {id: string;data: EntryLog},
        TContext
      > => {

      const mutationOptions = getPatchEntryLogIdMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Deletes a entry_log record
 * @summary Delete a entry_log record
 */
export const deleteEntryLogId = (
    id: string,
 ) => {
      
      
      return defaultInstance<DeleteEntryLogId200>(
      {url: `/entry_log/${id}`, method: 'DELETE'
    },
      );
    }
  


export const getDeleteEntryLogIdMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteEntryLogId>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteEntryLogId>>, TError,{id: string}, TContext> => {
    
const mutationKey = ['deleteEntryLogId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteEntryLogId>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteEntryLogId(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteEntryLogIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteEntryLogId>>>
    
    export type DeleteEntryLogIdMutationError = void

    /**
 * @summary Delete a entry_log record
 */
export const useDeleteEntryLogId = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteEntryLogId>>, TError,{id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteEntryLogId>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getDeleteEntryLogIdMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Returns a list of access_type records with pagination
 * @summary Get all access_type records
 */
export const getAccessType = (
    params?: GetAccessTypeParams,
 signal?: AbortSignal
) => {
      
      
      return defaultInstance<GetAccessType200>(
      {url: `/access_type`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getGetAccessTypeQueryKey = (params?: GetAccessTypeParams,) => {
    return [`/access_type`, ...(params ? [params]: [])] as const;
    }

    
export const getGetAccessTypeQueryOptions = <TData = Awaited<ReturnType<typeof getAccessType>>, TError = void>(params?: GetAccessTypeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAccessType>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAccessTypeQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAccessType>>> = ({ signal }) => getAccessType(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAccessType>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAccessTypeQueryResult = NonNullable<Awaited<ReturnType<typeof getAccessType>>>
export type GetAccessTypeQueryError = void


export function useGetAccessType<TData = Awaited<ReturnType<typeof getAccessType>>, TError = void>(
 params: undefined |  GetAccessTypeParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAccessType>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAccessType>>,
          TError,
          Awaited<ReturnType<typeof getAccessType>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAccessType<TData = Awaited<ReturnType<typeof getAccessType>>, TError = void>(
 params?: GetAccessTypeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAccessType>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAccessType>>,
          TError,
          Awaited<ReturnType<typeof getAccessType>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAccessType<TData = Awaited<ReturnType<typeof getAccessType>>, TError = void>(
 params?: GetAccessTypeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAccessType>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get all access_type records
 */

export function useGetAccessType<TData = Awaited<ReturnType<typeof getAccessType>>, TError = void>(
 params?: GetAccessTypeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAccessType>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAccessTypeQueryOptions(params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Creates a new access_type record
 * @summary Create a new access_type record
 */
export const postAccessType = (
    accessType: AccessType,
 signal?: AbortSignal
) => {
      
      
      return defaultInstance<PostAccessType200>(
      {url: `/access_type`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: accessType, signal
    },
      );
    }
  


export const getPostAccessTypeMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAccessType>>, TError,{data: AccessType}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postAccessType>>, TError,{data: AccessType}, TContext> => {
    
const mutationKey = ['postAccessType'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postAccessType>>, {data: AccessType}> = (props) => {
          const {data} = props ?? {};

          return  postAccessType(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostAccessTypeMutationResult = NonNullable<Awaited<ReturnType<typeof postAccessType>>>
    export type PostAccessTypeMutationBody = AccessType
    export type PostAccessTypeMutationError = void

    /**
 * @summary Create a new access_type record
 */
export const usePostAccessType = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAccessType>>, TError,{data: AccessType}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postAccessType>>,
        TError,
        {data: AccessType},
        TContext
      > => {

      const mutationOptions = getPostAccessTypeMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Returns a single access_type record by ID
 * @summary Get a specific access_type record
 */
export const getAccessTypeId = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return defaultInstance<GetAccessTypeId200>(
      {url: `/access_type/${id}`, method: 'GET', signal
    },
      );
    }
  

export const getGetAccessTypeIdQueryKey = (id: string,) => {
    return [`/access_type/${id}`] as const;
    }

    
export const getGetAccessTypeIdQueryOptions = <TData = Awaited<ReturnType<typeof getAccessTypeId>>, TError = void>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAccessTypeId>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAccessTypeIdQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAccessTypeId>>> = ({ signal }) => getAccessTypeId(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAccessTypeId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAccessTypeIdQueryResult = NonNullable<Awaited<ReturnType<typeof getAccessTypeId>>>
export type GetAccessTypeIdQueryError = void


export function useGetAccessTypeId<TData = Awaited<ReturnType<typeof getAccessTypeId>>, TError = void>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAccessTypeId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAccessTypeId>>,
          TError,
          Awaited<ReturnType<typeof getAccessTypeId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAccessTypeId<TData = Awaited<ReturnType<typeof getAccessTypeId>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAccessTypeId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAccessTypeId>>,
          TError,
          Awaited<ReturnType<typeof getAccessTypeId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAccessTypeId<TData = Awaited<ReturnType<typeof getAccessTypeId>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAccessTypeId>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get a specific access_type record
 */

export function useGetAccessTypeId<TData = Awaited<ReturnType<typeof getAccessTypeId>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAccessTypeId>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAccessTypeIdQueryOptions(id,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Updates an existing access_type record
 * @summary Update a access_type record
 */
export const putAccessTypeId = (
    id: string,
    accessType: AccessType,
 ) => {
      
      
      return defaultInstance<PutAccessTypeId200>(
      {url: `/access_type/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: accessType
    },
      );
    }
  


export const getPutAccessTypeIdMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putAccessTypeId>>, TError,{id: string;data: AccessType}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof putAccessTypeId>>, TError,{id: string;data: AccessType}, TContext> => {
    
const mutationKey = ['putAccessTypeId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putAccessTypeId>>, {id: string;data: AccessType}> = (props) => {
          const {id,data} = props ?? {};

          return  putAccessTypeId(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutAccessTypeIdMutationResult = NonNullable<Awaited<ReturnType<typeof putAccessTypeId>>>
    export type PutAccessTypeIdMutationBody = AccessType
    export type PutAccessTypeIdMutationError = void

    /**
 * @summary Update a access_type record
 */
export const usePutAccessTypeId = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putAccessTypeId>>, TError,{id: string;data: AccessType}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putAccessTypeId>>,
        TError,
        {id: string;data: AccessType},
        TContext
      > => {

      const mutationOptions = getPutAccessTypeIdMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Partially updates an existing access_type record
 * @summary Partially update a access_type record
 */
export const patchAccessTypeId = (
    id: string,
    accessType: AccessType,
 ) => {
      
      
      return defaultInstance<PatchAccessTypeId200>(
      {url: `/access_type/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: accessType
    },
      );
    }
  


export const getPatchAccessTypeIdMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchAccessTypeId>>, TError,{id: string;data: AccessType}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof patchAccessTypeId>>, TError,{id: string;data: AccessType}, TContext> => {
    
const mutationKey = ['patchAccessTypeId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchAccessTypeId>>, {id: string;data: AccessType}> = (props) => {
          const {id,data} = props ?? {};

          return  patchAccessTypeId(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PatchAccessTypeIdMutationResult = NonNullable<Awaited<ReturnType<typeof patchAccessTypeId>>>
    export type PatchAccessTypeIdMutationBody = AccessType
    export type PatchAccessTypeIdMutationError = void

    /**
 * @summary Partially update a access_type record
 */
export const usePatchAccessTypeId = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchAccessTypeId>>, TError,{id: string;data: AccessType}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patchAccessTypeId>>,
        TError,
        {id: string;data: AccessType},
        TContext
      > => {

      const mutationOptions = getPatchAccessTypeIdMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Deletes a access_type record
 * @summary Delete a access_type record
 */
export const deleteAccessTypeId = (
    id: string,
 ) => {
      
      
      return defaultInstance<DeleteAccessTypeId200>(
      {url: `/access_type/${id}`, method: 'DELETE'
    },
      );
    }
  


export const getDeleteAccessTypeIdMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAccessTypeId>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteAccessTypeId>>, TError,{id: string}, TContext> => {
    
const mutationKey = ['deleteAccessTypeId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteAccessTypeId>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteAccessTypeId(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteAccessTypeIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteAccessTypeId>>>
    
    export type DeleteAccessTypeIdMutationError = void

    /**
 * @summary Delete a access_type record
 */
export const useDeleteAccessTypeId = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAccessTypeId>>, TError,{id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteAccessTypeId>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getDeleteAccessTypeIdMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Returns a list of access_card records with pagination
 * @summary Get all access_card records
 */
export const getAccessCard = (
    params?: GetAccessCardParams,
 signal?: AbortSignal
) => {
      
      
      return defaultInstance<GetAccessCard200>(
      {url: `/access_card`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getGetAccessCardQueryKey = (params?: GetAccessCardParams,) => {
    return [`/access_card`, ...(params ? [params]: [])] as const;
    }

    
export const getGetAccessCardQueryOptions = <TData = Awaited<ReturnType<typeof getAccessCard>>, TError = void>(params?: GetAccessCardParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAccessCard>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAccessCardQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAccessCard>>> = ({ signal }) => getAccessCard(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAccessCard>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAccessCardQueryResult = NonNullable<Awaited<ReturnType<typeof getAccessCard>>>
export type GetAccessCardQueryError = void


export function useGetAccessCard<TData = Awaited<ReturnType<typeof getAccessCard>>, TError = void>(
 params: undefined |  GetAccessCardParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAccessCard>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAccessCard>>,
          TError,
          Awaited<ReturnType<typeof getAccessCard>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAccessCard<TData = Awaited<ReturnType<typeof getAccessCard>>, TError = void>(
 params?: GetAccessCardParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAccessCard>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAccessCard>>,
          TError,
          Awaited<ReturnType<typeof getAccessCard>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAccessCard<TData = Awaited<ReturnType<typeof getAccessCard>>, TError = void>(
 params?: GetAccessCardParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAccessCard>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get all access_card records
 */

export function useGetAccessCard<TData = Awaited<ReturnType<typeof getAccessCard>>, TError = void>(
 params?: GetAccessCardParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAccessCard>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAccessCardQueryOptions(params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Creates a new access_card record
 * @summary Create a new access_card record
 */
export const postAccessCard = (
    accessCard: AccessCard,
 signal?: AbortSignal
) => {
      
      
      return defaultInstance<PostAccessCard200>(
      {url: `/access_card`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: accessCard, signal
    },
      );
    }
  


export const getPostAccessCardMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAccessCard>>, TError,{data: AccessCard}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postAccessCard>>, TError,{data: AccessCard}, TContext> => {
    
const mutationKey = ['postAccessCard'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postAccessCard>>, {data: AccessCard}> = (props) => {
          const {data} = props ?? {};

          return  postAccessCard(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostAccessCardMutationResult = NonNullable<Awaited<ReturnType<typeof postAccessCard>>>
    export type PostAccessCardMutationBody = AccessCard
    export type PostAccessCardMutationError = void

    /**
 * @summary Create a new access_card record
 */
export const usePostAccessCard = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAccessCard>>, TError,{data: AccessCard}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postAccessCard>>,
        TError,
        {data: AccessCard},
        TContext
      > => {

      const mutationOptions = getPostAccessCardMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Returns a single access_card record by ID
 * @summary Get a specific access_card record
 */
export const getAccessCardId = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return defaultInstance<GetAccessCardId200>(
      {url: `/access_card/${id}`, method: 'GET', signal
    },
      );
    }
  

export const getGetAccessCardIdQueryKey = (id: string,) => {
    return [`/access_card/${id}`] as const;
    }

    
export const getGetAccessCardIdQueryOptions = <TData = Awaited<ReturnType<typeof getAccessCardId>>, TError = void>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAccessCardId>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAccessCardIdQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAccessCardId>>> = ({ signal }) => getAccessCardId(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAccessCardId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAccessCardIdQueryResult = NonNullable<Awaited<ReturnType<typeof getAccessCardId>>>
export type GetAccessCardIdQueryError = void


export function useGetAccessCardId<TData = Awaited<ReturnType<typeof getAccessCardId>>, TError = void>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAccessCardId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAccessCardId>>,
          TError,
          Awaited<ReturnType<typeof getAccessCardId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAccessCardId<TData = Awaited<ReturnType<typeof getAccessCardId>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAccessCardId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAccessCardId>>,
          TError,
          Awaited<ReturnType<typeof getAccessCardId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAccessCardId<TData = Awaited<ReturnType<typeof getAccessCardId>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAccessCardId>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get a specific access_card record
 */

export function useGetAccessCardId<TData = Awaited<ReturnType<typeof getAccessCardId>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAccessCardId>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAccessCardIdQueryOptions(id,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Updates an existing access_card record
 * @summary Update a access_card record
 */
export const putAccessCardId = (
    id: string,
    accessCard: AccessCard,
 ) => {
      
      
      return defaultInstance<PutAccessCardId200>(
      {url: `/access_card/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: accessCard
    },
      );
    }
  


export const getPutAccessCardIdMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putAccessCardId>>, TError,{id: string;data: AccessCard}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof putAccessCardId>>, TError,{id: string;data: AccessCard}, TContext> => {
    
const mutationKey = ['putAccessCardId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putAccessCardId>>, {id: string;data: AccessCard}> = (props) => {
          const {id,data} = props ?? {};

          return  putAccessCardId(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutAccessCardIdMutationResult = NonNullable<Awaited<ReturnType<typeof putAccessCardId>>>
    export type PutAccessCardIdMutationBody = AccessCard
    export type PutAccessCardIdMutationError = void

    /**
 * @summary Update a access_card record
 */
export const usePutAccessCardId = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putAccessCardId>>, TError,{id: string;data: AccessCard}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putAccessCardId>>,
        TError,
        {id: string;data: AccessCard},
        TContext
      > => {

      const mutationOptions = getPutAccessCardIdMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Partially updates an existing access_card record
 * @summary Partially update a access_card record
 */
export const patchAccessCardId = (
    id: string,
    accessCard: AccessCard,
 ) => {
      
      
      return defaultInstance<PatchAccessCardId200>(
      {url: `/access_card/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: accessCard
    },
      );
    }
  


export const getPatchAccessCardIdMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchAccessCardId>>, TError,{id: string;data: AccessCard}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof patchAccessCardId>>, TError,{id: string;data: AccessCard}, TContext> => {
    
const mutationKey = ['patchAccessCardId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchAccessCardId>>, {id: string;data: AccessCard}> = (props) => {
          const {id,data} = props ?? {};

          return  patchAccessCardId(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PatchAccessCardIdMutationResult = NonNullable<Awaited<ReturnType<typeof patchAccessCardId>>>
    export type PatchAccessCardIdMutationBody = AccessCard
    export type PatchAccessCardIdMutationError = void

    /**
 * @summary Partially update a access_card record
 */
export const usePatchAccessCardId = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchAccessCardId>>, TError,{id: string;data: AccessCard}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patchAccessCardId>>,
        TError,
        {id: string;data: AccessCard},
        TContext
      > => {

      const mutationOptions = getPatchAccessCardIdMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Deletes a access_card record
 * @summary Delete a access_card record
 */
export const deleteAccessCardId = (
    id: string,
 ) => {
      
      
      return defaultInstance<DeleteAccessCardId200>(
      {url: `/access_card/${id}`, method: 'DELETE'
    },
      );
    }
  


export const getDeleteAccessCardIdMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAccessCardId>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteAccessCardId>>, TError,{id: string}, TContext> => {
    
const mutationKey = ['deleteAccessCardId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteAccessCardId>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteAccessCardId(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteAccessCardIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteAccessCardId>>>
    
    export type DeleteAccessCardIdMutationError = void

    /**
 * @summary Delete a access_card record
 */
export const useDeleteAccessCardId = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAccessCardId>>, TError,{id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteAccessCardId>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getDeleteAccessCardIdMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Returns a list of user_access_card records with pagination
 * @summary Get all user_access_card records
 */
export const getUserAccessCard = (
    params?: GetUserAccessCardParams,
 signal?: AbortSignal
) => {
      
      
      return defaultInstance<GetUserAccessCard200>(
      {url: `/user_access_card`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getGetUserAccessCardQueryKey = (params?: GetUserAccessCardParams,) => {
    return [`/user_access_card`, ...(params ? [params]: [])] as const;
    }

    
export const getGetUserAccessCardQueryOptions = <TData = Awaited<ReturnType<typeof getUserAccessCard>>, TError = void>(params?: GetUserAccessCardParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserAccessCard>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUserAccessCardQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUserAccessCard>>> = ({ signal }) => getUserAccessCard(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getUserAccessCard>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetUserAccessCardQueryResult = NonNullable<Awaited<ReturnType<typeof getUserAccessCard>>>
export type GetUserAccessCardQueryError = void


export function useGetUserAccessCard<TData = Awaited<ReturnType<typeof getUserAccessCard>>, TError = void>(
 params: undefined |  GetUserAccessCardParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserAccessCard>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserAccessCard>>,
          TError,
          Awaited<ReturnType<typeof getUserAccessCard>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUserAccessCard<TData = Awaited<ReturnType<typeof getUserAccessCard>>, TError = void>(
 params?: GetUserAccessCardParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserAccessCard>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserAccessCard>>,
          TError,
          Awaited<ReturnType<typeof getUserAccessCard>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUserAccessCard<TData = Awaited<ReturnType<typeof getUserAccessCard>>, TError = void>(
 params?: GetUserAccessCardParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserAccessCard>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get all user_access_card records
 */

export function useGetUserAccessCard<TData = Awaited<ReturnType<typeof getUserAccessCard>>, TError = void>(
 params?: GetUserAccessCardParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserAccessCard>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetUserAccessCardQueryOptions(params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Creates a new user_access_card record
 * @summary Create a new user_access_card record
 */
export const postUserAccessCard = (
    userAccessCard: UserAccessCard,
 signal?: AbortSignal
) => {
      
      
      return defaultInstance<PostUserAccessCard200>(
      {url: `/user_access_card`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: userAccessCard, signal
    },
      );
    }
  


export const getPostUserAccessCardMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postUserAccessCard>>, TError,{data: UserAccessCard}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postUserAccessCard>>, TError,{data: UserAccessCard}, TContext> => {
    
const mutationKey = ['postUserAccessCard'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postUserAccessCard>>, {data: UserAccessCard}> = (props) => {
          const {data} = props ?? {};

          return  postUserAccessCard(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostUserAccessCardMutationResult = NonNullable<Awaited<ReturnType<typeof postUserAccessCard>>>
    export type PostUserAccessCardMutationBody = UserAccessCard
    export type PostUserAccessCardMutationError = void

    /**
 * @summary Create a new user_access_card record
 */
export const usePostUserAccessCard = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postUserAccessCard>>, TError,{data: UserAccessCard}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postUserAccessCard>>,
        TError,
        {data: UserAccessCard},
        TContext
      > => {

      const mutationOptions = getPostUserAccessCardMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Returns a single user_access_card record by ID
 * @summary Get a specific user_access_card record
 */
export const getUserAccessCardId = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return defaultInstance<GetUserAccessCardId200>(
      {url: `/user_access_card/${id}`, method: 'GET', signal
    },
      );
    }
  

export const getGetUserAccessCardIdQueryKey = (id: string,) => {
    return [`/user_access_card/${id}`] as const;
    }

    
export const getGetUserAccessCardIdQueryOptions = <TData = Awaited<ReturnType<typeof getUserAccessCardId>>, TError = void>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserAccessCardId>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUserAccessCardIdQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUserAccessCardId>>> = ({ signal }) => getUserAccessCardId(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getUserAccessCardId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetUserAccessCardIdQueryResult = NonNullable<Awaited<ReturnType<typeof getUserAccessCardId>>>
export type GetUserAccessCardIdQueryError = void


export function useGetUserAccessCardId<TData = Awaited<ReturnType<typeof getUserAccessCardId>>, TError = void>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserAccessCardId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserAccessCardId>>,
          TError,
          Awaited<ReturnType<typeof getUserAccessCardId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUserAccessCardId<TData = Awaited<ReturnType<typeof getUserAccessCardId>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserAccessCardId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserAccessCardId>>,
          TError,
          Awaited<ReturnType<typeof getUserAccessCardId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUserAccessCardId<TData = Awaited<ReturnType<typeof getUserAccessCardId>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserAccessCardId>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get a specific user_access_card record
 */

export function useGetUserAccessCardId<TData = Awaited<ReturnType<typeof getUserAccessCardId>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserAccessCardId>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetUserAccessCardIdQueryOptions(id,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Updates an existing user_access_card record
 * @summary Update a user_access_card record
 */
export const putUserAccessCardId = (
    id: string,
    userAccessCard: UserAccessCard,
 ) => {
      
      
      return defaultInstance<PutUserAccessCardId200>(
      {url: `/user_access_card/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: userAccessCard
    },
      );
    }
  


export const getPutUserAccessCardIdMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putUserAccessCardId>>, TError,{id: string;data: UserAccessCard}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof putUserAccessCardId>>, TError,{id: string;data: UserAccessCard}, TContext> => {
    
const mutationKey = ['putUserAccessCardId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putUserAccessCardId>>, {id: string;data: UserAccessCard}> = (props) => {
          const {id,data} = props ?? {};

          return  putUserAccessCardId(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutUserAccessCardIdMutationResult = NonNullable<Awaited<ReturnType<typeof putUserAccessCardId>>>
    export type PutUserAccessCardIdMutationBody = UserAccessCard
    export type PutUserAccessCardIdMutationError = void

    /**
 * @summary Update a user_access_card record
 */
export const usePutUserAccessCardId = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putUserAccessCardId>>, TError,{id: string;data: UserAccessCard}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putUserAccessCardId>>,
        TError,
        {id: string;data: UserAccessCard},
        TContext
      > => {

      const mutationOptions = getPutUserAccessCardIdMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Partially updates an existing user_access_card record
 * @summary Partially update a user_access_card record
 */
export const patchUserAccessCardId = (
    id: string,
    userAccessCard: UserAccessCard,
 ) => {
      
      
      return defaultInstance<PatchUserAccessCardId200>(
      {url: `/user_access_card/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: userAccessCard
    },
      );
    }
  


export const getPatchUserAccessCardIdMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchUserAccessCardId>>, TError,{id: string;data: UserAccessCard}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof patchUserAccessCardId>>, TError,{id: string;data: UserAccessCard}, TContext> => {
    
const mutationKey = ['patchUserAccessCardId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchUserAccessCardId>>, {id: string;data: UserAccessCard}> = (props) => {
          const {id,data} = props ?? {};

          return  patchUserAccessCardId(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PatchUserAccessCardIdMutationResult = NonNullable<Awaited<ReturnType<typeof patchUserAccessCardId>>>
    export type PatchUserAccessCardIdMutationBody = UserAccessCard
    export type PatchUserAccessCardIdMutationError = void

    /**
 * @summary Partially update a user_access_card record
 */
export const usePatchUserAccessCardId = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchUserAccessCardId>>, TError,{id: string;data: UserAccessCard}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patchUserAccessCardId>>,
        TError,
        {id: string;data: UserAccessCard},
        TContext
      > => {

      const mutationOptions = getPatchUserAccessCardIdMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Deletes a user_access_card record
 * @summary Delete a user_access_card record
 */
export const deleteUserAccessCardId = (
    id: string,
 ) => {
      
      
      return defaultInstance<DeleteUserAccessCardId200>(
      {url: `/user_access_card/${id}`, method: 'DELETE'
    },
      );
    }
  


export const getDeleteUserAccessCardIdMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteUserAccessCardId>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteUserAccessCardId>>, TError,{id: string}, TContext> => {
    
const mutationKey = ['deleteUserAccessCardId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteUserAccessCardId>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteUserAccessCardId(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteUserAccessCardIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteUserAccessCardId>>>
    
    export type DeleteUserAccessCardIdMutationError = void

    /**
 * @summary Delete a user_access_card record
 */
export const useDeleteUserAccessCardId = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteUserAccessCardId>>, TError,{id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteUserAccessCardId>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getDeleteUserAccessCardIdMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Returns a list of access_card_status_event records with pagination
 * @summary Get all access_card_status_event records
 */
export const getAccessCardStatusEvent = (
    params?: GetAccessCardStatusEventParams,
 signal?: AbortSignal
) => {
      
      
      return defaultInstance<GetAccessCardStatusEvent200>(
      {url: `/access_card_status_event`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getGetAccessCardStatusEventQueryKey = (params?: GetAccessCardStatusEventParams,) => {
    return [`/access_card_status_event`, ...(params ? [params]: [])] as const;
    }

    
export const getGetAccessCardStatusEventQueryOptions = <TData = Awaited<ReturnType<typeof getAccessCardStatusEvent>>, TError = void>(params?: GetAccessCardStatusEventParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAccessCardStatusEvent>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAccessCardStatusEventQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAccessCardStatusEvent>>> = ({ signal }) => getAccessCardStatusEvent(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAccessCardStatusEvent>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAccessCardStatusEventQueryResult = NonNullable<Awaited<ReturnType<typeof getAccessCardStatusEvent>>>
export type GetAccessCardStatusEventQueryError = void


export function useGetAccessCardStatusEvent<TData = Awaited<ReturnType<typeof getAccessCardStatusEvent>>, TError = void>(
 params: undefined |  GetAccessCardStatusEventParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAccessCardStatusEvent>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAccessCardStatusEvent>>,
          TError,
          Awaited<ReturnType<typeof getAccessCardStatusEvent>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAccessCardStatusEvent<TData = Awaited<ReturnType<typeof getAccessCardStatusEvent>>, TError = void>(
 params?: GetAccessCardStatusEventParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAccessCardStatusEvent>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAccessCardStatusEvent>>,
          TError,
          Awaited<ReturnType<typeof getAccessCardStatusEvent>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAccessCardStatusEvent<TData = Awaited<ReturnType<typeof getAccessCardStatusEvent>>, TError = void>(
 params?: GetAccessCardStatusEventParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAccessCardStatusEvent>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get all access_card_status_event records
 */

export function useGetAccessCardStatusEvent<TData = Awaited<ReturnType<typeof getAccessCardStatusEvent>>, TError = void>(
 params?: GetAccessCardStatusEventParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAccessCardStatusEvent>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAccessCardStatusEventQueryOptions(params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Creates a new access_card_status_event record
 * @summary Create a new access_card_status_event record
 */
export const postAccessCardStatusEvent = (
    accessCardStatusEvent: AccessCardStatusEvent,
 signal?: AbortSignal
) => {
      
      
      return defaultInstance<PostAccessCardStatusEvent200>(
      {url: `/access_card_status_event`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: accessCardStatusEvent, signal
    },
      );
    }
  


export const getPostAccessCardStatusEventMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAccessCardStatusEvent>>, TError,{data: AccessCardStatusEvent}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postAccessCardStatusEvent>>, TError,{data: AccessCardStatusEvent}, TContext> => {
    
const mutationKey = ['postAccessCardStatusEvent'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postAccessCardStatusEvent>>, {data: AccessCardStatusEvent}> = (props) => {
          const {data} = props ?? {};

          return  postAccessCardStatusEvent(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostAccessCardStatusEventMutationResult = NonNullable<Awaited<ReturnType<typeof postAccessCardStatusEvent>>>
    export type PostAccessCardStatusEventMutationBody = AccessCardStatusEvent
    export type PostAccessCardStatusEventMutationError = void

    /**
 * @summary Create a new access_card_status_event record
 */
export const usePostAccessCardStatusEvent = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAccessCardStatusEvent>>, TError,{data: AccessCardStatusEvent}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postAccessCardStatusEvent>>,
        TError,
        {data: AccessCardStatusEvent},
        TContext
      > => {

      const mutationOptions = getPostAccessCardStatusEventMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Returns a single access_card_status_event record by ID
 * @summary Get a specific access_card_status_event record
 */
export const getAccessCardStatusEventId = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return defaultInstance<GetAccessCardStatusEventId200>(
      {url: `/access_card_status_event/${id}`, method: 'GET', signal
    },
      );
    }
  

export const getGetAccessCardStatusEventIdQueryKey = (id: string,) => {
    return [`/access_card_status_event/${id}`] as const;
    }

    
export const getGetAccessCardStatusEventIdQueryOptions = <TData = Awaited<ReturnType<typeof getAccessCardStatusEventId>>, TError = void>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAccessCardStatusEventId>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAccessCardStatusEventIdQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAccessCardStatusEventId>>> = ({ signal }) => getAccessCardStatusEventId(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAccessCardStatusEventId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAccessCardStatusEventIdQueryResult = NonNullable<Awaited<ReturnType<typeof getAccessCardStatusEventId>>>
export type GetAccessCardStatusEventIdQueryError = void


export function useGetAccessCardStatusEventId<TData = Awaited<ReturnType<typeof getAccessCardStatusEventId>>, TError = void>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAccessCardStatusEventId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAccessCardStatusEventId>>,
          TError,
          Awaited<ReturnType<typeof getAccessCardStatusEventId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAccessCardStatusEventId<TData = Awaited<ReturnType<typeof getAccessCardStatusEventId>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAccessCardStatusEventId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAccessCardStatusEventId>>,
          TError,
          Awaited<ReturnType<typeof getAccessCardStatusEventId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAccessCardStatusEventId<TData = Awaited<ReturnType<typeof getAccessCardStatusEventId>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAccessCardStatusEventId>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get a specific access_card_status_event record
 */

export function useGetAccessCardStatusEventId<TData = Awaited<ReturnType<typeof getAccessCardStatusEventId>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAccessCardStatusEventId>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAccessCardStatusEventIdQueryOptions(id,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Updates an existing access_card_status_event record
 * @summary Update a access_card_status_event record
 */
export const putAccessCardStatusEventId = (
    id: string,
    accessCardStatusEvent: AccessCardStatusEvent,
 ) => {
      
      
      return defaultInstance<PutAccessCardStatusEventId200>(
      {url: `/access_card_status_event/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: accessCardStatusEvent
    },
      );
    }
  


export const getPutAccessCardStatusEventIdMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putAccessCardStatusEventId>>, TError,{id: string;data: AccessCardStatusEvent}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof putAccessCardStatusEventId>>, TError,{id: string;data: AccessCardStatusEvent}, TContext> => {
    
const mutationKey = ['putAccessCardStatusEventId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putAccessCardStatusEventId>>, {id: string;data: AccessCardStatusEvent}> = (props) => {
          const {id,data} = props ?? {};

          return  putAccessCardStatusEventId(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutAccessCardStatusEventIdMutationResult = NonNullable<Awaited<ReturnType<typeof putAccessCardStatusEventId>>>
    export type PutAccessCardStatusEventIdMutationBody = AccessCardStatusEvent
    export type PutAccessCardStatusEventIdMutationError = void

    /**
 * @summary Update a access_card_status_event record
 */
export const usePutAccessCardStatusEventId = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putAccessCardStatusEventId>>, TError,{id: string;data: AccessCardStatusEvent}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putAccessCardStatusEventId>>,
        TError,
        {id: string;data: AccessCardStatusEvent},
        TContext
      > => {

      const mutationOptions = getPutAccessCardStatusEventIdMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Partially updates an existing access_card_status_event record
 * @summary Partially update a access_card_status_event record
 */
export const patchAccessCardStatusEventId = (
    id: string,
    accessCardStatusEvent: AccessCardStatusEvent,
 ) => {
      
      
      return defaultInstance<PatchAccessCardStatusEventId200>(
      {url: `/access_card_status_event/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: accessCardStatusEvent
    },
      );
    }
  


export const getPatchAccessCardStatusEventIdMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchAccessCardStatusEventId>>, TError,{id: string;data: AccessCardStatusEvent}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof patchAccessCardStatusEventId>>, TError,{id: string;data: AccessCardStatusEvent}, TContext> => {
    
const mutationKey = ['patchAccessCardStatusEventId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchAccessCardStatusEventId>>, {id: string;data: AccessCardStatusEvent}> = (props) => {
          const {id,data} = props ?? {};

          return  patchAccessCardStatusEventId(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PatchAccessCardStatusEventIdMutationResult = NonNullable<Awaited<ReturnType<typeof patchAccessCardStatusEventId>>>
    export type PatchAccessCardStatusEventIdMutationBody = AccessCardStatusEvent
    export type PatchAccessCardStatusEventIdMutationError = void

    /**
 * @summary Partially update a access_card_status_event record
 */
export const usePatchAccessCardStatusEventId = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchAccessCardStatusEventId>>, TError,{id: string;data: AccessCardStatusEvent}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patchAccessCardStatusEventId>>,
        TError,
        {id: string;data: AccessCardStatusEvent},
        TContext
      > => {

      const mutationOptions = getPatchAccessCardStatusEventIdMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Deletes a access_card_status_event record
 * @summary Delete a access_card_status_event record
 */
export const deleteAccessCardStatusEventId = (
    id: string,
 ) => {
      
      
      return defaultInstance<DeleteAccessCardStatusEventId200>(
      {url: `/access_card_status_event/${id}`, method: 'DELETE'
    },
      );
    }
  


export const getDeleteAccessCardStatusEventIdMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAccessCardStatusEventId>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteAccessCardStatusEventId>>, TError,{id: string}, TContext> => {
    
const mutationKey = ['deleteAccessCardStatusEventId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteAccessCardStatusEventId>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteAccessCardStatusEventId(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteAccessCardStatusEventIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteAccessCardStatusEventId>>>
    
    export type DeleteAccessCardStatusEventIdMutationError = void

    /**
 * @summary Delete a access_card_status_event record
 */
export const useDeleteAccessCardStatusEventId = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAccessCardStatusEventId>>, TError,{id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteAccessCardStatusEventId>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getDeleteAccessCardStatusEventIdMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Returns a list of estate_access_type records with pagination
 * @summary Get all estate_access_type records
 */
export const getEstateAccessType = (
    params?: GetEstateAccessTypeParams,
 signal?: AbortSignal
) => {
      
      
      return defaultInstance<GetEstateAccessType200>(
      {url: `/estate_access_type`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getGetEstateAccessTypeQueryKey = (params?: GetEstateAccessTypeParams,) => {
    return [`/estate_access_type`, ...(params ? [params]: [])] as const;
    }

    
export const getGetEstateAccessTypeQueryOptions = <TData = Awaited<ReturnType<typeof getEstateAccessType>>, TError = void>(params?: GetEstateAccessTypeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEstateAccessType>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetEstateAccessTypeQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getEstateAccessType>>> = ({ signal }) => getEstateAccessType(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getEstateAccessType>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetEstateAccessTypeQueryResult = NonNullable<Awaited<ReturnType<typeof getEstateAccessType>>>
export type GetEstateAccessTypeQueryError = void


export function useGetEstateAccessType<TData = Awaited<ReturnType<typeof getEstateAccessType>>, TError = void>(
 params: undefined |  GetEstateAccessTypeParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEstateAccessType>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEstateAccessType>>,
          TError,
          Awaited<ReturnType<typeof getEstateAccessType>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEstateAccessType<TData = Awaited<ReturnType<typeof getEstateAccessType>>, TError = void>(
 params?: GetEstateAccessTypeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEstateAccessType>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEstateAccessType>>,
          TError,
          Awaited<ReturnType<typeof getEstateAccessType>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEstateAccessType<TData = Awaited<ReturnType<typeof getEstateAccessType>>, TError = void>(
 params?: GetEstateAccessTypeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEstateAccessType>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get all estate_access_type records
 */

export function useGetEstateAccessType<TData = Awaited<ReturnType<typeof getEstateAccessType>>, TError = void>(
 params?: GetEstateAccessTypeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEstateAccessType>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetEstateAccessTypeQueryOptions(params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Creates a new estate_access_type record
 * @summary Create a new estate_access_type record
 */
export const postEstateAccessType = (
    estateAccessType: EstateAccessType,
 signal?: AbortSignal
) => {
      
      
      return defaultInstance<PostEstateAccessType200>(
      {url: `/estate_access_type`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: estateAccessType, signal
    },
      );
    }
  


export const getPostEstateAccessTypeMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postEstateAccessType>>, TError,{data: EstateAccessType}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postEstateAccessType>>, TError,{data: EstateAccessType}, TContext> => {
    
const mutationKey = ['postEstateAccessType'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postEstateAccessType>>, {data: EstateAccessType}> = (props) => {
          const {data} = props ?? {};

          return  postEstateAccessType(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostEstateAccessTypeMutationResult = NonNullable<Awaited<ReturnType<typeof postEstateAccessType>>>
    export type PostEstateAccessTypeMutationBody = EstateAccessType
    export type PostEstateAccessTypeMutationError = void

    /**
 * @summary Create a new estate_access_type record
 */
export const usePostEstateAccessType = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postEstateAccessType>>, TError,{data: EstateAccessType}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postEstateAccessType>>,
        TError,
        {data: EstateAccessType},
        TContext
      > => {

      const mutationOptions = getPostEstateAccessTypeMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Returns a single estate_access_type record by ID
 * @summary Get a specific estate_access_type record
 */
export const getEstateAccessTypeId = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return defaultInstance<GetEstateAccessTypeId200>(
      {url: `/estate_access_type/${id}`, method: 'GET', signal
    },
      );
    }
  

export const getGetEstateAccessTypeIdQueryKey = (id: string,) => {
    return [`/estate_access_type/${id}`] as const;
    }

    
export const getGetEstateAccessTypeIdQueryOptions = <TData = Awaited<ReturnType<typeof getEstateAccessTypeId>>, TError = void>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEstateAccessTypeId>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetEstateAccessTypeIdQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getEstateAccessTypeId>>> = ({ signal }) => getEstateAccessTypeId(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getEstateAccessTypeId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetEstateAccessTypeIdQueryResult = NonNullable<Awaited<ReturnType<typeof getEstateAccessTypeId>>>
export type GetEstateAccessTypeIdQueryError = void


export function useGetEstateAccessTypeId<TData = Awaited<ReturnType<typeof getEstateAccessTypeId>>, TError = void>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEstateAccessTypeId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEstateAccessTypeId>>,
          TError,
          Awaited<ReturnType<typeof getEstateAccessTypeId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEstateAccessTypeId<TData = Awaited<ReturnType<typeof getEstateAccessTypeId>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEstateAccessTypeId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEstateAccessTypeId>>,
          TError,
          Awaited<ReturnType<typeof getEstateAccessTypeId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEstateAccessTypeId<TData = Awaited<ReturnType<typeof getEstateAccessTypeId>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEstateAccessTypeId>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get a specific estate_access_type record
 */

export function useGetEstateAccessTypeId<TData = Awaited<ReturnType<typeof getEstateAccessTypeId>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEstateAccessTypeId>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetEstateAccessTypeIdQueryOptions(id,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Updates an existing estate_access_type record
 * @summary Update a estate_access_type record
 */
export const putEstateAccessTypeId = (
    id: string,
    estateAccessType: EstateAccessType,
 ) => {
      
      
      return defaultInstance<PutEstateAccessTypeId200>(
      {url: `/estate_access_type/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: estateAccessType
    },
      );
    }
  


export const getPutEstateAccessTypeIdMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putEstateAccessTypeId>>, TError,{id: string;data: EstateAccessType}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof putEstateAccessTypeId>>, TError,{id: string;data: EstateAccessType}, TContext> => {
    
const mutationKey = ['putEstateAccessTypeId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putEstateAccessTypeId>>, {id: string;data: EstateAccessType}> = (props) => {
          const {id,data} = props ?? {};

          return  putEstateAccessTypeId(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutEstateAccessTypeIdMutationResult = NonNullable<Awaited<ReturnType<typeof putEstateAccessTypeId>>>
    export type PutEstateAccessTypeIdMutationBody = EstateAccessType
    export type PutEstateAccessTypeIdMutationError = void

    /**
 * @summary Update a estate_access_type record
 */
export const usePutEstateAccessTypeId = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putEstateAccessTypeId>>, TError,{id: string;data: EstateAccessType}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putEstateAccessTypeId>>,
        TError,
        {id: string;data: EstateAccessType},
        TContext
      > => {

      const mutationOptions = getPutEstateAccessTypeIdMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Partially updates an existing estate_access_type record
 * @summary Partially update a estate_access_type record
 */
export const patchEstateAccessTypeId = (
    id: string,
    estateAccessType: EstateAccessType,
 ) => {
      
      
      return defaultInstance<PatchEstateAccessTypeId200>(
      {url: `/estate_access_type/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: estateAccessType
    },
      );
    }
  


export const getPatchEstateAccessTypeIdMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchEstateAccessTypeId>>, TError,{id: string;data: EstateAccessType}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof patchEstateAccessTypeId>>, TError,{id: string;data: EstateAccessType}, TContext> => {
    
const mutationKey = ['patchEstateAccessTypeId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchEstateAccessTypeId>>, {id: string;data: EstateAccessType}> = (props) => {
          const {id,data} = props ?? {};

          return  patchEstateAccessTypeId(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PatchEstateAccessTypeIdMutationResult = NonNullable<Awaited<ReturnType<typeof patchEstateAccessTypeId>>>
    export type PatchEstateAccessTypeIdMutationBody = EstateAccessType
    export type PatchEstateAccessTypeIdMutationError = void

    /**
 * @summary Partially update a estate_access_type record
 */
export const usePatchEstateAccessTypeId = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchEstateAccessTypeId>>, TError,{id: string;data: EstateAccessType}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patchEstateAccessTypeId>>,
        TError,
        {id: string;data: EstateAccessType},
        TContext
      > => {

      const mutationOptions = getPatchEstateAccessTypeIdMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Deletes a estate_access_type record
 * @summary Delete a estate_access_type record
 */
export const deleteEstateAccessTypeId = (
    id: string,
 ) => {
      
      
      return defaultInstance<DeleteEstateAccessTypeId200>(
      {url: `/estate_access_type/${id}`, method: 'DELETE'
    },
      );
    }
  


export const getDeleteEstateAccessTypeIdMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteEstateAccessTypeId>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteEstateAccessTypeId>>, TError,{id: string}, TContext> => {
    
const mutationKey = ['deleteEstateAccessTypeId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteEstateAccessTypeId>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteEstateAccessTypeId(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteEstateAccessTypeIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteEstateAccessTypeId>>>
    
    export type DeleteEstateAccessTypeIdMutationError = void

    /**
 * @summary Delete a estate_access_type record
 */
export const useDeleteEstateAccessTypeId = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteEstateAccessTypeId>>, TError,{id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteEstateAccessTypeId>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getDeleteEstateAccessTypeIdMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Returns a list of schedule records with pagination
 * @summary Get all schedule records
 */
export const getSchedule = (
    params?: GetScheduleParams,
 signal?: AbortSignal
) => {
      
      
      return defaultInstance<GetSchedule200>(
      {url: `/schedule`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getGetScheduleQueryKey = (params?: GetScheduleParams,) => {
    return [`/schedule`, ...(params ? [params]: [])] as const;
    }

    
export const getGetScheduleQueryOptions = <TData = Awaited<ReturnType<typeof getSchedule>>, TError = void>(params?: GetScheduleParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSchedule>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetScheduleQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSchedule>>> = ({ signal }) => getSchedule(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSchedule>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetScheduleQueryResult = NonNullable<Awaited<ReturnType<typeof getSchedule>>>
export type GetScheduleQueryError = void


export function useGetSchedule<TData = Awaited<ReturnType<typeof getSchedule>>, TError = void>(
 params: undefined |  GetScheduleParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSchedule>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSchedule>>,
          TError,
          Awaited<ReturnType<typeof getSchedule>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSchedule<TData = Awaited<ReturnType<typeof getSchedule>>, TError = void>(
 params?: GetScheduleParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSchedule>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSchedule>>,
          TError,
          Awaited<ReturnType<typeof getSchedule>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSchedule<TData = Awaited<ReturnType<typeof getSchedule>>, TError = void>(
 params?: GetScheduleParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSchedule>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get all schedule records
 */

export function useGetSchedule<TData = Awaited<ReturnType<typeof getSchedule>>, TError = void>(
 params?: GetScheduleParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSchedule>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetScheduleQueryOptions(params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Creates a new schedule record
 * @summary Create a new schedule record
 */
export const postSchedule = (
    schedule: Schedule,
 signal?: AbortSignal
) => {
      
      
      return defaultInstance<PostSchedule200>(
      {url: `/schedule`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: schedule, signal
    },
      );
    }
  


export const getPostScheduleMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postSchedule>>, TError,{data: Schedule}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postSchedule>>, TError,{data: Schedule}, TContext> => {
    
const mutationKey = ['postSchedule'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postSchedule>>, {data: Schedule}> = (props) => {
          const {data} = props ?? {};

          return  postSchedule(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostScheduleMutationResult = NonNullable<Awaited<ReturnType<typeof postSchedule>>>
    export type PostScheduleMutationBody = Schedule
    export type PostScheduleMutationError = void

    /**
 * @summary Create a new schedule record
 */
export const usePostSchedule = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postSchedule>>, TError,{data: Schedule}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postSchedule>>,
        TError,
        {data: Schedule},
        TContext
      > => {

      const mutationOptions = getPostScheduleMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Returns a single schedule record by ID
 * @summary Get a specific schedule record
 */
export const getScheduleId = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return defaultInstance<GetScheduleId200>(
      {url: `/schedule/${id}`, method: 'GET', signal
    },
      );
    }
  

export const getGetScheduleIdQueryKey = (id: string,) => {
    return [`/schedule/${id}`] as const;
    }

    
export const getGetScheduleIdQueryOptions = <TData = Awaited<ReturnType<typeof getScheduleId>>, TError = void>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getScheduleId>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetScheduleIdQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getScheduleId>>> = ({ signal }) => getScheduleId(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getScheduleId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetScheduleIdQueryResult = NonNullable<Awaited<ReturnType<typeof getScheduleId>>>
export type GetScheduleIdQueryError = void


export function useGetScheduleId<TData = Awaited<ReturnType<typeof getScheduleId>>, TError = void>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getScheduleId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getScheduleId>>,
          TError,
          Awaited<ReturnType<typeof getScheduleId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetScheduleId<TData = Awaited<ReturnType<typeof getScheduleId>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getScheduleId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getScheduleId>>,
          TError,
          Awaited<ReturnType<typeof getScheduleId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetScheduleId<TData = Awaited<ReturnType<typeof getScheduleId>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getScheduleId>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get a specific schedule record
 */

export function useGetScheduleId<TData = Awaited<ReturnType<typeof getScheduleId>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getScheduleId>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetScheduleIdQueryOptions(id,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Updates an existing schedule record
 * @summary Update a schedule record
 */
export const putScheduleId = (
    id: string,
    schedule: Schedule,
 ) => {
      
      
      return defaultInstance<PutScheduleId200>(
      {url: `/schedule/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: schedule
    },
      );
    }
  


export const getPutScheduleIdMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putScheduleId>>, TError,{id: string;data: Schedule}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof putScheduleId>>, TError,{id: string;data: Schedule}, TContext> => {
    
const mutationKey = ['putScheduleId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putScheduleId>>, {id: string;data: Schedule}> = (props) => {
          const {id,data} = props ?? {};

          return  putScheduleId(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutScheduleIdMutationResult = NonNullable<Awaited<ReturnType<typeof putScheduleId>>>
    export type PutScheduleIdMutationBody = Schedule
    export type PutScheduleIdMutationError = void

    /**
 * @summary Update a schedule record
 */
export const usePutScheduleId = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putScheduleId>>, TError,{id: string;data: Schedule}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putScheduleId>>,
        TError,
        {id: string;data: Schedule},
        TContext
      > => {

      const mutationOptions = getPutScheduleIdMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Partially updates an existing schedule record
 * @summary Partially update a schedule record
 */
export const patchScheduleId = (
    id: string,
    schedule: Schedule,
 ) => {
      
      
      return defaultInstance<PatchScheduleId200>(
      {url: `/schedule/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: schedule
    },
      );
    }
  


export const getPatchScheduleIdMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchScheduleId>>, TError,{id: string;data: Schedule}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof patchScheduleId>>, TError,{id: string;data: Schedule}, TContext> => {
    
const mutationKey = ['patchScheduleId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchScheduleId>>, {id: string;data: Schedule}> = (props) => {
          const {id,data} = props ?? {};

          return  patchScheduleId(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PatchScheduleIdMutationResult = NonNullable<Awaited<ReturnType<typeof patchScheduleId>>>
    export type PatchScheduleIdMutationBody = Schedule
    export type PatchScheduleIdMutationError = void

    /**
 * @summary Partially update a schedule record
 */
export const usePatchScheduleId = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchScheduleId>>, TError,{id: string;data: Schedule}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patchScheduleId>>,
        TError,
        {id: string;data: Schedule},
        TContext
      > => {

      const mutationOptions = getPatchScheduleIdMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Deletes a schedule record
 * @summary Delete a schedule record
 */
export const deleteScheduleId = (
    id: string,
 ) => {
      
      
      return defaultInstance<DeleteScheduleId200>(
      {url: `/schedule/${id}`, method: 'DELETE'
    },
      );
    }
  


export const getDeleteScheduleIdMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteScheduleId>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteScheduleId>>, TError,{id: string}, TContext> => {
    
const mutationKey = ['deleteScheduleId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteScheduleId>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteScheduleId(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteScheduleIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteScheduleId>>>
    
    export type DeleteScheduleIdMutationError = void

    /**
 * @summary Delete a schedule record
 */
export const useDeleteScheduleId = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteScheduleId>>, TError,{id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteScheduleId>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getDeleteScheduleIdMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Returns a list of resource records with pagination
 * @summary Get all resource records
 */
export const getResource = (
    params?: GetResourceParams,
 signal?: AbortSignal
) => {
      
      
      return defaultInstance<GetResource200>(
      {url: `/resource`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getGetResourceQueryKey = (params?: GetResourceParams,) => {
    return [`/resource`, ...(params ? [params]: [])] as const;
    }

    
export const getGetResourceQueryOptions = <TData = Awaited<ReturnType<typeof getResource>>, TError = void>(params?: GetResourceParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getResource>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetResourceQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getResource>>> = ({ signal }) => getResource(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getResource>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetResourceQueryResult = NonNullable<Awaited<ReturnType<typeof getResource>>>
export type GetResourceQueryError = void


export function useGetResource<TData = Awaited<ReturnType<typeof getResource>>, TError = void>(
 params: undefined |  GetResourceParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getResource>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getResource>>,
          TError,
          Awaited<ReturnType<typeof getResource>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetResource<TData = Awaited<ReturnType<typeof getResource>>, TError = void>(
 params?: GetResourceParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getResource>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getResource>>,
          TError,
          Awaited<ReturnType<typeof getResource>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetResource<TData = Awaited<ReturnType<typeof getResource>>, TError = void>(
 params?: GetResourceParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getResource>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get all resource records
 */

export function useGetResource<TData = Awaited<ReturnType<typeof getResource>>, TError = void>(
 params?: GetResourceParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getResource>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetResourceQueryOptions(params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Creates a new resource record
 * @summary Create a new resource record
 */
export const postResource = (
    resource: Resource,
 signal?: AbortSignal
) => {
      
      
      return defaultInstance<PostResource200>(
      {url: `/resource`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: resource, signal
    },
      );
    }
  


export const getPostResourceMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postResource>>, TError,{data: Resource}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postResource>>, TError,{data: Resource}, TContext> => {
    
const mutationKey = ['postResource'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postResource>>, {data: Resource}> = (props) => {
          const {data} = props ?? {};

          return  postResource(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostResourceMutationResult = NonNullable<Awaited<ReturnType<typeof postResource>>>
    export type PostResourceMutationBody = Resource
    export type PostResourceMutationError = void

    /**
 * @summary Create a new resource record
 */
export const usePostResource = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postResource>>, TError,{data: Resource}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postResource>>,
        TError,
        {data: Resource},
        TContext
      > => {

      const mutationOptions = getPostResourceMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Returns a single resource record by ID
 * @summary Get a specific resource record
 */
export const getResourceId = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return defaultInstance<GetResourceId200>(
      {url: `/resource/${id}`, method: 'GET', signal
    },
      );
    }
  

export const getGetResourceIdQueryKey = (id: string,) => {
    return [`/resource/${id}`] as const;
    }

    
export const getGetResourceIdQueryOptions = <TData = Awaited<ReturnType<typeof getResourceId>>, TError = void>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getResourceId>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetResourceIdQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getResourceId>>> = ({ signal }) => getResourceId(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getResourceId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetResourceIdQueryResult = NonNullable<Awaited<ReturnType<typeof getResourceId>>>
export type GetResourceIdQueryError = void


export function useGetResourceId<TData = Awaited<ReturnType<typeof getResourceId>>, TError = void>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getResourceId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getResourceId>>,
          TError,
          Awaited<ReturnType<typeof getResourceId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetResourceId<TData = Awaited<ReturnType<typeof getResourceId>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getResourceId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getResourceId>>,
          TError,
          Awaited<ReturnType<typeof getResourceId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetResourceId<TData = Awaited<ReturnType<typeof getResourceId>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getResourceId>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get a specific resource record
 */

export function useGetResourceId<TData = Awaited<ReturnType<typeof getResourceId>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getResourceId>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetResourceIdQueryOptions(id,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Updates an existing resource record
 * @summary Update a resource record
 */
export const putResourceId = (
    id: string,
    resource: Resource,
 ) => {
      
      
      return defaultInstance<PutResourceId200>(
      {url: `/resource/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: resource
    },
      );
    }
  


export const getPutResourceIdMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putResourceId>>, TError,{id: string;data: Resource}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof putResourceId>>, TError,{id: string;data: Resource}, TContext> => {
    
const mutationKey = ['putResourceId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putResourceId>>, {id: string;data: Resource}> = (props) => {
          const {id,data} = props ?? {};

          return  putResourceId(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutResourceIdMutationResult = NonNullable<Awaited<ReturnType<typeof putResourceId>>>
    export type PutResourceIdMutationBody = Resource
    export type PutResourceIdMutationError = void

    /**
 * @summary Update a resource record
 */
export const usePutResourceId = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putResourceId>>, TError,{id: string;data: Resource}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putResourceId>>,
        TError,
        {id: string;data: Resource},
        TContext
      > => {

      const mutationOptions = getPutResourceIdMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Partially updates an existing resource record
 * @summary Partially update a resource record
 */
export const patchResourceId = (
    id: string,
    resource: Resource,
 ) => {
      
      
      return defaultInstance<PatchResourceId200>(
      {url: `/resource/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: resource
    },
      );
    }
  


export const getPatchResourceIdMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchResourceId>>, TError,{id: string;data: Resource}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof patchResourceId>>, TError,{id: string;data: Resource}, TContext> => {
    
const mutationKey = ['patchResourceId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchResourceId>>, {id: string;data: Resource}> = (props) => {
          const {id,data} = props ?? {};

          return  patchResourceId(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PatchResourceIdMutationResult = NonNullable<Awaited<ReturnType<typeof patchResourceId>>>
    export type PatchResourceIdMutationBody = Resource
    export type PatchResourceIdMutationError = void

    /**
 * @summary Partially update a resource record
 */
export const usePatchResourceId = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchResourceId>>, TError,{id: string;data: Resource}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patchResourceId>>,
        TError,
        {id: string;data: Resource},
        TContext
      > => {

      const mutationOptions = getPatchResourceIdMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Deletes a resource record
 * @summary Delete a resource record
 */
export const deleteResourceId = (
    id: string,
 ) => {
      
      
      return defaultInstance<DeleteResourceId200>(
      {url: `/resource/${id}`, method: 'DELETE'
    },
      );
    }
  


export const getDeleteResourceIdMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteResourceId>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteResourceId>>, TError,{id: string}, TContext> => {
    
const mutationKey = ['deleteResourceId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteResourceId>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteResourceId(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteResourceIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteResourceId>>>
    
    export type DeleteResourceIdMutationError = void

    /**
 * @summary Delete a resource record
 */
export const useDeleteResourceId = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteResourceId>>, TError,{id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteResourceId>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getDeleteResourceIdMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Returns a list of customer records with pagination
 * @summary Get all customer records
 */
export const getCustomer = (
    params?: GetCustomerParams,
 signal?: AbortSignal
) => {
      
      
      return defaultInstance<GetCustomer200>(
      {url: `/customer`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getGetCustomerQueryKey = (params?: GetCustomerParams,) => {
    return [`/customer`, ...(params ? [params]: [])] as const;
    }

    
export const getGetCustomerQueryOptions = <TData = Awaited<ReturnType<typeof getCustomer>>, TError = void>(params?: GetCustomerParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomer>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCustomerQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCustomer>>> = ({ signal }) => getCustomer(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCustomer>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetCustomerQueryResult = NonNullable<Awaited<ReturnType<typeof getCustomer>>>
export type GetCustomerQueryError = void


export function useGetCustomer<TData = Awaited<ReturnType<typeof getCustomer>>, TError = void>(
 params: undefined |  GetCustomerParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomer>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCustomer>>,
          TError,
          Awaited<ReturnType<typeof getCustomer>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCustomer<TData = Awaited<ReturnType<typeof getCustomer>>, TError = void>(
 params?: GetCustomerParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomer>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCustomer>>,
          TError,
          Awaited<ReturnType<typeof getCustomer>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCustomer<TData = Awaited<ReturnType<typeof getCustomer>>, TError = void>(
 params?: GetCustomerParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomer>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get all customer records
 */

export function useGetCustomer<TData = Awaited<ReturnType<typeof getCustomer>>, TError = void>(
 params?: GetCustomerParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomer>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetCustomerQueryOptions(params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Creates a new customer record
 * @summary Create a new customer record
 */
export const postCustomer = (
    customer: Customer,
 signal?: AbortSignal
) => {
      
      
      return defaultInstance<PostCustomer200>(
      {url: `/customer`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: customer, signal
    },
      );
    }
  


export const getPostCustomerMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCustomer>>, TError,{data: Customer}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postCustomer>>, TError,{data: Customer}, TContext> => {
    
const mutationKey = ['postCustomer'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postCustomer>>, {data: Customer}> = (props) => {
          const {data} = props ?? {};

          return  postCustomer(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostCustomerMutationResult = NonNullable<Awaited<ReturnType<typeof postCustomer>>>
    export type PostCustomerMutationBody = Customer
    export type PostCustomerMutationError = void

    /**
 * @summary Create a new customer record
 */
export const usePostCustomer = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCustomer>>, TError,{data: Customer}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postCustomer>>,
        TError,
        {data: Customer},
        TContext
      > => {

      const mutationOptions = getPostCustomerMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Returns a single customer record by ID
 * @summary Get a specific customer record
 */
export const getCustomerId = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return defaultInstance<GetCustomerId200>(
      {url: `/customer/${id}`, method: 'GET', signal
    },
      );
    }
  

export const getGetCustomerIdQueryKey = (id: string,) => {
    return [`/customer/${id}`] as const;
    }

    
export const getGetCustomerIdQueryOptions = <TData = Awaited<ReturnType<typeof getCustomerId>>, TError = void>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomerId>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCustomerIdQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCustomerId>>> = ({ signal }) => getCustomerId(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCustomerId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetCustomerIdQueryResult = NonNullable<Awaited<ReturnType<typeof getCustomerId>>>
export type GetCustomerIdQueryError = void


export function useGetCustomerId<TData = Awaited<ReturnType<typeof getCustomerId>>, TError = void>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomerId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCustomerId>>,
          TError,
          Awaited<ReturnType<typeof getCustomerId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCustomerId<TData = Awaited<ReturnType<typeof getCustomerId>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomerId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCustomerId>>,
          TError,
          Awaited<ReturnType<typeof getCustomerId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCustomerId<TData = Awaited<ReturnType<typeof getCustomerId>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomerId>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get a specific customer record
 */

export function useGetCustomerId<TData = Awaited<ReturnType<typeof getCustomerId>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomerId>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetCustomerIdQueryOptions(id,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Updates an existing customer record
 * @summary Update a customer record
 */
export const putCustomerId = (
    id: string,
    customer: Customer,
 ) => {
      
      
      return defaultInstance<PutCustomerId200>(
      {url: `/customer/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: customer
    },
      );
    }
  


export const getPutCustomerIdMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putCustomerId>>, TError,{id: string;data: Customer}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof putCustomerId>>, TError,{id: string;data: Customer}, TContext> => {
    
const mutationKey = ['putCustomerId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putCustomerId>>, {id: string;data: Customer}> = (props) => {
          const {id,data} = props ?? {};

          return  putCustomerId(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutCustomerIdMutationResult = NonNullable<Awaited<ReturnType<typeof putCustomerId>>>
    export type PutCustomerIdMutationBody = Customer
    export type PutCustomerIdMutationError = void

    /**
 * @summary Update a customer record
 */
export const usePutCustomerId = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putCustomerId>>, TError,{id: string;data: Customer}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putCustomerId>>,
        TError,
        {id: string;data: Customer},
        TContext
      > => {

      const mutationOptions = getPutCustomerIdMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Partially updates an existing customer record
 * @summary Partially update a customer record
 */
export const patchCustomerId = (
    id: string,
    customer: Customer,
 ) => {
      
      
      return defaultInstance<PatchCustomerId200>(
      {url: `/customer/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: customer
    },
      );
    }
  


export const getPatchCustomerIdMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchCustomerId>>, TError,{id: string;data: Customer}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof patchCustomerId>>, TError,{id: string;data: Customer}, TContext> => {
    
const mutationKey = ['patchCustomerId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchCustomerId>>, {id: string;data: Customer}> = (props) => {
          const {id,data} = props ?? {};

          return  patchCustomerId(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PatchCustomerIdMutationResult = NonNullable<Awaited<ReturnType<typeof patchCustomerId>>>
    export type PatchCustomerIdMutationBody = Customer
    export type PatchCustomerIdMutationError = void

    /**
 * @summary Partially update a customer record
 */
export const usePatchCustomerId = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchCustomerId>>, TError,{id: string;data: Customer}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patchCustomerId>>,
        TError,
        {id: string;data: Customer},
        TContext
      > => {

      const mutationOptions = getPatchCustomerIdMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Deletes a customer record
 * @summary Delete a customer record
 */
export const deleteCustomerId = (
    id: string,
 ) => {
      
      
      return defaultInstance<DeleteCustomerId200>(
      {url: `/customer/${id}`, method: 'DELETE'
    },
      );
    }
  


export const getDeleteCustomerIdMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteCustomerId>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteCustomerId>>, TError,{id: string}, TContext> => {
    
const mutationKey = ['deleteCustomerId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteCustomerId>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteCustomerId(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteCustomerIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteCustomerId>>>
    
    export type DeleteCustomerIdMutationError = void

    /**
 * @summary Delete a customer record
 */
export const useDeleteCustomerId = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteCustomerId>>, TError,{id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteCustomerId>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getDeleteCustomerIdMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Returns a list of customer_business records with pagination
 * @summary Get all customer_business records
 */
export const getCustomerBusiness = (
    params?: GetCustomerBusinessParams,
 signal?: AbortSignal
) => {
      
      
      return defaultInstance<GetCustomerBusiness200>(
      {url: `/customer_business`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getGetCustomerBusinessQueryKey = (params?: GetCustomerBusinessParams,) => {
    return [`/customer_business`, ...(params ? [params]: [])] as const;
    }

    
export const getGetCustomerBusinessQueryOptions = <TData = Awaited<ReturnType<typeof getCustomerBusiness>>, TError = void>(params?: GetCustomerBusinessParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomerBusiness>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCustomerBusinessQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCustomerBusiness>>> = ({ signal }) => getCustomerBusiness(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCustomerBusiness>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetCustomerBusinessQueryResult = NonNullable<Awaited<ReturnType<typeof getCustomerBusiness>>>
export type GetCustomerBusinessQueryError = void


export function useGetCustomerBusiness<TData = Awaited<ReturnType<typeof getCustomerBusiness>>, TError = void>(
 params: undefined |  GetCustomerBusinessParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomerBusiness>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCustomerBusiness>>,
          TError,
          Awaited<ReturnType<typeof getCustomerBusiness>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCustomerBusiness<TData = Awaited<ReturnType<typeof getCustomerBusiness>>, TError = void>(
 params?: GetCustomerBusinessParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomerBusiness>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCustomerBusiness>>,
          TError,
          Awaited<ReturnType<typeof getCustomerBusiness>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCustomerBusiness<TData = Awaited<ReturnType<typeof getCustomerBusiness>>, TError = void>(
 params?: GetCustomerBusinessParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomerBusiness>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get all customer_business records
 */

export function useGetCustomerBusiness<TData = Awaited<ReturnType<typeof getCustomerBusiness>>, TError = void>(
 params?: GetCustomerBusinessParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomerBusiness>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetCustomerBusinessQueryOptions(params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Creates a new customer_business record
 * @summary Create a new customer_business record
 */
export const postCustomerBusiness = (
    customerBusiness: CustomerBusiness,
 signal?: AbortSignal
) => {
      
      
      return defaultInstance<PostCustomerBusiness200>(
      {url: `/customer_business`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: customerBusiness, signal
    },
      );
    }
  


export const getPostCustomerBusinessMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCustomerBusiness>>, TError,{data: CustomerBusiness}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postCustomerBusiness>>, TError,{data: CustomerBusiness}, TContext> => {
    
const mutationKey = ['postCustomerBusiness'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postCustomerBusiness>>, {data: CustomerBusiness}> = (props) => {
          const {data} = props ?? {};

          return  postCustomerBusiness(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostCustomerBusinessMutationResult = NonNullable<Awaited<ReturnType<typeof postCustomerBusiness>>>
    export type PostCustomerBusinessMutationBody = CustomerBusiness
    export type PostCustomerBusinessMutationError = void

    /**
 * @summary Create a new customer_business record
 */
export const usePostCustomerBusiness = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCustomerBusiness>>, TError,{data: CustomerBusiness}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postCustomerBusiness>>,
        TError,
        {data: CustomerBusiness},
        TContext
      > => {

      const mutationOptions = getPostCustomerBusinessMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Returns a single customer_business record by ID
 * @summary Get a specific customer_business record
 */
export const getCustomerBusinessId = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return defaultInstance<GetCustomerBusinessId200>(
      {url: `/customer_business/${id}`, method: 'GET', signal
    },
      );
    }
  

export const getGetCustomerBusinessIdQueryKey = (id: string,) => {
    return [`/customer_business/${id}`] as const;
    }

    
export const getGetCustomerBusinessIdQueryOptions = <TData = Awaited<ReturnType<typeof getCustomerBusinessId>>, TError = void>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomerBusinessId>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCustomerBusinessIdQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCustomerBusinessId>>> = ({ signal }) => getCustomerBusinessId(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCustomerBusinessId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetCustomerBusinessIdQueryResult = NonNullable<Awaited<ReturnType<typeof getCustomerBusinessId>>>
export type GetCustomerBusinessIdQueryError = void


export function useGetCustomerBusinessId<TData = Awaited<ReturnType<typeof getCustomerBusinessId>>, TError = void>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomerBusinessId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCustomerBusinessId>>,
          TError,
          Awaited<ReturnType<typeof getCustomerBusinessId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCustomerBusinessId<TData = Awaited<ReturnType<typeof getCustomerBusinessId>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomerBusinessId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCustomerBusinessId>>,
          TError,
          Awaited<ReturnType<typeof getCustomerBusinessId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCustomerBusinessId<TData = Awaited<ReturnType<typeof getCustomerBusinessId>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomerBusinessId>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get a specific customer_business record
 */

export function useGetCustomerBusinessId<TData = Awaited<ReturnType<typeof getCustomerBusinessId>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomerBusinessId>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetCustomerBusinessIdQueryOptions(id,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Updates an existing customer_business record
 * @summary Update a customer_business record
 */
export const putCustomerBusinessId = (
    id: string,
    customerBusiness: CustomerBusiness,
 ) => {
      
      
      return defaultInstance<PutCustomerBusinessId200>(
      {url: `/customer_business/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: customerBusiness
    },
      );
    }
  


export const getPutCustomerBusinessIdMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putCustomerBusinessId>>, TError,{id: string;data: CustomerBusiness}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof putCustomerBusinessId>>, TError,{id: string;data: CustomerBusiness}, TContext> => {
    
const mutationKey = ['putCustomerBusinessId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putCustomerBusinessId>>, {id: string;data: CustomerBusiness}> = (props) => {
          const {id,data} = props ?? {};

          return  putCustomerBusinessId(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutCustomerBusinessIdMutationResult = NonNullable<Awaited<ReturnType<typeof putCustomerBusinessId>>>
    export type PutCustomerBusinessIdMutationBody = CustomerBusiness
    export type PutCustomerBusinessIdMutationError = void

    /**
 * @summary Update a customer_business record
 */
export const usePutCustomerBusinessId = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putCustomerBusinessId>>, TError,{id: string;data: CustomerBusiness}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putCustomerBusinessId>>,
        TError,
        {id: string;data: CustomerBusiness},
        TContext
      > => {

      const mutationOptions = getPutCustomerBusinessIdMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Partially updates an existing customer_business record
 * @summary Partially update a customer_business record
 */
export const patchCustomerBusinessId = (
    id: string,
    customerBusiness: CustomerBusiness,
 ) => {
      
      
      return defaultInstance<PatchCustomerBusinessId200>(
      {url: `/customer_business/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: customerBusiness
    },
      );
    }
  


export const getPatchCustomerBusinessIdMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchCustomerBusinessId>>, TError,{id: string;data: CustomerBusiness}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof patchCustomerBusinessId>>, TError,{id: string;data: CustomerBusiness}, TContext> => {
    
const mutationKey = ['patchCustomerBusinessId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchCustomerBusinessId>>, {id: string;data: CustomerBusiness}> = (props) => {
          const {id,data} = props ?? {};

          return  patchCustomerBusinessId(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PatchCustomerBusinessIdMutationResult = NonNullable<Awaited<ReturnType<typeof patchCustomerBusinessId>>>
    export type PatchCustomerBusinessIdMutationBody = CustomerBusiness
    export type PatchCustomerBusinessIdMutationError = void

    /**
 * @summary Partially update a customer_business record
 */
export const usePatchCustomerBusinessId = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchCustomerBusinessId>>, TError,{id: string;data: CustomerBusiness}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patchCustomerBusinessId>>,
        TError,
        {id: string;data: CustomerBusiness},
        TContext
      > => {

      const mutationOptions = getPatchCustomerBusinessIdMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Deletes a customer_business record
 * @summary Delete a customer_business record
 */
export const deleteCustomerBusinessId = (
    id: string,
 ) => {
      
      
      return defaultInstance<DeleteCustomerBusinessId200>(
      {url: `/customer_business/${id}`, method: 'DELETE'
    },
      );
    }
  


export const getDeleteCustomerBusinessIdMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteCustomerBusinessId>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteCustomerBusinessId>>, TError,{id: string}, TContext> => {
    
const mutationKey = ['deleteCustomerBusinessId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteCustomerBusinessId>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteCustomerBusinessId(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteCustomerBusinessIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteCustomerBusinessId>>>
    
    export type DeleteCustomerBusinessIdMutationError = void

    /**
 * @summary Delete a customer_business record
 */
export const useDeleteCustomerBusinessId = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteCustomerBusinessId>>, TError,{id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteCustomerBusinessId>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getDeleteCustomerBusinessIdMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Returns a list of service_contract records with pagination
 * @summary Get all service_contract records
 */
export const getServiceContract = (
    params?: GetServiceContractParams,
 signal?: AbortSignal
) => {
      
      
      return defaultInstance<GetServiceContract200>(
      {url: `/service_contract`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getGetServiceContractQueryKey = (params?: GetServiceContractParams,) => {
    return [`/service_contract`, ...(params ? [params]: [])] as const;
    }

    
export const getGetServiceContractQueryOptions = <TData = Awaited<ReturnType<typeof getServiceContract>>, TError = void>(params?: GetServiceContractParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getServiceContract>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetServiceContractQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getServiceContract>>> = ({ signal }) => getServiceContract(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getServiceContract>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetServiceContractQueryResult = NonNullable<Awaited<ReturnType<typeof getServiceContract>>>
export type GetServiceContractQueryError = void


export function useGetServiceContract<TData = Awaited<ReturnType<typeof getServiceContract>>, TError = void>(
 params: undefined |  GetServiceContractParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getServiceContract>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getServiceContract>>,
          TError,
          Awaited<ReturnType<typeof getServiceContract>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetServiceContract<TData = Awaited<ReturnType<typeof getServiceContract>>, TError = void>(
 params?: GetServiceContractParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getServiceContract>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getServiceContract>>,
          TError,
          Awaited<ReturnType<typeof getServiceContract>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetServiceContract<TData = Awaited<ReturnType<typeof getServiceContract>>, TError = void>(
 params?: GetServiceContractParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getServiceContract>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get all service_contract records
 */

export function useGetServiceContract<TData = Awaited<ReturnType<typeof getServiceContract>>, TError = void>(
 params?: GetServiceContractParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getServiceContract>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetServiceContractQueryOptions(params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Creates a new service_contract record
 * @summary Create a new service_contract record
 */
export const postServiceContract = (
    serviceContract: ServiceContract,
 signal?: AbortSignal
) => {
      
      
      return defaultInstance<PostServiceContract200>(
      {url: `/service_contract`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: serviceContract, signal
    },
      );
    }
  


export const getPostServiceContractMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postServiceContract>>, TError,{data: ServiceContract}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postServiceContract>>, TError,{data: ServiceContract}, TContext> => {
    
const mutationKey = ['postServiceContract'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postServiceContract>>, {data: ServiceContract}> = (props) => {
          const {data} = props ?? {};

          return  postServiceContract(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostServiceContractMutationResult = NonNullable<Awaited<ReturnType<typeof postServiceContract>>>
    export type PostServiceContractMutationBody = ServiceContract
    export type PostServiceContractMutationError = void

    /**
 * @summary Create a new service_contract record
 */
export const usePostServiceContract = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postServiceContract>>, TError,{data: ServiceContract}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postServiceContract>>,
        TError,
        {data: ServiceContract},
        TContext
      > => {

      const mutationOptions = getPostServiceContractMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Returns a single service_contract record by ID
 * @summary Get a specific service_contract record
 */
export const getServiceContractId = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return defaultInstance<GetServiceContractId200>(
      {url: `/service_contract/${id}`, method: 'GET', signal
    },
      );
    }
  

export const getGetServiceContractIdQueryKey = (id: string,) => {
    return [`/service_contract/${id}`] as const;
    }

    
export const getGetServiceContractIdQueryOptions = <TData = Awaited<ReturnType<typeof getServiceContractId>>, TError = void>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getServiceContractId>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetServiceContractIdQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getServiceContractId>>> = ({ signal }) => getServiceContractId(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getServiceContractId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetServiceContractIdQueryResult = NonNullable<Awaited<ReturnType<typeof getServiceContractId>>>
export type GetServiceContractIdQueryError = void


export function useGetServiceContractId<TData = Awaited<ReturnType<typeof getServiceContractId>>, TError = void>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getServiceContractId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getServiceContractId>>,
          TError,
          Awaited<ReturnType<typeof getServiceContractId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetServiceContractId<TData = Awaited<ReturnType<typeof getServiceContractId>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getServiceContractId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getServiceContractId>>,
          TError,
          Awaited<ReturnType<typeof getServiceContractId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetServiceContractId<TData = Awaited<ReturnType<typeof getServiceContractId>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getServiceContractId>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get a specific service_contract record
 */

export function useGetServiceContractId<TData = Awaited<ReturnType<typeof getServiceContractId>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getServiceContractId>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetServiceContractIdQueryOptions(id,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Updates an existing service_contract record
 * @summary Update a service_contract record
 */
export const putServiceContractId = (
    id: string,
    serviceContract: ServiceContract,
 ) => {
      
      
      return defaultInstance<PutServiceContractId200>(
      {url: `/service_contract/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: serviceContract
    },
      );
    }
  


export const getPutServiceContractIdMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putServiceContractId>>, TError,{id: string;data: ServiceContract}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof putServiceContractId>>, TError,{id: string;data: ServiceContract}, TContext> => {
    
const mutationKey = ['putServiceContractId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putServiceContractId>>, {id: string;data: ServiceContract}> = (props) => {
          const {id,data} = props ?? {};

          return  putServiceContractId(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutServiceContractIdMutationResult = NonNullable<Awaited<ReturnType<typeof putServiceContractId>>>
    export type PutServiceContractIdMutationBody = ServiceContract
    export type PutServiceContractIdMutationError = void

    /**
 * @summary Update a service_contract record
 */
export const usePutServiceContractId = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putServiceContractId>>, TError,{id: string;data: ServiceContract}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putServiceContractId>>,
        TError,
        {id: string;data: ServiceContract},
        TContext
      > => {

      const mutationOptions = getPutServiceContractIdMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Partially updates an existing service_contract record
 * @summary Partially update a service_contract record
 */
export const patchServiceContractId = (
    id: string,
    serviceContract: ServiceContract,
 ) => {
      
      
      return defaultInstance<PatchServiceContractId200>(
      {url: `/service_contract/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: serviceContract
    },
      );
    }
  


export const getPatchServiceContractIdMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchServiceContractId>>, TError,{id: string;data: ServiceContract}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof patchServiceContractId>>, TError,{id: string;data: ServiceContract}, TContext> => {
    
const mutationKey = ['patchServiceContractId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchServiceContractId>>, {id: string;data: ServiceContract}> = (props) => {
          const {id,data} = props ?? {};

          return  patchServiceContractId(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PatchServiceContractIdMutationResult = NonNullable<Awaited<ReturnType<typeof patchServiceContractId>>>
    export type PatchServiceContractIdMutationBody = ServiceContract
    export type PatchServiceContractIdMutationError = void

    /**
 * @summary Partially update a service_contract record
 */
export const usePatchServiceContractId = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchServiceContractId>>, TError,{id: string;data: ServiceContract}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patchServiceContractId>>,
        TError,
        {id: string;data: ServiceContract},
        TContext
      > => {

      const mutationOptions = getPatchServiceContractIdMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Deletes a service_contract record
 * @summary Delete a service_contract record
 */
export const deleteServiceContractId = (
    id: string,
 ) => {
      
      
      return defaultInstance<DeleteServiceContractId200>(
      {url: `/service_contract/${id}`, method: 'DELETE'
    },
      );
    }
  


export const getDeleteServiceContractIdMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteServiceContractId>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteServiceContractId>>, TError,{id: string}, TContext> => {
    
const mutationKey = ['deleteServiceContractId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteServiceContractId>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteServiceContractId(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteServiceContractIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteServiceContractId>>>
    
    export type DeleteServiceContractIdMutationError = void

    /**
 * @summary Delete a service_contract record
 */
export const useDeleteServiceContractId = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteServiceContractId>>, TError,{id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteServiceContractId>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getDeleteServiceContractIdMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Returns a list of product records with pagination
 * @summary Get all product records
 */
export const getProduct = (
    params?: GetProductParams,
 signal?: AbortSignal
) => {
      
      
      return defaultInstance<GetProduct200>(
      {url: `/product`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getGetProductQueryKey = (params?: GetProductParams,) => {
    return [`/product`, ...(params ? [params]: [])] as const;
    }

    
export const getGetProductQueryOptions = <TData = Awaited<ReturnType<typeof getProduct>>, TError = void>(params?: GetProductParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProduct>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetProductQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getProduct>>> = ({ signal }) => getProduct(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getProduct>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetProductQueryResult = NonNullable<Awaited<ReturnType<typeof getProduct>>>
export type GetProductQueryError = void


export function useGetProduct<TData = Awaited<ReturnType<typeof getProduct>>, TError = void>(
 params: undefined |  GetProductParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProduct>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProduct>>,
          TError,
          Awaited<ReturnType<typeof getProduct>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProduct<TData = Awaited<ReturnType<typeof getProduct>>, TError = void>(
 params?: GetProductParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProduct>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProduct>>,
          TError,
          Awaited<ReturnType<typeof getProduct>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProduct<TData = Awaited<ReturnType<typeof getProduct>>, TError = void>(
 params?: GetProductParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProduct>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get all product records
 */

export function useGetProduct<TData = Awaited<ReturnType<typeof getProduct>>, TError = void>(
 params?: GetProductParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProduct>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetProductQueryOptions(params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Creates a new product record
 * @summary Create a new product record
 */
export const postProduct = (
    product: Product,
 signal?: AbortSignal
) => {
      
      
      return defaultInstance<PostProduct200>(
      {url: `/product`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: product, signal
    },
      );
    }
  


export const getPostProductMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postProduct>>, TError,{data: Product}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postProduct>>, TError,{data: Product}, TContext> => {
    
const mutationKey = ['postProduct'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postProduct>>, {data: Product}> = (props) => {
          const {data} = props ?? {};

          return  postProduct(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostProductMutationResult = NonNullable<Awaited<ReturnType<typeof postProduct>>>
    export type PostProductMutationBody = Product
    export type PostProductMutationError = void

    /**
 * @summary Create a new product record
 */
export const usePostProduct = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postProduct>>, TError,{data: Product}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postProduct>>,
        TError,
        {data: Product},
        TContext
      > => {

      const mutationOptions = getPostProductMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Returns a single product record by ID
 * @summary Get a specific product record
 */
export const getProductId = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return defaultInstance<GetProductId200>(
      {url: `/product/${id}`, method: 'GET', signal
    },
      );
    }
  

export const getGetProductIdQueryKey = (id: string,) => {
    return [`/product/${id}`] as const;
    }

    
export const getGetProductIdQueryOptions = <TData = Awaited<ReturnType<typeof getProductId>>, TError = void>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProductId>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetProductIdQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getProductId>>> = ({ signal }) => getProductId(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getProductId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetProductIdQueryResult = NonNullable<Awaited<ReturnType<typeof getProductId>>>
export type GetProductIdQueryError = void


export function useGetProductId<TData = Awaited<ReturnType<typeof getProductId>>, TError = void>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProductId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProductId>>,
          TError,
          Awaited<ReturnType<typeof getProductId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProductId<TData = Awaited<ReturnType<typeof getProductId>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProductId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProductId>>,
          TError,
          Awaited<ReturnType<typeof getProductId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProductId<TData = Awaited<ReturnType<typeof getProductId>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProductId>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get a specific product record
 */

export function useGetProductId<TData = Awaited<ReturnType<typeof getProductId>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProductId>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetProductIdQueryOptions(id,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Updates an existing product record
 * @summary Update a product record
 */
export const putProductId = (
    id: string,
    product: Product,
 ) => {
      
      
      return defaultInstance<PutProductId200>(
      {url: `/product/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: product
    },
      );
    }
  


export const getPutProductIdMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putProductId>>, TError,{id: string;data: Product}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof putProductId>>, TError,{id: string;data: Product}, TContext> => {
    
const mutationKey = ['putProductId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putProductId>>, {id: string;data: Product}> = (props) => {
          const {id,data} = props ?? {};

          return  putProductId(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutProductIdMutationResult = NonNullable<Awaited<ReturnType<typeof putProductId>>>
    export type PutProductIdMutationBody = Product
    export type PutProductIdMutationError = void

    /**
 * @summary Update a product record
 */
export const usePutProductId = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putProductId>>, TError,{id: string;data: Product}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putProductId>>,
        TError,
        {id: string;data: Product},
        TContext
      > => {

      const mutationOptions = getPutProductIdMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Partially updates an existing product record
 * @summary Partially update a product record
 */
export const patchProductId = (
    id: string,
    product: Product,
 ) => {
      
      
      return defaultInstance<PatchProductId200>(
      {url: `/product/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: product
    },
      );
    }
  


export const getPatchProductIdMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchProductId>>, TError,{id: string;data: Product}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof patchProductId>>, TError,{id: string;data: Product}, TContext> => {
    
const mutationKey = ['patchProductId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchProductId>>, {id: string;data: Product}> = (props) => {
          const {id,data} = props ?? {};

          return  patchProductId(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PatchProductIdMutationResult = NonNullable<Awaited<ReturnType<typeof patchProductId>>>
    export type PatchProductIdMutationBody = Product
    export type PatchProductIdMutationError = void

    /**
 * @summary Partially update a product record
 */
export const usePatchProductId = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchProductId>>, TError,{id: string;data: Product}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patchProductId>>,
        TError,
        {id: string;data: Product},
        TContext
      > => {

      const mutationOptions = getPatchProductIdMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Deletes a product record
 * @summary Delete a product record
 */
export const deleteProductId = (
    id: string,
 ) => {
      
      
      return defaultInstance<DeleteProductId200>(
      {url: `/product/${id}`, method: 'DELETE'
    },
      );
    }
  


export const getDeleteProductIdMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteProductId>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteProductId>>, TError,{id: string}, TContext> => {
    
const mutationKey = ['deleteProductId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteProductId>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteProductId(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteProductIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteProductId>>>
    
    export type DeleteProductIdMutationError = void

    /**
 * @summary Delete a product record
 */
export const useDeleteProductId = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteProductId>>, TError,{id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteProductId>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getDeleteProductIdMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Returns a list of product_variant records with pagination
 * @summary Get all product_variant records
 */
export const getProductVariant = (
    params?: GetProductVariantParams,
 signal?: AbortSignal
) => {
      
      
      return defaultInstance<GetProductVariant200>(
      {url: `/product_variant`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getGetProductVariantQueryKey = (params?: GetProductVariantParams,) => {
    return [`/product_variant`, ...(params ? [params]: [])] as const;
    }

    
export const getGetProductVariantQueryOptions = <TData = Awaited<ReturnType<typeof getProductVariant>>, TError = void>(params?: GetProductVariantParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProductVariant>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetProductVariantQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getProductVariant>>> = ({ signal }) => getProductVariant(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getProductVariant>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetProductVariantQueryResult = NonNullable<Awaited<ReturnType<typeof getProductVariant>>>
export type GetProductVariantQueryError = void


export function useGetProductVariant<TData = Awaited<ReturnType<typeof getProductVariant>>, TError = void>(
 params: undefined |  GetProductVariantParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProductVariant>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProductVariant>>,
          TError,
          Awaited<ReturnType<typeof getProductVariant>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProductVariant<TData = Awaited<ReturnType<typeof getProductVariant>>, TError = void>(
 params?: GetProductVariantParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProductVariant>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProductVariant>>,
          TError,
          Awaited<ReturnType<typeof getProductVariant>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProductVariant<TData = Awaited<ReturnType<typeof getProductVariant>>, TError = void>(
 params?: GetProductVariantParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProductVariant>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get all product_variant records
 */

export function useGetProductVariant<TData = Awaited<ReturnType<typeof getProductVariant>>, TError = void>(
 params?: GetProductVariantParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProductVariant>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetProductVariantQueryOptions(params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Creates a new product_variant record
 * @summary Create a new product_variant record
 */
export const postProductVariant = (
    productVariant: ProductVariant,
 signal?: AbortSignal
) => {
      
      
      return defaultInstance<PostProductVariant200>(
      {url: `/product_variant`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: productVariant, signal
    },
      );
    }
  


export const getPostProductVariantMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postProductVariant>>, TError,{data: ProductVariant}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postProductVariant>>, TError,{data: ProductVariant}, TContext> => {
    
const mutationKey = ['postProductVariant'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postProductVariant>>, {data: ProductVariant}> = (props) => {
          const {data} = props ?? {};

          return  postProductVariant(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostProductVariantMutationResult = NonNullable<Awaited<ReturnType<typeof postProductVariant>>>
    export type PostProductVariantMutationBody = ProductVariant
    export type PostProductVariantMutationError = void

    /**
 * @summary Create a new product_variant record
 */
export const usePostProductVariant = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postProductVariant>>, TError,{data: ProductVariant}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postProductVariant>>,
        TError,
        {data: ProductVariant},
        TContext
      > => {

      const mutationOptions = getPostProductVariantMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Returns a single product_variant record by ID
 * @summary Get a specific product_variant record
 */
export const getProductVariantId = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return defaultInstance<GetProductVariantId200>(
      {url: `/product_variant/${id}`, method: 'GET', signal
    },
      );
    }
  

export const getGetProductVariantIdQueryKey = (id: string,) => {
    return [`/product_variant/${id}`] as const;
    }

    
export const getGetProductVariantIdQueryOptions = <TData = Awaited<ReturnType<typeof getProductVariantId>>, TError = void>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProductVariantId>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetProductVariantIdQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getProductVariantId>>> = ({ signal }) => getProductVariantId(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getProductVariantId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetProductVariantIdQueryResult = NonNullable<Awaited<ReturnType<typeof getProductVariantId>>>
export type GetProductVariantIdQueryError = void


export function useGetProductVariantId<TData = Awaited<ReturnType<typeof getProductVariantId>>, TError = void>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProductVariantId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProductVariantId>>,
          TError,
          Awaited<ReturnType<typeof getProductVariantId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProductVariantId<TData = Awaited<ReturnType<typeof getProductVariantId>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProductVariantId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProductVariantId>>,
          TError,
          Awaited<ReturnType<typeof getProductVariantId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProductVariantId<TData = Awaited<ReturnType<typeof getProductVariantId>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProductVariantId>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get a specific product_variant record
 */

export function useGetProductVariantId<TData = Awaited<ReturnType<typeof getProductVariantId>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProductVariantId>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetProductVariantIdQueryOptions(id,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Updates an existing product_variant record
 * @summary Update a product_variant record
 */
export const putProductVariantId = (
    id: string,
    productVariant: ProductVariant,
 ) => {
      
      
      return defaultInstance<PutProductVariantId200>(
      {url: `/product_variant/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: productVariant
    },
      );
    }
  


export const getPutProductVariantIdMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putProductVariantId>>, TError,{id: string;data: ProductVariant}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof putProductVariantId>>, TError,{id: string;data: ProductVariant}, TContext> => {
    
const mutationKey = ['putProductVariantId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putProductVariantId>>, {id: string;data: ProductVariant}> = (props) => {
          const {id,data} = props ?? {};

          return  putProductVariantId(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutProductVariantIdMutationResult = NonNullable<Awaited<ReturnType<typeof putProductVariantId>>>
    export type PutProductVariantIdMutationBody = ProductVariant
    export type PutProductVariantIdMutationError = void

    /**
 * @summary Update a product_variant record
 */
export const usePutProductVariantId = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putProductVariantId>>, TError,{id: string;data: ProductVariant}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putProductVariantId>>,
        TError,
        {id: string;data: ProductVariant},
        TContext
      > => {

      const mutationOptions = getPutProductVariantIdMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Partially updates an existing product_variant record
 * @summary Partially update a product_variant record
 */
export const patchProductVariantId = (
    id: string,
    productVariant: ProductVariant,
 ) => {
      
      
      return defaultInstance<PatchProductVariantId200>(
      {url: `/product_variant/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: productVariant
    },
      );
    }
  


export const getPatchProductVariantIdMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchProductVariantId>>, TError,{id: string;data: ProductVariant}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof patchProductVariantId>>, TError,{id: string;data: ProductVariant}, TContext> => {
    
const mutationKey = ['patchProductVariantId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchProductVariantId>>, {id: string;data: ProductVariant}> = (props) => {
          const {id,data} = props ?? {};

          return  patchProductVariantId(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PatchProductVariantIdMutationResult = NonNullable<Awaited<ReturnType<typeof patchProductVariantId>>>
    export type PatchProductVariantIdMutationBody = ProductVariant
    export type PatchProductVariantIdMutationError = void

    /**
 * @summary Partially update a product_variant record
 */
export const usePatchProductVariantId = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchProductVariantId>>, TError,{id: string;data: ProductVariant}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patchProductVariantId>>,
        TError,
        {id: string;data: ProductVariant},
        TContext
      > => {

      const mutationOptions = getPatchProductVariantIdMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Deletes a product_variant record
 * @summary Delete a product_variant record
 */
export const deleteProductVariantId = (
    id: string,
 ) => {
      
      
      return defaultInstance<DeleteProductVariantId200>(
      {url: `/product_variant/${id}`, method: 'DELETE'
    },
      );
    }
  


export const getDeleteProductVariantIdMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteProductVariantId>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteProductVariantId>>, TError,{id: string}, TContext> => {
    
const mutationKey = ['deleteProductVariantId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteProductVariantId>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteProductVariantId(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteProductVariantIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteProductVariantId>>>
    
    export type DeleteProductVariantIdMutationError = void

    /**
 * @summary Delete a product_variant record
 */
export const useDeleteProductVariantId = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteProductVariantId>>, TError,{id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteProductVariantId>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getDeleteProductVariantIdMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Returns a list of product_type records with pagination
 * @summary Get all product_type records
 */
export const getProductType = (
    params?: GetProductTypeParams,
 signal?: AbortSignal
) => {
      
      
      return defaultInstance<GetProductType200>(
      {url: `/product_type`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getGetProductTypeQueryKey = (params?: GetProductTypeParams,) => {
    return [`/product_type`, ...(params ? [params]: [])] as const;
    }

    
export const getGetProductTypeQueryOptions = <TData = Awaited<ReturnType<typeof getProductType>>, TError = void>(params?: GetProductTypeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProductType>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetProductTypeQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getProductType>>> = ({ signal }) => getProductType(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getProductType>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetProductTypeQueryResult = NonNullable<Awaited<ReturnType<typeof getProductType>>>
export type GetProductTypeQueryError = void


export function useGetProductType<TData = Awaited<ReturnType<typeof getProductType>>, TError = void>(
 params: undefined |  GetProductTypeParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProductType>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProductType>>,
          TError,
          Awaited<ReturnType<typeof getProductType>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProductType<TData = Awaited<ReturnType<typeof getProductType>>, TError = void>(
 params?: GetProductTypeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProductType>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProductType>>,
          TError,
          Awaited<ReturnType<typeof getProductType>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProductType<TData = Awaited<ReturnType<typeof getProductType>>, TError = void>(
 params?: GetProductTypeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProductType>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get all product_type records
 */

export function useGetProductType<TData = Awaited<ReturnType<typeof getProductType>>, TError = void>(
 params?: GetProductTypeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProductType>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetProductTypeQueryOptions(params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Creates a new product_type record
 * @summary Create a new product_type record
 */
export const postProductType = (
    productType: ProductType,
 signal?: AbortSignal
) => {
      
      
      return defaultInstance<PostProductType200>(
      {url: `/product_type`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: productType, signal
    },
      );
    }
  


export const getPostProductTypeMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postProductType>>, TError,{data: ProductType}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postProductType>>, TError,{data: ProductType}, TContext> => {
    
const mutationKey = ['postProductType'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postProductType>>, {data: ProductType}> = (props) => {
          const {data} = props ?? {};

          return  postProductType(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostProductTypeMutationResult = NonNullable<Awaited<ReturnType<typeof postProductType>>>
    export type PostProductTypeMutationBody = ProductType
    export type PostProductTypeMutationError = void

    /**
 * @summary Create a new product_type record
 */
export const usePostProductType = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postProductType>>, TError,{data: ProductType}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postProductType>>,
        TError,
        {data: ProductType},
        TContext
      > => {

      const mutationOptions = getPostProductTypeMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Returns a single product_type record by ID
 * @summary Get a specific product_type record
 */
export const getProductTypeId = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return defaultInstance<GetProductTypeId200>(
      {url: `/product_type/${id}`, method: 'GET', signal
    },
      );
    }
  

export const getGetProductTypeIdQueryKey = (id: string,) => {
    return [`/product_type/${id}`] as const;
    }

    
export const getGetProductTypeIdQueryOptions = <TData = Awaited<ReturnType<typeof getProductTypeId>>, TError = void>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProductTypeId>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetProductTypeIdQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getProductTypeId>>> = ({ signal }) => getProductTypeId(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getProductTypeId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetProductTypeIdQueryResult = NonNullable<Awaited<ReturnType<typeof getProductTypeId>>>
export type GetProductTypeIdQueryError = void


export function useGetProductTypeId<TData = Awaited<ReturnType<typeof getProductTypeId>>, TError = void>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProductTypeId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProductTypeId>>,
          TError,
          Awaited<ReturnType<typeof getProductTypeId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProductTypeId<TData = Awaited<ReturnType<typeof getProductTypeId>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProductTypeId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProductTypeId>>,
          TError,
          Awaited<ReturnType<typeof getProductTypeId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProductTypeId<TData = Awaited<ReturnType<typeof getProductTypeId>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProductTypeId>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get a specific product_type record
 */

export function useGetProductTypeId<TData = Awaited<ReturnType<typeof getProductTypeId>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProductTypeId>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetProductTypeIdQueryOptions(id,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Updates an existing product_type record
 * @summary Update a product_type record
 */
export const putProductTypeId = (
    id: string,
    productType: ProductType,
 ) => {
      
      
      return defaultInstance<PutProductTypeId200>(
      {url: `/product_type/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: productType
    },
      );
    }
  


export const getPutProductTypeIdMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putProductTypeId>>, TError,{id: string;data: ProductType}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof putProductTypeId>>, TError,{id: string;data: ProductType}, TContext> => {
    
const mutationKey = ['putProductTypeId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putProductTypeId>>, {id: string;data: ProductType}> = (props) => {
          const {id,data} = props ?? {};

          return  putProductTypeId(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutProductTypeIdMutationResult = NonNullable<Awaited<ReturnType<typeof putProductTypeId>>>
    export type PutProductTypeIdMutationBody = ProductType
    export type PutProductTypeIdMutationError = void

    /**
 * @summary Update a product_type record
 */
export const usePutProductTypeId = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putProductTypeId>>, TError,{id: string;data: ProductType}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putProductTypeId>>,
        TError,
        {id: string;data: ProductType},
        TContext
      > => {

      const mutationOptions = getPutProductTypeIdMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Partially updates an existing product_type record
 * @summary Partially update a product_type record
 */
export const patchProductTypeId = (
    id: string,
    productType: ProductType,
 ) => {
      
      
      return defaultInstance<PatchProductTypeId200>(
      {url: `/product_type/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: productType
    },
      );
    }
  


export const getPatchProductTypeIdMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchProductTypeId>>, TError,{id: string;data: ProductType}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof patchProductTypeId>>, TError,{id: string;data: ProductType}, TContext> => {
    
const mutationKey = ['patchProductTypeId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchProductTypeId>>, {id: string;data: ProductType}> = (props) => {
          const {id,data} = props ?? {};

          return  patchProductTypeId(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PatchProductTypeIdMutationResult = NonNullable<Awaited<ReturnType<typeof patchProductTypeId>>>
    export type PatchProductTypeIdMutationBody = ProductType
    export type PatchProductTypeIdMutationError = void

    /**
 * @summary Partially update a product_type record
 */
export const usePatchProductTypeId = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchProductTypeId>>, TError,{id: string;data: ProductType}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patchProductTypeId>>,
        TError,
        {id: string;data: ProductType},
        TContext
      > => {

      const mutationOptions = getPatchProductTypeIdMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Deletes a product_type record
 * @summary Delete a product_type record
 */
export const deleteProductTypeId = (
    id: string,
 ) => {
      
      
      return defaultInstance<DeleteProductTypeId200>(
      {url: `/product_type/${id}`, method: 'DELETE'
    },
      );
    }
  


export const getDeleteProductTypeIdMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteProductTypeId>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteProductTypeId>>, TError,{id: string}, TContext> => {
    
const mutationKey = ['deleteProductTypeId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteProductTypeId>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteProductTypeId(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteProductTypeIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteProductTypeId>>>
    
    export type DeleteProductTypeIdMutationError = void

    /**
 * @summary Delete a product_type record
 */
export const useDeleteProductTypeId = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteProductTypeId>>, TError,{id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteProductTypeId>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getDeleteProductTypeIdMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Returns a list of productclass records with pagination
 * @summary Get all productclass records
 */
export const getProductclass = (
    params?: GetProductclassParams,
 signal?: AbortSignal
) => {
      
      
      return defaultInstance<GetProductclass200>(
      {url: `/productclass`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getGetProductclassQueryKey = (params?: GetProductclassParams,) => {
    return [`/productclass`, ...(params ? [params]: [])] as const;
    }

    
export const getGetProductclassQueryOptions = <TData = Awaited<ReturnType<typeof getProductclass>>, TError = void>(params?: GetProductclassParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProductclass>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetProductclassQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getProductclass>>> = ({ signal }) => getProductclass(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getProductclass>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetProductclassQueryResult = NonNullable<Awaited<ReturnType<typeof getProductclass>>>
export type GetProductclassQueryError = void


export function useGetProductclass<TData = Awaited<ReturnType<typeof getProductclass>>, TError = void>(
 params: undefined |  GetProductclassParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProductclass>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProductclass>>,
          TError,
          Awaited<ReturnType<typeof getProductclass>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProductclass<TData = Awaited<ReturnType<typeof getProductclass>>, TError = void>(
 params?: GetProductclassParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProductclass>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProductclass>>,
          TError,
          Awaited<ReturnType<typeof getProductclass>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProductclass<TData = Awaited<ReturnType<typeof getProductclass>>, TError = void>(
 params?: GetProductclassParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProductclass>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get all productclass records
 */

export function useGetProductclass<TData = Awaited<ReturnType<typeof getProductclass>>, TError = void>(
 params?: GetProductclassParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProductclass>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetProductclassQueryOptions(params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Creates a new productclass record
 * @summary Create a new productclass record
 */
export const postProductclass = (
    productclass: Productclass,
 signal?: AbortSignal
) => {
      
      
      return defaultInstance<PostProductclass200>(
      {url: `/productclass`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: productclass, signal
    },
      );
    }
  


export const getPostProductclassMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postProductclass>>, TError,{data: Productclass}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postProductclass>>, TError,{data: Productclass}, TContext> => {
    
const mutationKey = ['postProductclass'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postProductclass>>, {data: Productclass}> = (props) => {
          const {data} = props ?? {};

          return  postProductclass(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostProductclassMutationResult = NonNullable<Awaited<ReturnType<typeof postProductclass>>>
    export type PostProductclassMutationBody = Productclass
    export type PostProductclassMutationError = void

    /**
 * @summary Create a new productclass record
 */
export const usePostProductclass = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postProductclass>>, TError,{data: Productclass}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postProductclass>>,
        TError,
        {data: Productclass},
        TContext
      > => {

      const mutationOptions = getPostProductclassMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Returns a single productclass record by ID
 * @summary Get a specific productclass record
 */
export const getProductclassId = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return defaultInstance<GetProductclassId200>(
      {url: `/productclass/${id}`, method: 'GET', signal
    },
      );
    }
  

export const getGetProductclassIdQueryKey = (id: string,) => {
    return [`/productclass/${id}`] as const;
    }

    
export const getGetProductclassIdQueryOptions = <TData = Awaited<ReturnType<typeof getProductclassId>>, TError = void>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProductclassId>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetProductclassIdQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getProductclassId>>> = ({ signal }) => getProductclassId(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getProductclassId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetProductclassIdQueryResult = NonNullable<Awaited<ReturnType<typeof getProductclassId>>>
export type GetProductclassIdQueryError = void


export function useGetProductclassId<TData = Awaited<ReturnType<typeof getProductclassId>>, TError = void>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProductclassId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProductclassId>>,
          TError,
          Awaited<ReturnType<typeof getProductclassId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProductclassId<TData = Awaited<ReturnType<typeof getProductclassId>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProductclassId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProductclassId>>,
          TError,
          Awaited<ReturnType<typeof getProductclassId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProductclassId<TData = Awaited<ReturnType<typeof getProductclassId>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProductclassId>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get a specific productclass record
 */

export function useGetProductclassId<TData = Awaited<ReturnType<typeof getProductclassId>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProductclassId>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetProductclassIdQueryOptions(id,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Updates an existing productclass record
 * @summary Update a productclass record
 */
export const putProductclassId = (
    id: string,
    productclass: Productclass,
 ) => {
      
      
      return defaultInstance<PutProductclassId200>(
      {url: `/productclass/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: productclass
    },
      );
    }
  


export const getPutProductclassIdMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putProductclassId>>, TError,{id: string;data: Productclass}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof putProductclassId>>, TError,{id: string;data: Productclass}, TContext> => {
    
const mutationKey = ['putProductclassId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putProductclassId>>, {id: string;data: Productclass}> = (props) => {
          const {id,data} = props ?? {};

          return  putProductclassId(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutProductclassIdMutationResult = NonNullable<Awaited<ReturnType<typeof putProductclassId>>>
    export type PutProductclassIdMutationBody = Productclass
    export type PutProductclassIdMutationError = void

    /**
 * @summary Update a productclass record
 */
export const usePutProductclassId = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putProductclassId>>, TError,{id: string;data: Productclass}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putProductclassId>>,
        TError,
        {id: string;data: Productclass},
        TContext
      > => {

      const mutationOptions = getPutProductclassIdMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Partially updates an existing productclass record
 * @summary Partially update a productclass record
 */
export const patchProductclassId = (
    id: string,
    productclass: Productclass,
 ) => {
      
      
      return defaultInstance<PatchProductclassId200>(
      {url: `/productclass/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: productclass
    },
      );
    }
  


export const getPatchProductclassIdMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchProductclassId>>, TError,{id: string;data: Productclass}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof patchProductclassId>>, TError,{id: string;data: Productclass}, TContext> => {
    
const mutationKey = ['patchProductclassId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchProductclassId>>, {id: string;data: Productclass}> = (props) => {
          const {id,data} = props ?? {};

          return  patchProductclassId(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PatchProductclassIdMutationResult = NonNullable<Awaited<ReturnType<typeof patchProductclassId>>>
    export type PatchProductclassIdMutationBody = Productclass
    export type PatchProductclassIdMutationError = void

    /**
 * @summary Partially update a productclass record
 */
export const usePatchProductclassId = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchProductclassId>>, TError,{id: string;data: Productclass}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patchProductclassId>>,
        TError,
        {id: string;data: Productclass},
        TContext
      > => {

      const mutationOptions = getPatchProductclassIdMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Deletes a productclass record
 * @summary Delete a productclass record
 */
export const deleteProductclassId = (
    id: string,
 ) => {
      
      
      return defaultInstance<DeleteProductclassId200>(
      {url: `/productclass/${id}`, method: 'DELETE'
    },
      );
    }
  


export const getDeleteProductclassIdMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteProductclassId>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteProductclassId>>, TError,{id: string}, TContext> => {
    
const mutationKey = ['deleteProductclassId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteProductclassId>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteProductclassId(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteProductclassIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteProductclassId>>>
    
    export type DeleteProductclassIdMutationError = void

    /**
 * @summary Delete a productclass record
 */
export const useDeleteProductclassId = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteProductclassId>>, TError,{id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteProductclassId>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getDeleteProductclassIdMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Returns a list of product_categories records with pagination
 * @summary Get all product_categories records
 */
export const getProductCategories = (
    params?: GetProductCategoriesParams,
 signal?: AbortSignal
) => {
      
      
      return defaultInstance<GetProductCategories200>(
      {url: `/product_categories`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getGetProductCategoriesQueryKey = (params?: GetProductCategoriesParams,) => {
    return [`/product_categories`, ...(params ? [params]: [])] as const;
    }

    
export const getGetProductCategoriesQueryOptions = <TData = Awaited<ReturnType<typeof getProductCategories>>, TError = void>(params?: GetProductCategoriesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProductCategories>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetProductCategoriesQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getProductCategories>>> = ({ signal }) => getProductCategories(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getProductCategories>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetProductCategoriesQueryResult = NonNullable<Awaited<ReturnType<typeof getProductCategories>>>
export type GetProductCategoriesQueryError = void


export function useGetProductCategories<TData = Awaited<ReturnType<typeof getProductCategories>>, TError = void>(
 params: undefined |  GetProductCategoriesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProductCategories>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProductCategories>>,
          TError,
          Awaited<ReturnType<typeof getProductCategories>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProductCategories<TData = Awaited<ReturnType<typeof getProductCategories>>, TError = void>(
 params?: GetProductCategoriesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProductCategories>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProductCategories>>,
          TError,
          Awaited<ReturnType<typeof getProductCategories>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProductCategories<TData = Awaited<ReturnType<typeof getProductCategories>>, TError = void>(
 params?: GetProductCategoriesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProductCategories>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get all product_categories records
 */

export function useGetProductCategories<TData = Awaited<ReturnType<typeof getProductCategories>>, TError = void>(
 params?: GetProductCategoriesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProductCategories>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetProductCategoriesQueryOptions(params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Creates a new product_categories record
 * @summary Create a new product_categories record
 */
export const postProductCategories = (
    productCategories: ProductCategories,
 signal?: AbortSignal
) => {
      
      
      return defaultInstance<PostProductCategories200>(
      {url: `/product_categories`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: productCategories, signal
    },
      );
    }
  


export const getPostProductCategoriesMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postProductCategories>>, TError,{data: ProductCategories}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postProductCategories>>, TError,{data: ProductCategories}, TContext> => {
    
const mutationKey = ['postProductCategories'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postProductCategories>>, {data: ProductCategories}> = (props) => {
          const {data} = props ?? {};

          return  postProductCategories(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostProductCategoriesMutationResult = NonNullable<Awaited<ReturnType<typeof postProductCategories>>>
    export type PostProductCategoriesMutationBody = ProductCategories
    export type PostProductCategoriesMutationError = void

    /**
 * @summary Create a new product_categories record
 */
export const usePostProductCategories = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postProductCategories>>, TError,{data: ProductCategories}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postProductCategories>>,
        TError,
        {data: ProductCategories},
        TContext
      > => {

      const mutationOptions = getPostProductCategoriesMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Returns a single product_categories record by ID
 * @summary Get a specific product_categories record
 */
export const getProductCategoriesId = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return defaultInstance<GetProductCategoriesId200>(
      {url: `/product_categories/${id}`, method: 'GET', signal
    },
      );
    }
  

export const getGetProductCategoriesIdQueryKey = (id: string,) => {
    return [`/product_categories/${id}`] as const;
    }

    
export const getGetProductCategoriesIdQueryOptions = <TData = Awaited<ReturnType<typeof getProductCategoriesId>>, TError = void>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProductCategoriesId>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetProductCategoriesIdQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getProductCategoriesId>>> = ({ signal }) => getProductCategoriesId(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getProductCategoriesId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetProductCategoriesIdQueryResult = NonNullable<Awaited<ReturnType<typeof getProductCategoriesId>>>
export type GetProductCategoriesIdQueryError = void


export function useGetProductCategoriesId<TData = Awaited<ReturnType<typeof getProductCategoriesId>>, TError = void>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProductCategoriesId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProductCategoriesId>>,
          TError,
          Awaited<ReturnType<typeof getProductCategoriesId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProductCategoriesId<TData = Awaited<ReturnType<typeof getProductCategoriesId>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProductCategoriesId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProductCategoriesId>>,
          TError,
          Awaited<ReturnType<typeof getProductCategoriesId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProductCategoriesId<TData = Awaited<ReturnType<typeof getProductCategoriesId>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProductCategoriesId>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get a specific product_categories record
 */

export function useGetProductCategoriesId<TData = Awaited<ReturnType<typeof getProductCategoriesId>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProductCategoriesId>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetProductCategoriesIdQueryOptions(id,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Updates an existing product_categories record
 * @summary Update a product_categories record
 */
export const putProductCategoriesId = (
    id: string,
    productCategories: ProductCategories,
 ) => {
      
      
      return defaultInstance<PutProductCategoriesId200>(
      {url: `/product_categories/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: productCategories
    },
      );
    }
  


export const getPutProductCategoriesIdMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putProductCategoriesId>>, TError,{id: string;data: ProductCategories}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof putProductCategoriesId>>, TError,{id: string;data: ProductCategories}, TContext> => {
    
const mutationKey = ['putProductCategoriesId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putProductCategoriesId>>, {id: string;data: ProductCategories}> = (props) => {
          const {id,data} = props ?? {};

          return  putProductCategoriesId(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutProductCategoriesIdMutationResult = NonNullable<Awaited<ReturnType<typeof putProductCategoriesId>>>
    export type PutProductCategoriesIdMutationBody = ProductCategories
    export type PutProductCategoriesIdMutationError = void

    /**
 * @summary Update a product_categories record
 */
export const usePutProductCategoriesId = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putProductCategoriesId>>, TError,{id: string;data: ProductCategories}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putProductCategoriesId>>,
        TError,
        {id: string;data: ProductCategories},
        TContext
      > => {

      const mutationOptions = getPutProductCategoriesIdMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Partially updates an existing product_categories record
 * @summary Partially update a product_categories record
 */
export const patchProductCategoriesId = (
    id: string,
    productCategories: ProductCategories,
 ) => {
      
      
      return defaultInstance<PatchProductCategoriesId200>(
      {url: `/product_categories/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: productCategories
    },
      );
    }
  


export const getPatchProductCategoriesIdMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchProductCategoriesId>>, TError,{id: string;data: ProductCategories}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof patchProductCategoriesId>>, TError,{id: string;data: ProductCategories}, TContext> => {
    
const mutationKey = ['patchProductCategoriesId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchProductCategoriesId>>, {id: string;data: ProductCategories}> = (props) => {
          const {id,data} = props ?? {};

          return  patchProductCategoriesId(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PatchProductCategoriesIdMutationResult = NonNullable<Awaited<ReturnType<typeof patchProductCategoriesId>>>
    export type PatchProductCategoriesIdMutationBody = ProductCategories
    export type PatchProductCategoriesIdMutationError = void

    /**
 * @summary Partially update a product_categories record
 */
export const usePatchProductCategoriesId = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchProductCategoriesId>>, TError,{id: string;data: ProductCategories}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patchProductCategoriesId>>,
        TError,
        {id: string;data: ProductCategories},
        TContext
      > => {

      const mutationOptions = getPatchProductCategoriesIdMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Deletes a product_categories record
 * @summary Delete a product_categories record
 */
export const deleteProductCategoriesId = (
    id: string,
 ) => {
      
      
      return defaultInstance<DeleteProductCategoriesId200>(
      {url: `/product_categories/${id}`, method: 'DELETE'
    },
      );
    }
  


export const getDeleteProductCategoriesIdMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteProductCategoriesId>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteProductCategoriesId>>, TError,{id: string}, TContext> => {
    
const mutationKey = ['deleteProductCategoriesId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteProductCategoriesId>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteProductCategoriesId(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteProductCategoriesIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteProductCategoriesId>>>
    
    export type DeleteProductCategoriesIdMutationError = void

    /**
 * @summary Delete a product_categories record
 */
export const useDeleteProductCategoriesId = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteProductCategoriesId>>, TError,{id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteProductCategoriesId>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getDeleteProductCategoriesIdMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Returns a list of product_attribute records with pagination
 * @summary Get all product_attribute records
 */
export const getProductAttribute = (
    params?: GetProductAttributeParams,
 signal?: AbortSignal
) => {
      
      
      return defaultInstance<GetProductAttribute200>(
      {url: `/product_attribute`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getGetProductAttributeQueryKey = (params?: GetProductAttributeParams,) => {
    return [`/product_attribute`, ...(params ? [params]: [])] as const;
    }

    
export const getGetProductAttributeQueryOptions = <TData = Awaited<ReturnType<typeof getProductAttribute>>, TError = void>(params?: GetProductAttributeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProductAttribute>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetProductAttributeQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getProductAttribute>>> = ({ signal }) => getProductAttribute(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getProductAttribute>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetProductAttributeQueryResult = NonNullable<Awaited<ReturnType<typeof getProductAttribute>>>
export type GetProductAttributeQueryError = void


export function useGetProductAttribute<TData = Awaited<ReturnType<typeof getProductAttribute>>, TError = void>(
 params: undefined |  GetProductAttributeParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProductAttribute>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProductAttribute>>,
          TError,
          Awaited<ReturnType<typeof getProductAttribute>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProductAttribute<TData = Awaited<ReturnType<typeof getProductAttribute>>, TError = void>(
 params?: GetProductAttributeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProductAttribute>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProductAttribute>>,
          TError,
          Awaited<ReturnType<typeof getProductAttribute>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProductAttribute<TData = Awaited<ReturnType<typeof getProductAttribute>>, TError = void>(
 params?: GetProductAttributeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProductAttribute>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get all product_attribute records
 */

export function useGetProductAttribute<TData = Awaited<ReturnType<typeof getProductAttribute>>, TError = void>(
 params?: GetProductAttributeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProductAttribute>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetProductAttributeQueryOptions(params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Creates a new product_attribute record
 * @summary Create a new product_attribute record
 */
export const postProductAttribute = (
    productAttribute: ProductAttribute,
 signal?: AbortSignal
) => {
      
      
      return defaultInstance<PostProductAttribute200>(
      {url: `/product_attribute`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: productAttribute, signal
    },
      );
    }
  


export const getPostProductAttributeMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postProductAttribute>>, TError,{data: ProductAttribute}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postProductAttribute>>, TError,{data: ProductAttribute}, TContext> => {
    
const mutationKey = ['postProductAttribute'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postProductAttribute>>, {data: ProductAttribute}> = (props) => {
          const {data} = props ?? {};

          return  postProductAttribute(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostProductAttributeMutationResult = NonNullable<Awaited<ReturnType<typeof postProductAttribute>>>
    export type PostProductAttributeMutationBody = ProductAttribute
    export type PostProductAttributeMutationError = void

    /**
 * @summary Create a new product_attribute record
 */
export const usePostProductAttribute = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postProductAttribute>>, TError,{data: ProductAttribute}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postProductAttribute>>,
        TError,
        {data: ProductAttribute},
        TContext
      > => {

      const mutationOptions = getPostProductAttributeMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Returns a single product_attribute record by ID
 * @summary Get a specific product_attribute record
 */
export const getProductAttributeId = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return defaultInstance<GetProductAttributeId200>(
      {url: `/product_attribute/${id}`, method: 'GET', signal
    },
      );
    }
  

export const getGetProductAttributeIdQueryKey = (id: string,) => {
    return [`/product_attribute/${id}`] as const;
    }

    
export const getGetProductAttributeIdQueryOptions = <TData = Awaited<ReturnType<typeof getProductAttributeId>>, TError = void>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProductAttributeId>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetProductAttributeIdQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getProductAttributeId>>> = ({ signal }) => getProductAttributeId(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getProductAttributeId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetProductAttributeIdQueryResult = NonNullable<Awaited<ReturnType<typeof getProductAttributeId>>>
export type GetProductAttributeIdQueryError = void


export function useGetProductAttributeId<TData = Awaited<ReturnType<typeof getProductAttributeId>>, TError = void>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProductAttributeId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProductAttributeId>>,
          TError,
          Awaited<ReturnType<typeof getProductAttributeId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProductAttributeId<TData = Awaited<ReturnType<typeof getProductAttributeId>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProductAttributeId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProductAttributeId>>,
          TError,
          Awaited<ReturnType<typeof getProductAttributeId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProductAttributeId<TData = Awaited<ReturnType<typeof getProductAttributeId>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProductAttributeId>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get a specific product_attribute record
 */

export function useGetProductAttributeId<TData = Awaited<ReturnType<typeof getProductAttributeId>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProductAttributeId>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetProductAttributeIdQueryOptions(id,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Updates an existing product_attribute record
 * @summary Update a product_attribute record
 */
export const putProductAttributeId = (
    id: string,
    productAttribute: ProductAttribute,
 ) => {
      
      
      return defaultInstance<PutProductAttributeId200>(
      {url: `/product_attribute/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: productAttribute
    },
      );
    }
  


export const getPutProductAttributeIdMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putProductAttributeId>>, TError,{id: string;data: ProductAttribute}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof putProductAttributeId>>, TError,{id: string;data: ProductAttribute}, TContext> => {
    
const mutationKey = ['putProductAttributeId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putProductAttributeId>>, {id: string;data: ProductAttribute}> = (props) => {
          const {id,data} = props ?? {};

          return  putProductAttributeId(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutProductAttributeIdMutationResult = NonNullable<Awaited<ReturnType<typeof putProductAttributeId>>>
    export type PutProductAttributeIdMutationBody = ProductAttribute
    export type PutProductAttributeIdMutationError = void

    /**
 * @summary Update a product_attribute record
 */
export const usePutProductAttributeId = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putProductAttributeId>>, TError,{id: string;data: ProductAttribute}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putProductAttributeId>>,
        TError,
        {id: string;data: ProductAttribute},
        TContext
      > => {

      const mutationOptions = getPutProductAttributeIdMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Partially updates an existing product_attribute record
 * @summary Partially update a product_attribute record
 */
export const patchProductAttributeId = (
    id: string,
    productAttribute: ProductAttribute,
 ) => {
      
      
      return defaultInstance<PatchProductAttributeId200>(
      {url: `/product_attribute/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: productAttribute
    },
      );
    }
  


export const getPatchProductAttributeIdMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchProductAttributeId>>, TError,{id: string;data: ProductAttribute}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof patchProductAttributeId>>, TError,{id: string;data: ProductAttribute}, TContext> => {
    
const mutationKey = ['patchProductAttributeId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchProductAttributeId>>, {id: string;data: ProductAttribute}> = (props) => {
          const {id,data} = props ?? {};

          return  patchProductAttributeId(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PatchProductAttributeIdMutationResult = NonNullable<Awaited<ReturnType<typeof patchProductAttributeId>>>
    export type PatchProductAttributeIdMutationBody = ProductAttribute
    export type PatchProductAttributeIdMutationError = void

    /**
 * @summary Partially update a product_attribute record
 */
export const usePatchProductAttributeId = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchProductAttributeId>>, TError,{id: string;data: ProductAttribute}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patchProductAttributeId>>,
        TError,
        {id: string;data: ProductAttribute},
        TContext
      > => {

      const mutationOptions = getPatchProductAttributeIdMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Deletes a product_attribute record
 * @summary Delete a product_attribute record
 */
export const deleteProductAttributeId = (
    id: string,
 ) => {
      
      
      return defaultInstance<DeleteProductAttributeId200>(
      {url: `/product_attribute/${id}`, method: 'DELETE'
    },
      );
    }
  


export const getDeleteProductAttributeIdMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteProductAttributeId>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteProductAttributeId>>, TError,{id: string}, TContext> => {
    
const mutationKey = ['deleteProductAttributeId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteProductAttributeId>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteProductAttributeId(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteProductAttributeIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteProductAttributeId>>>
    
    export type DeleteProductAttributeIdMutationError = void

    /**
 * @summary Delete a product_attribute record
 */
export const useDeleteProductAttributeId = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteProductAttributeId>>, TError,{id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteProductAttributeId>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getDeleteProductAttributeIdMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Returns a list of productclass_product_attribute records with pagination
 * @summary Get all productclass_product_attribute records
 */
export const getProductclassProductAttribute = (
    params?: GetProductclassProductAttributeParams,
 signal?: AbortSignal
) => {
      
      
      return defaultInstance<GetProductclassProductAttribute200>(
      {url: `/productclass_product_attribute`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getGetProductclassProductAttributeQueryKey = (params?: GetProductclassProductAttributeParams,) => {
    return [`/productclass_product_attribute`, ...(params ? [params]: [])] as const;
    }

    
export const getGetProductclassProductAttributeQueryOptions = <TData = Awaited<ReturnType<typeof getProductclassProductAttribute>>, TError = void>(params?: GetProductclassProductAttributeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProductclassProductAttribute>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetProductclassProductAttributeQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getProductclassProductAttribute>>> = ({ signal }) => getProductclassProductAttribute(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getProductclassProductAttribute>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetProductclassProductAttributeQueryResult = NonNullable<Awaited<ReturnType<typeof getProductclassProductAttribute>>>
export type GetProductclassProductAttributeQueryError = void


export function useGetProductclassProductAttribute<TData = Awaited<ReturnType<typeof getProductclassProductAttribute>>, TError = void>(
 params: undefined |  GetProductclassProductAttributeParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProductclassProductAttribute>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProductclassProductAttribute>>,
          TError,
          Awaited<ReturnType<typeof getProductclassProductAttribute>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProductclassProductAttribute<TData = Awaited<ReturnType<typeof getProductclassProductAttribute>>, TError = void>(
 params?: GetProductclassProductAttributeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProductclassProductAttribute>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProductclassProductAttribute>>,
          TError,
          Awaited<ReturnType<typeof getProductclassProductAttribute>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProductclassProductAttribute<TData = Awaited<ReturnType<typeof getProductclassProductAttribute>>, TError = void>(
 params?: GetProductclassProductAttributeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProductclassProductAttribute>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get all productclass_product_attribute records
 */

export function useGetProductclassProductAttribute<TData = Awaited<ReturnType<typeof getProductclassProductAttribute>>, TError = void>(
 params?: GetProductclassProductAttributeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProductclassProductAttribute>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetProductclassProductAttributeQueryOptions(params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Creates a new productclass_product_attribute record
 * @summary Create a new productclass_product_attribute record
 */
export const postProductclassProductAttribute = (
    productclassProductAttribute: ProductclassProductAttribute,
 signal?: AbortSignal
) => {
      
      
      return defaultInstance<PostProductclassProductAttribute200>(
      {url: `/productclass_product_attribute`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: productclassProductAttribute, signal
    },
      );
    }
  


export const getPostProductclassProductAttributeMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postProductclassProductAttribute>>, TError,{data: ProductclassProductAttribute}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postProductclassProductAttribute>>, TError,{data: ProductclassProductAttribute}, TContext> => {
    
const mutationKey = ['postProductclassProductAttribute'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postProductclassProductAttribute>>, {data: ProductclassProductAttribute}> = (props) => {
          const {data} = props ?? {};

          return  postProductclassProductAttribute(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostProductclassProductAttributeMutationResult = NonNullable<Awaited<ReturnType<typeof postProductclassProductAttribute>>>
    export type PostProductclassProductAttributeMutationBody = ProductclassProductAttribute
    export type PostProductclassProductAttributeMutationError = void

    /**
 * @summary Create a new productclass_product_attribute record
 */
export const usePostProductclassProductAttribute = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postProductclassProductAttribute>>, TError,{data: ProductclassProductAttribute}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postProductclassProductAttribute>>,
        TError,
        {data: ProductclassProductAttribute},
        TContext
      > => {

      const mutationOptions = getPostProductclassProductAttributeMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Returns a single productclass_product_attribute record by ID
 * @summary Get a specific productclass_product_attribute record
 */
export const getProductclassProductAttributeId = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return defaultInstance<GetProductclassProductAttributeId200>(
      {url: `/productclass_product_attribute/${id}`, method: 'GET', signal
    },
      );
    }
  

export const getGetProductclassProductAttributeIdQueryKey = (id: string,) => {
    return [`/productclass_product_attribute/${id}`] as const;
    }

    
export const getGetProductclassProductAttributeIdQueryOptions = <TData = Awaited<ReturnType<typeof getProductclassProductAttributeId>>, TError = void>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProductclassProductAttributeId>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetProductclassProductAttributeIdQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getProductclassProductAttributeId>>> = ({ signal }) => getProductclassProductAttributeId(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getProductclassProductAttributeId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetProductclassProductAttributeIdQueryResult = NonNullable<Awaited<ReturnType<typeof getProductclassProductAttributeId>>>
export type GetProductclassProductAttributeIdQueryError = void


export function useGetProductclassProductAttributeId<TData = Awaited<ReturnType<typeof getProductclassProductAttributeId>>, TError = void>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProductclassProductAttributeId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProductclassProductAttributeId>>,
          TError,
          Awaited<ReturnType<typeof getProductclassProductAttributeId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProductclassProductAttributeId<TData = Awaited<ReturnType<typeof getProductclassProductAttributeId>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProductclassProductAttributeId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProductclassProductAttributeId>>,
          TError,
          Awaited<ReturnType<typeof getProductclassProductAttributeId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProductclassProductAttributeId<TData = Awaited<ReturnType<typeof getProductclassProductAttributeId>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProductclassProductAttributeId>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get a specific productclass_product_attribute record
 */

export function useGetProductclassProductAttributeId<TData = Awaited<ReturnType<typeof getProductclassProductAttributeId>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProductclassProductAttributeId>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetProductclassProductAttributeIdQueryOptions(id,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Updates an existing productclass_product_attribute record
 * @summary Update a productclass_product_attribute record
 */
export const putProductclassProductAttributeId = (
    id: string,
    productclassProductAttribute: ProductclassProductAttribute,
 ) => {
      
      
      return defaultInstance<PutProductclassProductAttributeId200>(
      {url: `/productclass_product_attribute/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: productclassProductAttribute
    },
      );
    }
  


export const getPutProductclassProductAttributeIdMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putProductclassProductAttributeId>>, TError,{id: string;data: ProductclassProductAttribute}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof putProductclassProductAttributeId>>, TError,{id: string;data: ProductclassProductAttribute}, TContext> => {
    
const mutationKey = ['putProductclassProductAttributeId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putProductclassProductAttributeId>>, {id: string;data: ProductclassProductAttribute}> = (props) => {
          const {id,data} = props ?? {};

          return  putProductclassProductAttributeId(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutProductclassProductAttributeIdMutationResult = NonNullable<Awaited<ReturnType<typeof putProductclassProductAttributeId>>>
    export type PutProductclassProductAttributeIdMutationBody = ProductclassProductAttribute
    export type PutProductclassProductAttributeIdMutationError = void

    /**
 * @summary Update a productclass_product_attribute record
 */
export const usePutProductclassProductAttributeId = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putProductclassProductAttributeId>>, TError,{id: string;data: ProductclassProductAttribute}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putProductclassProductAttributeId>>,
        TError,
        {id: string;data: ProductclassProductAttribute},
        TContext
      > => {

      const mutationOptions = getPutProductclassProductAttributeIdMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Partially updates an existing productclass_product_attribute record
 * @summary Partially update a productclass_product_attribute record
 */
export const patchProductclassProductAttributeId = (
    id: string,
    productclassProductAttribute: ProductclassProductAttribute,
 ) => {
      
      
      return defaultInstance<PatchProductclassProductAttributeId200>(
      {url: `/productclass_product_attribute/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: productclassProductAttribute
    },
      );
    }
  


export const getPatchProductclassProductAttributeIdMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchProductclassProductAttributeId>>, TError,{id: string;data: ProductclassProductAttribute}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof patchProductclassProductAttributeId>>, TError,{id: string;data: ProductclassProductAttribute}, TContext> => {
    
const mutationKey = ['patchProductclassProductAttributeId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchProductclassProductAttributeId>>, {id: string;data: ProductclassProductAttribute}> = (props) => {
          const {id,data} = props ?? {};

          return  patchProductclassProductAttributeId(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PatchProductclassProductAttributeIdMutationResult = NonNullable<Awaited<ReturnType<typeof patchProductclassProductAttributeId>>>
    export type PatchProductclassProductAttributeIdMutationBody = ProductclassProductAttribute
    export type PatchProductclassProductAttributeIdMutationError = void

    /**
 * @summary Partially update a productclass_product_attribute record
 */
export const usePatchProductclassProductAttributeId = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchProductclassProductAttributeId>>, TError,{id: string;data: ProductclassProductAttribute}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patchProductclassProductAttributeId>>,
        TError,
        {id: string;data: ProductclassProductAttribute},
        TContext
      > => {

      const mutationOptions = getPatchProductclassProductAttributeIdMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Deletes a productclass_product_attribute record
 * @summary Delete a productclass_product_attribute record
 */
export const deleteProductclassProductAttributeId = (
    id: string,
 ) => {
      
      
      return defaultInstance<DeleteProductclassProductAttributeId200>(
      {url: `/productclass_product_attribute/${id}`, method: 'DELETE'
    },
      );
    }
  


export const getDeleteProductclassProductAttributeIdMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteProductclassProductAttributeId>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteProductclassProductAttributeId>>, TError,{id: string}, TContext> => {
    
const mutationKey = ['deleteProductclassProductAttributeId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteProductclassProductAttributeId>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteProductclassProductAttributeId(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteProductclassProductAttributeIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteProductclassProductAttributeId>>>
    
    export type DeleteProductclassProductAttributeIdMutationError = void

    /**
 * @summary Delete a productclass_product_attribute record
 */
export const useDeleteProductclassProductAttributeId = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteProductclassProductAttributeId>>, TError,{id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteProductclassProductAttributeId>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getDeleteProductclassProductAttributeIdMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Returns a list of attribute_choice_value records with pagination
 * @summary Get all attribute_choice_value records
 */
export const getAttributeChoiceValue = (
    params?: GetAttributeChoiceValueParams,
 signal?: AbortSignal
) => {
      
      
      return defaultInstance<GetAttributeChoiceValue200>(
      {url: `/attribute_choice_value`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getGetAttributeChoiceValueQueryKey = (params?: GetAttributeChoiceValueParams,) => {
    return [`/attribute_choice_value`, ...(params ? [params]: [])] as const;
    }

    
export const getGetAttributeChoiceValueQueryOptions = <TData = Awaited<ReturnType<typeof getAttributeChoiceValue>>, TError = void>(params?: GetAttributeChoiceValueParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAttributeChoiceValue>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAttributeChoiceValueQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAttributeChoiceValue>>> = ({ signal }) => getAttributeChoiceValue(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAttributeChoiceValue>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAttributeChoiceValueQueryResult = NonNullable<Awaited<ReturnType<typeof getAttributeChoiceValue>>>
export type GetAttributeChoiceValueQueryError = void


export function useGetAttributeChoiceValue<TData = Awaited<ReturnType<typeof getAttributeChoiceValue>>, TError = void>(
 params: undefined |  GetAttributeChoiceValueParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAttributeChoiceValue>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAttributeChoiceValue>>,
          TError,
          Awaited<ReturnType<typeof getAttributeChoiceValue>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAttributeChoiceValue<TData = Awaited<ReturnType<typeof getAttributeChoiceValue>>, TError = void>(
 params?: GetAttributeChoiceValueParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAttributeChoiceValue>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAttributeChoiceValue>>,
          TError,
          Awaited<ReturnType<typeof getAttributeChoiceValue>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAttributeChoiceValue<TData = Awaited<ReturnType<typeof getAttributeChoiceValue>>, TError = void>(
 params?: GetAttributeChoiceValueParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAttributeChoiceValue>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get all attribute_choice_value records
 */

export function useGetAttributeChoiceValue<TData = Awaited<ReturnType<typeof getAttributeChoiceValue>>, TError = void>(
 params?: GetAttributeChoiceValueParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAttributeChoiceValue>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAttributeChoiceValueQueryOptions(params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Creates a new attribute_choice_value record
 * @summary Create a new attribute_choice_value record
 */
export const postAttributeChoiceValue = (
    attributeChoiceValue: AttributeChoiceValue,
 signal?: AbortSignal
) => {
      
      
      return defaultInstance<PostAttributeChoiceValue200>(
      {url: `/attribute_choice_value`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: attributeChoiceValue, signal
    },
      );
    }
  


export const getPostAttributeChoiceValueMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAttributeChoiceValue>>, TError,{data: AttributeChoiceValue}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postAttributeChoiceValue>>, TError,{data: AttributeChoiceValue}, TContext> => {
    
const mutationKey = ['postAttributeChoiceValue'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postAttributeChoiceValue>>, {data: AttributeChoiceValue}> = (props) => {
          const {data} = props ?? {};

          return  postAttributeChoiceValue(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostAttributeChoiceValueMutationResult = NonNullable<Awaited<ReturnType<typeof postAttributeChoiceValue>>>
    export type PostAttributeChoiceValueMutationBody = AttributeChoiceValue
    export type PostAttributeChoiceValueMutationError = void

    /**
 * @summary Create a new attribute_choice_value record
 */
export const usePostAttributeChoiceValue = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAttributeChoiceValue>>, TError,{data: AttributeChoiceValue}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postAttributeChoiceValue>>,
        TError,
        {data: AttributeChoiceValue},
        TContext
      > => {

      const mutationOptions = getPostAttributeChoiceValueMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Returns a single attribute_choice_value record by ID
 * @summary Get a specific attribute_choice_value record
 */
export const getAttributeChoiceValueId = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return defaultInstance<GetAttributeChoiceValueId200>(
      {url: `/attribute_choice_value/${id}`, method: 'GET', signal
    },
      );
    }
  

export const getGetAttributeChoiceValueIdQueryKey = (id: string,) => {
    return [`/attribute_choice_value/${id}`] as const;
    }

    
export const getGetAttributeChoiceValueIdQueryOptions = <TData = Awaited<ReturnType<typeof getAttributeChoiceValueId>>, TError = void>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAttributeChoiceValueId>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAttributeChoiceValueIdQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAttributeChoiceValueId>>> = ({ signal }) => getAttributeChoiceValueId(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAttributeChoiceValueId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAttributeChoiceValueIdQueryResult = NonNullable<Awaited<ReturnType<typeof getAttributeChoiceValueId>>>
export type GetAttributeChoiceValueIdQueryError = void


export function useGetAttributeChoiceValueId<TData = Awaited<ReturnType<typeof getAttributeChoiceValueId>>, TError = void>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAttributeChoiceValueId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAttributeChoiceValueId>>,
          TError,
          Awaited<ReturnType<typeof getAttributeChoiceValueId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAttributeChoiceValueId<TData = Awaited<ReturnType<typeof getAttributeChoiceValueId>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAttributeChoiceValueId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAttributeChoiceValueId>>,
          TError,
          Awaited<ReturnType<typeof getAttributeChoiceValueId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAttributeChoiceValueId<TData = Awaited<ReturnType<typeof getAttributeChoiceValueId>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAttributeChoiceValueId>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get a specific attribute_choice_value record
 */

export function useGetAttributeChoiceValueId<TData = Awaited<ReturnType<typeof getAttributeChoiceValueId>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAttributeChoiceValueId>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAttributeChoiceValueIdQueryOptions(id,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Updates an existing attribute_choice_value record
 * @summary Update a attribute_choice_value record
 */
export const putAttributeChoiceValueId = (
    id: string,
    attributeChoiceValue: AttributeChoiceValue,
 ) => {
      
      
      return defaultInstance<PutAttributeChoiceValueId200>(
      {url: `/attribute_choice_value/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: attributeChoiceValue
    },
      );
    }
  


export const getPutAttributeChoiceValueIdMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putAttributeChoiceValueId>>, TError,{id: string;data: AttributeChoiceValue}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof putAttributeChoiceValueId>>, TError,{id: string;data: AttributeChoiceValue}, TContext> => {
    
const mutationKey = ['putAttributeChoiceValueId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putAttributeChoiceValueId>>, {id: string;data: AttributeChoiceValue}> = (props) => {
          const {id,data} = props ?? {};

          return  putAttributeChoiceValueId(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutAttributeChoiceValueIdMutationResult = NonNullable<Awaited<ReturnType<typeof putAttributeChoiceValueId>>>
    export type PutAttributeChoiceValueIdMutationBody = AttributeChoiceValue
    export type PutAttributeChoiceValueIdMutationError = void

    /**
 * @summary Update a attribute_choice_value record
 */
export const usePutAttributeChoiceValueId = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putAttributeChoiceValueId>>, TError,{id: string;data: AttributeChoiceValue}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putAttributeChoiceValueId>>,
        TError,
        {id: string;data: AttributeChoiceValue},
        TContext
      > => {

      const mutationOptions = getPutAttributeChoiceValueIdMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Partially updates an existing attribute_choice_value record
 * @summary Partially update a attribute_choice_value record
 */
export const patchAttributeChoiceValueId = (
    id: string,
    attributeChoiceValue: AttributeChoiceValue,
 ) => {
      
      
      return defaultInstance<PatchAttributeChoiceValueId200>(
      {url: `/attribute_choice_value/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: attributeChoiceValue
    },
      );
    }
  


export const getPatchAttributeChoiceValueIdMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchAttributeChoiceValueId>>, TError,{id: string;data: AttributeChoiceValue}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof patchAttributeChoiceValueId>>, TError,{id: string;data: AttributeChoiceValue}, TContext> => {
    
const mutationKey = ['patchAttributeChoiceValueId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchAttributeChoiceValueId>>, {id: string;data: AttributeChoiceValue}> = (props) => {
          const {id,data} = props ?? {};

          return  patchAttributeChoiceValueId(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PatchAttributeChoiceValueIdMutationResult = NonNullable<Awaited<ReturnType<typeof patchAttributeChoiceValueId>>>
    export type PatchAttributeChoiceValueIdMutationBody = AttributeChoiceValue
    export type PatchAttributeChoiceValueIdMutationError = void

    /**
 * @summary Partially update a attribute_choice_value record
 */
export const usePatchAttributeChoiceValueId = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchAttributeChoiceValueId>>, TError,{id: string;data: AttributeChoiceValue}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patchAttributeChoiceValueId>>,
        TError,
        {id: string;data: AttributeChoiceValue},
        TContext
      > => {

      const mutationOptions = getPatchAttributeChoiceValueIdMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Deletes a attribute_choice_value record
 * @summary Delete a attribute_choice_value record
 */
export const deleteAttributeChoiceValueId = (
    id: string,
 ) => {
      
      
      return defaultInstance<DeleteAttributeChoiceValueId200>(
      {url: `/attribute_choice_value/${id}`, method: 'DELETE'
    },
      );
    }
  


export const getDeleteAttributeChoiceValueIdMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAttributeChoiceValueId>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteAttributeChoiceValueId>>, TError,{id: string}, TContext> => {
    
const mutationKey = ['deleteAttributeChoiceValueId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteAttributeChoiceValueId>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteAttributeChoiceValueId(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteAttributeChoiceValueIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteAttributeChoiceValueId>>>
    
    export type DeleteAttributeChoiceValueIdMutationError = void

    /**
 * @summary Delete a attribute_choice_value record
 */
export const useDeleteAttributeChoiceValueId = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAttributeChoiceValueId>>, TError,{id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteAttributeChoiceValueId>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getDeleteAttributeChoiceValueIdMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Returns a list of product_image records with pagination
 * @summary Get all product_image records
 */
export const getProductImage = (
    params?: GetProductImageParams,
 signal?: AbortSignal
) => {
      
      
      return defaultInstance<GetProductImage200>(
      {url: `/product_image`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getGetProductImageQueryKey = (params?: GetProductImageParams,) => {
    return [`/product_image`, ...(params ? [params]: [])] as const;
    }

    
export const getGetProductImageQueryOptions = <TData = Awaited<ReturnType<typeof getProductImage>>, TError = void>(params?: GetProductImageParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProductImage>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetProductImageQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getProductImage>>> = ({ signal }) => getProductImage(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getProductImage>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetProductImageQueryResult = NonNullable<Awaited<ReturnType<typeof getProductImage>>>
export type GetProductImageQueryError = void


export function useGetProductImage<TData = Awaited<ReturnType<typeof getProductImage>>, TError = void>(
 params: undefined |  GetProductImageParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProductImage>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProductImage>>,
          TError,
          Awaited<ReturnType<typeof getProductImage>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProductImage<TData = Awaited<ReturnType<typeof getProductImage>>, TError = void>(
 params?: GetProductImageParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProductImage>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProductImage>>,
          TError,
          Awaited<ReturnType<typeof getProductImage>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProductImage<TData = Awaited<ReturnType<typeof getProductImage>>, TError = void>(
 params?: GetProductImageParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProductImage>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get all product_image records
 */

export function useGetProductImage<TData = Awaited<ReturnType<typeof getProductImage>>, TError = void>(
 params?: GetProductImageParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProductImage>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetProductImageQueryOptions(params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Creates a new product_image record
 * @summary Create a new product_image record
 */
export const postProductImage = (
    productImage: ProductImage,
 signal?: AbortSignal
) => {
      
      
      return defaultInstance<PostProductImage200>(
      {url: `/product_image`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: productImage, signal
    },
      );
    }
  


export const getPostProductImageMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postProductImage>>, TError,{data: ProductImage}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postProductImage>>, TError,{data: ProductImage}, TContext> => {
    
const mutationKey = ['postProductImage'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postProductImage>>, {data: ProductImage}> = (props) => {
          const {data} = props ?? {};

          return  postProductImage(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostProductImageMutationResult = NonNullable<Awaited<ReturnType<typeof postProductImage>>>
    export type PostProductImageMutationBody = ProductImage
    export type PostProductImageMutationError = void

    /**
 * @summary Create a new product_image record
 */
export const usePostProductImage = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postProductImage>>, TError,{data: ProductImage}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postProductImage>>,
        TError,
        {data: ProductImage},
        TContext
      > => {

      const mutationOptions = getPostProductImageMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Returns a single product_image record by ID
 * @summary Get a specific product_image record
 */
export const getProductImageId = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return defaultInstance<GetProductImageId200>(
      {url: `/product_image/${id}`, method: 'GET', signal
    },
      );
    }
  

export const getGetProductImageIdQueryKey = (id: string,) => {
    return [`/product_image/${id}`] as const;
    }

    
export const getGetProductImageIdQueryOptions = <TData = Awaited<ReturnType<typeof getProductImageId>>, TError = void>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProductImageId>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetProductImageIdQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getProductImageId>>> = ({ signal }) => getProductImageId(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getProductImageId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetProductImageIdQueryResult = NonNullable<Awaited<ReturnType<typeof getProductImageId>>>
export type GetProductImageIdQueryError = void


export function useGetProductImageId<TData = Awaited<ReturnType<typeof getProductImageId>>, TError = void>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProductImageId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProductImageId>>,
          TError,
          Awaited<ReturnType<typeof getProductImageId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProductImageId<TData = Awaited<ReturnType<typeof getProductImageId>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProductImageId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProductImageId>>,
          TError,
          Awaited<ReturnType<typeof getProductImageId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProductImageId<TData = Awaited<ReturnType<typeof getProductImageId>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProductImageId>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get a specific product_image record
 */

export function useGetProductImageId<TData = Awaited<ReturnType<typeof getProductImageId>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProductImageId>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetProductImageIdQueryOptions(id,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Updates an existing product_image record
 * @summary Update a product_image record
 */
export const putProductImageId = (
    id: string,
    productImage: ProductImage,
 ) => {
      
      
      return defaultInstance<PutProductImageId200>(
      {url: `/product_image/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: productImage
    },
      );
    }
  


export const getPutProductImageIdMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putProductImageId>>, TError,{id: string;data: ProductImage}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof putProductImageId>>, TError,{id: string;data: ProductImage}, TContext> => {
    
const mutationKey = ['putProductImageId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putProductImageId>>, {id: string;data: ProductImage}> = (props) => {
          const {id,data} = props ?? {};

          return  putProductImageId(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutProductImageIdMutationResult = NonNullable<Awaited<ReturnType<typeof putProductImageId>>>
    export type PutProductImageIdMutationBody = ProductImage
    export type PutProductImageIdMutationError = void

    /**
 * @summary Update a product_image record
 */
export const usePutProductImageId = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putProductImageId>>, TError,{id: string;data: ProductImage}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putProductImageId>>,
        TError,
        {id: string;data: ProductImage},
        TContext
      > => {

      const mutationOptions = getPutProductImageIdMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Partially updates an existing product_image record
 * @summary Partially update a product_image record
 */
export const patchProductImageId = (
    id: string,
    productImage: ProductImage,
 ) => {
      
      
      return defaultInstance<PatchProductImageId200>(
      {url: `/product_image/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: productImage
    },
      );
    }
  


export const getPatchProductImageIdMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchProductImageId>>, TError,{id: string;data: ProductImage}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof patchProductImageId>>, TError,{id: string;data: ProductImage}, TContext> => {
    
const mutationKey = ['patchProductImageId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchProductImageId>>, {id: string;data: ProductImage}> = (props) => {
          const {id,data} = props ?? {};

          return  patchProductImageId(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PatchProductImageIdMutationResult = NonNullable<Awaited<ReturnType<typeof patchProductImageId>>>
    export type PatchProductImageIdMutationBody = ProductImage
    export type PatchProductImageIdMutationError = void

    /**
 * @summary Partially update a product_image record
 */
export const usePatchProductImageId = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchProductImageId>>, TError,{id: string;data: ProductImage}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patchProductImageId>>,
        TError,
        {id: string;data: ProductImage},
        TContext
      > => {

      const mutationOptions = getPatchProductImageIdMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Deletes a product_image record
 * @summary Delete a product_image record
 */
export const deleteProductImageId = (
    id: string,
 ) => {
      
      
      return defaultInstance<DeleteProductImageId200>(
      {url: `/product_image/${id}`, method: 'DELETE'
    },
      );
    }
  


export const getDeleteProductImageIdMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteProductImageId>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteProductImageId>>, TError,{id: string}, TContext> => {
    
const mutationKey = ['deleteProductImageId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteProductImageId>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteProductImageId(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteProductImageIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteProductImageId>>>
    
    export type DeleteProductImageIdMutationError = void

    /**
 * @summary Delete a product_image record
 */
export const useDeleteProductImageId = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteProductImageId>>, TError,{id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteProductImageId>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getDeleteProductImageIdMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Returns a list of variant_image records with pagination
 * @summary Get all variant_image records
 */
export const getVariantImage = (
    params?: GetVariantImageParams,
 signal?: AbortSignal
) => {
      
      
      return defaultInstance<GetVariantImage200>(
      {url: `/variant_image`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getGetVariantImageQueryKey = (params?: GetVariantImageParams,) => {
    return [`/variant_image`, ...(params ? [params]: [])] as const;
    }

    
export const getGetVariantImageQueryOptions = <TData = Awaited<ReturnType<typeof getVariantImage>>, TError = void>(params?: GetVariantImageParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVariantImage>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetVariantImageQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getVariantImage>>> = ({ signal }) => getVariantImage(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getVariantImage>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetVariantImageQueryResult = NonNullable<Awaited<ReturnType<typeof getVariantImage>>>
export type GetVariantImageQueryError = void


export function useGetVariantImage<TData = Awaited<ReturnType<typeof getVariantImage>>, TError = void>(
 params: undefined |  GetVariantImageParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVariantImage>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getVariantImage>>,
          TError,
          Awaited<ReturnType<typeof getVariantImage>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetVariantImage<TData = Awaited<ReturnType<typeof getVariantImage>>, TError = void>(
 params?: GetVariantImageParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVariantImage>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getVariantImage>>,
          TError,
          Awaited<ReturnType<typeof getVariantImage>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetVariantImage<TData = Awaited<ReturnType<typeof getVariantImage>>, TError = void>(
 params?: GetVariantImageParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVariantImage>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get all variant_image records
 */

export function useGetVariantImage<TData = Awaited<ReturnType<typeof getVariantImage>>, TError = void>(
 params?: GetVariantImageParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVariantImage>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetVariantImageQueryOptions(params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Creates a new variant_image record
 * @summary Create a new variant_image record
 */
export const postVariantImage = (
    variantImage: VariantImage,
 signal?: AbortSignal
) => {
      
      
      return defaultInstance<PostVariantImage200>(
      {url: `/variant_image`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: variantImage, signal
    },
      );
    }
  


export const getPostVariantImageMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postVariantImage>>, TError,{data: VariantImage}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postVariantImage>>, TError,{data: VariantImage}, TContext> => {
    
const mutationKey = ['postVariantImage'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postVariantImage>>, {data: VariantImage}> = (props) => {
          const {data} = props ?? {};

          return  postVariantImage(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostVariantImageMutationResult = NonNullable<Awaited<ReturnType<typeof postVariantImage>>>
    export type PostVariantImageMutationBody = VariantImage
    export type PostVariantImageMutationError = void

    /**
 * @summary Create a new variant_image record
 */
export const usePostVariantImage = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postVariantImage>>, TError,{data: VariantImage}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postVariantImage>>,
        TError,
        {data: VariantImage},
        TContext
      > => {

      const mutationOptions = getPostVariantImageMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Returns a single variant_image record by ID
 * @summary Get a specific variant_image record
 */
export const getVariantImageId = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return defaultInstance<GetVariantImageId200>(
      {url: `/variant_image/${id}`, method: 'GET', signal
    },
      );
    }
  

export const getGetVariantImageIdQueryKey = (id: string,) => {
    return [`/variant_image/${id}`] as const;
    }

    
export const getGetVariantImageIdQueryOptions = <TData = Awaited<ReturnType<typeof getVariantImageId>>, TError = void>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVariantImageId>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetVariantImageIdQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getVariantImageId>>> = ({ signal }) => getVariantImageId(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getVariantImageId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetVariantImageIdQueryResult = NonNullable<Awaited<ReturnType<typeof getVariantImageId>>>
export type GetVariantImageIdQueryError = void


export function useGetVariantImageId<TData = Awaited<ReturnType<typeof getVariantImageId>>, TError = void>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVariantImageId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getVariantImageId>>,
          TError,
          Awaited<ReturnType<typeof getVariantImageId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetVariantImageId<TData = Awaited<ReturnType<typeof getVariantImageId>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVariantImageId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getVariantImageId>>,
          TError,
          Awaited<ReturnType<typeof getVariantImageId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetVariantImageId<TData = Awaited<ReturnType<typeof getVariantImageId>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVariantImageId>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get a specific variant_image record
 */

export function useGetVariantImageId<TData = Awaited<ReturnType<typeof getVariantImageId>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVariantImageId>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetVariantImageIdQueryOptions(id,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Updates an existing variant_image record
 * @summary Update a variant_image record
 */
export const putVariantImageId = (
    id: string,
    variantImage: VariantImage,
 ) => {
      
      
      return defaultInstance<PutVariantImageId200>(
      {url: `/variant_image/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: variantImage
    },
      );
    }
  


export const getPutVariantImageIdMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putVariantImageId>>, TError,{id: string;data: VariantImage}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof putVariantImageId>>, TError,{id: string;data: VariantImage}, TContext> => {
    
const mutationKey = ['putVariantImageId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putVariantImageId>>, {id: string;data: VariantImage}> = (props) => {
          const {id,data} = props ?? {};

          return  putVariantImageId(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutVariantImageIdMutationResult = NonNullable<Awaited<ReturnType<typeof putVariantImageId>>>
    export type PutVariantImageIdMutationBody = VariantImage
    export type PutVariantImageIdMutationError = void

    /**
 * @summary Update a variant_image record
 */
export const usePutVariantImageId = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putVariantImageId>>, TError,{id: string;data: VariantImage}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putVariantImageId>>,
        TError,
        {id: string;data: VariantImage},
        TContext
      > => {

      const mutationOptions = getPutVariantImageIdMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Partially updates an existing variant_image record
 * @summary Partially update a variant_image record
 */
export const patchVariantImageId = (
    id: string,
    variantImage: VariantImage,
 ) => {
      
      
      return defaultInstance<PatchVariantImageId200>(
      {url: `/variant_image/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: variantImage
    },
      );
    }
  


export const getPatchVariantImageIdMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchVariantImageId>>, TError,{id: string;data: VariantImage}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof patchVariantImageId>>, TError,{id: string;data: VariantImage}, TContext> => {
    
const mutationKey = ['patchVariantImageId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchVariantImageId>>, {id: string;data: VariantImage}> = (props) => {
          const {id,data} = props ?? {};

          return  patchVariantImageId(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PatchVariantImageIdMutationResult = NonNullable<Awaited<ReturnType<typeof patchVariantImageId>>>
    export type PatchVariantImageIdMutationBody = VariantImage
    export type PatchVariantImageIdMutationError = void

    /**
 * @summary Partially update a variant_image record
 */
export const usePatchVariantImageId = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchVariantImageId>>, TError,{id: string;data: VariantImage}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patchVariantImageId>>,
        TError,
        {id: string;data: VariantImage},
        TContext
      > => {

      const mutationOptions = getPatchVariantImageIdMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Deletes a variant_image record
 * @summary Delete a variant_image record
 */
export const deleteVariantImageId = (
    id: string,
 ) => {
      
      
      return defaultInstance<DeleteVariantImageId200>(
      {url: `/variant_image/${id}`, method: 'DELETE'
    },
      );
    }
  


export const getDeleteVariantImageIdMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteVariantImageId>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteVariantImageId>>, TError,{id: string}, TContext> => {
    
const mutationKey = ['deleteVariantImageId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteVariantImageId>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteVariantImageId(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteVariantImageIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteVariantImageId>>>
    
    export type DeleteVariantImageIdMutationError = void

    /**
 * @summary Delete a variant_image record
 */
export const useDeleteVariantImageId = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteVariantImageId>>, TError,{id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteVariantImageId>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getDeleteVariantImageIdMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Returns a list of stock_location records with pagination
 * @summary Get all stock_location records
 */
export const getStockLocation = (
    params?: GetStockLocationParams,
 signal?: AbortSignal
) => {
      
      
      return defaultInstance<GetStockLocation200>(
      {url: `/stock_location`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getGetStockLocationQueryKey = (params?: GetStockLocationParams,) => {
    return [`/stock_location`, ...(params ? [params]: [])] as const;
    }

    
export const getGetStockLocationQueryOptions = <TData = Awaited<ReturnType<typeof getStockLocation>>, TError = void>(params?: GetStockLocationParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getStockLocation>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetStockLocationQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getStockLocation>>> = ({ signal }) => getStockLocation(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getStockLocation>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetStockLocationQueryResult = NonNullable<Awaited<ReturnType<typeof getStockLocation>>>
export type GetStockLocationQueryError = void


export function useGetStockLocation<TData = Awaited<ReturnType<typeof getStockLocation>>, TError = void>(
 params: undefined |  GetStockLocationParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getStockLocation>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getStockLocation>>,
          TError,
          Awaited<ReturnType<typeof getStockLocation>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetStockLocation<TData = Awaited<ReturnType<typeof getStockLocation>>, TError = void>(
 params?: GetStockLocationParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getStockLocation>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getStockLocation>>,
          TError,
          Awaited<ReturnType<typeof getStockLocation>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetStockLocation<TData = Awaited<ReturnType<typeof getStockLocation>>, TError = void>(
 params?: GetStockLocationParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getStockLocation>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get all stock_location records
 */

export function useGetStockLocation<TData = Awaited<ReturnType<typeof getStockLocation>>, TError = void>(
 params?: GetStockLocationParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getStockLocation>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetStockLocationQueryOptions(params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Creates a new stock_location record
 * @summary Create a new stock_location record
 */
export const postStockLocation = (
    stockLocation: StockLocation,
 signal?: AbortSignal
) => {
      
      
      return defaultInstance<PostStockLocation200>(
      {url: `/stock_location`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: stockLocation, signal
    },
      );
    }
  


export const getPostStockLocationMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postStockLocation>>, TError,{data: StockLocation}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postStockLocation>>, TError,{data: StockLocation}, TContext> => {
    
const mutationKey = ['postStockLocation'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postStockLocation>>, {data: StockLocation}> = (props) => {
          const {data} = props ?? {};

          return  postStockLocation(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostStockLocationMutationResult = NonNullable<Awaited<ReturnType<typeof postStockLocation>>>
    export type PostStockLocationMutationBody = StockLocation
    export type PostStockLocationMutationError = void

    /**
 * @summary Create a new stock_location record
 */
export const usePostStockLocation = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postStockLocation>>, TError,{data: StockLocation}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postStockLocation>>,
        TError,
        {data: StockLocation},
        TContext
      > => {

      const mutationOptions = getPostStockLocationMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Returns a single stock_location record by ID
 * @summary Get a specific stock_location record
 */
export const getStockLocationId = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return defaultInstance<GetStockLocationId200>(
      {url: `/stock_location/${id}`, method: 'GET', signal
    },
      );
    }
  

export const getGetStockLocationIdQueryKey = (id: string,) => {
    return [`/stock_location/${id}`] as const;
    }

    
export const getGetStockLocationIdQueryOptions = <TData = Awaited<ReturnType<typeof getStockLocationId>>, TError = void>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getStockLocationId>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetStockLocationIdQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getStockLocationId>>> = ({ signal }) => getStockLocationId(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getStockLocationId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetStockLocationIdQueryResult = NonNullable<Awaited<ReturnType<typeof getStockLocationId>>>
export type GetStockLocationIdQueryError = void


export function useGetStockLocationId<TData = Awaited<ReturnType<typeof getStockLocationId>>, TError = void>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getStockLocationId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getStockLocationId>>,
          TError,
          Awaited<ReturnType<typeof getStockLocationId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetStockLocationId<TData = Awaited<ReturnType<typeof getStockLocationId>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getStockLocationId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getStockLocationId>>,
          TError,
          Awaited<ReturnType<typeof getStockLocationId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetStockLocationId<TData = Awaited<ReturnType<typeof getStockLocationId>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getStockLocationId>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get a specific stock_location record
 */

export function useGetStockLocationId<TData = Awaited<ReturnType<typeof getStockLocationId>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getStockLocationId>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetStockLocationIdQueryOptions(id,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Updates an existing stock_location record
 * @summary Update a stock_location record
 */
export const putStockLocationId = (
    id: string,
    stockLocation: StockLocation,
 ) => {
      
      
      return defaultInstance<PutStockLocationId200>(
      {url: `/stock_location/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: stockLocation
    },
      );
    }
  


export const getPutStockLocationIdMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putStockLocationId>>, TError,{id: string;data: StockLocation}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof putStockLocationId>>, TError,{id: string;data: StockLocation}, TContext> => {
    
const mutationKey = ['putStockLocationId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putStockLocationId>>, {id: string;data: StockLocation}> = (props) => {
          const {id,data} = props ?? {};

          return  putStockLocationId(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutStockLocationIdMutationResult = NonNullable<Awaited<ReturnType<typeof putStockLocationId>>>
    export type PutStockLocationIdMutationBody = StockLocation
    export type PutStockLocationIdMutationError = void

    /**
 * @summary Update a stock_location record
 */
export const usePutStockLocationId = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putStockLocationId>>, TError,{id: string;data: StockLocation}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putStockLocationId>>,
        TError,
        {id: string;data: StockLocation},
        TContext
      > => {

      const mutationOptions = getPutStockLocationIdMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Partially updates an existing stock_location record
 * @summary Partially update a stock_location record
 */
export const patchStockLocationId = (
    id: string,
    stockLocation: StockLocation,
 ) => {
      
      
      return defaultInstance<PatchStockLocationId200>(
      {url: `/stock_location/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: stockLocation
    },
      );
    }
  


export const getPatchStockLocationIdMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchStockLocationId>>, TError,{id: string;data: StockLocation}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof patchStockLocationId>>, TError,{id: string;data: StockLocation}, TContext> => {
    
const mutationKey = ['patchStockLocationId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchStockLocationId>>, {id: string;data: StockLocation}> = (props) => {
          const {id,data} = props ?? {};

          return  patchStockLocationId(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PatchStockLocationIdMutationResult = NonNullable<Awaited<ReturnType<typeof patchStockLocationId>>>
    export type PatchStockLocationIdMutationBody = StockLocation
    export type PatchStockLocationIdMutationError = void

    /**
 * @summary Partially update a stock_location record
 */
export const usePatchStockLocationId = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchStockLocationId>>, TError,{id: string;data: StockLocation}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patchStockLocationId>>,
        TError,
        {id: string;data: StockLocation},
        TContext
      > => {

      const mutationOptions = getPatchStockLocationIdMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Deletes a stock_location record
 * @summary Delete a stock_location record
 */
export const deleteStockLocationId = (
    id: string,
 ) => {
      
      
      return defaultInstance<DeleteStockLocationId200>(
      {url: `/stock_location/${id}`, method: 'DELETE'
    },
      );
    }
  


export const getDeleteStockLocationIdMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteStockLocationId>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteStockLocationId>>, TError,{id: string}, TContext> => {
    
const mutationKey = ['deleteStockLocationId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteStockLocationId>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteStockLocationId(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteStockLocationIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteStockLocationId>>>
    
    export type DeleteStockLocationIdMutationError = void

    /**
 * @summary Delete a stock_location record
 */
export const useDeleteStockLocationId = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteStockLocationId>>, TError,{id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteStockLocationId>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getDeleteStockLocationIdMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Returns a list of stock records with pagination
 * @summary Get all stock records
 */
export const getStock = (
    params?: GetStockParams,
 signal?: AbortSignal
) => {
      
      
      return defaultInstance<GetStock200>(
      {url: `/stock`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getGetStockQueryKey = (params?: GetStockParams,) => {
    return [`/stock`, ...(params ? [params]: [])] as const;
    }

    
export const getGetStockQueryOptions = <TData = Awaited<ReturnType<typeof getStock>>, TError = void>(params?: GetStockParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getStock>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetStockQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getStock>>> = ({ signal }) => getStock(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getStock>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetStockQueryResult = NonNullable<Awaited<ReturnType<typeof getStock>>>
export type GetStockQueryError = void


export function useGetStock<TData = Awaited<ReturnType<typeof getStock>>, TError = void>(
 params: undefined |  GetStockParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getStock>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getStock>>,
          TError,
          Awaited<ReturnType<typeof getStock>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetStock<TData = Awaited<ReturnType<typeof getStock>>, TError = void>(
 params?: GetStockParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getStock>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getStock>>,
          TError,
          Awaited<ReturnType<typeof getStock>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetStock<TData = Awaited<ReturnType<typeof getStock>>, TError = void>(
 params?: GetStockParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getStock>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get all stock records
 */

export function useGetStock<TData = Awaited<ReturnType<typeof getStock>>, TError = void>(
 params?: GetStockParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getStock>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetStockQueryOptions(params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Creates a new stock record
 * @summary Create a new stock record
 */
export const postStock = (
    stock: Stock,
 signal?: AbortSignal
) => {
      
      
      return defaultInstance<PostStock200>(
      {url: `/stock`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: stock, signal
    },
      );
    }
  


export const getPostStockMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postStock>>, TError,{data: Stock}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postStock>>, TError,{data: Stock}, TContext> => {
    
const mutationKey = ['postStock'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postStock>>, {data: Stock}> = (props) => {
          const {data} = props ?? {};

          return  postStock(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostStockMutationResult = NonNullable<Awaited<ReturnType<typeof postStock>>>
    export type PostStockMutationBody = Stock
    export type PostStockMutationError = void

    /**
 * @summary Create a new stock record
 */
export const usePostStock = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postStock>>, TError,{data: Stock}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postStock>>,
        TError,
        {data: Stock},
        TContext
      > => {

      const mutationOptions = getPostStockMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Returns a single stock record by ID
 * @summary Get a specific stock record
 */
export const getStockId = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return defaultInstance<GetStockId200>(
      {url: `/stock/${id}`, method: 'GET', signal
    },
      );
    }
  

export const getGetStockIdQueryKey = (id: string,) => {
    return [`/stock/${id}`] as const;
    }

    
export const getGetStockIdQueryOptions = <TData = Awaited<ReturnType<typeof getStockId>>, TError = void>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getStockId>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetStockIdQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getStockId>>> = ({ signal }) => getStockId(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getStockId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetStockIdQueryResult = NonNullable<Awaited<ReturnType<typeof getStockId>>>
export type GetStockIdQueryError = void


export function useGetStockId<TData = Awaited<ReturnType<typeof getStockId>>, TError = void>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getStockId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getStockId>>,
          TError,
          Awaited<ReturnType<typeof getStockId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetStockId<TData = Awaited<ReturnType<typeof getStockId>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getStockId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getStockId>>,
          TError,
          Awaited<ReturnType<typeof getStockId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetStockId<TData = Awaited<ReturnType<typeof getStockId>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getStockId>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get a specific stock record
 */

export function useGetStockId<TData = Awaited<ReturnType<typeof getStockId>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getStockId>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetStockIdQueryOptions(id,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Updates an existing stock record
 * @summary Update a stock record
 */
export const putStockId = (
    id: string,
    stock: Stock,
 ) => {
      
      
      return defaultInstance<PutStockId200>(
      {url: `/stock/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: stock
    },
      );
    }
  


export const getPutStockIdMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putStockId>>, TError,{id: string;data: Stock}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof putStockId>>, TError,{id: string;data: Stock}, TContext> => {
    
const mutationKey = ['putStockId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putStockId>>, {id: string;data: Stock}> = (props) => {
          const {id,data} = props ?? {};

          return  putStockId(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutStockIdMutationResult = NonNullable<Awaited<ReturnType<typeof putStockId>>>
    export type PutStockIdMutationBody = Stock
    export type PutStockIdMutationError = void

    /**
 * @summary Update a stock record
 */
export const usePutStockId = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putStockId>>, TError,{id: string;data: Stock}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putStockId>>,
        TError,
        {id: string;data: Stock},
        TContext
      > => {

      const mutationOptions = getPutStockIdMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Partially updates an existing stock record
 * @summary Partially update a stock record
 */
export const patchStockId = (
    id: string,
    stock: Stock,
 ) => {
      
      
      return defaultInstance<PatchStockId200>(
      {url: `/stock/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: stock
    },
      );
    }
  


export const getPatchStockIdMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchStockId>>, TError,{id: string;data: Stock}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof patchStockId>>, TError,{id: string;data: Stock}, TContext> => {
    
const mutationKey = ['patchStockId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchStockId>>, {id: string;data: Stock}> = (props) => {
          const {id,data} = props ?? {};

          return  patchStockId(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PatchStockIdMutationResult = NonNullable<Awaited<ReturnType<typeof patchStockId>>>
    export type PatchStockIdMutationBody = Stock
    export type PatchStockIdMutationError = void

    /**
 * @summary Partially update a stock record
 */
export const usePatchStockId = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchStockId>>, TError,{id: string;data: Stock}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patchStockId>>,
        TError,
        {id: string;data: Stock},
        TContext
      > => {

      const mutationOptions = getPatchStockIdMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Deletes a stock record
 * @summary Delete a stock record
 */
export const deleteStockId = (
    id: string,
 ) => {
      
      
      return defaultInstance<DeleteStockId200>(
      {url: `/stock/${id}`, method: 'DELETE'
    },
      );
    }
  


export const getDeleteStockIdMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteStockId>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteStockId>>, TError,{id: string}, TContext> => {
    
const mutationKey = ['deleteStockId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteStockId>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteStockId(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteStockIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteStockId>>>
    
    export type DeleteStockIdMutationError = void

    /**
 * @summary Delete a stock record
 */
export const useDeleteStockId = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteStockId>>, TError,{id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteStockId>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getDeleteStockIdMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Returns a list of invitation_type records with pagination
 * @summary Get all invitation_type records
 */
export const getInvitationType = (
    params?: GetInvitationTypeParams,
 signal?: AbortSignal
) => {
      
      
      return defaultInstance<GetInvitationType200>(
      {url: `/invitation_type`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getGetInvitationTypeQueryKey = (params?: GetInvitationTypeParams,) => {
    return [`/invitation_type`, ...(params ? [params]: [])] as const;
    }

    
export const getGetInvitationTypeQueryOptions = <TData = Awaited<ReturnType<typeof getInvitationType>>, TError = void>(params?: GetInvitationTypeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInvitationType>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetInvitationTypeQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getInvitationType>>> = ({ signal }) => getInvitationType(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getInvitationType>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetInvitationTypeQueryResult = NonNullable<Awaited<ReturnType<typeof getInvitationType>>>
export type GetInvitationTypeQueryError = void


export function useGetInvitationType<TData = Awaited<ReturnType<typeof getInvitationType>>, TError = void>(
 params: undefined |  GetInvitationTypeParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInvitationType>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getInvitationType>>,
          TError,
          Awaited<ReturnType<typeof getInvitationType>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetInvitationType<TData = Awaited<ReturnType<typeof getInvitationType>>, TError = void>(
 params?: GetInvitationTypeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInvitationType>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getInvitationType>>,
          TError,
          Awaited<ReturnType<typeof getInvitationType>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetInvitationType<TData = Awaited<ReturnType<typeof getInvitationType>>, TError = void>(
 params?: GetInvitationTypeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInvitationType>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get all invitation_type records
 */

export function useGetInvitationType<TData = Awaited<ReturnType<typeof getInvitationType>>, TError = void>(
 params?: GetInvitationTypeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInvitationType>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetInvitationTypeQueryOptions(params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Creates a new invitation_type record
 * @summary Create a new invitation_type record
 */
export const postInvitationType = (
    invitationType: InvitationType,
 signal?: AbortSignal
) => {
      
      
      return defaultInstance<PostInvitationType200>(
      {url: `/invitation_type`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: invitationType, signal
    },
      );
    }
  


export const getPostInvitationTypeMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postInvitationType>>, TError,{data: InvitationType}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postInvitationType>>, TError,{data: InvitationType}, TContext> => {
    
const mutationKey = ['postInvitationType'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postInvitationType>>, {data: InvitationType}> = (props) => {
          const {data} = props ?? {};

          return  postInvitationType(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostInvitationTypeMutationResult = NonNullable<Awaited<ReturnType<typeof postInvitationType>>>
    export type PostInvitationTypeMutationBody = InvitationType
    export type PostInvitationTypeMutationError = void

    /**
 * @summary Create a new invitation_type record
 */
export const usePostInvitationType = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postInvitationType>>, TError,{data: InvitationType}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postInvitationType>>,
        TError,
        {data: InvitationType},
        TContext
      > => {

      const mutationOptions = getPostInvitationTypeMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Returns a single invitation_type record by ID
 * @summary Get a specific invitation_type record
 */
export const getInvitationTypeId = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return defaultInstance<GetInvitationTypeId200>(
      {url: `/invitation_type/${id}`, method: 'GET', signal
    },
      );
    }
  

export const getGetInvitationTypeIdQueryKey = (id: string,) => {
    return [`/invitation_type/${id}`] as const;
    }

    
export const getGetInvitationTypeIdQueryOptions = <TData = Awaited<ReturnType<typeof getInvitationTypeId>>, TError = void>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInvitationTypeId>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetInvitationTypeIdQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getInvitationTypeId>>> = ({ signal }) => getInvitationTypeId(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getInvitationTypeId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetInvitationTypeIdQueryResult = NonNullable<Awaited<ReturnType<typeof getInvitationTypeId>>>
export type GetInvitationTypeIdQueryError = void


export function useGetInvitationTypeId<TData = Awaited<ReturnType<typeof getInvitationTypeId>>, TError = void>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInvitationTypeId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getInvitationTypeId>>,
          TError,
          Awaited<ReturnType<typeof getInvitationTypeId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetInvitationTypeId<TData = Awaited<ReturnType<typeof getInvitationTypeId>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInvitationTypeId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getInvitationTypeId>>,
          TError,
          Awaited<ReturnType<typeof getInvitationTypeId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetInvitationTypeId<TData = Awaited<ReturnType<typeof getInvitationTypeId>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInvitationTypeId>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get a specific invitation_type record
 */

export function useGetInvitationTypeId<TData = Awaited<ReturnType<typeof getInvitationTypeId>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInvitationTypeId>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetInvitationTypeIdQueryOptions(id,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Updates an existing invitation_type record
 * @summary Update a invitation_type record
 */
export const putInvitationTypeId = (
    id: string,
    invitationType: InvitationType,
 ) => {
      
      
      return defaultInstance<PutInvitationTypeId200>(
      {url: `/invitation_type/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: invitationType
    },
      );
    }
  


export const getPutInvitationTypeIdMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putInvitationTypeId>>, TError,{id: string;data: InvitationType}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof putInvitationTypeId>>, TError,{id: string;data: InvitationType}, TContext> => {
    
const mutationKey = ['putInvitationTypeId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putInvitationTypeId>>, {id: string;data: InvitationType}> = (props) => {
          const {id,data} = props ?? {};

          return  putInvitationTypeId(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutInvitationTypeIdMutationResult = NonNullable<Awaited<ReturnType<typeof putInvitationTypeId>>>
    export type PutInvitationTypeIdMutationBody = InvitationType
    export type PutInvitationTypeIdMutationError = void

    /**
 * @summary Update a invitation_type record
 */
export const usePutInvitationTypeId = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putInvitationTypeId>>, TError,{id: string;data: InvitationType}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putInvitationTypeId>>,
        TError,
        {id: string;data: InvitationType},
        TContext
      > => {

      const mutationOptions = getPutInvitationTypeIdMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Partially updates an existing invitation_type record
 * @summary Partially update a invitation_type record
 */
export const patchInvitationTypeId = (
    id: string,
    invitationType: InvitationType,
 ) => {
      
      
      return defaultInstance<PatchInvitationTypeId200>(
      {url: `/invitation_type/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: invitationType
    },
      );
    }
  


export const getPatchInvitationTypeIdMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchInvitationTypeId>>, TError,{id: string;data: InvitationType}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof patchInvitationTypeId>>, TError,{id: string;data: InvitationType}, TContext> => {
    
const mutationKey = ['patchInvitationTypeId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchInvitationTypeId>>, {id: string;data: InvitationType}> = (props) => {
          const {id,data} = props ?? {};

          return  patchInvitationTypeId(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PatchInvitationTypeIdMutationResult = NonNullable<Awaited<ReturnType<typeof patchInvitationTypeId>>>
    export type PatchInvitationTypeIdMutationBody = InvitationType
    export type PatchInvitationTypeIdMutationError = void

    /**
 * @summary Partially update a invitation_type record
 */
export const usePatchInvitationTypeId = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchInvitationTypeId>>, TError,{id: string;data: InvitationType}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patchInvitationTypeId>>,
        TError,
        {id: string;data: InvitationType},
        TContext
      > => {

      const mutationOptions = getPatchInvitationTypeIdMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Deletes a invitation_type record
 * @summary Delete a invitation_type record
 */
export const deleteInvitationTypeId = (
    id: string,
 ) => {
      
      
      return defaultInstance<DeleteInvitationTypeId200>(
      {url: `/invitation_type/${id}`, method: 'DELETE'
    },
      );
    }
  


export const getDeleteInvitationTypeIdMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteInvitationTypeId>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteInvitationTypeId>>, TError,{id: string}, TContext> => {
    
const mutationKey = ['deleteInvitationTypeId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteInvitationTypeId>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteInvitationTypeId(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteInvitationTypeIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteInvitationTypeId>>>
    
    export type DeleteInvitationTypeIdMutationError = void

    /**
 * @summary Delete a invitation_type record
 */
export const useDeleteInvitationTypeId = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteInvitationTypeId>>, TError,{id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteInvitationTypeId>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getDeleteInvitationTypeIdMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Returns a list of invitation records with pagination
 * @summary Get all invitation records
 */
export const getInvitation = (
    params?: GetInvitationParams,
 signal?: AbortSignal
) => {
      
      
      return defaultInstance<GetInvitation200>(
      {url: `/invitation`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getGetInvitationQueryKey = (params?: GetInvitationParams,) => {
    return [`/invitation`, ...(params ? [params]: [])] as const;
    }

    
export const getGetInvitationQueryOptions = <TData = Awaited<ReturnType<typeof getInvitation>>, TError = void>(params?: GetInvitationParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInvitation>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetInvitationQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getInvitation>>> = ({ signal }) => getInvitation(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getInvitation>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetInvitationQueryResult = NonNullable<Awaited<ReturnType<typeof getInvitation>>>
export type GetInvitationQueryError = void


export function useGetInvitation<TData = Awaited<ReturnType<typeof getInvitation>>, TError = void>(
 params: undefined |  GetInvitationParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInvitation>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getInvitation>>,
          TError,
          Awaited<ReturnType<typeof getInvitation>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetInvitation<TData = Awaited<ReturnType<typeof getInvitation>>, TError = void>(
 params?: GetInvitationParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInvitation>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getInvitation>>,
          TError,
          Awaited<ReturnType<typeof getInvitation>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetInvitation<TData = Awaited<ReturnType<typeof getInvitation>>, TError = void>(
 params?: GetInvitationParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInvitation>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get all invitation records
 */

export function useGetInvitation<TData = Awaited<ReturnType<typeof getInvitation>>, TError = void>(
 params?: GetInvitationParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInvitation>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetInvitationQueryOptions(params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Creates a new invitation record
 * @summary Create a new invitation record
 */
export const postInvitation = (
    invitation: Invitation,
 signal?: AbortSignal
) => {
      
      
      return defaultInstance<PostInvitation200>(
      {url: `/invitation`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: invitation, signal
    },
      );
    }
  


export const getPostInvitationMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postInvitation>>, TError,{data: Invitation}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postInvitation>>, TError,{data: Invitation}, TContext> => {
    
const mutationKey = ['postInvitation'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postInvitation>>, {data: Invitation}> = (props) => {
          const {data} = props ?? {};

          return  postInvitation(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostInvitationMutationResult = NonNullable<Awaited<ReturnType<typeof postInvitation>>>
    export type PostInvitationMutationBody = Invitation
    export type PostInvitationMutationError = void

    /**
 * @summary Create a new invitation record
 */
export const usePostInvitation = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postInvitation>>, TError,{data: Invitation}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postInvitation>>,
        TError,
        {data: Invitation},
        TContext
      > => {

      const mutationOptions = getPostInvitationMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Returns a single invitation record by ID
 * @summary Get a specific invitation record
 */
export const getInvitationId = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return defaultInstance<GetInvitationId200>(
      {url: `/invitation/${id}`, method: 'GET', signal
    },
      );
    }
  

export const getGetInvitationIdQueryKey = (id: string,) => {
    return [`/invitation/${id}`] as const;
    }

    
export const getGetInvitationIdQueryOptions = <TData = Awaited<ReturnType<typeof getInvitationId>>, TError = void>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInvitationId>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetInvitationIdQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getInvitationId>>> = ({ signal }) => getInvitationId(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getInvitationId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetInvitationIdQueryResult = NonNullable<Awaited<ReturnType<typeof getInvitationId>>>
export type GetInvitationIdQueryError = void


export function useGetInvitationId<TData = Awaited<ReturnType<typeof getInvitationId>>, TError = void>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInvitationId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getInvitationId>>,
          TError,
          Awaited<ReturnType<typeof getInvitationId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetInvitationId<TData = Awaited<ReturnType<typeof getInvitationId>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInvitationId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getInvitationId>>,
          TError,
          Awaited<ReturnType<typeof getInvitationId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetInvitationId<TData = Awaited<ReturnType<typeof getInvitationId>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInvitationId>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get a specific invitation record
 */

export function useGetInvitationId<TData = Awaited<ReturnType<typeof getInvitationId>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInvitationId>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetInvitationIdQueryOptions(id,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Updates an existing invitation record
 * @summary Update a invitation record
 */
export const putInvitationId = (
    id: string,
    invitation: Invitation,
 ) => {
      
      
      return defaultInstance<PutInvitationId200>(
      {url: `/invitation/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: invitation
    },
      );
    }
  


export const getPutInvitationIdMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putInvitationId>>, TError,{id: string;data: Invitation}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof putInvitationId>>, TError,{id: string;data: Invitation}, TContext> => {
    
const mutationKey = ['putInvitationId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putInvitationId>>, {id: string;data: Invitation}> = (props) => {
          const {id,data} = props ?? {};

          return  putInvitationId(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutInvitationIdMutationResult = NonNullable<Awaited<ReturnType<typeof putInvitationId>>>
    export type PutInvitationIdMutationBody = Invitation
    export type PutInvitationIdMutationError = void

    /**
 * @summary Update a invitation record
 */
export const usePutInvitationId = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putInvitationId>>, TError,{id: string;data: Invitation}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putInvitationId>>,
        TError,
        {id: string;data: Invitation},
        TContext
      > => {

      const mutationOptions = getPutInvitationIdMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Partially updates an existing invitation record
 * @summary Partially update a invitation record
 */
export const patchInvitationId = (
    id: string,
    invitation: Invitation,
 ) => {
      
      
      return defaultInstance<PatchInvitationId200>(
      {url: `/invitation/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: invitation
    },
      );
    }
  


export const getPatchInvitationIdMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchInvitationId>>, TError,{id: string;data: Invitation}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof patchInvitationId>>, TError,{id: string;data: Invitation}, TContext> => {
    
const mutationKey = ['patchInvitationId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchInvitationId>>, {id: string;data: Invitation}> = (props) => {
          const {id,data} = props ?? {};

          return  patchInvitationId(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PatchInvitationIdMutationResult = NonNullable<Awaited<ReturnType<typeof patchInvitationId>>>
    export type PatchInvitationIdMutationBody = Invitation
    export type PatchInvitationIdMutationError = void

    /**
 * @summary Partially update a invitation record
 */
export const usePatchInvitationId = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchInvitationId>>, TError,{id: string;data: Invitation}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patchInvitationId>>,
        TError,
        {id: string;data: Invitation},
        TContext
      > => {

      const mutationOptions = getPatchInvitationIdMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Deletes a invitation record
 * @summary Delete a invitation record
 */
export const deleteInvitationId = (
    id: string,
 ) => {
      
      
      return defaultInstance<DeleteInvitationId200>(
      {url: `/invitation/${id}`, method: 'DELETE'
    },
      );
    }
  


export const getDeleteInvitationIdMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteInvitationId>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteInvitationId>>, TError,{id: string}, TContext> => {
    
const mutationKey = ['deleteInvitationId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteInvitationId>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteInvitationId(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteInvitationIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteInvitationId>>>
    
    export type DeleteInvitationIdMutationError = void

    /**
 * @summary Delete a invitation record
 */
export const useDeleteInvitationId = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteInvitationId>>, TError,{id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteInvitationId>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getDeleteInvitationIdMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Returns a list of invitation_status_event records with pagination
 * @summary Get all invitation_status_event records
 */
export const getInvitationStatusEvent = (
    params?: GetInvitationStatusEventParams,
 signal?: AbortSignal
) => {
      
      
      return defaultInstance<GetInvitationStatusEvent200>(
      {url: `/invitation_status_event`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getGetInvitationStatusEventQueryKey = (params?: GetInvitationStatusEventParams,) => {
    return [`/invitation_status_event`, ...(params ? [params]: [])] as const;
    }

    
export const getGetInvitationStatusEventQueryOptions = <TData = Awaited<ReturnType<typeof getInvitationStatusEvent>>, TError = void>(params?: GetInvitationStatusEventParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInvitationStatusEvent>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetInvitationStatusEventQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getInvitationStatusEvent>>> = ({ signal }) => getInvitationStatusEvent(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getInvitationStatusEvent>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetInvitationStatusEventQueryResult = NonNullable<Awaited<ReturnType<typeof getInvitationStatusEvent>>>
export type GetInvitationStatusEventQueryError = void


export function useGetInvitationStatusEvent<TData = Awaited<ReturnType<typeof getInvitationStatusEvent>>, TError = void>(
 params: undefined |  GetInvitationStatusEventParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInvitationStatusEvent>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getInvitationStatusEvent>>,
          TError,
          Awaited<ReturnType<typeof getInvitationStatusEvent>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetInvitationStatusEvent<TData = Awaited<ReturnType<typeof getInvitationStatusEvent>>, TError = void>(
 params?: GetInvitationStatusEventParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInvitationStatusEvent>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getInvitationStatusEvent>>,
          TError,
          Awaited<ReturnType<typeof getInvitationStatusEvent>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetInvitationStatusEvent<TData = Awaited<ReturnType<typeof getInvitationStatusEvent>>, TError = void>(
 params?: GetInvitationStatusEventParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInvitationStatusEvent>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get all invitation_status_event records
 */

export function useGetInvitationStatusEvent<TData = Awaited<ReturnType<typeof getInvitationStatusEvent>>, TError = void>(
 params?: GetInvitationStatusEventParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInvitationStatusEvent>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetInvitationStatusEventQueryOptions(params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Creates a new invitation_status_event record
 * @summary Create a new invitation_status_event record
 */
export const postInvitationStatusEvent = (
    invitationStatusEvent: InvitationStatusEvent,
 signal?: AbortSignal
) => {
      
      
      return defaultInstance<PostInvitationStatusEvent200>(
      {url: `/invitation_status_event`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: invitationStatusEvent, signal
    },
      );
    }
  


export const getPostInvitationStatusEventMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postInvitationStatusEvent>>, TError,{data: InvitationStatusEvent}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postInvitationStatusEvent>>, TError,{data: InvitationStatusEvent}, TContext> => {
    
const mutationKey = ['postInvitationStatusEvent'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postInvitationStatusEvent>>, {data: InvitationStatusEvent}> = (props) => {
          const {data} = props ?? {};

          return  postInvitationStatusEvent(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostInvitationStatusEventMutationResult = NonNullable<Awaited<ReturnType<typeof postInvitationStatusEvent>>>
    export type PostInvitationStatusEventMutationBody = InvitationStatusEvent
    export type PostInvitationStatusEventMutationError = void

    /**
 * @summary Create a new invitation_status_event record
 */
export const usePostInvitationStatusEvent = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postInvitationStatusEvent>>, TError,{data: InvitationStatusEvent}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postInvitationStatusEvent>>,
        TError,
        {data: InvitationStatusEvent},
        TContext
      > => {

      const mutationOptions = getPostInvitationStatusEventMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Returns a single invitation_status_event record by ID
 * @summary Get a specific invitation_status_event record
 */
export const getInvitationStatusEventId = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return defaultInstance<GetInvitationStatusEventId200>(
      {url: `/invitation_status_event/${id}`, method: 'GET', signal
    },
      );
    }
  

export const getGetInvitationStatusEventIdQueryKey = (id: string,) => {
    return [`/invitation_status_event/${id}`] as const;
    }

    
export const getGetInvitationStatusEventIdQueryOptions = <TData = Awaited<ReturnType<typeof getInvitationStatusEventId>>, TError = void>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInvitationStatusEventId>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetInvitationStatusEventIdQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getInvitationStatusEventId>>> = ({ signal }) => getInvitationStatusEventId(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getInvitationStatusEventId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetInvitationStatusEventIdQueryResult = NonNullable<Awaited<ReturnType<typeof getInvitationStatusEventId>>>
export type GetInvitationStatusEventIdQueryError = void


export function useGetInvitationStatusEventId<TData = Awaited<ReturnType<typeof getInvitationStatusEventId>>, TError = void>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInvitationStatusEventId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getInvitationStatusEventId>>,
          TError,
          Awaited<ReturnType<typeof getInvitationStatusEventId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetInvitationStatusEventId<TData = Awaited<ReturnType<typeof getInvitationStatusEventId>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInvitationStatusEventId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getInvitationStatusEventId>>,
          TError,
          Awaited<ReturnType<typeof getInvitationStatusEventId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetInvitationStatusEventId<TData = Awaited<ReturnType<typeof getInvitationStatusEventId>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInvitationStatusEventId>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get a specific invitation_status_event record
 */

export function useGetInvitationStatusEventId<TData = Awaited<ReturnType<typeof getInvitationStatusEventId>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInvitationStatusEventId>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetInvitationStatusEventIdQueryOptions(id,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Updates an existing invitation_status_event record
 * @summary Update a invitation_status_event record
 */
export const putInvitationStatusEventId = (
    id: string,
    invitationStatusEvent: InvitationStatusEvent,
 ) => {
      
      
      return defaultInstance<PutInvitationStatusEventId200>(
      {url: `/invitation_status_event/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: invitationStatusEvent
    },
      );
    }
  


export const getPutInvitationStatusEventIdMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putInvitationStatusEventId>>, TError,{id: string;data: InvitationStatusEvent}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof putInvitationStatusEventId>>, TError,{id: string;data: InvitationStatusEvent}, TContext> => {
    
const mutationKey = ['putInvitationStatusEventId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putInvitationStatusEventId>>, {id: string;data: InvitationStatusEvent}> = (props) => {
          const {id,data} = props ?? {};

          return  putInvitationStatusEventId(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutInvitationStatusEventIdMutationResult = NonNullable<Awaited<ReturnType<typeof putInvitationStatusEventId>>>
    export type PutInvitationStatusEventIdMutationBody = InvitationStatusEvent
    export type PutInvitationStatusEventIdMutationError = void

    /**
 * @summary Update a invitation_status_event record
 */
export const usePutInvitationStatusEventId = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putInvitationStatusEventId>>, TError,{id: string;data: InvitationStatusEvent}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putInvitationStatusEventId>>,
        TError,
        {id: string;data: InvitationStatusEvent},
        TContext
      > => {

      const mutationOptions = getPutInvitationStatusEventIdMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Partially updates an existing invitation_status_event record
 * @summary Partially update a invitation_status_event record
 */
export const patchInvitationStatusEventId = (
    id: string,
    invitationStatusEvent: InvitationStatusEvent,
 ) => {
      
      
      return defaultInstance<PatchInvitationStatusEventId200>(
      {url: `/invitation_status_event/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: invitationStatusEvent
    },
      );
    }
  


export const getPatchInvitationStatusEventIdMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchInvitationStatusEventId>>, TError,{id: string;data: InvitationStatusEvent}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof patchInvitationStatusEventId>>, TError,{id: string;data: InvitationStatusEvent}, TContext> => {
    
const mutationKey = ['patchInvitationStatusEventId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchInvitationStatusEventId>>, {id: string;data: InvitationStatusEvent}> = (props) => {
          const {id,data} = props ?? {};

          return  patchInvitationStatusEventId(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PatchInvitationStatusEventIdMutationResult = NonNullable<Awaited<ReturnType<typeof patchInvitationStatusEventId>>>
    export type PatchInvitationStatusEventIdMutationBody = InvitationStatusEvent
    export type PatchInvitationStatusEventIdMutationError = void

    /**
 * @summary Partially update a invitation_status_event record
 */
export const usePatchInvitationStatusEventId = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchInvitationStatusEventId>>, TError,{id: string;data: InvitationStatusEvent}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patchInvitationStatusEventId>>,
        TError,
        {id: string;data: InvitationStatusEvent},
        TContext
      > => {

      const mutationOptions = getPatchInvitationStatusEventIdMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Deletes a invitation_status_event record
 * @summary Delete a invitation_status_event record
 */
export const deleteInvitationStatusEventId = (
    id: string,
 ) => {
      
      
      return defaultInstance<DeleteInvitationStatusEventId200>(
      {url: `/invitation_status_event/${id}`, method: 'DELETE'
    },
      );
    }
  


export const getDeleteInvitationStatusEventIdMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteInvitationStatusEventId>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteInvitationStatusEventId>>, TError,{id: string}, TContext> => {
    
const mutationKey = ['deleteInvitationStatusEventId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteInvitationStatusEventId>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteInvitationStatusEventId(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteInvitationStatusEventIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteInvitationStatusEventId>>>
    
    export type DeleteInvitationStatusEventIdMutationError = void

    /**
 * @summary Delete a invitation_status_event record
 */
export const useDeleteInvitationStatusEventId = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteInvitationStatusEventId>>, TError,{id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteInvitationStatusEventId>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getDeleteInvitationStatusEventIdMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Returns a list of guest records with pagination
 * @summary Get all guest records
 */
export const getGuest = (
    params?: GetGuestParams,
 signal?: AbortSignal
) => {
      
      
      return defaultInstance<GetGuest200>(
      {url: `/guest`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getGetGuestQueryKey = (params?: GetGuestParams,) => {
    return [`/guest`, ...(params ? [params]: [])] as const;
    }

    
export const getGetGuestQueryOptions = <TData = Awaited<ReturnType<typeof getGuest>>, TError = void>(params?: GetGuestParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getGuest>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetGuestQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getGuest>>> = ({ signal }) => getGuest(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getGuest>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetGuestQueryResult = NonNullable<Awaited<ReturnType<typeof getGuest>>>
export type GetGuestQueryError = void


export function useGetGuest<TData = Awaited<ReturnType<typeof getGuest>>, TError = void>(
 params: undefined |  GetGuestParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getGuest>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getGuest>>,
          TError,
          Awaited<ReturnType<typeof getGuest>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetGuest<TData = Awaited<ReturnType<typeof getGuest>>, TError = void>(
 params?: GetGuestParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getGuest>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getGuest>>,
          TError,
          Awaited<ReturnType<typeof getGuest>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetGuest<TData = Awaited<ReturnType<typeof getGuest>>, TError = void>(
 params?: GetGuestParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getGuest>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get all guest records
 */

export function useGetGuest<TData = Awaited<ReturnType<typeof getGuest>>, TError = void>(
 params?: GetGuestParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getGuest>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetGuestQueryOptions(params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Creates a new guest record
 * @summary Create a new guest record
 */
export const postGuest = (
    guest: Guest,
 signal?: AbortSignal
) => {
      
      
      return defaultInstance<PostGuest200>(
      {url: `/guest`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: guest, signal
    },
      );
    }
  


export const getPostGuestMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postGuest>>, TError,{data: Guest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postGuest>>, TError,{data: Guest}, TContext> => {
    
const mutationKey = ['postGuest'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postGuest>>, {data: Guest}> = (props) => {
          const {data} = props ?? {};

          return  postGuest(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostGuestMutationResult = NonNullable<Awaited<ReturnType<typeof postGuest>>>
    export type PostGuestMutationBody = Guest
    export type PostGuestMutationError = void

    /**
 * @summary Create a new guest record
 */
export const usePostGuest = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postGuest>>, TError,{data: Guest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postGuest>>,
        TError,
        {data: Guest},
        TContext
      > => {

      const mutationOptions = getPostGuestMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Returns a single guest record by ID
 * @summary Get a specific guest record
 */
export const getGuestId = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return defaultInstance<GetGuestId200>(
      {url: `/guest/${id}`, method: 'GET', signal
    },
      );
    }
  

export const getGetGuestIdQueryKey = (id: string,) => {
    return [`/guest/${id}`] as const;
    }

    
export const getGetGuestIdQueryOptions = <TData = Awaited<ReturnType<typeof getGuestId>>, TError = void>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getGuestId>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetGuestIdQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getGuestId>>> = ({ signal }) => getGuestId(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getGuestId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetGuestIdQueryResult = NonNullable<Awaited<ReturnType<typeof getGuestId>>>
export type GetGuestIdQueryError = void


export function useGetGuestId<TData = Awaited<ReturnType<typeof getGuestId>>, TError = void>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getGuestId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getGuestId>>,
          TError,
          Awaited<ReturnType<typeof getGuestId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetGuestId<TData = Awaited<ReturnType<typeof getGuestId>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getGuestId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getGuestId>>,
          TError,
          Awaited<ReturnType<typeof getGuestId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetGuestId<TData = Awaited<ReturnType<typeof getGuestId>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getGuestId>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get a specific guest record
 */

export function useGetGuestId<TData = Awaited<ReturnType<typeof getGuestId>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getGuestId>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetGuestIdQueryOptions(id,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Updates an existing guest record
 * @summary Update a guest record
 */
export const putGuestId = (
    id: string,
    guest: Guest,
 ) => {
      
      
      return defaultInstance<PutGuestId200>(
      {url: `/guest/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: guest
    },
      );
    }
  


export const getPutGuestIdMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putGuestId>>, TError,{id: string;data: Guest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof putGuestId>>, TError,{id: string;data: Guest}, TContext> => {
    
const mutationKey = ['putGuestId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putGuestId>>, {id: string;data: Guest}> = (props) => {
          const {id,data} = props ?? {};

          return  putGuestId(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutGuestIdMutationResult = NonNullable<Awaited<ReturnType<typeof putGuestId>>>
    export type PutGuestIdMutationBody = Guest
    export type PutGuestIdMutationError = void

    /**
 * @summary Update a guest record
 */
export const usePutGuestId = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putGuestId>>, TError,{id: string;data: Guest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putGuestId>>,
        TError,
        {id: string;data: Guest},
        TContext
      > => {

      const mutationOptions = getPutGuestIdMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Partially updates an existing guest record
 * @summary Partially update a guest record
 */
export const patchGuestId = (
    id: string,
    guest: Guest,
 ) => {
      
      
      return defaultInstance<PatchGuestId200>(
      {url: `/guest/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: guest
    },
      );
    }
  


export const getPatchGuestIdMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchGuestId>>, TError,{id: string;data: Guest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof patchGuestId>>, TError,{id: string;data: Guest}, TContext> => {
    
const mutationKey = ['patchGuestId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchGuestId>>, {id: string;data: Guest}> = (props) => {
          const {id,data} = props ?? {};

          return  patchGuestId(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PatchGuestIdMutationResult = NonNullable<Awaited<ReturnType<typeof patchGuestId>>>
    export type PatchGuestIdMutationBody = Guest
    export type PatchGuestIdMutationError = void

    /**
 * @summary Partially update a guest record
 */
export const usePatchGuestId = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchGuestId>>, TError,{id: string;data: Guest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patchGuestId>>,
        TError,
        {id: string;data: Guest},
        TContext
      > => {

      const mutationOptions = getPatchGuestIdMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Deletes a guest record
 * @summary Delete a guest record
 */
export const deleteGuestId = (
    id: string,
 ) => {
      
      
      return defaultInstance<DeleteGuestId200>(
      {url: `/guest/${id}`, method: 'DELETE'
    },
      );
    }
  


export const getDeleteGuestIdMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteGuestId>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteGuestId>>, TError,{id: string}, TContext> => {
    
const mutationKey = ['deleteGuestId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteGuestId>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteGuestId(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteGuestIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteGuestId>>>
    
    export type DeleteGuestIdMutationError = void

    /**
 * @summary Delete a guest record
 */
export const useDeleteGuestId = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteGuestId>>, TError,{id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteGuestId>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getDeleteGuestIdMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Returns a list of companion records with pagination
 * @summary Get all companion records
 */
export const getCompanion = (
    params?: GetCompanionParams,
 signal?: AbortSignal
) => {
      
      
      return defaultInstance<GetCompanion200>(
      {url: `/companion`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getGetCompanionQueryKey = (params?: GetCompanionParams,) => {
    return [`/companion`, ...(params ? [params]: [])] as const;
    }

    
export const getGetCompanionQueryOptions = <TData = Awaited<ReturnType<typeof getCompanion>>, TError = void>(params?: GetCompanionParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCompanion>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCompanionQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCompanion>>> = ({ signal }) => getCompanion(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCompanion>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetCompanionQueryResult = NonNullable<Awaited<ReturnType<typeof getCompanion>>>
export type GetCompanionQueryError = void


export function useGetCompanion<TData = Awaited<ReturnType<typeof getCompanion>>, TError = void>(
 params: undefined |  GetCompanionParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCompanion>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCompanion>>,
          TError,
          Awaited<ReturnType<typeof getCompanion>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCompanion<TData = Awaited<ReturnType<typeof getCompanion>>, TError = void>(
 params?: GetCompanionParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCompanion>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCompanion>>,
          TError,
          Awaited<ReturnType<typeof getCompanion>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCompanion<TData = Awaited<ReturnType<typeof getCompanion>>, TError = void>(
 params?: GetCompanionParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCompanion>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get all companion records
 */

export function useGetCompanion<TData = Awaited<ReturnType<typeof getCompanion>>, TError = void>(
 params?: GetCompanionParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCompanion>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetCompanionQueryOptions(params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Creates a new companion record
 * @summary Create a new companion record
 */
export const postCompanion = (
    companion: Companion,
 signal?: AbortSignal
) => {
      
      
      return defaultInstance<PostCompanion200>(
      {url: `/companion`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: companion, signal
    },
      );
    }
  


export const getPostCompanionMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCompanion>>, TError,{data: Companion}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postCompanion>>, TError,{data: Companion}, TContext> => {
    
const mutationKey = ['postCompanion'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postCompanion>>, {data: Companion}> = (props) => {
          const {data} = props ?? {};

          return  postCompanion(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostCompanionMutationResult = NonNullable<Awaited<ReturnType<typeof postCompanion>>>
    export type PostCompanionMutationBody = Companion
    export type PostCompanionMutationError = void

    /**
 * @summary Create a new companion record
 */
export const usePostCompanion = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCompanion>>, TError,{data: Companion}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postCompanion>>,
        TError,
        {data: Companion},
        TContext
      > => {

      const mutationOptions = getPostCompanionMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Returns a single companion record by ID
 * @summary Get a specific companion record
 */
export const getCompanionId = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return defaultInstance<GetCompanionId200>(
      {url: `/companion/${id}`, method: 'GET', signal
    },
      );
    }
  

export const getGetCompanionIdQueryKey = (id: string,) => {
    return [`/companion/${id}`] as const;
    }

    
export const getGetCompanionIdQueryOptions = <TData = Awaited<ReturnType<typeof getCompanionId>>, TError = void>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCompanionId>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCompanionIdQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCompanionId>>> = ({ signal }) => getCompanionId(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCompanionId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetCompanionIdQueryResult = NonNullable<Awaited<ReturnType<typeof getCompanionId>>>
export type GetCompanionIdQueryError = void


export function useGetCompanionId<TData = Awaited<ReturnType<typeof getCompanionId>>, TError = void>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCompanionId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCompanionId>>,
          TError,
          Awaited<ReturnType<typeof getCompanionId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCompanionId<TData = Awaited<ReturnType<typeof getCompanionId>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCompanionId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCompanionId>>,
          TError,
          Awaited<ReturnType<typeof getCompanionId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCompanionId<TData = Awaited<ReturnType<typeof getCompanionId>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCompanionId>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get a specific companion record
 */

export function useGetCompanionId<TData = Awaited<ReturnType<typeof getCompanionId>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCompanionId>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetCompanionIdQueryOptions(id,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Updates an existing companion record
 * @summary Update a companion record
 */
export const putCompanionId = (
    id: string,
    companion: Companion,
 ) => {
      
      
      return defaultInstance<PutCompanionId200>(
      {url: `/companion/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: companion
    },
      );
    }
  


export const getPutCompanionIdMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putCompanionId>>, TError,{id: string;data: Companion}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof putCompanionId>>, TError,{id: string;data: Companion}, TContext> => {
    
const mutationKey = ['putCompanionId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putCompanionId>>, {id: string;data: Companion}> = (props) => {
          const {id,data} = props ?? {};

          return  putCompanionId(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutCompanionIdMutationResult = NonNullable<Awaited<ReturnType<typeof putCompanionId>>>
    export type PutCompanionIdMutationBody = Companion
    export type PutCompanionIdMutationError = void

    /**
 * @summary Update a companion record
 */
export const usePutCompanionId = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putCompanionId>>, TError,{id: string;data: Companion}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putCompanionId>>,
        TError,
        {id: string;data: Companion},
        TContext
      > => {

      const mutationOptions = getPutCompanionIdMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Partially updates an existing companion record
 * @summary Partially update a companion record
 */
export const patchCompanionId = (
    id: string,
    companion: Companion,
 ) => {
      
      
      return defaultInstance<PatchCompanionId200>(
      {url: `/companion/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: companion
    },
      );
    }
  


export const getPatchCompanionIdMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchCompanionId>>, TError,{id: string;data: Companion}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof patchCompanionId>>, TError,{id: string;data: Companion}, TContext> => {
    
const mutationKey = ['patchCompanionId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchCompanionId>>, {id: string;data: Companion}> = (props) => {
          const {id,data} = props ?? {};

          return  patchCompanionId(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PatchCompanionIdMutationResult = NonNullable<Awaited<ReturnType<typeof patchCompanionId>>>
    export type PatchCompanionIdMutationBody = Companion
    export type PatchCompanionIdMutationError = void

    /**
 * @summary Partially update a companion record
 */
export const usePatchCompanionId = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchCompanionId>>, TError,{id: string;data: Companion}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patchCompanionId>>,
        TError,
        {id: string;data: Companion},
        TContext
      > => {

      const mutationOptions = getPatchCompanionIdMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Deletes a companion record
 * @summary Delete a companion record
 */
export const deleteCompanionId = (
    id: string,
 ) => {
      
      
      return defaultInstance<DeleteCompanionId200>(
      {url: `/companion/${id}`, method: 'DELETE'
    },
      );
    }
  


export const getDeleteCompanionIdMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteCompanionId>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteCompanionId>>, TError,{id: string}, TContext> => {
    
const mutationKey = ['deleteCompanionId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteCompanionId>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteCompanionId(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteCompanionIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteCompanionId>>>
    
    export type DeleteCompanionIdMutationError = void

    /**
 * @summary Delete a companion record
 */
export const useDeleteCompanionId = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteCompanionId>>, TError,{id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteCompanionId>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getDeleteCompanionIdMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Returns a list of user_estate_status records with pagination
 * @summary Get all user_estate_status records
 */
export const getUserEstateStatus = (
    params?: GetUserEstateStatusParams,
 signal?: AbortSignal
) => {
      
      
      return defaultInstance<GetUserEstateStatus200>(
      {url: `/user_estate_status`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getGetUserEstateStatusQueryKey = (params?: GetUserEstateStatusParams,) => {
    return [`/user_estate_status`, ...(params ? [params]: [])] as const;
    }

    
export const getGetUserEstateStatusQueryOptions = <TData = Awaited<ReturnType<typeof getUserEstateStatus>>, TError = void>(params?: GetUserEstateStatusParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserEstateStatus>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUserEstateStatusQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUserEstateStatus>>> = ({ signal }) => getUserEstateStatus(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getUserEstateStatus>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetUserEstateStatusQueryResult = NonNullable<Awaited<ReturnType<typeof getUserEstateStatus>>>
export type GetUserEstateStatusQueryError = void


export function useGetUserEstateStatus<TData = Awaited<ReturnType<typeof getUserEstateStatus>>, TError = void>(
 params: undefined |  GetUserEstateStatusParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserEstateStatus>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserEstateStatus>>,
          TError,
          Awaited<ReturnType<typeof getUserEstateStatus>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUserEstateStatus<TData = Awaited<ReturnType<typeof getUserEstateStatus>>, TError = void>(
 params?: GetUserEstateStatusParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserEstateStatus>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserEstateStatus>>,
          TError,
          Awaited<ReturnType<typeof getUserEstateStatus>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUserEstateStatus<TData = Awaited<ReturnType<typeof getUserEstateStatus>>, TError = void>(
 params?: GetUserEstateStatusParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserEstateStatus>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get all user_estate_status records
 */

export function useGetUserEstateStatus<TData = Awaited<ReturnType<typeof getUserEstateStatus>>, TError = void>(
 params?: GetUserEstateStatusParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserEstateStatus>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetUserEstateStatusQueryOptions(params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Creates a new user_estate_status record
 * @summary Create a new user_estate_status record
 */
export const postUserEstateStatus = (
    userEstateStatus: UserEstateStatus,
 signal?: AbortSignal
) => {
      
      
      return defaultInstance<PostUserEstateStatus200>(
      {url: `/user_estate_status`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: userEstateStatus, signal
    },
      );
    }
  


export const getPostUserEstateStatusMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postUserEstateStatus>>, TError,{data: UserEstateStatus}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postUserEstateStatus>>, TError,{data: UserEstateStatus}, TContext> => {
    
const mutationKey = ['postUserEstateStatus'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postUserEstateStatus>>, {data: UserEstateStatus}> = (props) => {
          const {data} = props ?? {};

          return  postUserEstateStatus(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostUserEstateStatusMutationResult = NonNullable<Awaited<ReturnType<typeof postUserEstateStatus>>>
    export type PostUserEstateStatusMutationBody = UserEstateStatus
    export type PostUserEstateStatusMutationError = void

    /**
 * @summary Create a new user_estate_status record
 */
export const usePostUserEstateStatus = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postUserEstateStatus>>, TError,{data: UserEstateStatus}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postUserEstateStatus>>,
        TError,
        {data: UserEstateStatus},
        TContext
      > => {

      const mutationOptions = getPostUserEstateStatusMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Returns a single user_estate_status record by ID
 * @summary Get a specific user_estate_status record
 */
export const getUserEstateStatusId = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return defaultInstance<GetUserEstateStatusId200>(
      {url: `/user_estate_status/${id}`, method: 'GET', signal
    },
      );
    }
  

export const getGetUserEstateStatusIdQueryKey = (id: string,) => {
    return [`/user_estate_status/${id}`] as const;
    }

    
export const getGetUserEstateStatusIdQueryOptions = <TData = Awaited<ReturnType<typeof getUserEstateStatusId>>, TError = void>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserEstateStatusId>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUserEstateStatusIdQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUserEstateStatusId>>> = ({ signal }) => getUserEstateStatusId(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getUserEstateStatusId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetUserEstateStatusIdQueryResult = NonNullable<Awaited<ReturnType<typeof getUserEstateStatusId>>>
export type GetUserEstateStatusIdQueryError = void


export function useGetUserEstateStatusId<TData = Awaited<ReturnType<typeof getUserEstateStatusId>>, TError = void>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserEstateStatusId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserEstateStatusId>>,
          TError,
          Awaited<ReturnType<typeof getUserEstateStatusId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUserEstateStatusId<TData = Awaited<ReturnType<typeof getUserEstateStatusId>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserEstateStatusId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserEstateStatusId>>,
          TError,
          Awaited<ReturnType<typeof getUserEstateStatusId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUserEstateStatusId<TData = Awaited<ReturnType<typeof getUserEstateStatusId>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserEstateStatusId>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get a specific user_estate_status record
 */

export function useGetUserEstateStatusId<TData = Awaited<ReturnType<typeof getUserEstateStatusId>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserEstateStatusId>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetUserEstateStatusIdQueryOptions(id,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Updates an existing user_estate_status record
 * @summary Update a user_estate_status record
 */
export const putUserEstateStatusId = (
    id: string,
    userEstateStatus: UserEstateStatus,
 ) => {
      
      
      return defaultInstance<PutUserEstateStatusId200>(
      {url: `/user_estate_status/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: userEstateStatus
    },
      );
    }
  


export const getPutUserEstateStatusIdMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putUserEstateStatusId>>, TError,{id: string;data: UserEstateStatus}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof putUserEstateStatusId>>, TError,{id: string;data: UserEstateStatus}, TContext> => {
    
const mutationKey = ['putUserEstateStatusId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putUserEstateStatusId>>, {id: string;data: UserEstateStatus}> = (props) => {
          const {id,data} = props ?? {};

          return  putUserEstateStatusId(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutUserEstateStatusIdMutationResult = NonNullable<Awaited<ReturnType<typeof putUserEstateStatusId>>>
    export type PutUserEstateStatusIdMutationBody = UserEstateStatus
    export type PutUserEstateStatusIdMutationError = void

    /**
 * @summary Update a user_estate_status record
 */
export const usePutUserEstateStatusId = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putUserEstateStatusId>>, TError,{id: string;data: UserEstateStatus}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putUserEstateStatusId>>,
        TError,
        {id: string;data: UserEstateStatus},
        TContext
      > => {

      const mutationOptions = getPutUserEstateStatusIdMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Partially updates an existing user_estate_status record
 * @summary Partially update a user_estate_status record
 */
export const patchUserEstateStatusId = (
    id: string,
    userEstateStatus: UserEstateStatus,
 ) => {
      
      
      return defaultInstance<PatchUserEstateStatusId200>(
      {url: `/user_estate_status/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: userEstateStatus
    },
      );
    }
  


export const getPatchUserEstateStatusIdMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchUserEstateStatusId>>, TError,{id: string;data: UserEstateStatus}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof patchUserEstateStatusId>>, TError,{id: string;data: UserEstateStatus}, TContext> => {
    
const mutationKey = ['patchUserEstateStatusId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchUserEstateStatusId>>, {id: string;data: UserEstateStatus}> = (props) => {
          const {id,data} = props ?? {};

          return  patchUserEstateStatusId(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PatchUserEstateStatusIdMutationResult = NonNullable<Awaited<ReturnType<typeof patchUserEstateStatusId>>>
    export type PatchUserEstateStatusIdMutationBody = UserEstateStatus
    export type PatchUserEstateStatusIdMutationError = void

    /**
 * @summary Partially update a user_estate_status record
 */
export const usePatchUserEstateStatusId = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchUserEstateStatusId>>, TError,{id: string;data: UserEstateStatus}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patchUserEstateStatusId>>,
        TError,
        {id: string;data: UserEstateStatus},
        TContext
      > => {

      const mutationOptions = getPatchUserEstateStatusIdMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Deletes a user_estate_status record
 * @summary Delete a user_estate_status record
 */
export const deleteUserEstateStatusId = (
    id: string,
 ) => {
      
      
      return defaultInstance<DeleteUserEstateStatusId200>(
      {url: `/user_estate_status/${id}`, method: 'DELETE'
    },
      );
    }
  


export const getDeleteUserEstateStatusIdMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteUserEstateStatusId>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteUserEstateStatusId>>, TError,{id: string}, TContext> => {
    
const mutationKey = ['deleteUserEstateStatusId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteUserEstateStatusId>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteUserEstateStatusId(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteUserEstateStatusIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteUserEstateStatusId>>>
    
    export type DeleteUserEstateStatusIdMutationError = void

    /**
 * @summary Delete a user_estate_status record
 */
export const useDeleteUserEstateStatusId = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteUserEstateStatusId>>, TError,{id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteUserEstateStatusId>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getDeleteUserEstateStatusIdMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Returns a list of legal_documents records with pagination
 * @summary Get all legal_documents records
 */
export const getLegalDocuments = (
    params?: GetLegalDocumentsParams,
 signal?: AbortSignal
) => {
      
      
      return defaultInstance<GetLegalDocuments200>(
      {url: `/legal_documents`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getGetLegalDocumentsQueryKey = (params?: GetLegalDocumentsParams,) => {
    return [`/legal_documents`, ...(params ? [params]: [])] as const;
    }

    
export const getGetLegalDocumentsQueryOptions = <TData = Awaited<ReturnType<typeof getLegalDocuments>>, TError = void>(params?: GetLegalDocumentsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLegalDocuments>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetLegalDocumentsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getLegalDocuments>>> = ({ signal }) => getLegalDocuments(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getLegalDocuments>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetLegalDocumentsQueryResult = NonNullable<Awaited<ReturnType<typeof getLegalDocuments>>>
export type GetLegalDocumentsQueryError = void


export function useGetLegalDocuments<TData = Awaited<ReturnType<typeof getLegalDocuments>>, TError = void>(
 params: undefined |  GetLegalDocumentsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLegalDocuments>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLegalDocuments>>,
          TError,
          Awaited<ReturnType<typeof getLegalDocuments>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLegalDocuments<TData = Awaited<ReturnType<typeof getLegalDocuments>>, TError = void>(
 params?: GetLegalDocumentsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLegalDocuments>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLegalDocuments>>,
          TError,
          Awaited<ReturnType<typeof getLegalDocuments>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLegalDocuments<TData = Awaited<ReturnType<typeof getLegalDocuments>>, TError = void>(
 params?: GetLegalDocumentsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLegalDocuments>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get all legal_documents records
 */

export function useGetLegalDocuments<TData = Awaited<ReturnType<typeof getLegalDocuments>>, TError = void>(
 params?: GetLegalDocumentsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLegalDocuments>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetLegalDocumentsQueryOptions(params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Creates a new legal_documents record
 * @summary Create a new legal_documents record
 */
export const postLegalDocuments = (
    legalDocuments: LegalDocuments,
 signal?: AbortSignal
) => {
      
      
      return defaultInstance<PostLegalDocuments200>(
      {url: `/legal_documents`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: legalDocuments, signal
    },
      );
    }
  


export const getPostLegalDocumentsMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postLegalDocuments>>, TError,{data: LegalDocuments}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postLegalDocuments>>, TError,{data: LegalDocuments}, TContext> => {
    
const mutationKey = ['postLegalDocuments'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postLegalDocuments>>, {data: LegalDocuments}> = (props) => {
          const {data} = props ?? {};

          return  postLegalDocuments(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostLegalDocumentsMutationResult = NonNullable<Awaited<ReturnType<typeof postLegalDocuments>>>
    export type PostLegalDocumentsMutationBody = LegalDocuments
    export type PostLegalDocumentsMutationError = void

    /**
 * @summary Create a new legal_documents record
 */
export const usePostLegalDocuments = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postLegalDocuments>>, TError,{data: LegalDocuments}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postLegalDocuments>>,
        TError,
        {data: LegalDocuments},
        TContext
      > => {

      const mutationOptions = getPostLegalDocumentsMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Returns a single legal_documents record by ID
 * @summary Get a specific legal_documents record
 */
export const getLegalDocumentsId = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return defaultInstance<GetLegalDocumentsId200>(
      {url: `/legal_documents/${id}`, method: 'GET', signal
    },
      );
    }
  

export const getGetLegalDocumentsIdQueryKey = (id: string,) => {
    return [`/legal_documents/${id}`] as const;
    }

    
export const getGetLegalDocumentsIdQueryOptions = <TData = Awaited<ReturnType<typeof getLegalDocumentsId>>, TError = void>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLegalDocumentsId>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetLegalDocumentsIdQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getLegalDocumentsId>>> = ({ signal }) => getLegalDocumentsId(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getLegalDocumentsId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetLegalDocumentsIdQueryResult = NonNullable<Awaited<ReturnType<typeof getLegalDocumentsId>>>
export type GetLegalDocumentsIdQueryError = void


export function useGetLegalDocumentsId<TData = Awaited<ReturnType<typeof getLegalDocumentsId>>, TError = void>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLegalDocumentsId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLegalDocumentsId>>,
          TError,
          Awaited<ReturnType<typeof getLegalDocumentsId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLegalDocumentsId<TData = Awaited<ReturnType<typeof getLegalDocumentsId>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLegalDocumentsId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLegalDocumentsId>>,
          TError,
          Awaited<ReturnType<typeof getLegalDocumentsId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLegalDocumentsId<TData = Awaited<ReturnType<typeof getLegalDocumentsId>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLegalDocumentsId>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get a specific legal_documents record
 */

export function useGetLegalDocumentsId<TData = Awaited<ReturnType<typeof getLegalDocumentsId>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLegalDocumentsId>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetLegalDocumentsIdQueryOptions(id,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Updates an existing legal_documents record
 * @summary Update a legal_documents record
 */
export const putLegalDocumentsId = (
    id: string,
    legalDocuments: LegalDocuments,
 ) => {
      
      
      return defaultInstance<PutLegalDocumentsId200>(
      {url: `/legal_documents/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: legalDocuments
    },
      );
    }
  


export const getPutLegalDocumentsIdMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putLegalDocumentsId>>, TError,{id: string;data: LegalDocuments}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof putLegalDocumentsId>>, TError,{id: string;data: LegalDocuments}, TContext> => {
    
const mutationKey = ['putLegalDocumentsId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putLegalDocumentsId>>, {id: string;data: LegalDocuments}> = (props) => {
          const {id,data} = props ?? {};

          return  putLegalDocumentsId(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutLegalDocumentsIdMutationResult = NonNullable<Awaited<ReturnType<typeof putLegalDocumentsId>>>
    export type PutLegalDocumentsIdMutationBody = LegalDocuments
    export type PutLegalDocumentsIdMutationError = void

    /**
 * @summary Update a legal_documents record
 */
export const usePutLegalDocumentsId = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putLegalDocumentsId>>, TError,{id: string;data: LegalDocuments}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putLegalDocumentsId>>,
        TError,
        {id: string;data: LegalDocuments},
        TContext
      > => {

      const mutationOptions = getPutLegalDocumentsIdMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Partially updates an existing legal_documents record
 * @summary Partially update a legal_documents record
 */
export const patchLegalDocumentsId = (
    id: string,
    legalDocuments: LegalDocuments,
 ) => {
      
      
      return defaultInstance<PatchLegalDocumentsId200>(
      {url: `/legal_documents/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: legalDocuments
    },
      );
    }
  


export const getPatchLegalDocumentsIdMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchLegalDocumentsId>>, TError,{id: string;data: LegalDocuments}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof patchLegalDocumentsId>>, TError,{id: string;data: LegalDocuments}, TContext> => {
    
const mutationKey = ['patchLegalDocumentsId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchLegalDocumentsId>>, {id: string;data: LegalDocuments}> = (props) => {
          const {id,data} = props ?? {};

          return  patchLegalDocumentsId(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PatchLegalDocumentsIdMutationResult = NonNullable<Awaited<ReturnType<typeof patchLegalDocumentsId>>>
    export type PatchLegalDocumentsIdMutationBody = LegalDocuments
    export type PatchLegalDocumentsIdMutationError = void

    /**
 * @summary Partially update a legal_documents record
 */
export const usePatchLegalDocumentsId = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchLegalDocumentsId>>, TError,{id: string;data: LegalDocuments}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patchLegalDocumentsId>>,
        TError,
        {id: string;data: LegalDocuments},
        TContext
      > => {

      const mutationOptions = getPatchLegalDocumentsIdMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Deletes a legal_documents record
 * @summary Delete a legal_documents record
 */
export const deleteLegalDocumentsId = (
    id: string,
 ) => {
      
      
      return defaultInstance<DeleteLegalDocumentsId200>(
      {url: `/legal_documents/${id}`, method: 'DELETE'
    },
      );
    }
  


export const getDeleteLegalDocumentsIdMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteLegalDocumentsId>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteLegalDocumentsId>>, TError,{id: string}, TContext> => {
    
const mutationKey = ['deleteLegalDocumentsId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteLegalDocumentsId>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteLegalDocumentsId(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteLegalDocumentsIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteLegalDocumentsId>>>
    
    export type DeleteLegalDocumentsIdMutationError = void

    /**
 * @summary Delete a legal_documents record
 */
export const useDeleteLegalDocumentsId = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteLegalDocumentsId>>, TError,{id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteLegalDocumentsId>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getDeleteLegalDocumentsIdMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Returns a list of author records with pagination
 * @summary Get all author records
 */
export const getAuthor = (
    params?: GetAuthorParams,
 signal?: AbortSignal
) => {
      
      
      return defaultInstance<GetAuthor200>(
      {url: `/author`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getGetAuthorQueryKey = (params?: GetAuthorParams,) => {
    return [`/author`, ...(params ? [params]: [])] as const;
    }

    
export const getGetAuthorQueryOptions = <TData = Awaited<ReturnType<typeof getAuthor>>, TError = void>(params?: GetAuthorParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAuthor>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAuthorQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAuthor>>> = ({ signal }) => getAuthor(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAuthor>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAuthorQueryResult = NonNullable<Awaited<ReturnType<typeof getAuthor>>>
export type GetAuthorQueryError = void


export function useGetAuthor<TData = Awaited<ReturnType<typeof getAuthor>>, TError = void>(
 params: undefined |  GetAuthorParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAuthor>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAuthor>>,
          TError,
          Awaited<ReturnType<typeof getAuthor>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAuthor<TData = Awaited<ReturnType<typeof getAuthor>>, TError = void>(
 params?: GetAuthorParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAuthor>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAuthor>>,
          TError,
          Awaited<ReturnType<typeof getAuthor>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAuthor<TData = Awaited<ReturnType<typeof getAuthor>>, TError = void>(
 params?: GetAuthorParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAuthor>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get all author records
 */

export function useGetAuthor<TData = Awaited<ReturnType<typeof getAuthor>>, TError = void>(
 params?: GetAuthorParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAuthor>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAuthorQueryOptions(params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Creates a new author record
 * @summary Create a new author record
 */
export const postAuthor = (
    author: Author,
 signal?: AbortSignal
) => {
      
      
      return defaultInstance<PostAuthor200>(
      {url: `/author`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: author, signal
    },
      );
    }
  


export const getPostAuthorMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAuthor>>, TError,{data: Author}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postAuthor>>, TError,{data: Author}, TContext> => {
    
const mutationKey = ['postAuthor'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postAuthor>>, {data: Author}> = (props) => {
          const {data} = props ?? {};

          return  postAuthor(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostAuthorMutationResult = NonNullable<Awaited<ReturnType<typeof postAuthor>>>
    export type PostAuthorMutationBody = Author
    export type PostAuthorMutationError = void

    /**
 * @summary Create a new author record
 */
export const usePostAuthor = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAuthor>>, TError,{data: Author}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postAuthor>>,
        TError,
        {data: Author},
        TContext
      > => {

      const mutationOptions = getPostAuthorMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Returns a single author record by ID
 * @summary Get a specific author record
 */
export const getAuthorId = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return defaultInstance<GetAuthorId200>(
      {url: `/author/${id}`, method: 'GET', signal
    },
      );
    }
  

export const getGetAuthorIdQueryKey = (id: string,) => {
    return [`/author/${id}`] as const;
    }

    
export const getGetAuthorIdQueryOptions = <TData = Awaited<ReturnType<typeof getAuthorId>>, TError = void>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAuthorId>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAuthorIdQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAuthorId>>> = ({ signal }) => getAuthorId(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAuthorId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAuthorIdQueryResult = NonNullable<Awaited<ReturnType<typeof getAuthorId>>>
export type GetAuthorIdQueryError = void


export function useGetAuthorId<TData = Awaited<ReturnType<typeof getAuthorId>>, TError = void>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAuthorId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAuthorId>>,
          TError,
          Awaited<ReturnType<typeof getAuthorId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAuthorId<TData = Awaited<ReturnType<typeof getAuthorId>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAuthorId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAuthorId>>,
          TError,
          Awaited<ReturnType<typeof getAuthorId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAuthorId<TData = Awaited<ReturnType<typeof getAuthorId>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAuthorId>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get a specific author record
 */

export function useGetAuthorId<TData = Awaited<ReturnType<typeof getAuthorId>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAuthorId>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAuthorIdQueryOptions(id,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Updates an existing author record
 * @summary Update a author record
 */
export const putAuthorId = (
    id: string,
    author: Author,
 ) => {
      
      
      return defaultInstance<PutAuthorId200>(
      {url: `/author/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: author
    },
      );
    }
  


export const getPutAuthorIdMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putAuthorId>>, TError,{id: string;data: Author}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof putAuthorId>>, TError,{id: string;data: Author}, TContext> => {
    
const mutationKey = ['putAuthorId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putAuthorId>>, {id: string;data: Author}> = (props) => {
          const {id,data} = props ?? {};

          return  putAuthorId(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutAuthorIdMutationResult = NonNullable<Awaited<ReturnType<typeof putAuthorId>>>
    export type PutAuthorIdMutationBody = Author
    export type PutAuthorIdMutationError = void

    /**
 * @summary Update a author record
 */
export const usePutAuthorId = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putAuthorId>>, TError,{id: string;data: Author}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putAuthorId>>,
        TError,
        {id: string;data: Author},
        TContext
      > => {

      const mutationOptions = getPutAuthorIdMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Partially updates an existing author record
 * @summary Partially update a author record
 */
export const patchAuthorId = (
    id: string,
    author: Author,
 ) => {
      
      
      return defaultInstance<PatchAuthorId200>(
      {url: `/author/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: author
    },
      );
    }
  


export const getPatchAuthorIdMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchAuthorId>>, TError,{id: string;data: Author}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof patchAuthorId>>, TError,{id: string;data: Author}, TContext> => {
    
const mutationKey = ['patchAuthorId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchAuthorId>>, {id: string;data: Author}> = (props) => {
          const {id,data} = props ?? {};

          return  patchAuthorId(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PatchAuthorIdMutationResult = NonNullable<Awaited<ReturnType<typeof patchAuthorId>>>
    export type PatchAuthorIdMutationBody = Author
    export type PatchAuthorIdMutationError = void

    /**
 * @summary Partially update a author record
 */
export const usePatchAuthorId = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchAuthorId>>, TError,{id: string;data: Author}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patchAuthorId>>,
        TError,
        {id: string;data: Author},
        TContext
      > => {

      const mutationOptions = getPatchAuthorIdMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Deletes a author record
 * @summary Delete a author record
 */
export const deleteAuthorId = (
    id: string,
 ) => {
      
      
      return defaultInstance<DeleteAuthorId200>(
      {url: `/author/${id}`, method: 'DELETE'
    },
      );
    }
  


export const getDeleteAuthorIdMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAuthorId>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteAuthorId>>, TError,{id: string}, TContext> => {
    
const mutationKey = ['deleteAuthorId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteAuthorId>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteAuthorId(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteAuthorIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteAuthorId>>>
    
    export type DeleteAuthorIdMutationError = void

    /**
 * @summary Delete a author record
 */
export const useDeleteAuthorId = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAuthorId>>, TError,{id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteAuthorId>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getDeleteAuthorIdMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Returns a list of ads records with pagination
 * @summary Get all ads records
 */
export const getAds = (
    params?: GetAdsParams,
 signal?: AbortSignal
) => {
      
      
      return defaultInstance<GetAds200>(
      {url: `/ads`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getGetAdsQueryKey = (params?: GetAdsParams,) => {
    return [`/ads`, ...(params ? [params]: [])] as const;
    }

    
export const getGetAdsQueryOptions = <TData = Awaited<ReturnType<typeof getAds>>, TError = void>(params?: GetAdsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAds>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAds>>> = ({ signal }) => getAds(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAds>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAdsQueryResult = NonNullable<Awaited<ReturnType<typeof getAds>>>
export type GetAdsQueryError = void


export function useGetAds<TData = Awaited<ReturnType<typeof getAds>>, TError = void>(
 params: undefined |  GetAdsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAds>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAds>>,
          TError,
          Awaited<ReturnType<typeof getAds>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAds<TData = Awaited<ReturnType<typeof getAds>>, TError = void>(
 params?: GetAdsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAds>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAds>>,
          TError,
          Awaited<ReturnType<typeof getAds>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAds<TData = Awaited<ReturnType<typeof getAds>>, TError = void>(
 params?: GetAdsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAds>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get all ads records
 */

export function useGetAds<TData = Awaited<ReturnType<typeof getAds>>, TError = void>(
 params?: GetAdsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAds>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAdsQueryOptions(params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Creates a new ads record
 * @summary Create a new ads record
 */
export const postAds = (
    ads: Ads,
 signal?: AbortSignal
) => {
      
      
      return defaultInstance<PostAds200>(
      {url: `/ads`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: ads, signal
    },
      );
    }
  


export const getPostAdsMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAds>>, TError,{data: Ads}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postAds>>, TError,{data: Ads}, TContext> => {
    
const mutationKey = ['postAds'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postAds>>, {data: Ads}> = (props) => {
          const {data} = props ?? {};

          return  postAds(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostAdsMutationResult = NonNullable<Awaited<ReturnType<typeof postAds>>>
    export type PostAdsMutationBody = Ads
    export type PostAdsMutationError = void

    /**
 * @summary Create a new ads record
 */
export const usePostAds = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAds>>, TError,{data: Ads}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postAds>>,
        TError,
        {data: Ads},
        TContext
      > => {

      const mutationOptions = getPostAdsMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Returns a single ads record by ID
 * @summary Get a specific ads record
 */
export const getAdsId = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return defaultInstance<GetAdsId200>(
      {url: `/ads/${id}`, method: 'GET', signal
    },
      );
    }
  

export const getGetAdsIdQueryKey = (id: string,) => {
    return [`/ads/${id}`] as const;
    }

    
export const getGetAdsIdQueryOptions = <TData = Awaited<ReturnType<typeof getAdsId>>, TError = void>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdsId>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdsIdQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdsId>>> = ({ signal }) => getAdsId(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAdsId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAdsIdQueryResult = NonNullable<Awaited<ReturnType<typeof getAdsId>>>
export type GetAdsIdQueryError = void


export function useGetAdsId<TData = Awaited<ReturnType<typeof getAdsId>>, TError = void>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdsId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdsId>>,
          TError,
          Awaited<ReturnType<typeof getAdsId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdsId<TData = Awaited<ReturnType<typeof getAdsId>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdsId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdsId>>,
          TError,
          Awaited<ReturnType<typeof getAdsId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdsId<TData = Awaited<ReturnType<typeof getAdsId>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdsId>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get a specific ads record
 */

export function useGetAdsId<TData = Awaited<ReturnType<typeof getAdsId>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdsId>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAdsIdQueryOptions(id,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Updates an existing ads record
 * @summary Update a ads record
 */
export const putAdsId = (
    id: string,
    ads: Ads,
 ) => {
      
      
      return defaultInstance<PutAdsId200>(
      {url: `/ads/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: ads
    },
      );
    }
  


export const getPutAdsIdMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putAdsId>>, TError,{id: string;data: Ads}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof putAdsId>>, TError,{id: string;data: Ads}, TContext> => {
    
const mutationKey = ['putAdsId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putAdsId>>, {id: string;data: Ads}> = (props) => {
          const {id,data} = props ?? {};

          return  putAdsId(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutAdsIdMutationResult = NonNullable<Awaited<ReturnType<typeof putAdsId>>>
    export type PutAdsIdMutationBody = Ads
    export type PutAdsIdMutationError = void

    /**
 * @summary Update a ads record
 */
export const usePutAdsId = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putAdsId>>, TError,{id: string;data: Ads}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putAdsId>>,
        TError,
        {id: string;data: Ads},
        TContext
      > => {

      const mutationOptions = getPutAdsIdMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Partially updates an existing ads record
 * @summary Partially update a ads record
 */
export const patchAdsId = (
    id: string,
    ads: Ads,
 ) => {
      
      
      return defaultInstance<PatchAdsId200>(
      {url: `/ads/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: ads
    },
      );
    }
  


export const getPatchAdsIdMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchAdsId>>, TError,{id: string;data: Ads}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof patchAdsId>>, TError,{id: string;data: Ads}, TContext> => {
    
const mutationKey = ['patchAdsId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchAdsId>>, {id: string;data: Ads}> = (props) => {
          const {id,data} = props ?? {};

          return  patchAdsId(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PatchAdsIdMutationResult = NonNullable<Awaited<ReturnType<typeof patchAdsId>>>
    export type PatchAdsIdMutationBody = Ads
    export type PatchAdsIdMutationError = void

    /**
 * @summary Partially update a ads record
 */
export const usePatchAdsId = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchAdsId>>, TError,{id: string;data: Ads}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patchAdsId>>,
        TError,
        {id: string;data: Ads},
        TContext
      > => {

      const mutationOptions = getPatchAdsIdMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Deletes a ads record
 * @summary Delete a ads record
 */
export const deleteAdsId = (
    id: string,
 ) => {
      
      
      return defaultInstance<DeleteAdsId200>(
      {url: `/ads/${id}`, method: 'DELETE'
    },
      );
    }
  


export const getDeleteAdsIdMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAdsId>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteAdsId>>, TError,{id: string}, TContext> => {
    
const mutationKey = ['deleteAdsId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteAdsId>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteAdsId(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteAdsIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteAdsId>>>
    
    export type DeleteAdsIdMutationError = void

    /**
 * @summary Delete a ads record
 */
export const useDeleteAdsId = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAdsId>>, TError,{id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteAdsId>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getDeleteAdsIdMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Returns a list of business_category records with pagination
 * @summary Get all business_category records
 */
export const getBusinessCategory = (
    params?: GetBusinessCategoryParams,
 signal?: AbortSignal
) => {
      
      
      return defaultInstance<GetBusinessCategory200>(
      {url: `/business_category`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getGetBusinessCategoryQueryKey = (params?: GetBusinessCategoryParams,) => {
    return [`/business_category`, ...(params ? [params]: [])] as const;
    }

    
export const getGetBusinessCategoryQueryOptions = <TData = Awaited<ReturnType<typeof getBusinessCategory>>, TError = void>(params?: GetBusinessCategoryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBusinessCategory>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetBusinessCategoryQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getBusinessCategory>>> = ({ signal }) => getBusinessCategory(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getBusinessCategory>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetBusinessCategoryQueryResult = NonNullable<Awaited<ReturnType<typeof getBusinessCategory>>>
export type GetBusinessCategoryQueryError = void


export function useGetBusinessCategory<TData = Awaited<ReturnType<typeof getBusinessCategory>>, TError = void>(
 params: undefined |  GetBusinessCategoryParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBusinessCategory>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBusinessCategory>>,
          TError,
          Awaited<ReturnType<typeof getBusinessCategory>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBusinessCategory<TData = Awaited<ReturnType<typeof getBusinessCategory>>, TError = void>(
 params?: GetBusinessCategoryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBusinessCategory>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBusinessCategory>>,
          TError,
          Awaited<ReturnType<typeof getBusinessCategory>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBusinessCategory<TData = Awaited<ReturnType<typeof getBusinessCategory>>, TError = void>(
 params?: GetBusinessCategoryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBusinessCategory>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get all business_category records
 */

export function useGetBusinessCategory<TData = Awaited<ReturnType<typeof getBusinessCategory>>, TError = void>(
 params?: GetBusinessCategoryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBusinessCategory>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetBusinessCategoryQueryOptions(params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Creates a new business_category record
 * @summary Create a new business_category record
 */
export const postBusinessCategory = (
    businessCategory: BusinessCategory,
 signal?: AbortSignal
) => {
      
      
      return defaultInstance<PostBusinessCategory200>(
      {url: `/business_category`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: businessCategory, signal
    },
      );
    }
  


export const getPostBusinessCategoryMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postBusinessCategory>>, TError,{data: BusinessCategory}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postBusinessCategory>>, TError,{data: BusinessCategory}, TContext> => {
    
const mutationKey = ['postBusinessCategory'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postBusinessCategory>>, {data: BusinessCategory}> = (props) => {
          const {data} = props ?? {};

          return  postBusinessCategory(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostBusinessCategoryMutationResult = NonNullable<Awaited<ReturnType<typeof postBusinessCategory>>>
    export type PostBusinessCategoryMutationBody = BusinessCategory
    export type PostBusinessCategoryMutationError = void

    /**
 * @summary Create a new business_category record
 */
export const usePostBusinessCategory = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postBusinessCategory>>, TError,{data: BusinessCategory}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postBusinessCategory>>,
        TError,
        {data: BusinessCategory},
        TContext
      > => {

      const mutationOptions = getPostBusinessCategoryMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Returns a single business_category record by ID
 * @summary Get a specific business_category record
 */
export const getBusinessCategoryId = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return defaultInstance<GetBusinessCategoryId200>(
      {url: `/business_category/${id}`, method: 'GET', signal
    },
      );
    }
  

export const getGetBusinessCategoryIdQueryKey = (id: string,) => {
    return [`/business_category/${id}`] as const;
    }

    
export const getGetBusinessCategoryIdQueryOptions = <TData = Awaited<ReturnType<typeof getBusinessCategoryId>>, TError = void>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBusinessCategoryId>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetBusinessCategoryIdQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getBusinessCategoryId>>> = ({ signal }) => getBusinessCategoryId(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getBusinessCategoryId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetBusinessCategoryIdQueryResult = NonNullable<Awaited<ReturnType<typeof getBusinessCategoryId>>>
export type GetBusinessCategoryIdQueryError = void


export function useGetBusinessCategoryId<TData = Awaited<ReturnType<typeof getBusinessCategoryId>>, TError = void>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBusinessCategoryId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBusinessCategoryId>>,
          TError,
          Awaited<ReturnType<typeof getBusinessCategoryId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBusinessCategoryId<TData = Awaited<ReturnType<typeof getBusinessCategoryId>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBusinessCategoryId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBusinessCategoryId>>,
          TError,
          Awaited<ReturnType<typeof getBusinessCategoryId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBusinessCategoryId<TData = Awaited<ReturnType<typeof getBusinessCategoryId>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBusinessCategoryId>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get a specific business_category record
 */

export function useGetBusinessCategoryId<TData = Awaited<ReturnType<typeof getBusinessCategoryId>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBusinessCategoryId>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetBusinessCategoryIdQueryOptions(id,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Updates an existing business_category record
 * @summary Update a business_category record
 */
export const putBusinessCategoryId = (
    id: string,
    businessCategory: BusinessCategory,
 ) => {
      
      
      return defaultInstance<PutBusinessCategoryId200>(
      {url: `/business_category/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: businessCategory
    },
      );
    }
  


export const getPutBusinessCategoryIdMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putBusinessCategoryId>>, TError,{id: string;data: BusinessCategory}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof putBusinessCategoryId>>, TError,{id: string;data: BusinessCategory}, TContext> => {
    
const mutationKey = ['putBusinessCategoryId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putBusinessCategoryId>>, {id: string;data: BusinessCategory}> = (props) => {
          const {id,data} = props ?? {};

          return  putBusinessCategoryId(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutBusinessCategoryIdMutationResult = NonNullable<Awaited<ReturnType<typeof putBusinessCategoryId>>>
    export type PutBusinessCategoryIdMutationBody = BusinessCategory
    export type PutBusinessCategoryIdMutationError = void

    /**
 * @summary Update a business_category record
 */
export const usePutBusinessCategoryId = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putBusinessCategoryId>>, TError,{id: string;data: BusinessCategory}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putBusinessCategoryId>>,
        TError,
        {id: string;data: BusinessCategory},
        TContext
      > => {

      const mutationOptions = getPutBusinessCategoryIdMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Partially updates an existing business_category record
 * @summary Partially update a business_category record
 */
export const patchBusinessCategoryId = (
    id: string,
    businessCategory: BusinessCategory,
 ) => {
      
      
      return defaultInstance<PatchBusinessCategoryId200>(
      {url: `/business_category/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: businessCategory
    },
      );
    }
  


export const getPatchBusinessCategoryIdMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchBusinessCategoryId>>, TError,{id: string;data: BusinessCategory}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof patchBusinessCategoryId>>, TError,{id: string;data: BusinessCategory}, TContext> => {
    
const mutationKey = ['patchBusinessCategoryId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchBusinessCategoryId>>, {id: string;data: BusinessCategory}> = (props) => {
          const {id,data} = props ?? {};

          return  patchBusinessCategoryId(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PatchBusinessCategoryIdMutationResult = NonNullable<Awaited<ReturnType<typeof patchBusinessCategoryId>>>
    export type PatchBusinessCategoryIdMutationBody = BusinessCategory
    export type PatchBusinessCategoryIdMutationError = void

    /**
 * @summary Partially update a business_category record
 */
export const usePatchBusinessCategoryId = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchBusinessCategoryId>>, TError,{id: string;data: BusinessCategory}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patchBusinessCategoryId>>,
        TError,
        {id: string;data: BusinessCategory},
        TContext
      > => {

      const mutationOptions = getPatchBusinessCategoryIdMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Deletes a business_category record
 * @summary Delete a business_category record
 */
export const deleteBusinessCategoryId = (
    id: string,
 ) => {
      
      
      return defaultInstance<DeleteBusinessCategoryId200>(
      {url: `/business_category/${id}`, method: 'DELETE'
    },
      );
    }
  


export const getDeleteBusinessCategoryIdMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteBusinessCategoryId>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteBusinessCategoryId>>, TError,{id: string}, TContext> => {
    
const mutationKey = ['deleteBusinessCategoryId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteBusinessCategoryId>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteBusinessCategoryId(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteBusinessCategoryIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteBusinessCategoryId>>>
    
    export type DeleteBusinessCategoryIdMutationError = void

    /**
 * @summary Delete a business_category record
 */
export const useDeleteBusinessCategoryId = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteBusinessCategoryId>>, TError,{id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteBusinessCategoryId>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getDeleteBusinessCategoryIdMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Returns a list of business_type records with pagination
 * @summary Get all business_type records
 */
export const getBusinessType = (
    params?: GetBusinessTypeParams,
 signal?: AbortSignal
) => {
      
      
      return defaultInstance<GetBusinessType200>(
      {url: `/business_type`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getGetBusinessTypeQueryKey = (params?: GetBusinessTypeParams,) => {
    return [`/business_type`, ...(params ? [params]: [])] as const;
    }

    
export const getGetBusinessTypeQueryOptions = <TData = Awaited<ReturnType<typeof getBusinessType>>, TError = void>(params?: GetBusinessTypeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBusinessType>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetBusinessTypeQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getBusinessType>>> = ({ signal }) => getBusinessType(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getBusinessType>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetBusinessTypeQueryResult = NonNullable<Awaited<ReturnType<typeof getBusinessType>>>
export type GetBusinessTypeQueryError = void


export function useGetBusinessType<TData = Awaited<ReturnType<typeof getBusinessType>>, TError = void>(
 params: undefined |  GetBusinessTypeParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBusinessType>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBusinessType>>,
          TError,
          Awaited<ReturnType<typeof getBusinessType>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBusinessType<TData = Awaited<ReturnType<typeof getBusinessType>>, TError = void>(
 params?: GetBusinessTypeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBusinessType>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBusinessType>>,
          TError,
          Awaited<ReturnType<typeof getBusinessType>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBusinessType<TData = Awaited<ReturnType<typeof getBusinessType>>, TError = void>(
 params?: GetBusinessTypeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBusinessType>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get all business_type records
 */

export function useGetBusinessType<TData = Awaited<ReturnType<typeof getBusinessType>>, TError = void>(
 params?: GetBusinessTypeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBusinessType>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetBusinessTypeQueryOptions(params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Creates a new business_type record
 * @summary Create a new business_type record
 */
export const postBusinessType = (
    businessType: BusinessType,
 signal?: AbortSignal
) => {
      
      
      return defaultInstance<PostBusinessType200>(
      {url: `/business_type`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: businessType, signal
    },
      );
    }
  


export const getPostBusinessTypeMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postBusinessType>>, TError,{data: BusinessType}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postBusinessType>>, TError,{data: BusinessType}, TContext> => {
    
const mutationKey = ['postBusinessType'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postBusinessType>>, {data: BusinessType}> = (props) => {
          const {data} = props ?? {};

          return  postBusinessType(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostBusinessTypeMutationResult = NonNullable<Awaited<ReturnType<typeof postBusinessType>>>
    export type PostBusinessTypeMutationBody = BusinessType
    export type PostBusinessTypeMutationError = void

    /**
 * @summary Create a new business_type record
 */
export const usePostBusinessType = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postBusinessType>>, TError,{data: BusinessType}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postBusinessType>>,
        TError,
        {data: BusinessType},
        TContext
      > => {

      const mutationOptions = getPostBusinessTypeMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Returns a single business_type record by ID
 * @summary Get a specific business_type record
 */
export const getBusinessTypeId = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return defaultInstance<GetBusinessTypeId200>(
      {url: `/business_type/${id}`, method: 'GET', signal
    },
      );
    }
  

export const getGetBusinessTypeIdQueryKey = (id: string,) => {
    return [`/business_type/${id}`] as const;
    }

    
export const getGetBusinessTypeIdQueryOptions = <TData = Awaited<ReturnType<typeof getBusinessTypeId>>, TError = void>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBusinessTypeId>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetBusinessTypeIdQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getBusinessTypeId>>> = ({ signal }) => getBusinessTypeId(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getBusinessTypeId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetBusinessTypeIdQueryResult = NonNullable<Awaited<ReturnType<typeof getBusinessTypeId>>>
export type GetBusinessTypeIdQueryError = void


export function useGetBusinessTypeId<TData = Awaited<ReturnType<typeof getBusinessTypeId>>, TError = void>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBusinessTypeId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBusinessTypeId>>,
          TError,
          Awaited<ReturnType<typeof getBusinessTypeId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBusinessTypeId<TData = Awaited<ReturnType<typeof getBusinessTypeId>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBusinessTypeId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBusinessTypeId>>,
          TError,
          Awaited<ReturnType<typeof getBusinessTypeId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBusinessTypeId<TData = Awaited<ReturnType<typeof getBusinessTypeId>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBusinessTypeId>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get a specific business_type record
 */

export function useGetBusinessTypeId<TData = Awaited<ReturnType<typeof getBusinessTypeId>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBusinessTypeId>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetBusinessTypeIdQueryOptions(id,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Updates an existing business_type record
 * @summary Update a business_type record
 */
export const putBusinessTypeId = (
    id: string,
    businessType: BusinessType,
 ) => {
      
      
      return defaultInstance<PutBusinessTypeId200>(
      {url: `/business_type/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: businessType
    },
      );
    }
  


export const getPutBusinessTypeIdMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putBusinessTypeId>>, TError,{id: string;data: BusinessType}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof putBusinessTypeId>>, TError,{id: string;data: BusinessType}, TContext> => {
    
const mutationKey = ['putBusinessTypeId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putBusinessTypeId>>, {id: string;data: BusinessType}> = (props) => {
          const {id,data} = props ?? {};

          return  putBusinessTypeId(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutBusinessTypeIdMutationResult = NonNullable<Awaited<ReturnType<typeof putBusinessTypeId>>>
    export type PutBusinessTypeIdMutationBody = BusinessType
    export type PutBusinessTypeIdMutationError = void

    /**
 * @summary Update a business_type record
 */
export const usePutBusinessTypeId = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putBusinessTypeId>>, TError,{id: string;data: BusinessType}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putBusinessTypeId>>,
        TError,
        {id: string;data: BusinessType},
        TContext
      > => {

      const mutationOptions = getPutBusinessTypeIdMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Partially updates an existing business_type record
 * @summary Partially update a business_type record
 */
export const patchBusinessTypeId = (
    id: string,
    businessType: BusinessType,
 ) => {
      
      
      return defaultInstance<PatchBusinessTypeId200>(
      {url: `/business_type/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: businessType
    },
      );
    }
  


export const getPatchBusinessTypeIdMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchBusinessTypeId>>, TError,{id: string;data: BusinessType}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof patchBusinessTypeId>>, TError,{id: string;data: BusinessType}, TContext> => {
    
const mutationKey = ['patchBusinessTypeId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchBusinessTypeId>>, {id: string;data: BusinessType}> = (props) => {
          const {id,data} = props ?? {};

          return  patchBusinessTypeId(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PatchBusinessTypeIdMutationResult = NonNullable<Awaited<ReturnType<typeof patchBusinessTypeId>>>
    export type PatchBusinessTypeIdMutationBody = BusinessType
    export type PatchBusinessTypeIdMutationError = void

    /**
 * @summary Partially update a business_type record
 */
export const usePatchBusinessTypeId = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchBusinessTypeId>>, TError,{id: string;data: BusinessType}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patchBusinessTypeId>>,
        TError,
        {id: string;data: BusinessType},
        TContext
      > => {

      const mutationOptions = getPatchBusinessTypeIdMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Deletes a business_type record
 * @summary Delete a business_type record
 */
export const deleteBusinessTypeId = (
    id: string,
 ) => {
      
      
      return defaultInstance<DeleteBusinessTypeId200>(
      {url: `/business_type/${id}`, method: 'DELETE'
    },
      );
    }
  


export const getDeleteBusinessTypeIdMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteBusinessTypeId>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteBusinessTypeId>>, TError,{id: string}, TContext> => {
    
const mutationKey = ['deleteBusinessTypeId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteBusinessTypeId>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteBusinessTypeId(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteBusinessTypeIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteBusinessTypeId>>>
    
    export type DeleteBusinessTypeIdMutationError = void

    /**
 * @summary Delete a business_type record
 */
export const useDeleteBusinessTypeId = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteBusinessTypeId>>, TError,{id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteBusinessTypeId>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getDeleteBusinessTypeIdMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Returns a list of business_unit records with pagination
 * @summary Get all business_unit records
 */
export const getBusinessUnit = (
    params?: GetBusinessUnitParams,
 signal?: AbortSignal
) => {
      
      
      return defaultInstance<GetBusinessUnit200>(
      {url: `/business_unit`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getGetBusinessUnitQueryKey = (params?: GetBusinessUnitParams,) => {
    return [`/business_unit`, ...(params ? [params]: [])] as const;
    }

    
export const getGetBusinessUnitQueryOptions = <TData = Awaited<ReturnType<typeof getBusinessUnit>>, TError = void>(params?: GetBusinessUnitParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBusinessUnit>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetBusinessUnitQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getBusinessUnit>>> = ({ signal }) => getBusinessUnit(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getBusinessUnit>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetBusinessUnitQueryResult = NonNullable<Awaited<ReturnType<typeof getBusinessUnit>>>
export type GetBusinessUnitQueryError = void


export function useGetBusinessUnit<TData = Awaited<ReturnType<typeof getBusinessUnit>>, TError = void>(
 params: undefined |  GetBusinessUnitParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBusinessUnit>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBusinessUnit>>,
          TError,
          Awaited<ReturnType<typeof getBusinessUnit>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBusinessUnit<TData = Awaited<ReturnType<typeof getBusinessUnit>>, TError = void>(
 params?: GetBusinessUnitParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBusinessUnit>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBusinessUnit>>,
          TError,
          Awaited<ReturnType<typeof getBusinessUnit>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBusinessUnit<TData = Awaited<ReturnType<typeof getBusinessUnit>>, TError = void>(
 params?: GetBusinessUnitParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBusinessUnit>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get all business_unit records
 */

export function useGetBusinessUnit<TData = Awaited<ReturnType<typeof getBusinessUnit>>, TError = void>(
 params?: GetBusinessUnitParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBusinessUnit>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetBusinessUnitQueryOptions(params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Creates a new business_unit record
 * @summary Create a new business_unit record
 */
export const postBusinessUnit = (
    businessUnit: BusinessUnit,
 signal?: AbortSignal
) => {
      
      
      return defaultInstance<PostBusinessUnit200>(
      {url: `/business_unit`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: businessUnit, signal
    },
      );
    }
  


export const getPostBusinessUnitMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postBusinessUnit>>, TError,{data: BusinessUnit}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postBusinessUnit>>, TError,{data: BusinessUnit}, TContext> => {
    
const mutationKey = ['postBusinessUnit'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postBusinessUnit>>, {data: BusinessUnit}> = (props) => {
          const {data} = props ?? {};

          return  postBusinessUnit(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostBusinessUnitMutationResult = NonNullable<Awaited<ReturnType<typeof postBusinessUnit>>>
    export type PostBusinessUnitMutationBody = BusinessUnit
    export type PostBusinessUnitMutationError = void

    /**
 * @summary Create a new business_unit record
 */
export const usePostBusinessUnit = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postBusinessUnit>>, TError,{data: BusinessUnit}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postBusinessUnit>>,
        TError,
        {data: BusinessUnit},
        TContext
      > => {

      const mutationOptions = getPostBusinessUnitMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Returns a single business_unit record by ID
 * @summary Get a specific business_unit record
 */
export const getBusinessUnitId = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return defaultInstance<GetBusinessUnitId200>(
      {url: `/business_unit/${id}`, method: 'GET', signal
    },
      );
    }
  

export const getGetBusinessUnitIdQueryKey = (id: string,) => {
    return [`/business_unit/${id}`] as const;
    }

    
export const getGetBusinessUnitIdQueryOptions = <TData = Awaited<ReturnType<typeof getBusinessUnitId>>, TError = void>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBusinessUnitId>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetBusinessUnitIdQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getBusinessUnitId>>> = ({ signal }) => getBusinessUnitId(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getBusinessUnitId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetBusinessUnitIdQueryResult = NonNullable<Awaited<ReturnType<typeof getBusinessUnitId>>>
export type GetBusinessUnitIdQueryError = void


export function useGetBusinessUnitId<TData = Awaited<ReturnType<typeof getBusinessUnitId>>, TError = void>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBusinessUnitId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBusinessUnitId>>,
          TError,
          Awaited<ReturnType<typeof getBusinessUnitId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBusinessUnitId<TData = Awaited<ReturnType<typeof getBusinessUnitId>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBusinessUnitId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBusinessUnitId>>,
          TError,
          Awaited<ReturnType<typeof getBusinessUnitId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBusinessUnitId<TData = Awaited<ReturnType<typeof getBusinessUnitId>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBusinessUnitId>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get a specific business_unit record
 */

export function useGetBusinessUnitId<TData = Awaited<ReturnType<typeof getBusinessUnitId>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBusinessUnitId>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetBusinessUnitIdQueryOptions(id,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Updates an existing business_unit record
 * @summary Update a business_unit record
 */
export const putBusinessUnitId = (
    id: string,
    businessUnit: BusinessUnit,
 ) => {
      
      
      return defaultInstance<PutBusinessUnitId200>(
      {url: `/business_unit/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: businessUnit
    },
      );
    }
  


export const getPutBusinessUnitIdMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putBusinessUnitId>>, TError,{id: string;data: BusinessUnit}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof putBusinessUnitId>>, TError,{id: string;data: BusinessUnit}, TContext> => {
    
const mutationKey = ['putBusinessUnitId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putBusinessUnitId>>, {id: string;data: BusinessUnit}> = (props) => {
          const {id,data} = props ?? {};

          return  putBusinessUnitId(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutBusinessUnitIdMutationResult = NonNullable<Awaited<ReturnType<typeof putBusinessUnitId>>>
    export type PutBusinessUnitIdMutationBody = BusinessUnit
    export type PutBusinessUnitIdMutationError = void

    /**
 * @summary Update a business_unit record
 */
export const usePutBusinessUnitId = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putBusinessUnitId>>, TError,{id: string;data: BusinessUnit}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putBusinessUnitId>>,
        TError,
        {id: string;data: BusinessUnit},
        TContext
      > => {

      const mutationOptions = getPutBusinessUnitIdMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Partially updates an existing business_unit record
 * @summary Partially update a business_unit record
 */
export const patchBusinessUnitId = (
    id: string,
    businessUnit: BusinessUnit,
 ) => {
      
      
      return defaultInstance<PatchBusinessUnitId200>(
      {url: `/business_unit/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: businessUnit
    },
      );
    }
  


export const getPatchBusinessUnitIdMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchBusinessUnitId>>, TError,{id: string;data: BusinessUnit}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof patchBusinessUnitId>>, TError,{id: string;data: BusinessUnit}, TContext> => {
    
const mutationKey = ['patchBusinessUnitId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchBusinessUnitId>>, {id: string;data: BusinessUnit}> = (props) => {
          const {id,data} = props ?? {};

          return  patchBusinessUnitId(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PatchBusinessUnitIdMutationResult = NonNullable<Awaited<ReturnType<typeof patchBusinessUnitId>>>
    export type PatchBusinessUnitIdMutationBody = BusinessUnit
    export type PatchBusinessUnitIdMutationError = void

    /**
 * @summary Partially update a business_unit record
 */
export const usePatchBusinessUnitId = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchBusinessUnitId>>, TError,{id: string;data: BusinessUnit}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patchBusinessUnitId>>,
        TError,
        {id: string;data: BusinessUnit},
        TContext
      > => {

      const mutationOptions = getPatchBusinessUnitIdMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Deletes a business_unit record
 * @summary Delete a business_unit record
 */
export const deleteBusinessUnitId = (
    id: string,
 ) => {
      
      
      return defaultInstance<DeleteBusinessUnitId200>(
      {url: `/business_unit/${id}`, method: 'DELETE'
    },
      );
    }
  


export const getDeleteBusinessUnitIdMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteBusinessUnitId>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteBusinessUnitId>>, TError,{id: string}, TContext> => {
    
const mutationKey = ['deleteBusinessUnitId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteBusinessUnitId>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteBusinessUnitId(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteBusinessUnitIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteBusinessUnitId>>>
    
    export type DeleteBusinessUnitIdMutationError = void

    /**
 * @summary Delete a business_unit record
 */
export const useDeleteBusinessUnitId = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteBusinessUnitId>>, TError,{id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteBusinessUnitId>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getDeleteBusinessUnitIdMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Returns a list of business records with pagination
 * @summary Get all business records
 */
export const getBusiness = (
    params?: GetBusinessParams,
 signal?: AbortSignal
) => {
      
      
      return defaultInstance<GetBusiness200>(
      {url: `/business`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getGetBusinessQueryKey = (params?: GetBusinessParams,) => {
    return [`/business`, ...(params ? [params]: [])] as const;
    }

    
export const getGetBusinessQueryOptions = <TData = Awaited<ReturnType<typeof getBusiness>>, TError = void>(params?: GetBusinessParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBusiness>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetBusinessQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getBusiness>>> = ({ signal }) => getBusiness(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getBusiness>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetBusinessQueryResult = NonNullable<Awaited<ReturnType<typeof getBusiness>>>
export type GetBusinessQueryError = void


export function useGetBusiness<TData = Awaited<ReturnType<typeof getBusiness>>, TError = void>(
 params: undefined |  GetBusinessParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBusiness>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBusiness>>,
          TError,
          Awaited<ReturnType<typeof getBusiness>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBusiness<TData = Awaited<ReturnType<typeof getBusiness>>, TError = void>(
 params?: GetBusinessParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBusiness>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBusiness>>,
          TError,
          Awaited<ReturnType<typeof getBusiness>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBusiness<TData = Awaited<ReturnType<typeof getBusiness>>, TError = void>(
 params?: GetBusinessParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBusiness>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get all business records
 */

export function useGetBusiness<TData = Awaited<ReturnType<typeof getBusiness>>, TError = void>(
 params?: GetBusinessParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBusiness>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetBusinessQueryOptions(params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Creates a new business record
 * @summary Create a new business record
 */
export const postBusiness = (
    business: Business,
 signal?: AbortSignal
) => {
      
      
      return defaultInstance<PostBusiness200>(
      {url: `/business`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: business, signal
    },
      );
    }
  


export const getPostBusinessMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postBusiness>>, TError,{data: Business}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postBusiness>>, TError,{data: Business}, TContext> => {
    
const mutationKey = ['postBusiness'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postBusiness>>, {data: Business}> = (props) => {
          const {data} = props ?? {};

          return  postBusiness(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostBusinessMutationResult = NonNullable<Awaited<ReturnType<typeof postBusiness>>>
    export type PostBusinessMutationBody = Business
    export type PostBusinessMutationError = void

    /**
 * @summary Create a new business record
 */
export const usePostBusiness = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postBusiness>>, TError,{data: Business}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postBusiness>>,
        TError,
        {data: Business},
        TContext
      > => {

      const mutationOptions = getPostBusinessMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Returns a single business record by ID
 * @summary Get a specific business record
 */
export const getBusinessId = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return defaultInstance<GetBusinessId200>(
      {url: `/business/${id}`, method: 'GET', signal
    },
      );
    }
  

export const getGetBusinessIdQueryKey = (id: string,) => {
    return [`/business/${id}`] as const;
    }

    
export const getGetBusinessIdQueryOptions = <TData = Awaited<ReturnType<typeof getBusinessId>>, TError = void>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBusinessId>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetBusinessIdQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getBusinessId>>> = ({ signal }) => getBusinessId(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getBusinessId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetBusinessIdQueryResult = NonNullable<Awaited<ReturnType<typeof getBusinessId>>>
export type GetBusinessIdQueryError = void


export function useGetBusinessId<TData = Awaited<ReturnType<typeof getBusinessId>>, TError = void>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBusinessId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBusinessId>>,
          TError,
          Awaited<ReturnType<typeof getBusinessId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBusinessId<TData = Awaited<ReturnType<typeof getBusinessId>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBusinessId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBusinessId>>,
          TError,
          Awaited<ReturnType<typeof getBusinessId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBusinessId<TData = Awaited<ReturnType<typeof getBusinessId>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBusinessId>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get a specific business record
 */

export function useGetBusinessId<TData = Awaited<ReturnType<typeof getBusinessId>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBusinessId>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetBusinessIdQueryOptions(id,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Updates an existing business record
 * @summary Update a business record
 */
export const putBusinessId = (
    id: string,
    business: Business,
 ) => {
      
      
      return defaultInstance<PutBusinessId200>(
      {url: `/business/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: business
    },
      );
    }
  


export const getPutBusinessIdMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putBusinessId>>, TError,{id: string;data: Business}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof putBusinessId>>, TError,{id: string;data: Business}, TContext> => {
    
const mutationKey = ['putBusinessId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putBusinessId>>, {id: string;data: Business}> = (props) => {
          const {id,data} = props ?? {};

          return  putBusinessId(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutBusinessIdMutationResult = NonNullable<Awaited<ReturnType<typeof putBusinessId>>>
    export type PutBusinessIdMutationBody = Business
    export type PutBusinessIdMutationError = void

    /**
 * @summary Update a business record
 */
export const usePutBusinessId = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putBusinessId>>, TError,{id: string;data: Business}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putBusinessId>>,
        TError,
        {id: string;data: Business},
        TContext
      > => {

      const mutationOptions = getPutBusinessIdMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Partially updates an existing business record
 * @summary Partially update a business record
 */
export const patchBusinessId = (
    id: string,
    business: Business,
 ) => {
      
      
      return defaultInstance<PatchBusinessId200>(
      {url: `/business/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: business
    },
      );
    }
  


export const getPatchBusinessIdMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchBusinessId>>, TError,{id: string;data: Business}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof patchBusinessId>>, TError,{id: string;data: Business}, TContext> => {
    
const mutationKey = ['patchBusinessId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchBusinessId>>, {id: string;data: Business}> = (props) => {
          const {id,data} = props ?? {};

          return  patchBusinessId(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PatchBusinessIdMutationResult = NonNullable<Awaited<ReturnType<typeof patchBusinessId>>>
    export type PatchBusinessIdMutationBody = Business
    export type PatchBusinessIdMutationError = void

    /**
 * @summary Partially update a business record
 */
export const usePatchBusinessId = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchBusinessId>>, TError,{id: string;data: Business}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patchBusinessId>>,
        TError,
        {id: string;data: Business},
        TContext
      > => {

      const mutationOptions = getPatchBusinessIdMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Deletes a business record
 * @summary Delete a business record
 */
export const deleteBusinessId = (
    id: string,
 ) => {
      
      
      return defaultInstance<DeleteBusinessId200>(
      {url: `/business/${id}`, method: 'DELETE'
    },
      );
    }
  


export const getDeleteBusinessIdMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteBusinessId>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteBusinessId>>, TError,{id: string}, TContext> => {
    
const mutationKey = ['deleteBusinessId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteBusinessId>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteBusinessId(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteBusinessIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteBusinessId>>>
    
    export type DeleteBusinessIdMutationError = void

    /**
 * @summary Delete a business record
 */
export const useDeleteBusinessId = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteBusinessId>>, TError,{id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteBusinessId>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getDeleteBusinessIdMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Returns a list of article_group records with pagination
 * @summary Get all article_group records
 */
export const getArticleGroup = (
    params?: GetArticleGroupParams,
 signal?: AbortSignal
) => {
      
      
      return defaultInstance<GetArticleGroup200>(
      {url: `/article_group`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getGetArticleGroupQueryKey = (params?: GetArticleGroupParams,) => {
    return [`/article_group`, ...(params ? [params]: [])] as const;
    }

    
export const getGetArticleGroupQueryOptions = <TData = Awaited<ReturnType<typeof getArticleGroup>>, TError = void>(params?: GetArticleGroupParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getArticleGroup>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetArticleGroupQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getArticleGroup>>> = ({ signal }) => getArticleGroup(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getArticleGroup>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetArticleGroupQueryResult = NonNullable<Awaited<ReturnType<typeof getArticleGroup>>>
export type GetArticleGroupQueryError = void


export function useGetArticleGroup<TData = Awaited<ReturnType<typeof getArticleGroup>>, TError = void>(
 params: undefined |  GetArticleGroupParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getArticleGroup>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getArticleGroup>>,
          TError,
          Awaited<ReturnType<typeof getArticleGroup>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetArticleGroup<TData = Awaited<ReturnType<typeof getArticleGroup>>, TError = void>(
 params?: GetArticleGroupParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getArticleGroup>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getArticleGroup>>,
          TError,
          Awaited<ReturnType<typeof getArticleGroup>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetArticleGroup<TData = Awaited<ReturnType<typeof getArticleGroup>>, TError = void>(
 params?: GetArticleGroupParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getArticleGroup>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get all article_group records
 */

export function useGetArticleGroup<TData = Awaited<ReturnType<typeof getArticleGroup>>, TError = void>(
 params?: GetArticleGroupParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getArticleGroup>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetArticleGroupQueryOptions(params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Creates a new article_group record
 * @summary Create a new article_group record
 */
export const postArticleGroup = (
    articleGroup: ArticleGroup,
 signal?: AbortSignal
) => {
      
      
      return defaultInstance<PostArticleGroup200>(
      {url: `/article_group`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: articleGroup, signal
    },
      );
    }
  


export const getPostArticleGroupMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postArticleGroup>>, TError,{data: ArticleGroup}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postArticleGroup>>, TError,{data: ArticleGroup}, TContext> => {
    
const mutationKey = ['postArticleGroup'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postArticleGroup>>, {data: ArticleGroup}> = (props) => {
          const {data} = props ?? {};

          return  postArticleGroup(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostArticleGroupMutationResult = NonNullable<Awaited<ReturnType<typeof postArticleGroup>>>
    export type PostArticleGroupMutationBody = ArticleGroup
    export type PostArticleGroupMutationError = void

    /**
 * @summary Create a new article_group record
 */
export const usePostArticleGroup = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postArticleGroup>>, TError,{data: ArticleGroup}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postArticleGroup>>,
        TError,
        {data: ArticleGroup},
        TContext
      > => {

      const mutationOptions = getPostArticleGroupMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Returns a single article_group record by ID
 * @summary Get a specific article_group record
 */
export const getArticleGroupId = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return defaultInstance<GetArticleGroupId200>(
      {url: `/article_group/${id}`, method: 'GET', signal
    },
      );
    }
  

export const getGetArticleGroupIdQueryKey = (id: string,) => {
    return [`/article_group/${id}`] as const;
    }

    
export const getGetArticleGroupIdQueryOptions = <TData = Awaited<ReturnType<typeof getArticleGroupId>>, TError = void>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getArticleGroupId>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetArticleGroupIdQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getArticleGroupId>>> = ({ signal }) => getArticleGroupId(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getArticleGroupId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetArticleGroupIdQueryResult = NonNullable<Awaited<ReturnType<typeof getArticleGroupId>>>
export type GetArticleGroupIdQueryError = void


export function useGetArticleGroupId<TData = Awaited<ReturnType<typeof getArticleGroupId>>, TError = void>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getArticleGroupId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getArticleGroupId>>,
          TError,
          Awaited<ReturnType<typeof getArticleGroupId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetArticleGroupId<TData = Awaited<ReturnType<typeof getArticleGroupId>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getArticleGroupId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getArticleGroupId>>,
          TError,
          Awaited<ReturnType<typeof getArticleGroupId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetArticleGroupId<TData = Awaited<ReturnType<typeof getArticleGroupId>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getArticleGroupId>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get a specific article_group record
 */

export function useGetArticleGroupId<TData = Awaited<ReturnType<typeof getArticleGroupId>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getArticleGroupId>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetArticleGroupIdQueryOptions(id,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Updates an existing article_group record
 * @summary Update a article_group record
 */
export const putArticleGroupId = (
    id: string,
    articleGroup: ArticleGroup,
 ) => {
      
      
      return defaultInstance<PutArticleGroupId200>(
      {url: `/article_group/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: articleGroup
    },
      );
    }
  


export const getPutArticleGroupIdMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putArticleGroupId>>, TError,{id: string;data: ArticleGroup}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof putArticleGroupId>>, TError,{id: string;data: ArticleGroup}, TContext> => {
    
const mutationKey = ['putArticleGroupId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putArticleGroupId>>, {id: string;data: ArticleGroup}> = (props) => {
          const {id,data} = props ?? {};

          return  putArticleGroupId(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutArticleGroupIdMutationResult = NonNullable<Awaited<ReturnType<typeof putArticleGroupId>>>
    export type PutArticleGroupIdMutationBody = ArticleGroup
    export type PutArticleGroupIdMutationError = void

    /**
 * @summary Update a article_group record
 */
export const usePutArticleGroupId = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putArticleGroupId>>, TError,{id: string;data: ArticleGroup}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putArticleGroupId>>,
        TError,
        {id: string;data: ArticleGroup},
        TContext
      > => {

      const mutationOptions = getPutArticleGroupIdMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Partially updates an existing article_group record
 * @summary Partially update a article_group record
 */
export const patchArticleGroupId = (
    id: string,
    articleGroup: ArticleGroup,
 ) => {
      
      
      return defaultInstance<PatchArticleGroupId200>(
      {url: `/article_group/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: articleGroup
    },
      );
    }
  


export const getPatchArticleGroupIdMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchArticleGroupId>>, TError,{id: string;data: ArticleGroup}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof patchArticleGroupId>>, TError,{id: string;data: ArticleGroup}, TContext> => {
    
const mutationKey = ['patchArticleGroupId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchArticleGroupId>>, {id: string;data: ArticleGroup}> = (props) => {
          const {id,data} = props ?? {};

          return  patchArticleGroupId(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PatchArticleGroupIdMutationResult = NonNullable<Awaited<ReturnType<typeof patchArticleGroupId>>>
    export type PatchArticleGroupIdMutationBody = ArticleGroup
    export type PatchArticleGroupIdMutationError = void

    /**
 * @summary Partially update a article_group record
 */
export const usePatchArticleGroupId = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchArticleGroupId>>, TError,{id: string;data: ArticleGroup}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patchArticleGroupId>>,
        TError,
        {id: string;data: ArticleGroup},
        TContext
      > => {

      const mutationOptions = getPatchArticleGroupIdMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Deletes a article_group record
 * @summary Delete a article_group record
 */
export const deleteArticleGroupId = (
    id: string,
 ) => {
      
      
      return defaultInstance<DeleteArticleGroupId200>(
      {url: `/article_group/${id}`, method: 'DELETE'
    },
      );
    }
  


export const getDeleteArticleGroupIdMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteArticleGroupId>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteArticleGroupId>>, TError,{id: string}, TContext> => {
    
const mutationKey = ['deleteArticleGroupId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteArticleGroupId>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteArticleGroupId(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteArticleGroupIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteArticleGroupId>>>
    
    export type DeleteArticleGroupIdMutationError = void

    /**
 * @summary Delete a article_group record
 */
export const useDeleteArticleGroupId = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteArticleGroupId>>, TError,{id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteArticleGroupId>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getDeleteArticleGroupIdMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Returns a list of article_type records with pagination
 * @summary Get all article_type records
 */
export const getArticleType = (
    params?: GetArticleTypeParams,
 signal?: AbortSignal
) => {
      
      
      return defaultInstance<GetArticleType200>(
      {url: `/article_type`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getGetArticleTypeQueryKey = (params?: GetArticleTypeParams,) => {
    return [`/article_type`, ...(params ? [params]: [])] as const;
    }

    
export const getGetArticleTypeQueryOptions = <TData = Awaited<ReturnType<typeof getArticleType>>, TError = void>(params?: GetArticleTypeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getArticleType>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetArticleTypeQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getArticleType>>> = ({ signal }) => getArticleType(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getArticleType>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetArticleTypeQueryResult = NonNullable<Awaited<ReturnType<typeof getArticleType>>>
export type GetArticleTypeQueryError = void


export function useGetArticleType<TData = Awaited<ReturnType<typeof getArticleType>>, TError = void>(
 params: undefined |  GetArticleTypeParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getArticleType>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getArticleType>>,
          TError,
          Awaited<ReturnType<typeof getArticleType>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetArticleType<TData = Awaited<ReturnType<typeof getArticleType>>, TError = void>(
 params?: GetArticleTypeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getArticleType>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getArticleType>>,
          TError,
          Awaited<ReturnType<typeof getArticleType>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetArticleType<TData = Awaited<ReturnType<typeof getArticleType>>, TError = void>(
 params?: GetArticleTypeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getArticleType>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get all article_type records
 */

export function useGetArticleType<TData = Awaited<ReturnType<typeof getArticleType>>, TError = void>(
 params?: GetArticleTypeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getArticleType>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetArticleTypeQueryOptions(params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Creates a new article_type record
 * @summary Create a new article_type record
 */
export const postArticleType = (
    articleType: ArticleType,
 signal?: AbortSignal
) => {
      
      
      return defaultInstance<PostArticleType200>(
      {url: `/article_type`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: articleType, signal
    },
      );
    }
  


export const getPostArticleTypeMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postArticleType>>, TError,{data: ArticleType}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postArticleType>>, TError,{data: ArticleType}, TContext> => {
    
const mutationKey = ['postArticleType'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postArticleType>>, {data: ArticleType}> = (props) => {
          const {data} = props ?? {};

          return  postArticleType(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostArticleTypeMutationResult = NonNullable<Awaited<ReturnType<typeof postArticleType>>>
    export type PostArticleTypeMutationBody = ArticleType
    export type PostArticleTypeMutationError = void

    /**
 * @summary Create a new article_type record
 */
export const usePostArticleType = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postArticleType>>, TError,{data: ArticleType}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postArticleType>>,
        TError,
        {data: ArticleType},
        TContext
      > => {

      const mutationOptions = getPostArticleTypeMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Returns a single article_type record by ID
 * @summary Get a specific article_type record
 */
export const getArticleTypeId = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return defaultInstance<GetArticleTypeId200>(
      {url: `/article_type/${id}`, method: 'GET', signal
    },
      );
    }
  

export const getGetArticleTypeIdQueryKey = (id: string,) => {
    return [`/article_type/${id}`] as const;
    }

    
export const getGetArticleTypeIdQueryOptions = <TData = Awaited<ReturnType<typeof getArticleTypeId>>, TError = void>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getArticleTypeId>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetArticleTypeIdQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getArticleTypeId>>> = ({ signal }) => getArticleTypeId(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getArticleTypeId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetArticleTypeIdQueryResult = NonNullable<Awaited<ReturnType<typeof getArticleTypeId>>>
export type GetArticleTypeIdQueryError = void


export function useGetArticleTypeId<TData = Awaited<ReturnType<typeof getArticleTypeId>>, TError = void>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getArticleTypeId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getArticleTypeId>>,
          TError,
          Awaited<ReturnType<typeof getArticleTypeId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetArticleTypeId<TData = Awaited<ReturnType<typeof getArticleTypeId>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getArticleTypeId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getArticleTypeId>>,
          TError,
          Awaited<ReturnType<typeof getArticleTypeId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetArticleTypeId<TData = Awaited<ReturnType<typeof getArticleTypeId>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getArticleTypeId>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get a specific article_type record
 */

export function useGetArticleTypeId<TData = Awaited<ReturnType<typeof getArticleTypeId>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getArticleTypeId>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetArticleTypeIdQueryOptions(id,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Updates an existing article_type record
 * @summary Update a article_type record
 */
export const putArticleTypeId = (
    id: string,
    articleType: ArticleType,
 ) => {
      
      
      return defaultInstance<PutArticleTypeId200>(
      {url: `/article_type/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: articleType
    },
      );
    }
  


export const getPutArticleTypeIdMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putArticleTypeId>>, TError,{id: string;data: ArticleType}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof putArticleTypeId>>, TError,{id: string;data: ArticleType}, TContext> => {
    
const mutationKey = ['putArticleTypeId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putArticleTypeId>>, {id: string;data: ArticleType}> = (props) => {
          const {id,data} = props ?? {};

          return  putArticleTypeId(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutArticleTypeIdMutationResult = NonNullable<Awaited<ReturnType<typeof putArticleTypeId>>>
    export type PutArticleTypeIdMutationBody = ArticleType
    export type PutArticleTypeIdMutationError = void

    /**
 * @summary Update a article_type record
 */
export const usePutArticleTypeId = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putArticleTypeId>>, TError,{id: string;data: ArticleType}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putArticleTypeId>>,
        TError,
        {id: string;data: ArticleType},
        TContext
      > => {

      const mutationOptions = getPutArticleTypeIdMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Partially updates an existing article_type record
 * @summary Partially update a article_type record
 */
export const patchArticleTypeId = (
    id: string,
    articleType: ArticleType,
 ) => {
      
      
      return defaultInstance<PatchArticleTypeId200>(
      {url: `/article_type/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: articleType
    },
      );
    }
  


export const getPatchArticleTypeIdMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchArticleTypeId>>, TError,{id: string;data: ArticleType}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof patchArticleTypeId>>, TError,{id: string;data: ArticleType}, TContext> => {
    
const mutationKey = ['patchArticleTypeId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchArticleTypeId>>, {id: string;data: ArticleType}> = (props) => {
          const {id,data} = props ?? {};

          return  patchArticleTypeId(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PatchArticleTypeIdMutationResult = NonNullable<Awaited<ReturnType<typeof patchArticleTypeId>>>
    export type PatchArticleTypeIdMutationBody = ArticleType
    export type PatchArticleTypeIdMutationError = void

    /**
 * @summary Partially update a article_type record
 */
export const usePatchArticleTypeId = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchArticleTypeId>>, TError,{id: string;data: ArticleType}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patchArticleTypeId>>,
        TError,
        {id: string;data: ArticleType},
        TContext
      > => {

      const mutationOptions = getPatchArticleTypeIdMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Deletes a article_type record
 * @summary Delete a article_type record
 */
export const deleteArticleTypeId = (
    id: string,
 ) => {
      
      
      return defaultInstance<DeleteArticleTypeId200>(
      {url: `/article_type/${id}`, method: 'DELETE'
    },
      );
    }
  


export const getDeleteArticleTypeIdMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteArticleTypeId>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteArticleTypeId>>, TError,{id: string}, TContext> => {
    
const mutationKey = ['deleteArticleTypeId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteArticleTypeId>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteArticleTypeId(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteArticleTypeIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteArticleTypeId>>>
    
    export type DeleteArticleTypeIdMutationError = void

    /**
 * @summary Delete a article_type record
 */
export const useDeleteArticleTypeId = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteArticleTypeId>>, TError,{id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteArticleTypeId>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getDeleteArticleTypeIdMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Returns a list of article records with pagination
 * @summary Get all article records
 */
export const getArticle = (
    params?: GetArticleParams,
 signal?: AbortSignal
) => {
      
      
      return defaultInstance<GetArticle200>(
      {url: `/article`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getGetArticleQueryKey = (params?: GetArticleParams,) => {
    return [`/article`, ...(params ? [params]: [])] as const;
    }

    
export const getGetArticleQueryOptions = <TData = Awaited<ReturnType<typeof getArticle>>, TError = void>(params?: GetArticleParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getArticle>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetArticleQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getArticle>>> = ({ signal }) => getArticle(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getArticle>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetArticleQueryResult = NonNullable<Awaited<ReturnType<typeof getArticle>>>
export type GetArticleQueryError = void


export function useGetArticle<TData = Awaited<ReturnType<typeof getArticle>>, TError = void>(
 params: undefined |  GetArticleParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getArticle>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getArticle>>,
          TError,
          Awaited<ReturnType<typeof getArticle>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetArticle<TData = Awaited<ReturnType<typeof getArticle>>, TError = void>(
 params?: GetArticleParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getArticle>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getArticle>>,
          TError,
          Awaited<ReturnType<typeof getArticle>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetArticle<TData = Awaited<ReturnType<typeof getArticle>>, TError = void>(
 params?: GetArticleParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getArticle>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get all article records
 */

export function useGetArticle<TData = Awaited<ReturnType<typeof getArticle>>, TError = void>(
 params?: GetArticleParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getArticle>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetArticleQueryOptions(params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Creates a new article record
 * @summary Create a new article record
 */
export const postArticle = (
    article: Article,
 signal?: AbortSignal
) => {
      
      
      return defaultInstance<PostArticle200>(
      {url: `/article`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: article, signal
    },
      );
    }
  


export const getPostArticleMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postArticle>>, TError,{data: Article}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postArticle>>, TError,{data: Article}, TContext> => {
    
const mutationKey = ['postArticle'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postArticle>>, {data: Article}> = (props) => {
          const {data} = props ?? {};

          return  postArticle(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostArticleMutationResult = NonNullable<Awaited<ReturnType<typeof postArticle>>>
    export type PostArticleMutationBody = Article
    export type PostArticleMutationError = void

    /**
 * @summary Create a new article record
 */
export const usePostArticle = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postArticle>>, TError,{data: Article}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postArticle>>,
        TError,
        {data: Article},
        TContext
      > => {

      const mutationOptions = getPostArticleMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Returns a single article record by ID
 * @summary Get a specific article record
 */
export const getArticleId = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return defaultInstance<GetArticleId200>(
      {url: `/article/${id}`, method: 'GET', signal
    },
      );
    }
  

export const getGetArticleIdQueryKey = (id: string,) => {
    return [`/article/${id}`] as const;
    }

    
export const getGetArticleIdQueryOptions = <TData = Awaited<ReturnType<typeof getArticleId>>, TError = void>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getArticleId>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetArticleIdQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getArticleId>>> = ({ signal }) => getArticleId(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getArticleId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetArticleIdQueryResult = NonNullable<Awaited<ReturnType<typeof getArticleId>>>
export type GetArticleIdQueryError = void


export function useGetArticleId<TData = Awaited<ReturnType<typeof getArticleId>>, TError = void>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getArticleId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getArticleId>>,
          TError,
          Awaited<ReturnType<typeof getArticleId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetArticleId<TData = Awaited<ReturnType<typeof getArticleId>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getArticleId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getArticleId>>,
          TError,
          Awaited<ReturnType<typeof getArticleId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetArticleId<TData = Awaited<ReturnType<typeof getArticleId>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getArticleId>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get a specific article record
 */

export function useGetArticleId<TData = Awaited<ReturnType<typeof getArticleId>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getArticleId>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetArticleIdQueryOptions(id,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Updates an existing article record
 * @summary Update a article record
 */
export const putArticleId = (
    id: string,
    article: Article,
 ) => {
      
      
      return defaultInstance<PutArticleId200>(
      {url: `/article/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: article
    },
      );
    }
  


export const getPutArticleIdMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putArticleId>>, TError,{id: string;data: Article}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof putArticleId>>, TError,{id: string;data: Article}, TContext> => {
    
const mutationKey = ['putArticleId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putArticleId>>, {id: string;data: Article}> = (props) => {
          const {id,data} = props ?? {};

          return  putArticleId(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutArticleIdMutationResult = NonNullable<Awaited<ReturnType<typeof putArticleId>>>
    export type PutArticleIdMutationBody = Article
    export type PutArticleIdMutationError = void

    /**
 * @summary Update a article record
 */
export const usePutArticleId = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putArticleId>>, TError,{id: string;data: Article}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putArticleId>>,
        TError,
        {id: string;data: Article},
        TContext
      > => {

      const mutationOptions = getPutArticleIdMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Partially updates an existing article record
 * @summary Partially update a article record
 */
export const patchArticleId = (
    id: string,
    article: Article,
 ) => {
      
      
      return defaultInstance<PatchArticleId200>(
      {url: `/article/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: article
    },
      );
    }
  


export const getPatchArticleIdMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchArticleId>>, TError,{id: string;data: Article}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof patchArticleId>>, TError,{id: string;data: Article}, TContext> => {
    
const mutationKey = ['patchArticleId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchArticleId>>, {id: string;data: Article}> = (props) => {
          const {id,data} = props ?? {};

          return  patchArticleId(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PatchArticleIdMutationResult = NonNullable<Awaited<ReturnType<typeof patchArticleId>>>
    export type PatchArticleIdMutationBody = Article
    export type PatchArticleIdMutationError = void

    /**
 * @summary Partially update a article record
 */
export const usePatchArticleId = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchArticleId>>, TError,{id: string;data: Article}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patchArticleId>>,
        TError,
        {id: string;data: Article},
        TContext
      > => {

      const mutationOptions = getPatchArticleIdMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Deletes a article record
 * @summary Delete a article record
 */
export const deleteArticleId = (
    id: string,
 ) => {
      
      
      return defaultInstance<DeleteArticleId200>(
      {url: `/article/${id}`, method: 'DELETE'
    },
      );
    }
  


export const getDeleteArticleIdMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteArticleId>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteArticleId>>, TError,{id: string}, TContext> => {
    
const mutationKey = ['deleteArticleId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteArticleId>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteArticleId(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteArticleIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteArticleId>>>
    
    export type DeleteArticleIdMutationError = void

    /**
 * @summary Delete a article record
 */
export const useDeleteArticleId = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteArticleId>>, TError,{id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteArticleId>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getDeleteArticleIdMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Returns a list of notification records with pagination
 * @summary Get all notification records
 */
export const getNotification = (
    params?: GetNotificationParams,
 signal?: AbortSignal
) => {
      
      
      return defaultInstance<GetNotification200>(
      {url: `/notification`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getGetNotificationQueryKey = (params?: GetNotificationParams,) => {
    return [`/notification`, ...(params ? [params]: [])] as const;
    }

    
export const getGetNotificationQueryOptions = <TData = Awaited<ReturnType<typeof getNotification>>, TError = void>(params?: GetNotificationParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNotification>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetNotificationQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getNotification>>> = ({ signal }) => getNotification(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getNotification>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetNotificationQueryResult = NonNullable<Awaited<ReturnType<typeof getNotification>>>
export type GetNotificationQueryError = void


export function useGetNotification<TData = Awaited<ReturnType<typeof getNotification>>, TError = void>(
 params: undefined |  GetNotificationParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNotification>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getNotification>>,
          TError,
          Awaited<ReturnType<typeof getNotification>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetNotification<TData = Awaited<ReturnType<typeof getNotification>>, TError = void>(
 params?: GetNotificationParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNotification>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getNotification>>,
          TError,
          Awaited<ReturnType<typeof getNotification>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetNotification<TData = Awaited<ReturnType<typeof getNotification>>, TError = void>(
 params?: GetNotificationParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNotification>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get all notification records
 */

export function useGetNotification<TData = Awaited<ReturnType<typeof getNotification>>, TError = void>(
 params?: GetNotificationParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNotification>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetNotificationQueryOptions(params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Creates a new notification record
 * @summary Create a new notification record
 */
export const postNotification = (
    notification: Notification,
 signal?: AbortSignal
) => {
      
      
      return defaultInstance<PostNotification200>(
      {url: `/notification`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: notification, signal
    },
      );
    }
  


export const getPostNotificationMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postNotification>>, TError,{data: Notification}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postNotification>>, TError,{data: Notification}, TContext> => {
    
const mutationKey = ['postNotification'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postNotification>>, {data: Notification}> = (props) => {
          const {data} = props ?? {};

          return  postNotification(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostNotificationMutationResult = NonNullable<Awaited<ReturnType<typeof postNotification>>>
    export type PostNotificationMutationBody = Notification
    export type PostNotificationMutationError = void

    /**
 * @summary Create a new notification record
 */
export const usePostNotification = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postNotification>>, TError,{data: Notification}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postNotification>>,
        TError,
        {data: Notification},
        TContext
      > => {

      const mutationOptions = getPostNotificationMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Returns a single notification record by ID
 * @summary Get a specific notification record
 */
export const getNotificationId = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return defaultInstance<GetNotificationId200>(
      {url: `/notification/${id}`, method: 'GET', signal
    },
      );
    }
  

export const getGetNotificationIdQueryKey = (id: string,) => {
    return [`/notification/${id}`] as const;
    }

    
export const getGetNotificationIdQueryOptions = <TData = Awaited<ReturnType<typeof getNotificationId>>, TError = void>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNotificationId>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetNotificationIdQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getNotificationId>>> = ({ signal }) => getNotificationId(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getNotificationId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetNotificationIdQueryResult = NonNullable<Awaited<ReturnType<typeof getNotificationId>>>
export type GetNotificationIdQueryError = void


export function useGetNotificationId<TData = Awaited<ReturnType<typeof getNotificationId>>, TError = void>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNotificationId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getNotificationId>>,
          TError,
          Awaited<ReturnType<typeof getNotificationId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetNotificationId<TData = Awaited<ReturnType<typeof getNotificationId>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNotificationId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getNotificationId>>,
          TError,
          Awaited<ReturnType<typeof getNotificationId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetNotificationId<TData = Awaited<ReturnType<typeof getNotificationId>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNotificationId>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get a specific notification record
 */

export function useGetNotificationId<TData = Awaited<ReturnType<typeof getNotificationId>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNotificationId>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetNotificationIdQueryOptions(id,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Updates an existing notification record
 * @summary Update a notification record
 */
export const putNotificationId = (
    id: string,
    notification: Notification,
 ) => {
      
      
      return defaultInstance<PutNotificationId200>(
      {url: `/notification/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: notification
    },
      );
    }
  


export const getPutNotificationIdMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putNotificationId>>, TError,{id: string;data: Notification}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof putNotificationId>>, TError,{id: string;data: Notification}, TContext> => {
    
const mutationKey = ['putNotificationId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putNotificationId>>, {id: string;data: Notification}> = (props) => {
          const {id,data} = props ?? {};

          return  putNotificationId(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutNotificationIdMutationResult = NonNullable<Awaited<ReturnType<typeof putNotificationId>>>
    export type PutNotificationIdMutationBody = Notification
    export type PutNotificationIdMutationError = void

    /**
 * @summary Update a notification record
 */
export const usePutNotificationId = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putNotificationId>>, TError,{id: string;data: Notification}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putNotificationId>>,
        TError,
        {id: string;data: Notification},
        TContext
      > => {

      const mutationOptions = getPutNotificationIdMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Partially updates an existing notification record
 * @summary Partially update a notification record
 */
export const patchNotificationId = (
    id: string,
    notification: Notification,
 ) => {
      
      
      return defaultInstance<PatchNotificationId200>(
      {url: `/notification/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: notification
    },
      );
    }
  


export const getPatchNotificationIdMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchNotificationId>>, TError,{id: string;data: Notification}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof patchNotificationId>>, TError,{id: string;data: Notification}, TContext> => {
    
const mutationKey = ['patchNotificationId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchNotificationId>>, {id: string;data: Notification}> = (props) => {
          const {id,data} = props ?? {};

          return  patchNotificationId(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PatchNotificationIdMutationResult = NonNullable<Awaited<ReturnType<typeof patchNotificationId>>>
    export type PatchNotificationIdMutationBody = Notification
    export type PatchNotificationIdMutationError = void

    /**
 * @summary Partially update a notification record
 */
export const usePatchNotificationId = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchNotificationId>>, TError,{id: string;data: Notification}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patchNotificationId>>,
        TError,
        {id: string;data: Notification},
        TContext
      > => {

      const mutationOptions = getPatchNotificationIdMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Deletes a notification record
 * @summary Delete a notification record
 */
export const deleteNotificationId = (
    id: string,
 ) => {
      
      
      return defaultInstance<DeleteNotificationId200>(
      {url: `/notification/${id}`, method: 'DELETE'
    },
      );
    }
  


export const getDeleteNotificationIdMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteNotificationId>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteNotificationId>>, TError,{id: string}, TContext> => {
    
const mutationKey = ['deleteNotificationId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteNotificationId>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteNotificationId(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteNotificationIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteNotificationId>>>
    
    export type DeleteNotificationIdMutationError = void

    /**
 * @summary Delete a notification record
 */
export const useDeleteNotificationId = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteNotificationId>>, TError,{id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteNotificationId>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getDeleteNotificationIdMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Returns a list of user_notification_activity records with pagination
 * @summary Get all user_notification_activity records
 */
export const getUserNotificationActivity = (
    params?: GetUserNotificationActivityParams,
 signal?: AbortSignal
) => {
      
      
      return defaultInstance<GetUserNotificationActivity200>(
      {url: `/user_notification_activity`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getGetUserNotificationActivityQueryKey = (params?: GetUserNotificationActivityParams,) => {
    return [`/user_notification_activity`, ...(params ? [params]: [])] as const;
    }

    
export const getGetUserNotificationActivityQueryOptions = <TData = Awaited<ReturnType<typeof getUserNotificationActivity>>, TError = void>(params?: GetUserNotificationActivityParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserNotificationActivity>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUserNotificationActivityQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUserNotificationActivity>>> = ({ signal }) => getUserNotificationActivity(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getUserNotificationActivity>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetUserNotificationActivityQueryResult = NonNullable<Awaited<ReturnType<typeof getUserNotificationActivity>>>
export type GetUserNotificationActivityQueryError = void


export function useGetUserNotificationActivity<TData = Awaited<ReturnType<typeof getUserNotificationActivity>>, TError = void>(
 params: undefined |  GetUserNotificationActivityParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserNotificationActivity>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserNotificationActivity>>,
          TError,
          Awaited<ReturnType<typeof getUserNotificationActivity>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUserNotificationActivity<TData = Awaited<ReturnType<typeof getUserNotificationActivity>>, TError = void>(
 params?: GetUserNotificationActivityParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserNotificationActivity>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserNotificationActivity>>,
          TError,
          Awaited<ReturnType<typeof getUserNotificationActivity>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUserNotificationActivity<TData = Awaited<ReturnType<typeof getUserNotificationActivity>>, TError = void>(
 params?: GetUserNotificationActivityParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserNotificationActivity>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get all user_notification_activity records
 */

export function useGetUserNotificationActivity<TData = Awaited<ReturnType<typeof getUserNotificationActivity>>, TError = void>(
 params?: GetUserNotificationActivityParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserNotificationActivity>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetUserNotificationActivityQueryOptions(params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Creates a new user_notification_activity record
 * @summary Create a new user_notification_activity record
 */
export const postUserNotificationActivity = (
    userNotificationActivity: UserNotificationActivity,
 signal?: AbortSignal
) => {
      
      
      return defaultInstance<PostUserNotificationActivity200>(
      {url: `/user_notification_activity`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: userNotificationActivity, signal
    },
      );
    }
  


export const getPostUserNotificationActivityMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postUserNotificationActivity>>, TError,{data: UserNotificationActivity}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postUserNotificationActivity>>, TError,{data: UserNotificationActivity}, TContext> => {
    
const mutationKey = ['postUserNotificationActivity'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postUserNotificationActivity>>, {data: UserNotificationActivity}> = (props) => {
          const {data} = props ?? {};

          return  postUserNotificationActivity(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostUserNotificationActivityMutationResult = NonNullable<Awaited<ReturnType<typeof postUserNotificationActivity>>>
    export type PostUserNotificationActivityMutationBody = UserNotificationActivity
    export type PostUserNotificationActivityMutationError = void

    /**
 * @summary Create a new user_notification_activity record
 */
export const usePostUserNotificationActivity = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postUserNotificationActivity>>, TError,{data: UserNotificationActivity}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postUserNotificationActivity>>,
        TError,
        {data: UserNotificationActivity},
        TContext
      > => {

      const mutationOptions = getPostUserNotificationActivityMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Returns a single user_notification_activity record by ID
 * @summary Get a specific user_notification_activity record
 */
export const getUserNotificationActivityId = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return defaultInstance<GetUserNotificationActivityId200>(
      {url: `/user_notification_activity/${id}`, method: 'GET', signal
    },
      );
    }
  

export const getGetUserNotificationActivityIdQueryKey = (id: string,) => {
    return [`/user_notification_activity/${id}`] as const;
    }

    
export const getGetUserNotificationActivityIdQueryOptions = <TData = Awaited<ReturnType<typeof getUserNotificationActivityId>>, TError = void>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserNotificationActivityId>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUserNotificationActivityIdQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUserNotificationActivityId>>> = ({ signal }) => getUserNotificationActivityId(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getUserNotificationActivityId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetUserNotificationActivityIdQueryResult = NonNullable<Awaited<ReturnType<typeof getUserNotificationActivityId>>>
export type GetUserNotificationActivityIdQueryError = void


export function useGetUserNotificationActivityId<TData = Awaited<ReturnType<typeof getUserNotificationActivityId>>, TError = void>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserNotificationActivityId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserNotificationActivityId>>,
          TError,
          Awaited<ReturnType<typeof getUserNotificationActivityId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUserNotificationActivityId<TData = Awaited<ReturnType<typeof getUserNotificationActivityId>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserNotificationActivityId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserNotificationActivityId>>,
          TError,
          Awaited<ReturnType<typeof getUserNotificationActivityId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUserNotificationActivityId<TData = Awaited<ReturnType<typeof getUserNotificationActivityId>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserNotificationActivityId>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get a specific user_notification_activity record
 */

export function useGetUserNotificationActivityId<TData = Awaited<ReturnType<typeof getUserNotificationActivityId>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserNotificationActivityId>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetUserNotificationActivityIdQueryOptions(id,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Updates an existing user_notification_activity record
 * @summary Update a user_notification_activity record
 */
export const putUserNotificationActivityId = (
    id: string,
    userNotificationActivity: UserNotificationActivity,
 ) => {
      
      
      return defaultInstance<PutUserNotificationActivityId200>(
      {url: `/user_notification_activity/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: userNotificationActivity
    },
      );
    }
  


export const getPutUserNotificationActivityIdMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putUserNotificationActivityId>>, TError,{id: string;data: UserNotificationActivity}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof putUserNotificationActivityId>>, TError,{id: string;data: UserNotificationActivity}, TContext> => {
    
const mutationKey = ['putUserNotificationActivityId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putUserNotificationActivityId>>, {id: string;data: UserNotificationActivity}> = (props) => {
          const {id,data} = props ?? {};

          return  putUserNotificationActivityId(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutUserNotificationActivityIdMutationResult = NonNullable<Awaited<ReturnType<typeof putUserNotificationActivityId>>>
    export type PutUserNotificationActivityIdMutationBody = UserNotificationActivity
    export type PutUserNotificationActivityIdMutationError = void

    /**
 * @summary Update a user_notification_activity record
 */
export const usePutUserNotificationActivityId = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putUserNotificationActivityId>>, TError,{id: string;data: UserNotificationActivity}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putUserNotificationActivityId>>,
        TError,
        {id: string;data: UserNotificationActivity},
        TContext
      > => {

      const mutationOptions = getPutUserNotificationActivityIdMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Partially updates an existing user_notification_activity record
 * @summary Partially update a user_notification_activity record
 */
export const patchUserNotificationActivityId = (
    id: string,
    userNotificationActivity: UserNotificationActivity,
 ) => {
      
      
      return defaultInstance<PatchUserNotificationActivityId200>(
      {url: `/user_notification_activity/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: userNotificationActivity
    },
      );
    }
  


export const getPatchUserNotificationActivityIdMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchUserNotificationActivityId>>, TError,{id: string;data: UserNotificationActivity}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof patchUserNotificationActivityId>>, TError,{id: string;data: UserNotificationActivity}, TContext> => {
    
const mutationKey = ['patchUserNotificationActivityId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchUserNotificationActivityId>>, {id: string;data: UserNotificationActivity}> = (props) => {
          const {id,data} = props ?? {};

          return  patchUserNotificationActivityId(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PatchUserNotificationActivityIdMutationResult = NonNullable<Awaited<ReturnType<typeof patchUserNotificationActivityId>>>
    export type PatchUserNotificationActivityIdMutationBody = UserNotificationActivity
    export type PatchUserNotificationActivityIdMutationError = void

    /**
 * @summary Partially update a user_notification_activity record
 */
export const usePatchUserNotificationActivityId = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchUserNotificationActivityId>>, TError,{id: string;data: UserNotificationActivity}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patchUserNotificationActivityId>>,
        TError,
        {id: string;data: UserNotificationActivity},
        TContext
      > => {

      const mutationOptions = getPatchUserNotificationActivityIdMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Deletes a user_notification_activity record
 * @summary Delete a user_notification_activity record
 */
export const deleteUserNotificationActivityId = (
    id: string,
 ) => {
      
      
      return defaultInstance<DeleteUserNotificationActivityId200>(
      {url: `/user_notification_activity/${id}`, method: 'DELETE'
    },
      );
    }
  


export const getDeleteUserNotificationActivityIdMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteUserNotificationActivityId>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteUserNotificationActivityId>>, TError,{id: string}, TContext> => {
    
const mutationKey = ['deleteUserNotificationActivityId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteUserNotificationActivityId>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteUserNotificationActivityId(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteUserNotificationActivityIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteUserNotificationActivityId>>>
    
    export type DeleteUserNotificationActivityIdMutationError = void

    /**
 * @summary Delete a user_notification_activity record
 */
export const useDeleteUserNotificationActivityId = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteUserNotificationActivityId>>, TError,{id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteUserNotificationActivityId>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getDeleteUserNotificationActivityIdMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Returns a list of sponsorship records with pagination
 * @summary Get all sponsorship records
 */
export const getSponsorship = (
    params?: GetSponsorshipParams,
 signal?: AbortSignal
) => {
      
      
      return defaultInstance<GetSponsorship200>(
      {url: `/sponsorship`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getGetSponsorshipQueryKey = (params?: GetSponsorshipParams,) => {
    return [`/sponsorship`, ...(params ? [params]: [])] as const;
    }

    
export const getGetSponsorshipQueryOptions = <TData = Awaited<ReturnType<typeof getSponsorship>>, TError = void>(params?: GetSponsorshipParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSponsorship>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSponsorshipQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSponsorship>>> = ({ signal }) => getSponsorship(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSponsorship>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetSponsorshipQueryResult = NonNullable<Awaited<ReturnType<typeof getSponsorship>>>
export type GetSponsorshipQueryError = void


export function useGetSponsorship<TData = Awaited<ReturnType<typeof getSponsorship>>, TError = void>(
 params: undefined |  GetSponsorshipParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSponsorship>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSponsorship>>,
          TError,
          Awaited<ReturnType<typeof getSponsorship>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSponsorship<TData = Awaited<ReturnType<typeof getSponsorship>>, TError = void>(
 params?: GetSponsorshipParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSponsorship>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSponsorship>>,
          TError,
          Awaited<ReturnType<typeof getSponsorship>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSponsorship<TData = Awaited<ReturnType<typeof getSponsorship>>, TError = void>(
 params?: GetSponsorshipParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSponsorship>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get all sponsorship records
 */

export function useGetSponsorship<TData = Awaited<ReturnType<typeof getSponsorship>>, TError = void>(
 params?: GetSponsorshipParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSponsorship>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetSponsorshipQueryOptions(params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Creates a new sponsorship record
 * @summary Create a new sponsorship record
 */
export const postSponsorship = (
    sponsorship: Sponsorship,
 signal?: AbortSignal
) => {
      
      
      return defaultInstance<PostSponsorship200>(
      {url: `/sponsorship`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: sponsorship, signal
    },
      );
    }
  


export const getPostSponsorshipMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postSponsorship>>, TError,{data: Sponsorship}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postSponsorship>>, TError,{data: Sponsorship}, TContext> => {
    
const mutationKey = ['postSponsorship'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postSponsorship>>, {data: Sponsorship}> = (props) => {
          const {data} = props ?? {};

          return  postSponsorship(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostSponsorshipMutationResult = NonNullable<Awaited<ReturnType<typeof postSponsorship>>>
    export type PostSponsorshipMutationBody = Sponsorship
    export type PostSponsorshipMutationError = void

    /**
 * @summary Create a new sponsorship record
 */
export const usePostSponsorship = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postSponsorship>>, TError,{data: Sponsorship}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postSponsorship>>,
        TError,
        {data: Sponsorship},
        TContext
      > => {

      const mutationOptions = getPostSponsorshipMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Returns a single sponsorship record by ID
 * @summary Get a specific sponsorship record
 */
export const getSponsorshipId = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return defaultInstance<GetSponsorshipId200>(
      {url: `/sponsorship/${id}`, method: 'GET', signal
    },
      );
    }
  

export const getGetSponsorshipIdQueryKey = (id: string,) => {
    return [`/sponsorship/${id}`] as const;
    }

    
export const getGetSponsorshipIdQueryOptions = <TData = Awaited<ReturnType<typeof getSponsorshipId>>, TError = void>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSponsorshipId>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSponsorshipIdQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSponsorshipId>>> = ({ signal }) => getSponsorshipId(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSponsorshipId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetSponsorshipIdQueryResult = NonNullable<Awaited<ReturnType<typeof getSponsorshipId>>>
export type GetSponsorshipIdQueryError = void


export function useGetSponsorshipId<TData = Awaited<ReturnType<typeof getSponsorshipId>>, TError = void>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSponsorshipId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSponsorshipId>>,
          TError,
          Awaited<ReturnType<typeof getSponsorshipId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSponsorshipId<TData = Awaited<ReturnType<typeof getSponsorshipId>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSponsorshipId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSponsorshipId>>,
          TError,
          Awaited<ReturnType<typeof getSponsorshipId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSponsorshipId<TData = Awaited<ReturnType<typeof getSponsorshipId>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSponsorshipId>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get a specific sponsorship record
 */

export function useGetSponsorshipId<TData = Awaited<ReturnType<typeof getSponsorshipId>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSponsorshipId>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetSponsorshipIdQueryOptions(id,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Updates an existing sponsorship record
 * @summary Update a sponsorship record
 */
export const putSponsorshipId = (
    id: string,
    sponsorship: Sponsorship,
 ) => {
      
      
      return defaultInstance<PutSponsorshipId200>(
      {url: `/sponsorship/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: sponsorship
    },
      );
    }
  


export const getPutSponsorshipIdMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putSponsorshipId>>, TError,{id: string;data: Sponsorship}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof putSponsorshipId>>, TError,{id: string;data: Sponsorship}, TContext> => {
    
const mutationKey = ['putSponsorshipId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putSponsorshipId>>, {id: string;data: Sponsorship}> = (props) => {
          const {id,data} = props ?? {};

          return  putSponsorshipId(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutSponsorshipIdMutationResult = NonNullable<Awaited<ReturnType<typeof putSponsorshipId>>>
    export type PutSponsorshipIdMutationBody = Sponsorship
    export type PutSponsorshipIdMutationError = void

    /**
 * @summary Update a sponsorship record
 */
export const usePutSponsorshipId = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putSponsorshipId>>, TError,{id: string;data: Sponsorship}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putSponsorshipId>>,
        TError,
        {id: string;data: Sponsorship},
        TContext
      > => {

      const mutationOptions = getPutSponsorshipIdMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Partially updates an existing sponsorship record
 * @summary Partially update a sponsorship record
 */
export const patchSponsorshipId = (
    id: string,
    sponsorship: Sponsorship,
 ) => {
      
      
      return defaultInstance<PatchSponsorshipId200>(
      {url: `/sponsorship/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: sponsorship
    },
      );
    }
  


export const getPatchSponsorshipIdMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchSponsorshipId>>, TError,{id: string;data: Sponsorship}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof patchSponsorshipId>>, TError,{id: string;data: Sponsorship}, TContext> => {
    
const mutationKey = ['patchSponsorshipId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchSponsorshipId>>, {id: string;data: Sponsorship}> = (props) => {
          const {id,data} = props ?? {};

          return  patchSponsorshipId(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PatchSponsorshipIdMutationResult = NonNullable<Awaited<ReturnType<typeof patchSponsorshipId>>>
    export type PatchSponsorshipIdMutationBody = Sponsorship
    export type PatchSponsorshipIdMutationError = void

    /**
 * @summary Partially update a sponsorship record
 */
export const usePatchSponsorshipId = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchSponsorshipId>>, TError,{id: string;data: Sponsorship}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patchSponsorshipId>>,
        TError,
        {id: string;data: Sponsorship},
        TContext
      > => {

      const mutationOptions = getPatchSponsorshipIdMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Deletes a sponsorship record
 * @summary Delete a sponsorship record
 */
export const deleteSponsorshipId = (
    id: string,
 ) => {
      
      
      return defaultInstance<DeleteSponsorshipId200>(
      {url: `/sponsorship/${id}`, method: 'DELETE'
    },
      );
    }
  


export const getDeleteSponsorshipIdMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteSponsorshipId>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteSponsorshipId>>, TError,{id: string}, TContext> => {
    
const mutationKey = ['deleteSponsorshipId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteSponsorshipId>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteSponsorshipId(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteSponsorshipIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteSponsorshipId>>>
    
    export type DeleteSponsorshipIdMutationError = void

    /**
 * @summary Delete a sponsorship record
 */
export const useDeleteSponsorshipId = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteSponsorshipId>>, TError,{id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteSponsorshipId>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getDeleteSponsorshipIdMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Returns a list of user_business_viewed records with pagination
 * @summary Get all user_business_viewed records
 */
export const getUserBusinessViewed = (
    params?: GetUserBusinessViewedParams,
 signal?: AbortSignal
) => {
      
      
      return defaultInstance<GetUserBusinessViewed200>(
      {url: `/user_business_viewed`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getGetUserBusinessViewedQueryKey = (params?: GetUserBusinessViewedParams,) => {
    return [`/user_business_viewed`, ...(params ? [params]: [])] as const;
    }

    
export const getGetUserBusinessViewedQueryOptions = <TData = Awaited<ReturnType<typeof getUserBusinessViewed>>, TError = void>(params?: GetUserBusinessViewedParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserBusinessViewed>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUserBusinessViewedQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUserBusinessViewed>>> = ({ signal }) => getUserBusinessViewed(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getUserBusinessViewed>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetUserBusinessViewedQueryResult = NonNullable<Awaited<ReturnType<typeof getUserBusinessViewed>>>
export type GetUserBusinessViewedQueryError = void


export function useGetUserBusinessViewed<TData = Awaited<ReturnType<typeof getUserBusinessViewed>>, TError = void>(
 params: undefined |  GetUserBusinessViewedParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserBusinessViewed>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserBusinessViewed>>,
          TError,
          Awaited<ReturnType<typeof getUserBusinessViewed>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUserBusinessViewed<TData = Awaited<ReturnType<typeof getUserBusinessViewed>>, TError = void>(
 params?: GetUserBusinessViewedParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserBusinessViewed>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserBusinessViewed>>,
          TError,
          Awaited<ReturnType<typeof getUserBusinessViewed>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUserBusinessViewed<TData = Awaited<ReturnType<typeof getUserBusinessViewed>>, TError = void>(
 params?: GetUserBusinessViewedParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserBusinessViewed>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get all user_business_viewed records
 */

export function useGetUserBusinessViewed<TData = Awaited<ReturnType<typeof getUserBusinessViewed>>, TError = void>(
 params?: GetUserBusinessViewedParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserBusinessViewed>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetUserBusinessViewedQueryOptions(params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Creates a new user_business_viewed record
 * @summary Create a new user_business_viewed record
 */
export const postUserBusinessViewed = (
    userBusinessViewed: UserBusinessViewed,
 signal?: AbortSignal
) => {
      
      
      return defaultInstance<PostUserBusinessViewed200>(
      {url: `/user_business_viewed`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: userBusinessViewed, signal
    },
      );
    }
  


export const getPostUserBusinessViewedMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postUserBusinessViewed>>, TError,{data: UserBusinessViewed}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postUserBusinessViewed>>, TError,{data: UserBusinessViewed}, TContext> => {
    
const mutationKey = ['postUserBusinessViewed'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postUserBusinessViewed>>, {data: UserBusinessViewed}> = (props) => {
          const {data} = props ?? {};

          return  postUserBusinessViewed(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostUserBusinessViewedMutationResult = NonNullable<Awaited<ReturnType<typeof postUserBusinessViewed>>>
    export type PostUserBusinessViewedMutationBody = UserBusinessViewed
    export type PostUserBusinessViewedMutationError = void

    /**
 * @summary Create a new user_business_viewed record
 */
export const usePostUserBusinessViewed = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postUserBusinessViewed>>, TError,{data: UserBusinessViewed}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postUserBusinessViewed>>,
        TError,
        {data: UserBusinessViewed},
        TContext
      > => {

      const mutationOptions = getPostUserBusinessViewedMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Returns a single user_business_viewed record by ID
 * @summary Get a specific user_business_viewed record
 */
export const getUserBusinessViewedId = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return defaultInstance<GetUserBusinessViewedId200>(
      {url: `/user_business_viewed/${id}`, method: 'GET', signal
    },
      );
    }
  

export const getGetUserBusinessViewedIdQueryKey = (id: string,) => {
    return [`/user_business_viewed/${id}`] as const;
    }

    
export const getGetUserBusinessViewedIdQueryOptions = <TData = Awaited<ReturnType<typeof getUserBusinessViewedId>>, TError = void>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserBusinessViewedId>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUserBusinessViewedIdQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUserBusinessViewedId>>> = ({ signal }) => getUserBusinessViewedId(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getUserBusinessViewedId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetUserBusinessViewedIdQueryResult = NonNullable<Awaited<ReturnType<typeof getUserBusinessViewedId>>>
export type GetUserBusinessViewedIdQueryError = void


export function useGetUserBusinessViewedId<TData = Awaited<ReturnType<typeof getUserBusinessViewedId>>, TError = void>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserBusinessViewedId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserBusinessViewedId>>,
          TError,
          Awaited<ReturnType<typeof getUserBusinessViewedId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUserBusinessViewedId<TData = Awaited<ReturnType<typeof getUserBusinessViewedId>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserBusinessViewedId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserBusinessViewedId>>,
          TError,
          Awaited<ReturnType<typeof getUserBusinessViewedId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUserBusinessViewedId<TData = Awaited<ReturnType<typeof getUserBusinessViewedId>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserBusinessViewedId>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get a specific user_business_viewed record
 */

export function useGetUserBusinessViewedId<TData = Awaited<ReturnType<typeof getUserBusinessViewedId>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserBusinessViewedId>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetUserBusinessViewedIdQueryOptions(id,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Updates an existing user_business_viewed record
 * @summary Update a user_business_viewed record
 */
export const putUserBusinessViewedId = (
    id: string,
    userBusinessViewed: UserBusinessViewed,
 ) => {
      
      
      return defaultInstance<PutUserBusinessViewedId200>(
      {url: `/user_business_viewed/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: userBusinessViewed
    },
      );
    }
  


export const getPutUserBusinessViewedIdMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putUserBusinessViewedId>>, TError,{id: string;data: UserBusinessViewed}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof putUserBusinessViewedId>>, TError,{id: string;data: UserBusinessViewed}, TContext> => {
    
const mutationKey = ['putUserBusinessViewedId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putUserBusinessViewedId>>, {id: string;data: UserBusinessViewed}> = (props) => {
          const {id,data} = props ?? {};

          return  putUserBusinessViewedId(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutUserBusinessViewedIdMutationResult = NonNullable<Awaited<ReturnType<typeof putUserBusinessViewedId>>>
    export type PutUserBusinessViewedIdMutationBody = UserBusinessViewed
    export type PutUserBusinessViewedIdMutationError = void

    /**
 * @summary Update a user_business_viewed record
 */
export const usePutUserBusinessViewedId = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putUserBusinessViewedId>>, TError,{id: string;data: UserBusinessViewed}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putUserBusinessViewedId>>,
        TError,
        {id: string;data: UserBusinessViewed},
        TContext
      > => {

      const mutationOptions = getPutUserBusinessViewedIdMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Partially updates an existing user_business_viewed record
 * @summary Partially update a user_business_viewed record
 */
export const patchUserBusinessViewedId = (
    id: string,
    userBusinessViewed: UserBusinessViewed,
 ) => {
      
      
      return defaultInstance<PatchUserBusinessViewedId200>(
      {url: `/user_business_viewed/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: userBusinessViewed
    },
      );
    }
  


export const getPatchUserBusinessViewedIdMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchUserBusinessViewedId>>, TError,{id: string;data: UserBusinessViewed}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof patchUserBusinessViewedId>>, TError,{id: string;data: UserBusinessViewed}, TContext> => {
    
const mutationKey = ['patchUserBusinessViewedId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchUserBusinessViewedId>>, {id: string;data: UserBusinessViewed}> = (props) => {
          const {id,data} = props ?? {};

          return  patchUserBusinessViewedId(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PatchUserBusinessViewedIdMutationResult = NonNullable<Awaited<ReturnType<typeof patchUserBusinessViewedId>>>
    export type PatchUserBusinessViewedIdMutationBody = UserBusinessViewed
    export type PatchUserBusinessViewedIdMutationError = void

    /**
 * @summary Partially update a user_business_viewed record
 */
export const usePatchUserBusinessViewedId = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchUserBusinessViewedId>>, TError,{id: string;data: UserBusinessViewed}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patchUserBusinessViewedId>>,
        TError,
        {id: string;data: UserBusinessViewed},
        TContext
      > => {

      const mutationOptions = getPatchUserBusinessViewedIdMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Deletes a user_business_viewed record
 * @summary Delete a user_business_viewed record
 */
export const deleteUserBusinessViewedId = (
    id: string,
 ) => {
      
      
      return defaultInstance<DeleteUserBusinessViewedId200>(
      {url: `/user_business_viewed/${id}`, method: 'DELETE'
    },
      );
    }
  


export const getDeleteUserBusinessViewedIdMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteUserBusinessViewedId>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteUserBusinessViewedId>>, TError,{id: string}, TContext> => {
    
const mutationKey = ['deleteUserBusinessViewedId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteUserBusinessViewedId>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteUserBusinessViewedId(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteUserBusinessViewedIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteUserBusinessViewedId>>>
    
    export type DeleteUserBusinessViewedIdMutationError = void

    /**
 * @summary Delete a user_business_viewed record
 */
export const useDeleteUserBusinessViewedId = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteUserBusinessViewedId>>, TError,{id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteUserBusinessViewedId>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getDeleteUserBusinessViewedIdMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Returns a list of business_access_type records with pagination
 * @summary Get all business_access_type records
 */
export const getBusinessAccessType = (
    params?: GetBusinessAccessTypeParams,
 signal?: AbortSignal
) => {
      
      
      return defaultInstance<GetBusinessAccessType200>(
      {url: `/business_access_type`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getGetBusinessAccessTypeQueryKey = (params?: GetBusinessAccessTypeParams,) => {
    return [`/business_access_type`, ...(params ? [params]: [])] as const;
    }

    
export const getGetBusinessAccessTypeQueryOptions = <TData = Awaited<ReturnType<typeof getBusinessAccessType>>, TError = void>(params?: GetBusinessAccessTypeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBusinessAccessType>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetBusinessAccessTypeQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getBusinessAccessType>>> = ({ signal }) => getBusinessAccessType(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getBusinessAccessType>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetBusinessAccessTypeQueryResult = NonNullable<Awaited<ReturnType<typeof getBusinessAccessType>>>
export type GetBusinessAccessTypeQueryError = void


export function useGetBusinessAccessType<TData = Awaited<ReturnType<typeof getBusinessAccessType>>, TError = void>(
 params: undefined |  GetBusinessAccessTypeParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBusinessAccessType>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBusinessAccessType>>,
          TError,
          Awaited<ReturnType<typeof getBusinessAccessType>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBusinessAccessType<TData = Awaited<ReturnType<typeof getBusinessAccessType>>, TError = void>(
 params?: GetBusinessAccessTypeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBusinessAccessType>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBusinessAccessType>>,
          TError,
          Awaited<ReturnType<typeof getBusinessAccessType>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBusinessAccessType<TData = Awaited<ReturnType<typeof getBusinessAccessType>>, TError = void>(
 params?: GetBusinessAccessTypeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBusinessAccessType>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get all business_access_type records
 */

export function useGetBusinessAccessType<TData = Awaited<ReturnType<typeof getBusinessAccessType>>, TError = void>(
 params?: GetBusinessAccessTypeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBusinessAccessType>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetBusinessAccessTypeQueryOptions(params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Creates a new business_access_type record
 * @summary Create a new business_access_type record
 */
export const postBusinessAccessType = (
    businessAccessType: BusinessAccessType,
 signal?: AbortSignal
) => {
      
      
      return defaultInstance<PostBusinessAccessType200>(
      {url: `/business_access_type`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: businessAccessType, signal
    },
      );
    }
  


export const getPostBusinessAccessTypeMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postBusinessAccessType>>, TError,{data: BusinessAccessType}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postBusinessAccessType>>, TError,{data: BusinessAccessType}, TContext> => {
    
const mutationKey = ['postBusinessAccessType'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postBusinessAccessType>>, {data: BusinessAccessType}> = (props) => {
          const {data} = props ?? {};

          return  postBusinessAccessType(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostBusinessAccessTypeMutationResult = NonNullable<Awaited<ReturnType<typeof postBusinessAccessType>>>
    export type PostBusinessAccessTypeMutationBody = BusinessAccessType
    export type PostBusinessAccessTypeMutationError = void

    /**
 * @summary Create a new business_access_type record
 */
export const usePostBusinessAccessType = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postBusinessAccessType>>, TError,{data: BusinessAccessType}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postBusinessAccessType>>,
        TError,
        {data: BusinessAccessType},
        TContext
      > => {

      const mutationOptions = getPostBusinessAccessTypeMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Returns a single business_access_type record by ID
 * @summary Get a specific business_access_type record
 */
export const getBusinessAccessTypeId = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return defaultInstance<GetBusinessAccessTypeId200>(
      {url: `/business_access_type/${id}`, method: 'GET', signal
    },
      );
    }
  

export const getGetBusinessAccessTypeIdQueryKey = (id: string,) => {
    return [`/business_access_type/${id}`] as const;
    }

    
export const getGetBusinessAccessTypeIdQueryOptions = <TData = Awaited<ReturnType<typeof getBusinessAccessTypeId>>, TError = void>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBusinessAccessTypeId>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetBusinessAccessTypeIdQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getBusinessAccessTypeId>>> = ({ signal }) => getBusinessAccessTypeId(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getBusinessAccessTypeId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetBusinessAccessTypeIdQueryResult = NonNullable<Awaited<ReturnType<typeof getBusinessAccessTypeId>>>
export type GetBusinessAccessTypeIdQueryError = void


export function useGetBusinessAccessTypeId<TData = Awaited<ReturnType<typeof getBusinessAccessTypeId>>, TError = void>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBusinessAccessTypeId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBusinessAccessTypeId>>,
          TError,
          Awaited<ReturnType<typeof getBusinessAccessTypeId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBusinessAccessTypeId<TData = Awaited<ReturnType<typeof getBusinessAccessTypeId>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBusinessAccessTypeId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBusinessAccessTypeId>>,
          TError,
          Awaited<ReturnType<typeof getBusinessAccessTypeId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBusinessAccessTypeId<TData = Awaited<ReturnType<typeof getBusinessAccessTypeId>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBusinessAccessTypeId>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get a specific business_access_type record
 */

export function useGetBusinessAccessTypeId<TData = Awaited<ReturnType<typeof getBusinessAccessTypeId>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBusinessAccessTypeId>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetBusinessAccessTypeIdQueryOptions(id,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Updates an existing business_access_type record
 * @summary Update a business_access_type record
 */
export const putBusinessAccessTypeId = (
    id: string,
    businessAccessType: BusinessAccessType,
 ) => {
      
      
      return defaultInstance<PutBusinessAccessTypeId200>(
      {url: `/business_access_type/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: businessAccessType
    },
      );
    }
  


export const getPutBusinessAccessTypeIdMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putBusinessAccessTypeId>>, TError,{id: string;data: BusinessAccessType}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof putBusinessAccessTypeId>>, TError,{id: string;data: BusinessAccessType}, TContext> => {
    
const mutationKey = ['putBusinessAccessTypeId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putBusinessAccessTypeId>>, {id: string;data: BusinessAccessType}> = (props) => {
          const {id,data} = props ?? {};

          return  putBusinessAccessTypeId(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutBusinessAccessTypeIdMutationResult = NonNullable<Awaited<ReturnType<typeof putBusinessAccessTypeId>>>
    export type PutBusinessAccessTypeIdMutationBody = BusinessAccessType
    export type PutBusinessAccessTypeIdMutationError = void

    /**
 * @summary Update a business_access_type record
 */
export const usePutBusinessAccessTypeId = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putBusinessAccessTypeId>>, TError,{id: string;data: BusinessAccessType}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putBusinessAccessTypeId>>,
        TError,
        {id: string;data: BusinessAccessType},
        TContext
      > => {

      const mutationOptions = getPutBusinessAccessTypeIdMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Partially updates an existing business_access_type record
 * @summary Partially update a business_access_type record
 */
export const patchBusinessAccessTypeId = (
    id: string,
    businessAccessType: BusinessAccessType,
 ) => {
      
      
      return defaultInstance<PatchBusinessAccessTypeId200>(
      {url: `/business_access_type/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: businessAccessType
    },
      );
    }
  


export const getPatchBusinessAccessTypeIdMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchBusinessAccessTypeId>>, TError,{id: string;data: BusinessAccessType}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof patchBusinessAccessTypeId>>, TError,{id: string;data: BusinessAccessType}, TContext> => {
    
const mutationKey = ['patchBusinessAccessTypeId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchBusinessAccessTypeId>>, {id: string;data: BusinessAccessType}> = (props) => {
          const {id,data} = props ?? {};

          return  patchBusinessAccessTypeId(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PatchBusinessAccessTypeIdMutationResult = NonNullable<Awaited<ReturnType<typeof patchBusinessAccessTypeId>>>
    export type PatchBusinessAccessTypeIdMutationBody = BusinessAccessType
    export type PatchBusinessAccessTypeIdMutationError = void

    /**
 * @summary Partially update a business_access_type record
 */
export const usePatchBusinessAccessTypeId = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchBusinessAccessTypeId>>, TError,{id: string;data: BusinessAccessType}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patchBusinessAccessTypeId>>,
        TError,
        {id: string;data: BusinessAccessType},
        TContext
      > => {

      const mutationOptions = getPatchBusinessAccessTypeIdMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Deletes a business_access_type record
 * @summary Delete a business_access_type record
 */
export const deleteBusinessAccessTypeId = (
    id: string,
 ) => {
      
      
      return defaultInstance<DeleteBusinessAccessTypeId200>(
      {url: `/business_access_type/${id}`, method: 'DELETE'
    },
      );
    }
  


export const getDeleteBusinessAccessTypeIdMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteBusinessAccessTypeId>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteBusinessAccessTypeId>>, TError,{id: string}, TContext> => {
    
const mutationKey = ['deleteBusinessAccessTypeId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteBusinessAccessTypeId>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteBusinessAccessTypeId(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteBusinessAccessTypeIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteBusinessAccessTypeId>>>
    
    export type DeleteBusinessAccessTypeIdMutationError = void

    /**
 * @summary Delete a business_access_type record
 */
export const useDeleteBusinessAccessTypeId = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteBusinessAccessTypeId>>, TError,{id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteBusinessAccessTypeId>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getDeleteBusinessAccessTypeIdMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Returns a list of business_access_status records with pagination
 * @summary Get all business_access_status records
 */
export const getBusinessAccessStatus = (
    params?: GetBusinessAccessStatusParams,
 signal?: AbortSignal
) => {
      
      
      return defaultInstance<GetBusinessAccessStatus200>(
      {url: `/business_access_status`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getGetBusinessAccessStatusQueryKey = (params?: GetBusinessAccessStatusParams,) => {
    return [`/business_access_status`, ...(params ? [params]: [])] as const;
    }

    
export const getGetBusinessAccessStatusQueryOptions = <TData = Awaited<ReturnType<typeof getBusinessAccessStatus>>, TError = void>(params?: GetBusinessAccessStatusParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBusinessAccessStatus>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetBusinessAccessStatusQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getBusinessAccessStatus>>> = ({ signal }) => getBusinessAccessStatus(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getBusinessAccessStatus>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetBusinessAccessStatusQueryResult = NonNullable<Awaited<ReturnType<typeof getBusinessAccessStatus>>>
export type GetBusinessAccessStatusQueryError = void


export function useGetBusinessAccessStatus<TData = Awaited<ReturnType<typeof getBusinessAccessStatus>>, TError = void>(
 params: undefined |  GetBusinessAccessStatusParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBusinessAccessStatus>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBusinessAccessStatus>>,
          TError,
          Awaited<ReturnType<typeof getBusinessAccessStatus>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBusinessAccessStatus<TData = Awaited<ReturnType<typeof getBusinessAccessStatus>>, TError = void>(
 params?: GetBusinessAccessStatusParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBusinessAccessStatus>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBusinessAccessStatus>>,
          TError,
          Awaited<ReturnType<typeof getBusinessAccessStatus>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBusinessAccessStatus<TData = Awaited<ReturnType<typeof getBusinessAccessStatus>>, TError = void>(
 params?: GetBusinessAccessStatusParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBusinessAccessStatus>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get all business_access_status records
 */

export function useGetBusinessAccessStatus<TData = Awaited<ReturnType<typeof getBusinessAccessStatus>>, TError = void>(
 params?: GetBusinessAccessStatusParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBusinessAccessStatus>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetBusinessAccessStatusQueryOptions(params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Creates a new business_access_status record
 * @summary Create a new business_access_status record
 */
export const postBusinessAccessStatus = (
    businessAccessStatus: BusinessAccessStatus,
 signal?: AbortSignal
) => {
      
      
      return defaultInstance<PostBusinessAccessStatus200>(
      {url: `/business_access_status`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: businessAccessStatus, signal
    },
      );
    }
  


export const getPostBusinessAccessStatusMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postBusinessAccessStatus>>, TError,{data: BusinessAccessStatus}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postBusinessAccessStatus>>, TError,{data: BusinessAccessStatus}, TContext> => {
    
const mutationKey = ['postBusinessAccessStatus'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postBusinessAccessStatus>>, {data: BusinessAccessStatus}> = (props) => {
          const {data} = props ?? {};

          return  postBusinessAccessStatus(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostBusinessAccessStatusMutationResult = NonNullable<Awaited<ReturnType<typeof postBusinessAccessStatus>>>
    export type PostBusinessAccessStatusMutationBody = BusinessAccessStatus
    export type PostBusinessAccessStatusMutationError = void

    /**
 * @summary Create a new business_access_status record
 */
export const usePostBusinessAccessStatus = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postBusinessAccessStatus>>, TError,{data: BusinessAccessStatus}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postBusinessAccessStatus>>,
        TError,
        {data: BusinessAccessStatus},
        TContext
      > => {

      const mutationOptions = getPostBusinessAccessStatusMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Returns a single business_access_status record by ID
 * @summary Get a specific business_access_status record
 */
export const getBusinessAccessStatusId = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return defaultInstance<GetBusinessAccessStatusId200>(
      {url: `/business_access_status/${id}`, method: 'GET', signal
    },
      );
    }
  

export const getGetBusinessAccessStatusIdQueryKey = (id: string,) => {
    return [`/business_access_status/${id}`] as const;
    }

    
export const getGetBusinessAccessStatusIdQueryOptions = <TData = Awaited<ReturnType<typeof getBusinessAccessStatusId>>, TError = void>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBusinessAccessStatusId>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetBusinessAccessStatusIdQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getBusinessAccessStatusId>>> = ({ signal }) => getBusinessAccessStatusId(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getBusinessAccessStatusId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetBusinessAccessStatusIdQueryResult = NonNullable<Awaited<ReturnType<typeof getBusinessAccessStatusId>>>
export type GetBusinessAccessStatusIdQueryError = void


export function useGetBusinessAccessStatusId<TData = Awaited<ReturnType<typeof getBusinessAccessStatusId>>, TError = void>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBusinessAccessStatusId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBusinessAccessStatusId>>,
          TError,
          Awaited<ReturnType<typeof getBusinessAccessStatusId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBusinessAccessStatusId<TData = Awaited<ReturnType<typeof getBusinessAccessStatusId>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBusinessAccessStatusId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBusinessAccessStatusId>>,
          TError,
          Awaited<ReturnType<typeof getBusinessAccessStatusId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBusinessAccessStatusId<TData = Awaited<ReturnType<typeof getBusinessAccessStatusId>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBusinessAccessStatusId>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get a specific business_access_status record
 */

export function useGetBusinessAccessStatusId<TData = Awaited<ReturnType<typeof getBusinessAccessStatusId>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBusinessAccessStatusId>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetBusinessAccessStatusIdQueryOptions(id,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Updates an existing business_access_status record
 * @summary Update a business_access_status record
 */
export const putBusinessAccessStatusId = (
    id: string,
    businessAccessStatus: BusinessAccessStatus,
 ) => {
      
      
      return defaultInstance<PutBusinessAccessStatusId200>(
      {url: `/business_access_status/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: businessAccessStatus
    },
      );
    }
  


export const getPutBusinessAccessStatusIdMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putBusinessAccessStatusId>>, TError,{id: string;data: BusinessAccessStatus}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof putBusinessAccessStatusId>>, TError,{id: string;data: BusinessAccessStatus}, TContext> => {
    
const mutationKey = ['putBusinessAccessStatusId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putBusinessAccessStatusId>>, {id: string;data: BusinessAccessStatus}> = (props) => {
          const {id,data} = props ?? {};

          return  putBusinessAccessStatusId(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutBusinessAccessStatusIdMutationResult = NonNullable<Awaited<ReturnType<typeof putBusinessAccessStatusId>>>
    export type PutBusinessAccessStatusIdMutationBody = BusinessAccessStatus
    export type PutBusinessAccessStatusIdMutationError = void

    /**
 * @summary Update a business_access_status record
 */
export const usePutBusinessAccessStatusId = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putBusinessAccessStatusId>>, TError,{id: string;data: BusinessAccessStatus}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putBusinessAccessStatusId>>,
        TError,
        {id: string;data: BusinessAccessStatus},
        TContext
      > => {

      const mutationOptions = getPutBusinessAccessStatusIdMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Partially updates an existing business_access_status record
 * @summary Partially update a business_access_status record
 */
export const patchBusinessAccessStatusId = (
    id: string,
    businessAccessStatus: BusinessAccessStatus,
 ) => {
      
      
      return defaultInstance<PatchBusinessAccessStatusId200>(
      {url: `/business_access_status/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: businessAccessStatus
    },
      );
    }
  


export const getPatchBusinessAccessStatusIdMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchBusinessAccessStatusId>>, TError,{id: string;data: BusinessAccessStatus}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof patchBusinessAccessStatusId>>, TError,{id: string;data: BusinessAccessStatus}, TContext> => {
    
const mutationKey = ['patchBusinessAccessStatusId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchBusinessAccessStatusId>>, {id: string;data: BusinessAccessStatus}> = (props) => {
          const {id,data} = props ?? {};

          return  patchBusinessAccessStatusId(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PatchBusinessAccessStatusIdMutationResult = NonNullable<Awaited<ReturnType<typeof patchBusinessAccessStatusId>>>
    export type PatchBusinessAccessStatusIdMutationBody = BusinessAccessStatus
    export type PatchBusinessAccessStatusIdMutationError = void

    /**
 * @summary Partially update a business_access_status record
 */
export const usePatchBusinessAccessStatusId = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchBusinessAccessStatusId>>, TError,{id: string;data: BusinessAccessStatus}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patchBusinessAccessStatusId>>,
        TError,
        {id: string;data: BusinessAccessStatus},
        TContext
      > => {

      const mutationOptions = getPatchBusinessAccessStatusIdMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Deletes a business_access_status record
 * @summary Delete a business_access_status record
 */
export const deleteBusinessAccessStatusId = (
    id: string,
 ) => {
      
      
      return defaultInstance<DeleteBusinessAccessStatusId200>(
      {url: `/business_access_status/${id}`, method: 'DELETE'
    },
      );
    }
  


export const getDeleteBusinessAccessStatusIdMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteBusinessAccessStatusId>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteBusinessAccessStatusId>>, TError,{id: string}, TContext> => {
    
const mutationKey = ['deleteBusinessAccessStatusId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteBusinessAccessStatusId>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteBusinessAccessStatusId(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteBusinessAccessStatusIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteBusinessAccessStatusId>>>
    
    export type DeleteBusinessAccessStatusIdMutationError = void

    /**
 * @summary Delete a business_access_status record
 */
export const useDeleteBusinessAccessStatusId = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteBusinessAccessStatusId>>, TError,{id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteBusinessAccessStatusId>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getDeleteBusinessAccessStatusIdMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Returns a list of business_guest records with pagination
 * @summary Get all business_guest records
 */
export const getBusinessGuest = (
    params?: GetBusinessGuestParams,
 signal?: AbortSignal
) => {
      
      
      return defaultInstance<GetBusinessGuest200>(
      {url: `/business_guest`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getGetBusinessGuestQueryKey = (params?: GetBusinessGuestParams,) => {
    return [`/business_guest`, ...(params ? [params]: [])] as const;
    }

    
export const getGetBusinessGuestQueryOptions = <TData = Awaited<ReturnType<typeof getBusinessGuest>>, TError = void>(params?: GetBusinessGuestParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBusinessGuest>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetBusinessGuestQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getBusinessGuest>>> = ({ signal }) => getBusinessGuest(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getBusinessGuest>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetBusinessGuestQueryResult = NonNullable<Awaited<ReturnType<typeof getBusinessGuest>>>
export type GetBusinessGuestQueryError = void


export function useGetBusinessGuest<TData = Awaited<ReturnType<typeof getBusinessGuest>>, TError = void>(
 params: undefined |  GetBusinessGuestParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBusinessGuest>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBusinessGuest>>,
          TError,
          Awaited<ReturnType<typeof getBusinessGuest>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBusinessGuest<TData = Awaited<ReturnType<typeof getBusinessGuest>>, TError = void>(
 params?: GetBusinessGuestParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBusinessGuest>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBusinessGuest>>,
          TError,
          Awaited<ReturnType<typeof getBusinessGuest>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBusinessGuest<TData = Awaited<ReturnType<typeof getBusinessGuest>>, TError = void>(
 params?: GetBusinessGuestParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBusinessGuest>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get all business_guest records
 */

export function useGetBusinessGuest<TData = Awaited<ReturnType<typeof getBusinessGuest>>, TError = void>(
 params?: GetBusinessGuestParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBusinessGuest>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetBusinessGuestQueryOptions(params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Creates a new business_guest record
 * @summary Create a new business_guest record
 */
export const postBusinessGuest = (
    businessGuest: BusinessGuest,
 signal?: AbortSignal
) => {
      
      
      return defaultInstance<PostBusinessGuest200>(
      {url: `/business_guest`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: businessGuest, signal
    },
      );
    }
  


export const getPostBusinessGuestMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postBusinessGuest>>, TError,{data: BusinessGuest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postBusinessGuest>>, TError,{data: BusinessGuest}, TContext> => {
    
const mutationKey = ['postBusinessGuest'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postBusinessGuest>>, {data: BusinessGuest}> = (props) => {
          const {data} = props ?? {};

          return  postBusinessGuest(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostBusinessGuestMutationResult = NonNullable<Awaited<ReturnType<typeof postBusinessGuest>>>
    export type PostBusinessGuestMutationBody = BusinessGuest
    export type PostBusinessGuestMutationError = void

    /**
 * @summary Create a new business_guest record
 */
export const usePostBusinessGuest = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postBusinessGuest>>, TError,{data: BusinessGuest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postBusinessGuest>>,
        TError,
        {data: BusinessGuest},
        TContext
      > => {

      const mutationOptions = getPostBusinessGuestMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Returns a single business_guest record by ID
 * @summary Get a specific business_guest record
 */
export const getBusinessGuestId = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return defaultInstance<GetBusinessGuestId200>(
      {url: `/business_guest/${id}`, method: 'GET', signal
    },
      );
    }
  

export const getGetBusinessGuestIdQueryKey = (id: string,) => {
    return [`/business_guest/${id}`] as const;
    }

    
export const getGetBusinessGuestIdQueryOptions = <TData = Awaited<ReturnType<typeof getBusinessGuestId>>, TError = void>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBusinessGuestId>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetBusinessGuestIdQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getBusinessGuestId>>> = ({ signal }) => getBusinessGuestId(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getBusinessGuestId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetBusinessGuestIdQueryResult = NonNullable<Awaited<ReturnType<typeof getBusinessGuestId>>>
export type GetBusinessGuestIdQueryError = void


export function useGetBusinessGuestId<TData = Awaited<ReturnType<typeof getBusinessGuestId>>, TError = void>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBusinessGuestId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBusinessGuestId>>,
          TError,
          Awaited<ReturnType<typeof getBusinessGuestId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBusinessGuestId<TData = Awaited<ReturnType<typeof getBusinessGuestId>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBusinessGuestId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBusinessGuestId>>,
          TError,
          Awaited<ReturnType<typeof getBusinessGuestId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBusinessGuestId<TData = Awaited<ReturnType<typeof getBusinessGuestId>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBusinessGuestId>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get a specific business_guest record
 */

export function useGetBusinessGuestId<TData = Awaited<ReturnType<typeof getBusinessGuestId>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBusinessGuestId>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetBusinessGuestIdQueryOptions(id,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Updates an existing business_guest record
 * @summary Update a business_guest record
 */
export const putBusinessGuestId = (
    id: string,
    businessGuest: BusinessGuest,
 ) => {
      
      
      return defaultInstance<PutBusinessGuestId200>(
      {url: `/business_guest/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: businessGuest
    },
      );
    }
  


export const getPutBusinessGuestIdMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putBusinessGuestId>>, TError,{id: string;data: BusinessGuest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof putBusinessGuestId>>, TError,{id: string;data: BusinessGuest}, TContext> => {
    
const mutationKey = ['putBusinessGuestId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putBusinessGuestId>>, {id: string;data: BusinessGuest}> = (props) => {
          const {id,data} = props ?? {};

          return  putBusinessGuestId(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutBusinessGuestIdMutationResult = NonNullable<Awaited<ReturnType<typeof putBusinessGuestId>>>
    export type PutBusinessGuestIdMutationBody = BusinessGuest
    export type PutBusinessGuestIdMutationError = void

    /**
 * @summary Update a business_guest record
 */
export const usePutBusinessGuestId = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putBusinessGuestId>>, TError,{id: string;data: BusinessGuest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putBusinessGuestId>>,
        TError,
        {id: string;data: BusinessGuest},
        TContext
      > => {

      const mutationOptions = getPutBusinessGuestIdMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Partially updates an existing business_guest record
 * @summary Partially update a business_guest record
 */
export const patchBusinessGuestId = (
    id: string,
    businessGuest: BusinessGuest,
 ) => {
      
      
      return defaultInstance<PatchBusinessGuestId200>(
      {url: `/business_guest/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: businessGuest
    },
      );
    }
  


export const getPatchBusinessGuestIdMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchBusinessGuestId>>, TError,{id: string;data: BusinessGuest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof patchBusinessGuestId>>, TError,{id: string;data: BusinessGuest}, TContext> => {
    
const mutationKey = ['patchBusinessGuestId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchBusinessGuestId>>, {id: string;data: BusinessGuest}> = (props) => {
          const {id,data} = props ?? {};

          return  patchBusinessGuestId(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PatchBusinessGuestIdMutationResult = NonNullable<Awaited<ReturnType<typeof patchBusinessGuestId>>>
    export type PatchBusinessGuestIdMutationBody = BusinessGuest
    export type PatchBusinessGuestIdMutationError = void

    /**
 * @summary Partially update a business_guest record
 */
export const usePatchBusinessGuestId = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchBusinessGuestId>>, TError,{id: string;data: BusinessGuest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patchBusinessGuestId>>,
        TError,
        {id: string;data: BusinessGuest},
        TContext
      > => {

      const mutationOptions = getPatchBusinessGuestIdMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Deletes a business_guest record
 * @summary Delete a business_guest record
 */
export const deleteBusinessGuestId = (
    id: string,
 ) => {
      
      
      return defaultInstance<DeleteBusinessGuestId200>(
      {url: `/business_guest/${id}`, method: 'DELETE'
    },
      );
    }
  


export const getDeleteBusinessGuestIdMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteBusinessGuestId>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteBusinessGuestId>>, TError,{id: string}, TContext> => {
    
const mutationKey = ['deleteBusinessGuestId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteBusinessGuestId>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteBusinessGuestId(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteBusinessGuestIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteBusinessGuestId>>>
    
    export type DeleteBusinessGuestIdMutationError = void

    /**
 * @summary Delete a business_guest record
 */
export const useDeleteBusinessGuestId = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteBusinessGuestId>>, TError,{id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteBusinessGuestId>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getDeleteBusinessGuestIdMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Returns a list of business_access_channel records with pagination
 * @summary Get all business_access_channel records
 */
export const getBusinessAccessChannel = (
    params?: GetBusinessAccessChannelParams,
 signal?: AbortSignal
) => {
      
      
      return defaultInstance<GetBusinessAccessChannel200>(
      {url: `/business_access_channel`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getGetBusinessAccessChannelQueryKey = (params?: GetBusinessAccessChannelParams,) => {
    return [`/business_access_channel`, ...(params ? [params]: [])] as const;
    }

    
export const getGetBusinessAccessChannelQueryOptions = <TData = Awaited<ReturnType<typeof getBusinessAccessChannel>>, TError = void>(params?: GetBusinessAccessChannelParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBusinessAccessChannel>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetBusinessAccessChannelQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getBusinessAccessChannel>>> = ({ signal }) => getBusinessAccessChannel(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getBusinessAccessChannel>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetBusinessAccessChannelQueryResult = NonNullable<Awaited<ReturnType<typeof getBusinessAccessChannel>>>
export type GetBusinessAccessChannelQueryError = void


export function useGetBusinessAccessChannel<TData = Awaited<ReturnType<typeof getBusinessAccessChannel>>, TError = void>(
 params: undefined |  GetBusinessAccessChannelParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBusinessAccessChannel>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBusinessAccessChannel>>,
          TError,
          Awaited<ReturnType<typeof getBusinessAccessChannel>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBusinessAccessChannel<TData = Awaited<ReturnType<typeof getBusinessAccessChannel>>, TError = void>(
 params?: GetBusinessAccessChannelParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBusinessAccessChannel>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBusinessAccessChannel>>,
          TError,
          Awaited<ReturnType<typeof getBusinessAccessChannel>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBusinessAccessChannel<TData = Awaited<ReturnType<typeof getBusinessAccessChannel>>, TError = void>(
 params?: GetBusinessAccessChannelParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBusinessAccessChannel>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get all business_access_channel records
 */

export function useGetBusinessAccessChannel<TData = Awaited<ReturnType<typeof getBusinessAccessChannel>>, TError = void>(
 params?: GetBusinessAccessChannelParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBusinessAccessChannel>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetBusinessAccessChannelQueryOptions(params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Creates a new business_access_channel record
 * @summary Create a new business_access_channel record
 */
export const postBusinessAccessChannel = (
    businessAccessChannel: BusinessAccessChannel,
 signal?: AbortSignal
) => {
      
      
      return defaultInstance<PostBusinessAccessChannel200>(
      {url: `/business_access_channel`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: businessAccessChannel, signal
    },
      );
    }
  


export const getPostBusinessAccessChannelMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postBusinessAccessChannel>>, TError,{data: BusinessAccessChannel}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postBusinessAccessChannel>>, TError,{data: BusinessAccessChannel}, TContext> => {
    
const mutationKey = ['postBusinessAccessChannel'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postBusinessAccessChannel>>, {data: BusinessAccessChannel}> = (props) => {
          const {data} = props ?? {};

          return  postBusinessAccessChannel(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostBusinessAccessChannelMutationResult = NonNullable<Awaited<ReturnType<typeof postBusinessAccessChannel>>>
    export type PostBusinessAccessChannelMutationBody = BusinessAccessChannel
    export type PostBusinessAccessChannelMutationError = void

    /**
 * @summary Create a new business_access_channel record
 */
export const usePostBusinessAccessChannel = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postBusinessAccessChannel>>, TError,{data: BusinessAccessChannel}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postBusinessAccessChannel>>,
        TError,
        {data: BusinessAccessChannel},
        TContext
      > => {

      const mutationOptions = getPostBusinessAccessChannelMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Returns a single business_access_channel record by ID
 * @summary Get a specific business_access_channel record
 */
export const getBusinessAccessChannelId = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return defaultInstance<GetBusinessAccessChannelId200>(
      {url: `/business_access_channel/${id}`, method: 'GET', signal
    },
      );
    }
  

export const getGetBusinessAccessChannelIdQueryKey = (id: string,) => {
    return [`/business_access_channel/${id}`] as const;
    }

    
export const getGetBusinessAccessChannelIdQueryOptions = <TData = Awaited<ReturnType<typeof getBusinessAccessChannelId>>, TError = void>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBusinessAccessChannelId>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetBusinessAccessChannelIdQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getBusinessAccessChannelId>>> = ({ signal }) => getBusinessAccessChannelId(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getBusinessAccessChannelId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetBusinessAccessChannelIdQueryResult = NonNullable<Awaited<ReturnType<typeof getBusinessAccessChannelId>>>
export type GetBusinessAccessChannelIdQueryError = void


export function useGetBusinessAccessChannelId<TData = Awaited<ReturnType<typeof getBusinessAccessChannelId>>, TError = void>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBusinessAccessChannelId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBusinessAccessChannelId>>,
          TError,
          Awaited<ReturnType<typeof getBusinessAccessChannelId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBusinessAccessChannelId<TData = Awaited<ReturnType<typeof getBusinessAccessChannelId>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBusinessAccessChannelId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBusinessAccessChannelId>>,
          TError,
          Awaited<ReturnType<typeof getBusinessAccessChannelId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBusinessAccessChannelId<TData = Awaited<ReturnType<typeof getBusinessAccessChannelId>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBusinessAccessChannelId>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get a specific business_access_channel record
 */

export function useGetBusinessAccessChannelId<TData = Awaited<ReturnType<typeof getBusinessAccessChannelId>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBusinessAccessChannelId>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetBusinessAccessChannelIdQueryOptions(id,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Updates an existing business_access_channel record
 * @summary Update a business_access_channel record
 */
export const putBusinessAccessChannelId = (
    id: string,
    businessAccessChannel: BusinessAccessChannel,
 ) => {
      
      
      return defaultInstance<PutBusinessAccessChannelId200>(
      {url: `/business_access_channel/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: businessAccessChannel
    },
      );
    }
  


export const getPutBusinessAccessChannelIdMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putBusinessAccessChannelId>>, TError,{id: string;data: BusinessAccessChannel}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof putBusinessAccessChannelId>>, TError,{id: string;data: BusinessAccessChannel}, TContext> => {
    
const mutationKey = ['putBusinessAccessChannelId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putBusinessAccessChannelId>>, {id: string;data: BusinessAccessChannel}> = (props) => {
          const {id,data} = props ?? {};

          return  putBusinessAccessChannelId(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutBusinessAccessChannelIdMutationResult = NonNullable<Awaited<ReturnType<typeof putBusinessAccessChannelId>>>
    export type PutBusinessAccessChannelIdMutationBody = BusinessAccessChannel
    export type PutBusinessAccessChannelIdMutationError = void

    /**
 * @summary Update a business_access_channel record
 */
export const usePutBusinessAccessChannelId = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putBusinessAccessChannelId>>, TError,{id: string;data: BusinessAccessChannel}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putBusinessAccessChannelId>>,
        TError,
        {id: string;data: BusinessAccessChannel},
        TContext
      > => {

      const mutationOptions = getPutBusinessAccessChannelIdMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Partially updates an existing business_access_channel record
 * @summary Partially update a business_access_channel record
 */
export const patchBusinessAccessChannelId = (
    id: string,
    businessAccessChannel: BusinessAccessChannel,
 ) => {
      
      
      return defaultInstance<PatchBusinessAccessChannelId200>(
      {url: `/business_access_channel/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: businessAccessChannel
    },
      );
    }
  


export const getPatchBusinessAccessChannelIdMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchBusinessAccessChannelId>>, TError,{id: string;data: BusinessAccessChannel}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof patchBusinessAccessChannelId>>, TError,{id: string;data: BusinessAccessChannel}, TContext> => {
    
const mutationKey = ['patchBusinessAccessChannelId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchBusinessAccessChannelId>>, {id: string;data: BusinessAccessChannel}> = (props) => {
          const {id,data} = props ?? {};

          return  patchBusinessAccessChannelId(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PatchBusinessAccessChannelIdMutationResult = NonNullable<Awaited<ReturnType<typeof patchBusinessAccessChannelId>>>
    export type PatchBusinessAccessChannelIdMutationBody = BusinessAccessChannel
    export type PatchBusinessAccessChannelIdMutationError = void

    /**
 * @summary Partially update a business_access_channel record
 */
export const usePatchBusinessAccessChannelId = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchBusinessAccessChannelId>>, TError,{id: string;data: BusinessAccessChannel}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patchBusinessAccessChannelId>>,
        TError,
        {id: string;data: BusinessAccessChannel},
        TContext
      > => {

      const mutationOptions = getPatchBusinessAccessChannelIdMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Deletes a business_access_channel record
 * @summary Delete a business_access_channel record
 */
export const deleteBusinessAccessChannelId = (
    id: string,
 ) => {
      
      
      return defaultInstance<DeleteBusinessAccessChannelId200>(
      {url: `/business_access_channel/${id}`, method: 'DELETE'
    },
      );
    }
  


export const getDeleteBusinessAccessChannelIdMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteBusinessAccessChannelId>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteBusinessAccessChannelId>>, TError,{id: string}, TContext> => {
    
const mutationKey = ['deleteBusinessAccessChannelId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteBusinessAccessChannelId>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteBusinessAccessChannelId(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteBusinessAccessChannelIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteBusinessAccessChannelId>>>
    
    export type DeleteBusinessAccessChannelIdMutationError = void

    /**
 * @summary Delete a business_access_channel record
 */
export const useDeleteBusinessAccessChannelId = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteBusinessAccessChannelId>>, TError,{id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteBusinessAccessChannelId>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getDeleteBusinessAccessChannelIdMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Returns a list of event_type records with pagination
 * @summary Get all event_type records
 */
export const getEventType = (
    params?: GetEventTypeParams,
 signal?: AbortSignal
) => {
      
      
      return defaultInstance<GetEventType200>(
      {url: `/event_type`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getGetEventTypeQueryKey = (params?: GetEventTypeParams,) => {
    return [`/event_type`, ...(params ? [params]: [])] as const;
    }

    
export const getGetEventTypeQueryOptions = <TData = Awaited<ReturnType<typeof getEventType>>, TError = void>(params?: GetEventTypeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEventType>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetEventTypeQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getEventType>>> = ({ signal }) => getEventType(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getEventType>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetEventTypeQueryResult = NonNullable<Awaited<ReturnType<typeof getEventType>>>
export type GetEventTypeQueryError = void


export function useGetEventType<TData = Awaited<ReturnType<typeof getEventType>>, TError = void>(
 params: undefined |  GetEventTypeParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEventType>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEventType>>,
          TError,
          Awaited<ReturnType<typeof getEventType>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEventType<TData = Awaited<ReturnType<typeof getEventType>>, TError = void>(
 params?: GetEventTypeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEventType>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEventType>>,
          TError,
          Awaited<ReturnType<typeof getEventType>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEventType<TData = Awaited<ReturnType<typeof getEventType>>, TError = void>(
 params?: GetEventTypeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEventType>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get all event_type records
 */

export function useGetEventType<TData = Awaited<ReturnType<typeof getEventType>>, TError = void>(
 params?: GetEventTypeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEventType>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetEventTypeQueryOptions(params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Creates a new event_type record
 * @summary Create a new event_type record
 */
export const postEventType = (
    eventType: EventType,
 signal?: AbortSignal
) => {
      
      
      return defaultInstance<PostEventType200>(
      {url: `/event_type`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: eventType, signal
    },
      );
    }
  


export const getPostEventTypeMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postEventType>>, TError,{data: EventType}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postEventType>>, TError,{data: EventType}, TContext> => {
    
const mutationKey = ['postEventType'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postEventType>>, {data: EventType}> = (props) => {
          const {data} = props ?? {};

          return  postEventType(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostEventTypeMutationResult = NonNullable<Awaited<ReturnType<typeof postEventType>>>
    export type PostEventTypeMutationBody = EventType
    export type PostEventTypeMutationError = void

    /**
 * @summary Create a new event_type record
 */
export const usePostEventType = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postEventType>>, TError,{data: EventType}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postEventType>>,
        TError,
        {data: EventType},
        TContext
      > => {

      const mutationOptions = getPostEventTypeMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Returns a single event_type record by ID
 * @summary Get a specific event_type record
 */
export const getEventTypeId = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return defaultInstance<GetEventTypeId200>(
      {url: `/event_type/${id}`, method: 'GET', signal
    },
      );
    }
  

export const getGetEventTypeIdQueryKey = (id: string,) => {
    return [`/event_type/${id}`] as const;
    }

    
export const getGetEventTypeIdQueryOptions = <TData = Awaited<ReturnType<typeof getEventTypeId>>, TError = void>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEventTypeId>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetEventTypeIdQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getEventTypeId>>> = ({ signal }) => getEventTypeId(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getEventTypeId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetEventTypeIdQueryResult = NonNullable<Awaited<ReturnType<typeof getEventTypeId>>>
export type GetEventTypeIdQueryError = void


export function useGetEventTypeId<TData = Awaited<ReturnType<typeof getEventTypeId>>, TError = void>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEventTypeId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEventTypeId>>,
          TError,
          Awaited<ReturnType<typeof getEventTypeId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEventTypeId<TData = Awaited<ReturnType<typeof getEventTypeId>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEventTypeId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEventTypeId>>,
          TError,
          Awaited<ReturnType<typeof getEventTypeId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEventTypeId<TData = Awaited<ReturnType<typeof getEventTypeId>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEventTypeId>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get a specific event_type record
 */

export function useGetEventTypeId<TData = Awaited<ReturnType<typeof getEventTypeId>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEventTypeId>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetEventTypeIdQueryOptions(id,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Updates an existing event_type record
 * @summary Update a event_type record
 */
export const putEventTypeId = (
    id: string,
    eventType: EventType,
 ) => {
      
      
      return defaultInstance<PutEventTypeId200>(
      {url: `/event_type/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: eventType
    },
      );
    }
  


export const getPutEventTypeIdMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putEventTypeId>>, TError,{id: string;data: EventType}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof putEventTypeId>>, TError,{id: string;data: EventType}, TContext> => {
    
const mutationKey = ['putEventTypeId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putEventTypeId>>, {id: string;data: EventType}> = (props) => {
          const {id,data} = props ?? {};

          return  putEventTypeId(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutEventTypeIdMutationResult = NonNullable<Awaited<ReturnType<typeof putEventTypeId>>>
    export type PutEventTypeIdMutationBody = EventType
    export type PutEventTypeIdMutationError = void

    /**
 * @summary Update a event_type record
 */
export const usePutEventTypeId = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putEventTypeId>>, TError,{id: string;data: EventType}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putEventTypeId>>,
        TError,
        {id: string;data: EventType},
        TContext
      > => {

      const mutationOptions = getPutEventTypeIdMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Partially updates an existing event_type record
 * @summary Partially update a event_type record
 */
export const patchEventTypeId = (
    id: string,
    eventType: EventType,
 ) => {
      
      
      return defaultInstance<PatchEventTypeId200>(
      {url: `/event_type/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: eventType
    },
      );
    }
  


export const getPatchEventTypeIdMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchEventTypeId>>, TError,{id: string;data: EventType}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof patchEventTypeId>>, TError,{id: string;data: EventType}, TContext> => {
    
const mutationKey = ['patchEventTypeId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchEventTypeId>>, {id: string;data: EventType}> = (props) => {
          const {id,data} = props ?? {};

          return  patchEventTypeId(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PatchEventTypeIdMutationResult = NonNullable<Awaited<ReturnType<typeof patchEventTypeId>>>
    export type PatchEventTypeIdMutationBody = EventType
    export type PatchEventTypeIdMutationError = void

    /**
 * @summary Partially update a event_type record
 */
export const usePatchEventTypeId = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchEventTypeId>>, TError,{id: string;data: EventType}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patchEventTypeId>>,
        TError,
        {id: string;data: EventType},
        TContext
      > => {

      const mutationOptions = getPatchEventTypeIdMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Deletes a event_type record
 * @summary Delete a event_type record
 */
export const deleteEventTypeId = (
    id: string,
 ) => {
      
      
      return defaultInstance<DeleteEventTypeId200>(
      {url: `/event_type/${id}`, method: 'DELETE'
    },
      );
    }
  


export const getDeleteEventTypeIdMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteEventTypeId>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteEventTypeId>>, TError,{id: string}, TContext> => {
    
const mutationKey = ['deleteEventTypeId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteEventTypeId>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteEventTypeId(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteEventTypeIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteEventTypeId>>>
    
    export type DeleteEventTypeIdMutationError = void

    /**
 * @summary Delete a event_type record
 */
export const useDeleteEventTypeId = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteEventTypeId>>, TError,{id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteEventTypeId>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getDeleteEventTypeIdMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Returns a list of event_group records with pagination
 * @summary Get all event_group records
 */
export const getEventGroup = (
    params?: GetEventGroupParams,
 signal?: AbortSignal
) => {
      
      
      return defaultInstance<GetEventGroup200>(
      {url: `/event_group`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getGetEventGroupQueryKey = (params?: GetEventGroupParams,) => {
    return [`/event_group`, ...(params ? [params]: [])] as const;
    }

    
export const getGetEventGroupQueryOptions = <TData = Awaited<ReturnType<typeof getEventGroup>>, TError = void>(params?: GetEventGroupParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEventGroup>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetEventGroupQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getEventGroup>>> = ({ signal }) => getEventGroup(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getEventGroup>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetEventGroupQueryResult = NonNullable<Awaited<ReturnType<typeof getEventGroup>>>
export type GetEventGroupQueryError = void


export function useGetEventGroup<TData = Awaited<ReturnType<typeof getEventGroup>>, TError = void>(
 params: undefined |  GetEventGroupParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEventGroup>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEventGroup>>,
          TError,
          Awaited<ReturnType<typeof getEventGroup>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEventGroup<TData = Awaited<ReturnType<typeof getEventGroup>>, TError = void>(
 params?: GetEventGroupParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEventGroup>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEventGroup>>,
          TError,
          Awaited<ReturnType<typeof getEventGroup>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEventGroup<TData = Awaited<ReturnType<typeof getEventGroup>>, TError = void>(
 params?: GetEventGroupParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEventGroup>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get all event_group records
 */

export function useGetEventGroup<TData = Awaited<ReturnType<typeof getEventGroup>>, TError = void>(
 params?: GetEventGroupParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEventGroup>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetEventGroupQueryOptions(params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Creates a new event_group record
 * @summary Create a new event_group record
 */
export const postEventGroup = (
    eventGroup: EventGroup,
 signal?: AbortSignal
) => {
      
      
      return defaultInstance<PostEventGroup200>(
      {url: `/event_group`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: eventGroup, signal
    },
      );
    }
  


export const getPostEventGroupMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postEventGroup>>, TError,{data: EventGroup}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postEventGroup>>, TError,{data: EventGroup}, TContext> => {
    
const mutationKey = ['postEventGroup'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postEventGroup>>, {data: EventGroup}> = (props) => {
          const {data} = props ?? {};

          return  postEventGroup(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostEventGroupMutationResult = NonNullable<Awaited<ReturnType<typeof postEventGroup>>>
    export type PostEventGroupMutationBody = EventGroup
    export type PostEventGroupMutationError = void

    /**
 * @summary Create a new event_group record
 */
export const usePostEventGroup = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postEventGroup>>, TError,{data: EventGroup}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postEventGroup>>,
        TError,
        {data: EventGroup},
        TContext
      > => {

      const mutationOptions = getPostEventGroupMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Returns a single event_group record by ID
 * @summary Get a specific event_group record
 */
export const getEventGroupId = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return defaultInstance<GetEventGroupId200>(
      {url: `/event_group/${id}`, method: 'GET', signal
    },
      );
    }
  

export const getGetEventGroupIdQueryKey = (id: string,) => {
    return [`/event_group/${id}`] as const;
    }

    
export const getGetEventGroupIdQueryOptions = <TData = Awaited<ReturnType<typeof getEventGroupId>>, TError = void>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEventGroupId>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetEventGroupIdQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getEventGroupId>>> = ({ signal }) => getEventGroupId(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getEventGroupId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetEventGroupIdQueryResult = NonNullable<Awaited<ReturnType<typeof getEventGroupId>>>
export type GetEventGroupIdQueryError = void


export function useGetEventGroupId<TData = Awaited<ReturnType<typeof getEventGroupId>>, TError = void>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEventGroupId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEventGroupId>>,
          TError,
          Awaited<ReturnType<typeof getEventGroupId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEventGroupId<TData = Awaited<ReturnType<typeof getEventGroupId>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEventGroupId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEventGroupId>>,
          TError,
          Awaited<ReturnType<typeof getEventGroupId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEventGroupId<TData = Awaited<ReturnType<typeof getEventGroupId>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEventGroupId>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get a specific event_group record
 */

export function useGetEventGroupId<TData = Awaited<ReturnType<typeof getEventGroupId>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEventGroupId>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetEventGroupIdQueryOptions(id,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Updates an existing event_group record
 * @summary Update a event_group record
 */
export const putEventGroupId = (
    id: string,
    eventGroup: EventGroup,
 ) => {
      
      
      return defaultInstance<PutEventGroupId200>(
      {url: `/event_group/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: eventGroup
    },
      );
    }
  


export const getPutEventGroupIdMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putEventGroupId>>, TError,{id: string;data: EventGroup}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof putEventGroupId>>, TError,{id: string;data: EventGroup}, TContext> => {
    
const mutationKey = ['putEventGroupId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putEventGroupId>>, {id: string;data: EventGroup}> = (props) => {
          const {id,data} = props ?? {};

          return  putEventGroupId(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutEventGroupIdMutationResult = NonNullable<Awaited<ReturnType<typeof putEventGroupId>>>
    export type PutEventGroupIdMutationBody = EventGroup
    export type PutEventGroupIdMutationError = void

    /**
 * @summary Update a event_group record
 */
export const usePutEventGroupId = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putEventGroupId>>, TError,{id: string;data: EventGroup}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putEventGroupId>>,
        TError,
        {id: string;data: EventGroup},
        TContext
      > => {

      const mutationOptions = getPutEventGroupIdMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Partially updates an existing event_group record
 * @summary Partially update a event_group record
 */
export const patchEventGroupId = (
    id: string,
    eventGroup: EventGroup,
 ) => {
      
      
      return defaultInstance<PatchEventGroupId200>(
      {url: `/event_group/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: eventGroup
    },
      );
    }
  


export const getPatchEventGroupIdMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchEventGroupId>>, TError,{id: string;data: EventGroup}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof patchEventGroupId>>, TError,{id: string;data: EventGroup}, TContext> => {
    
const mutationKey = ['patchEventGroupId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchEventGroupId>>, {id: string;data: EventGroup}> = (props) => {
          const {id,data} = props ?? {};

          return  patchEventGroupId(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PatchEventGroupIdMutationResult = NonNullable<Awaited<ReturnType<typeof patchEventGroupId>>>
    export type PatchEventGroupIdMutationBody = EventGroup
    export type PatchEventGroupIdMutationError = void

    /**
 * @summary Partially update a event_group record
 */
export const usePatchEventGroupId = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchEventGroupId>>, TError,{id: string;data: EventGroup}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patchEventGroupId>>,
        TError,
        {id: string;data: EventGroup},
        TContext
      > => {

      const mutationOptions = getPatchEventGroupIdMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Deletes a event_group record
 * @summary Delete a event_group record
 */
export const deleteEventGroupId = (
    id: string,
 ) => {
      
      
      return defaultInstance<DeleteEventGroupId200>(
      {url: `/event_group/${id}`, method: 'DELETE'
    },
      );
    }
  


export const getDeleteEventGroupIdMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteEventGroupId>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteEventGroupId>>, TError,{id: string}, TContext> => {
    
const mutationKey = ['deleteEventGroupId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteEventGroupId>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteEventGroupId(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteEventGroupIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteEventGroupId>>>
    
    export type DeleteEventGroupIdMutationError = void

    /**
 * @summary Delete a event_group record
 */
export const useDeleteEventGroupId = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteEventGroupId>>, TError,{id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteEventGroupId>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getDeleteEventGroupIdMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Returns a list of access_settings records with pagination
 * @summary Get all access_settings records
 */
export const getAccessSettings = (
    params?: GetAccessSettingsParams,
 signal?: AbortSignal
) => {
      
      
      return defaultInstance<GetAccessSettings200>(
      {url: `/access_settings`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getGetAccessSettingsQueryKey = (params?: GetAccessSettingsParams,) => {
    return [`/access_settings`, ...(params ? [params]: [])] as const;
    }

    
export const getGetAccessSettingsQueryOptions = <TData = Awaited<ReturnType<typeof getAccessSettings>>, TError = void>(params?: GetAccessSettingsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAccessSettings>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAccessSettingsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAccessSettings>>> = ({ signal }) => getAccessSettings(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAccessSettings>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAccessSettingsQueryResult = NonNullable<Awaited<ReturnType<typeof getAccessSettings>>>
export type GetAccessSettingsQueryError = void


export function useGetAccessSettings<TData = Awaited<ReturnType<typeof getAccessSettings>>, TError = void>(
 params: undefined |  GetAccessSettingsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAccessSettings>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAccessSettings>>,
          TError,
          Awaited<ReturnType<typeof getAccessSettings>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAccessSettings<TData = Awaited<ReturnType<typeof getAccessSettings>>, TError = void>(
 params?: GetAccessSettingsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAccessSettings>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAccessSettings>>,
          TError,
          Awaited<ReturnType<typeof getAccessSettings>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAccessSettings<TData = Awaited<ReturnType<typeof getAccessSettings>>, TError = void>(
 params?: GetAccessSettingsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAccessSettings>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get all access_settings records
 */

export function useGetAccessSettings<TData = Awaited<ReturnType<typeof getAccessSettings>>, TError = void>(
 params?: GetAccessSettingsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAccessSettings>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAccessSettingsQueryOptions(params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Creates a new access_settings record
 * @summary Create a new access_settings record
 */
export const postAccessSettings = (
    accessSettings: AccessSettings,
 signal?: AbortSignal
) => {
      
      
      return defaultInstance<PostAccessSettings200>(
      {url: `/access_settings`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: accessSettings, signal
    },
      );
    }
  


export const getPostAccessSettingsMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAccessSettings>>, TError,{data: AccessSettings}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postAccessSettings>>, TError,{data: AccessSettings}, TContext> => {
    
const mutationKey = ['postAccessSettings'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postAccessSettings>>, {data: AccessSettings}> = (props) => {
          const {data} = props ?? {};

          return  postAccessSettings(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostAccessSettingsMutationResult = NonNullable<Awaited<ReturnType<typeof postAccessSettings>>>
    export type PostAccessSettingsMutationBody = AccessSettings
    export type PostAccessSettingsMutationError = void

    /**
 * @summary Create a new access_settings record
 */
export const usePostAccessSettings = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAccessSettings>>, TError,{data: AccessSettings}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postAccessSettings>>,
        TError,
        {data: AccessSettings},
        TContext
      > => {

      const mutationOptions = getPostAccessSettingsMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Returns a single access_settings record by ID
 * @summary Get a specific access_settings record
 */
export const getAccessSettingsId = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return defaultInstance<GetAccessSettingsId200>(
      {url: `/access_settings/${id}`, method: 'GET', signal
    },
      );
    }
  

export const getGetAccessSettingsIdQueryKey = (id: string,) => {
    return [`/access_settings/${id}`] as const;
    }

    
export const getGetAccessSettingsIdQueryOptions = <TData = Awaited<ReturnType<typeof getAccessSettingsId>>, TError = void>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAccessSettingsId>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAccessSettingsIdQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAccessSettingsId>>> = ({ signal }) => getAccessSettingsId(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAccessSettingsId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAccessSettingsIdQueryResult = NonNullable<Awaited<ReturnType<typeof getAccessSettingsId>>>
export type GetAccessSettingsIdQueryError = void


export function useGetAccessSettingsId<TData = Awaited<ReturnType<typeof getAccessSettingsId>>, TError = void>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAccessSettingsId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAccessSettingsId>>,
          TError,
          Awaited<ReturnType<typeof getAccessSettingsId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAccessSettingsId<TData = Awaited<ReturnType<typeof getAccessSettingsId>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAccessSettingsId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAccessSettingsId>>,
          TError,
          Awaited<ReturnType<typeof getAccessSettingsId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAccessSettingsId<TData = Awaited<ReturnType<typeof getAccessSettingsId>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAccessSettingsId>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get a specific access_settings record
 */

export function useGetAccessSettingsId<TData = Awaited<ReturnType<typeof getAccessSettingsId>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAccessSettingsId>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAccessSettingsIdQueryOptions(id,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Updates an existing access_settings record
 * @summary Update a access_settings record
 */
export const putAccessSettingsId = (
    id: string,
    accessSettings: AccessSettings,
 ) => {
      
      
      return defaultInstance<PutAccessSettingsId200>(
      {url: `/access_settings/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: accessSettings
    },
      );
    }
  


export const getPutAccessSettingsIdMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putAccessSettingsId>>, TError,{id: string;data: AccessSettings}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof putAccessSettingsId>>, TError,{id: string;data: AccessSettings}, TContext> => {
    
const mutationKey = ['putAccessSettingsId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putAccessSettingsId>>, {id: string;data: AccessSettings}> = (props) => {
          const {id,data} = props ?? {};

          return  putAccessSettingsId(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutAccessSettingsIdMutationResult = NonNullable<Awaited<ReturnType<typeof putAccessSettingsId>>>
    export type PutAccessSettingsIdMutationBody = AccessSettings
    export type PutAccessSettingsIdMutationError = void

    /**
 * @summary Update a access_settings record
 */
export const usePutAccessSettingsId = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putAccessSettingsId>>, TError,{id: string;data: AccessSettings}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putAccessSettingsId>>,
        TError,
        {id: string;data: AccessSettings},
        TContext
      > => {

      const mutationOptions = getPutAccessSettingsIdMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Partially updates an existing access_settings record
 * @summary Partially update a access_settings record
 */
export const patchAccessSettingsId = (
    id: string,
    accessSettings: AccessSettings,
 ) => {
      
      
      return defaultInstance<PatchAccessSettingsId200>(
      {url: `/access_settings/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: accessSettings
    },
      );
    }
  


export const getPatchAccessSettingsIdMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchAccessSettingsId>>, TError,{id: string;data: AccessSettings}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof patchAccessSettingsId>>, TError,{id: string;data: AccessSettings}, TContext> => {
    
const mutationKey = ['patchAccessSettingsId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchAccessSettingsId>>, {id: string;data: AccessSettings}> = (props) => {
          const {id,data} = props ?? {};

          return  patchAccessSettingsId(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PatchAccessSettingsIdMutationResult = NonNullable<Awaited<ReturnType<typeof patchAccessSettingsId>>>
    export type PatchAccessSettingsIdMutationBody = AccessSettings
    export type PatchAccessSettingsIdMutationError = void

    /**
 * @summary Partially update a access_settings record
 */
export const usePatchAccessSettingsId = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchAccessSettingsId>>, TError,{id: string;data: AccessSettings}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patchAccessSettingsId>>,
        TError,
        {id: string;data: AccessSettings},
        TContext
      > => {

      const mutationOptions = getPatchAccessSettingsIdMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Deletes a access_settings record
 * @summary Delete a access_settings record
 */
export const deleteAccessSettingsId = (
    id: string,
 ) => {
      
      
      return defaultInstance<DeleteAccessSettingsId200>(
      {url: `/access_settings/${id}`, method: 'DELETE'
    },
      );
    }
  


export const getDeleteAccessSettingsIdMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAccessSettingsId>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteAccessSettingsId>>, TError,{id: string}, TContext> => {
    
const mutationKey = ['deleteAccessSettingsId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteAccessSettingsId>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteAccessSettingsId(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteAccessSettingsIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteAccessSettingsId>>>
    
    export type DeleteAccessSettingsIdMutationError = void

    /**
 * @summary Delete a access_settings record
 */
export const useDeleteAccessSettingsId = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAccessSettingsId>>, TError,{id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteAccessSettingsId>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getDeleteAccessSettingsIdMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Returns a list of event records with pagination
 * @summary Get all event records
 */
export const getEvent = (
    params?: GetEventParams,
 signal?: AbortSignal
) => {
      
      
      return defaultInstance<GetEvent200>(
      {url: `/event`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getGetEventQueryKey = (params?: GetEventParams,) => {
    return [`/event`, ...(params ? [params]: [])] as const;
    }

    
export const getGetEventQueryOptions = <TData = Awaited<ReturnType<typeof getEvent>>, TError = void>(params?: GetEventParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEvent>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetEventQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getEvent>>> = ({ signal }) => getEvent(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getEvent>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetEventQueryResult = NonNullable<Awaited<ReturnType<typeof getEvent>>>
export type GetEventQueryError = void


export function useGetEvent<TData = Awaited<ReturnType<typeof getEvent>>, TError = void>(
 params: undefined |  GetEventParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEvent>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEvent>>,
          TError,
          Awaited<ReturnType<typeof getEvent>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEvent<TData = Awaited<ReturnType<typeof getEvent>>, TError = void>(
 params?: GetEventParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEvent>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEvent>>,
          TError,
          Awaited<ReturnType<typeof getEvent>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEvent<TData = Awaited<ReturnType<typeof getEvent>>, TError = void>(
 params?: GetEventParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEvent>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get all event records
 */

export function useGetEvent<TData = Awaited<ReturnType<typeof getEvent>>, TError = void>(
 params?: GetEventParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEvent>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetEventQueryOptions(params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Creates a new event record
 * @summary Create a new event record
 */
export const postEvent = (
    event: Event,
 signal?: AbortSignal
) => {
      
      
      return defaultInstance<PostEvent200>(
      {url: `/event`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: event, signal
    },
      );
    }
  


export const getPostEventMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postEvent>>, TError,{data: Event}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postEvent>>, TError,{data: Event}, TContext> => {
    
const mutationKey = ['postEvent'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postEvent>>, {data: Event}> = (props) => {
          const {data} = props ?? {};

          return  postEvent(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostEventMutationResult = NonNullable<Awaited<ReturnType<typeof postEvent>>>
    export type PostEventMutationBody = Event
    export type PostEventMutationError = void

    /**
 * @summary Create a new event record
 */
export const usePostEvent = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postEvent>>, TError,{data: Event}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postEvent>>,
        TError,
        {data: Event},
        TContext
      > => {

      const mutationOptions = getPostEventMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Returns a single event record by ID
 * @summary Get a specific event record
 */
export const getEventId = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return defaultInstance<GetEventId200>(
      {url: `/event/${id}`, method: 'GET', signal
    },
      );
    }
  

export const getGetEventIdQueryKey = (id: string,) => {
    return [`/event/${id}`] as const;
    }

    
export const getGetEventIdQueryOptions = <TData = Awaited<ReturnType<typeof getEventId>>, TError = void>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEventId>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetEventIdQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getEventId>>> = ({ signal }) => getEventId(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getEventId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetEventIdQueryResult = NonNullable<Awaited<ReturnType<typeof getEventId>>>
export type GetEventIdQueryError = void


export function useGetEventId<TData = Awaited<ReturnType<typeof getEventId>>, TError = void>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEventId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEventId>>,
          TError,
          Awaited<ReturnType<typeof getEventId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEventId<TData = Awaited<ReturnType<typeof getEventId>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEventId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEventId>>,
          TError,
          Awaited<ReturnType<typeof getEventId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEventId<TData = Awaited<ReturnType<typeof getEventId>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEventId>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get a specific event record
 */

export function useGetEventId<TData = Awaited<ReturnType<typeof getEventId>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEventId>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetEventIdQueryOptions(id,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Updates an existing event record
 * @summary Update a event record
 */
export const putEventId = (
    id: string,
    event: Event,
 ) => {
      
      
      return defaultInstance<PutEventId200>(
      {url: `/event/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: event
    },
      );
    }
  


export const getPutEventIdMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putEventId>>, TError,{id: string;data: Event}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof putEventId>>, TError,{id: string;data: Event}, TContext> => {
    
const mutationKey = ['putEventId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putEventId>>, {id: string;data: Event}> = (props) => {
          const {id,data} = props ?? {};

          return  putEventId(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutEventIdMutationResult = NonNullable<Awaited<ReturnType<typeof putEventId>>>
    export type PutEventIdMutationBody = Event
    export type PutEventIdMutationError = void

    /**
 * @summary Update a event record
 */
export const usePutEventId = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putEventId>>, TError,{id: string;data: Event}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putEventId>>,
        TError,
        {id: string;data: Event},
        TContext
      > => {

      const mutationOptions = getPutEventIdMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Partially updates an existing event record
 * @summary Partially update a event record
 */
export const patchEventId = (
    id: string,
    event: Event,
 ) => {
      
      
      return defaultInstance<PatchEventId200>(
      {url: `/event/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: event
    },
      );
    }
  


export const getPatchEventIdMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchEventId>>, TError,{id: string;data: Event}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof patchEventId>>, TError,{id: string;data: Event}, TContext> => {
    
const mutationKey = ['patchEventId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchEventId>>, {id: string;data: Event}> = (props) => {
          const {id,data} = props ?? {};

          return  patchEventId(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PatchEventIdMutationResult = NonNullable<Awaited<ReturnType<typeof patchEventId>>>
    export type PatchEventIdMutationBody = Event
    export type PatchEventIdMutationError = void

    /**
 * @summary Partially update a event record
 */
export const usePatchEventId = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchEventId>>, TError,{id: string;data: Event}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patchEventId>>,
        TError,
        {id: string;data: Event},
        TContext
      > => {

      const mutationOptions = getPatchEventIdMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Deletes a event record
 * @summary Delete a event record
 */
export const deleteEventId = (
    id: string,
 ) => {
      
      
      return defaultInstance<DeleteEventId200>(
      {url: `/event/${id}`, method: 'DELETE'
    },
      );
    }
  


export const getDeleteEventIdMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteEventId>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteEventId>>, TError,{id: string}, TContext> => {
    
const mutationKey = ['deleteEventId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteEventId>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteEventId(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteEventIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteEventId>>>
    
    export type DeleteEventIdMutationError = void

    /**
 * @summary Delete a event record
 */
export const useDeleteEventId = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteEventId>>, TError,{id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteEventId>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getDeleteEventIdMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Returns a list of business_access records with pagination
 * @summary Get all business_access records
 */
export const getBusinessAccess = (
    params?: GetBusinessAccessParams,
 signal?: AbortSignal
) => {
      
      
      return defaultInstance<GetBusinessAccess200>(
      {url: `/business_access`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getGetBusinessAccessQueryKey = (params?: GetBusinessAccessParams,) => {
    return [`/business_access`, ...(params ? [params]: [])] as const;
    }

    
export const getGetBusinessAccessQueryOptions = <TData = Awaited<ReturnType<typeof getBusinessAccess>>, TError = void>(params?: GetBusinessAccessParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBusinessAccess>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetBusinessAccessQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getBusinessAccess>>> = ({ signal }) => getBusinessAccess(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getBusinessAccess>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetBusinessAccessQueryResult = NonNullable<Awaited<ReturnType<typeof getBusinessAccess>>>
export type GetBusinessAccessQueryError = void


export function useGetBusinessAccess<TData = Awaited<ReturnType<typeof getBusinessAccess>>, TError = void>(
 params: undefined |  GetBusinessAccessParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBusinessAccess>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBusinessAccess>>,
          TError,
          Awaited<ReturnType<typeof getBusinessAccess>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBusinessAccess<TData = Awaited<ReturnType<typeof getBusinessAccess>>, TError = void>(
 params?: GetBusinessAccessParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBusinessAccess>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBusinessAccess>>,
          TError,
          Awaited<ReturnType<typeof getBusinessAccess>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBusinessAccess<TData = Awaited<ReturnType<typeof getBusinessAccess>>, TError = void>(
 params?: GetBusinessAccessParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBusinessAccess>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get all business_access records
 */

export function useGetBusinessAccess<TData = Awaited<ReturnType<typeof getBusinessAccess>>, TError = void>(
 params?: GetBusinessAccessParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBusinessAccess>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetBusinessAccessQueryOptions(params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Creates a new business_access record
 * @summary Create a new business_access record
 */
export const postBusinessAccess = (
    businessAccess: BusinessAccess,
 signal?: AbortSignal
) => {
      
      
      return defaultInstance<PostBusinessAccess200>(
      {url: `/business_access`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: businessAccess, signal
    },
      );
    }
  


export const getPostBusinessAccessMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postBusinessAccess>>, TError,{data: BusinessAccess}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postBusinessAccess>>, TError,{data: BusinessAccess}, TContext> => {
    
const mutationKey = ['postBusinessAccess'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postBusinessAccess>>, {data: BusinessAccess}> = (props) => {
          const {data} = props ?? {};

          return  postBusinessAccess(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostBusinessAccessMutationResult = NonNullable<Awaited<ReturnType<typeof postBusinessAccess>>>
    export type PostBusinessAccessMutationBody = BusinessAccess
    export type PostBusinessAccessMutationError = void

    /**
 * @summary Create a new business_access record
 */
export const usePostBusinessAccess = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postBusinessAccess>>, TError,{data: BusinessAccess}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postBusinessAccess>>,
        TError,
        {data: BusinessAccess},
        TContext
      > => {

      const mutationOptions = getPostBusinessAccessMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Returns a single business_access record by ID
 * @summary Get a specific business_access record
 */
export const getBusinessAccessId = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return defaultInstance<GetBusinessAccessId200>(
      {url: `/business_access/${id}`, method: 'GET', signal
    },
      );
    }
  

export const getGetBusinessAccessIdQueryKey = (id: string,) => {
    return [`/business_access/${id}`] as const;
    }

    
export const getGetBusinessAccessIdQueryOptions = <TData = Awaited<ReturnType<typeof getBusinessAccessId>>, TError = void>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBusinessAccessId>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetBusinessAccessIdQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getBusinessAccessId>>> = ({ signal }) => getBusinessAccessId(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getBusinessAccessId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetBusinessAccessIdQueryResult = NonNullable<Awaited<ReturnType<typeof getBusinessAccessId>>>
export type GetBusinessAccessIdQueryError = void


export function useGetBusinessAccessId<TData = Awaited<ReturnType<typeof getBusinessAccessId>>, TError = void>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBusinessAccessId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBusinessAccessId>>,
          TError,
          Awaited<ReturnType<typeof getBusinessAccessId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBusinessAccessId<TData = Awaited<ReturnType<typeof getBusinessAccessId>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBusinessAccessId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBusinessAccessId>>,
          TError,
          Awaited<ReturnType<typeof getBusinessAccessId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBusinessAccessId<TData = Awaited<ReturnType<typeof getBusinessAccessId>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBusinessAccessId>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get a specific business_access record
 */

export function useGetBusinessAccessId<TData = Awaited<ReturnType<typeof getBusinessAccessId>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBusinessAccessId>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetBusinessAccessIdQueryOptions(id,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Updates an existing business_access record
 * @summary Update a business_access record
 */
export const putBusinessAccessId = (
    id: string,
    businessAccess: BusinessAccess,
 ) => {
      
      
      return defaultInstance<PutBusinessAccessId200>(
      {url: `/business_access/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: businessAccess
    },
      );
    }
  


export const getPutBusinessAccessIdMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putBusinessAccessId>>, TError,{id: string;data: BusinessAccess}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof putBusinessAccessId>>, TError,{id: string;data: BusinessAccess}, TContext> => {
    
const mutationKey = ['putBusinessAccessId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putBusinessAccessId>>, {id: string;data: BusinessAccess}> = (props) => {
          const {id,data} = props ?? {};

          return  putBusinessAccessId(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutBusinessAccessIdMutationResult = NonNullable<Awaited<ReturnType<typeof putBusinessAccessId>>>
    export type PutBusinessAccessIdMutationBody = BusinessAccess
    export type PutBusinessAccessIdMutationError = void

    /**
 * @summary Update a business_access record
 */
export const usePutBusinessAccessId = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putBusinessAccessId>>, TError,{id: string;data: BusinessAccess}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putBusinessAccessId>>,
        TError,
        {id: string;data: BusinessAccess},
        TContext
      > => {

      const mutationOptions = getPutBusinessAccessIdMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Partially updates an existing business_access record
 * @summary Partially update a business_access record
 */
export const patchBusinessAccessId = (
    id: string,
    businessAccess: BusinessAccess,
 ) => {
      
      
      return defaultInstance<PatchBusinessAccessId200>(
      {url: `/business_access/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: businessAccess
    },
      );
    }
  


export const getPatchBusinessAccessIdMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchBusinessAccessId>>, TError,{id: string;data: BusinessAccess}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof patchBusinessAccessId>>, TError,{id: string;data: BusinessAccess}, TContext> => {
    
const mutationKey = ['patchBusinessAccessId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchBusinessAccessId>>, {id: string;data: BusinessAccess}> = (props) => {
          const {id,data} = props ?? {};

          return  patchBusinessAccessId(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PatchBusinessAccessIdMutationResult = NonNullable<Awaited<ReturnType<typeof patchBusinessAccessId>>>
    export type PatchBusinessAccessIdMutationBody = BusinessAccess
    export type PatchBusinessAccessIdMutationError = void

    /**
 * @summary Partially update a business_access record
 */
export const usePatchBusinessAccessId = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchBusinessAccessId>>, TError,{id: string;data: BusinessAccess}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patchBusinessAccessId>>,
        TError,
        {id: string;data: BusinessAccess},
        TContext
      > => {

      const mutationOptions = getPatchBusinessAccessIdMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Deletes a business_access record
 * @summary Delete a business_access record
 */
export const deleteBusinessAccessId = (
    id: string,
 ) => {
      
      
      return defaultInstance<DeleteBusinessAccessId200>(
      {url: `/business_access/${id}`, method: 'DELETE'
    },
      );
    }
  


export const getDeleteBusinessAccessIdMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteBusinessAccessId>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteBusinessAccessId>>, TError,{id: string}, TContext> => {
    
const mutationKey = ['deleteBusinessAccessId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteBusinessAccessId>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteBusinessAccessId(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteBusinessAccessIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteBusinessAccessId>>>
    
    export type DeleteBusinessAccessIdMutationError = void

    /**
 * @summary Delete a business_access record
 */
export const useDeleteBusinessAccessId = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteBusinessAccessId>>, TError,{id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteBusinessAccessId>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getDeleteBusinessAccessIdMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Returns a list of service_type records with pagination
 * @summary Get all service_type records
 */
export const getServiceType = (
    params?: GetServiceTypeParams,
 signal?: AbortSignal
) => {
      
      
      return defaultInstance<GetServiceType200>(
      {url: `/service_type`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getGetServiceTypeQueryKey = (params?: GetServiceTypeParams,) => {
    return [`/service_type`, ...(params ? [params]: [])] as const;
    }

    
export const getGetServiceTypeQueryOptions = <TData = Awaited<ReturnType<typeof getServiceType>>, TError = void>(params?: GetServiceTypeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getServiceType>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetServiceTypeQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getServiceType>>> = ({ signal }) => getServiceType(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getServiceType>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetServiceTypeQueryResult = NonNullable<Awaited<ReturnType<typeof getServiceType>>>
export type GetServiceTypeQueryError = void


export function useGetServiceType<TData = Awaited<ReturnType<typeof getServiceType>>, TError = void>(
 params: undefined |  GetServiceTypeParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getServiceType>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getServiceType>>,
          TError,
          Awaited<ReturnType<typeof getServiceType>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetServiceType<TData = Awaited<ReturnType<typeof getServiceType>>, TError = void>(
 params?: GetServiceTypeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getServiceType>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getServiceType>>,
          TError,
          Awaited<ReturnType<typeof getServiceType>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetServiceType<TData = Awaited<ReturnType<typeof getServiceType>>, TError = void>(
 params?: GetServiceTypeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getServiceType>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get all service_type records
 */

export function useGetServiceType<TData = Awaited<ReturnType<typeof getServiceType>>, TError = void>(
 params?: GetServiceTypeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getServiceType>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetServiceTypeQueryOptions(params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Creates a new service_type record
 * @summary Create a new service_type record
 */
export const postServiceType = (
    serviceType: ServiceType,
 signal?: AbortSignal
) => {
      
      
      return defaultInstance<PostServiceType200>(
      {url: `/service_type`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: serviceType, signal
    },
      );
    }
  


export const getPostServiceTypeMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postServiceType>>, TError,{data: ServiceType}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postServiceType>>, TError,{data: ServiceType}, TContext> => {
    
const mutationKey = ['postServiceType'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postServiceType>>, {data: ServiceType}> = (props) => {
          const {data} = props ?? {};

          return  postServiceType(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostServiceTypeMutationResult = NonNullable<Awaited<ReturnType<typeof postServiceType>>>
    export type PostServiceTypeMutationBody = ServiceType
    export type PostServiceTypeMutationError = void

    /**
 * @summary Create a new service_type record
 */
export const usePostServiceType = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postServiceType>>, TError,{data: ServiceType}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postServiceType>>,
        TError,
        {data: ServiceType},
        TContext
      > => {

      const mutationOptions = getPostServiceTypeMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Returns a single service_type record by ID
 * @summary Get a specific service_type record
 */
export const getServiceTypeId = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return defaultInstance<GetServiceTypeId200>(
      {url: `/service_type/${id}`, method: 'GET', signal
    },
      );
    }
  

export const getGetServiceTypeIdQueryKey = (id: string,) => {
    return [`/service_type/${id}`] as const;
    }

    
export const getGetServiceTypeIdQueryOptions = <TData = Awaited<ReturnType<typeof getServiceTypeId>>, TError = void>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getServiceTypeId>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetServiceTypeIdQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getServiceTypeId>>> = ({ signal }) => getServiceTypeId(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getServiceTypeId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetServiceTypeIdQueryResult = NonNullable<Awaited<ReturnType<typeof getServiceTypeId>>>
export type GetServiceTypeIdQueryError = void


export function useGetServiceTypeId<TData = Awaited<ReturnType<typeof getServiceTypeId>>, TError = void>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getServiceTypeId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getServiceTypeId>>,
          TError,
          Awaited<ReturnType<typeof getServiceTypeId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetServiceTypeId<TData = Awaited<ReturnType<typeof getServiceTypeId>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getServiceTypeId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getServiceTypeId>>,
          TError,
          Awaited<ReturnType<typeof getServiceTypeId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetServiceTypeId<TData = Awaited<ReturnType<typeof getServiceTypeId>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getServiceTypeId>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get a specific service_type record
 */

export function useGetServiceTypeId<TData = Awaited<ReturnType<typeof getServiceTypeId>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getServiceTypeId>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetServiceTypeIdQueryOptions(id,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Updates an existing service_type record
 * @summary Update a service_type record
 */
export const putServiceTypeId = (
    id: string,
    serviceType: ServiceType,
 ) => {
      
      
      return defaultInstance<PutServiceTypeId200>(
      {url: `/service_type/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: serviceType
    },
      );
    }
  


export const getPutServiceTypeIdMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putServiceTypeId>>, TError,{id: string;data: ServiceType}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof putServiceTypeId>>, TError,{id: string;data: ServiceType}, TContext> => {
    
const mutationKey = ['putServiceTypeId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putServiceTypeId>>, {id: string;data: ServiceType}> = (props) => {
          const {id,data} = props ?? {};

          return  putServiceTypeId(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutServiceTypeIdMutationResult = NonNullable<Awaited<ReturnType<typeof putServiceTypeId>>>
    export type PutServiceTypeIdMutationBody = ServiceType
    export type PutServiceTypeIdMutationError = void

    /**
 * @summary Update a service_type record
 */
export const usePutServiceTypeId = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putServiceTypeId>>, TError,{id: string;data: ServiceType}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putServiceTypeId>>,
        TError,
        {id: string;data: ServiceType},
        TContext
      > => {

      const mutationOptions = getPutServiceTypeIdMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Partially updates an existing service_type record
 * @summary Partially update a service_type record
 */
export const patchServiceTypeId = (
    id: string,
    serviceType: ServiceType,
 ) => {
      
      
      return defaultInstance<PatchServiceTypeId200>(
      {url: `/service_type/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: serviceType
    },
      );
    }
  


export const getPatchServiceTypeIdMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchServiceTypeId>>, TError,{id: string;data: ServiceType}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof patchServiceTypeId>>, TError,{id: string;data: ServiceType}, TContext> => {
    
const mutationKey = ['patchServiceTypeId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchServiceTypeId>>, {id: string;data: ServiceType}> = (props) => {
          const {id,data} = props ?? {};

          return  patchServiceTypeId(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PatchServiceTypeIdMutationResult = NonNullable<Awaited<ReturnType<typeof patchServiceTypeId>>>
    export type PatchServiceTypeIdMutationBody = ServiceType
    export type PatchServiceTypeIdMutationError = void

    /**
 * @summary Partially update a service_type record
 */
export const usePatchServiceTypeId = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchServiceTypeId>>, TError,{id: string;data: ServiceType}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patchServiceTypeId>>,
        TError,
        {id: string;data: ServiceType},
        TContext
      > => {

      const mutationOptions = getPatchServiceTypeIdMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Deletes a service_type record
 * @summary Delete a service_type record
 */
export const deleteServiceTypeId = (
    id: string,
 ) => {
      
      
      return defaultInstance<DeleteServiceTypeId200>(
      {url: `/service_type/${id}`, method: 'DELETE'
    },
      );
    }
  


export const getDeleteServiceTypeIdMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteServiceTypeId>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteServiceTypeId>>, TError,{id: string}, TContext> => {
    
const mutationKey = ['deleteServiceTypeId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteServiceTypeId>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteServiceTypeId(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteServiceTypeIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteServiceTypeId>>>
    
    export type DeleteServiceTypeIdMutationError = void

    /**
 * @summary Delete a service_type record
 */
export const useDeleteServiceTypeId = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteServiceTypeId>>, TError,{id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteServiceTypeId>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getDeleteServiceTypeIdMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Returns a list of service_group records with pagination
 * @summary Get all service_group records
 */
export const getServiceGroup = (
    params?: GetServiceGroupParams,
 signal?: AbortSignal
) => {
      
      
      return defaultInstance<GetServiceGroup200>(
      {url: `/service_group`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getGetServiceGroupQueryKey = (params?: GetServiceGroupParams,) => {
    return [`/service_group`, ...(params ? [params]: [])] as const;
    }

    
export const getGetServiceGroupQueryOptions = <TData = Awaited<ReturnType<typeof getServiceGroup>>, TError = void>(params?: GetServiceGroupParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getServiceGroup>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetServiceGroupQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getServiceGroup>>> = ({ signal }) => getServiceGroup(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getServiceGroup>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetServiceGroupQueryResult = NonNullable<Awaited<ReturnType<typeof getServiceGroup>>>
export type GetServiceGroupQueryError = void


export function useGetServiceGroup<TData = Awaited<ReturnType<typeof getServiceGroup>>, TError = void>(
 params: undefined |  GetServiceGroupParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getServiceGroup>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getServiceGroup>>,
          TError,
          Awaited<ReturnType<typeof getServiceGroup>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetServiceGroup<TData = Awaited<ReturnType<typeof getServiceGroup>>, TError = void>(
 params?: GetServiceGroupParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getServiceGroup>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getServiceGroup>>,
          TError,
          Awaited<ReturnType<typeof getServiceGroup>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetServiceGroup<TData = Awaited<ReturnType<typeof getServiceGroup>>, TError = void>(
 params?: GetServiceGroupParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getServiceGroup>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get all service_group records
 */

export function useGetServiceGroup<TData = Awaited<ReturnType<typeof getServiceGroup>>, TError = void>(
 params?: GetServiceGroupParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getServiceGroup>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetServiceGroupQueryOptions(params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Creates a new service_group record
 * @summary Create a new service_group record
 */
export const postServiceGroup = (
    serviceGroup: ServiceGroup,
 signal?: AbortSignal
) => {
      
      
      return defaultInstance<PostServiceGroup200>(
      {url: `/service_group`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: serviceGroup, signal
    },
      );
    }
  


export const getPostServiceGroupMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postServiceGroup>>, TError,{data: ServiceGroup}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postServiceGroup>>, TError,{data: ServiceGroup}, TContext> => {
    
const mutationKey = ['postServiceGroup'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postServiceGroup>>, {data: ServiceGroup}> = (props) => {
          const {data} = props ?? {};

          return  postServiceGroup(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostServiceGroupMutationResult = NonNullable<Awaited<ReturnType<typeof postServiceGroup>>>
    export type PostServiceGroupMutationBody = ServiceGroup
    export type PostServiceGroupMutationError = void

    /**
 * @summary Create a new service_group record
 */
export const usePostServiceGroup = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postServiceGroup>>, TError,{data: ServiceGroup}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postServiceGroup>>,
        TError,
        {data: ServiceGroup},
        TContext
      > => {

      const mutationOptions = getPostServiceGroupMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Returns a single service_group record by ID
 * @summary Get a specific service_group record
 */
export const getServiceGroupId = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return defaultInstance<GetServiceGroupId200>(
      {url: `/service_group/${id}`, method: 'GET', signal
    },
      );
    }
  

export const getGetServiceGroupIdQueryKey = (id: string,) => {
    return [`/service_group/${id}`] as const;
    }

    
export const getGetServiceGroupIdQueryOptions = <TData = Awaited<ReturnType<typeof getServiceGroupId>>, TError = void>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getServiceGroupId>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetServiceGroupIdQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getServiceGroupId>>> = ({ signal }) => getServiceGroupId(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getServiceGroupId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetServiceGroupIdQueryResult = NonNullable<Awaited<ReturnType<typeof getServiceGroupId>>>
export type GetServiceGroupIdQueryError = void


export function useGetServiceGroupId<TData = Awaited<ReturnType<typeof getServiceGroupId>>, TError = void>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getServiceGroupId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getServiceGroupId>>,
          TError,
          Awaited<ReturnType<typeof getServiceGroupId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetServiceGroupId<TData = Awaited<ReturnType<typeof getServiceGroupId>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getServiceGroupId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getServiceGroupId>>,
          TError,
          Awaited<ReturnType<typeof getServiceGroupId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetServiceGroupId<TData = Awaited<ReturnType<typeof getServiceGroupId>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getServiceGroupId>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get a specific service_group record
 */

export function useGetServiceGroupId<TData = Awaited<ReturnType<typeof getServiceGroupId>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getServiceGroupId>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetServiceGroupIdQueryOptions(id,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Updates an existing service_group record
 * @summary Update a service_group record
 */
export const putServiceGroupId = (
    id: string,
    serviceGroup: ServiceGroup,
 ) => {
      
      
      return defaultInstance<PutServiceGroupId200>(
      {url: `/service_group/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: serviceGroup
    },
      );
    }
  


export const getPutServiceGroupIdMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putServiceGroupId>>, TError,{id: string;data: ServiceGroup}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof putServiceGroupId>>, TError,{id: string;data: ServiceGroup}, TContext> => {
    
const mutationKey = ['putServiceGroupId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putServiceGroupId>>, {id: string;data: ServiceGroup}> = (props) => {
          const {id,data} = props ?? {};

          return  putServiceGroupId(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutServiceGroupIdMutationResult = NonNullable<Awaited<ReturnType<typeof putServiceGroupId>>>
    export type PutServiceGroupIdMutationBody = ServiceGroup
    export type PutServiceGroupIdMutationError = void

    /**
 * @summary Update a service_group record
 */
export const usePutServiceGroupId = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putServiceGroupId>>, TError,{id: string;data: ServiceGroup}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putServiceGroupId>>,
        TError,
        {id: string;data: ServiceGroup},
        TContext
      > => {

      const mutationOptions = getPutServiceGroupIdMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Partially updates an existing service_group record
 * @summary Partially update a service_group record
 */
export const patchServiceGroupId = (
    id: string,
    serviceGroup: ServiceGroup,
 ) => {
      
      
      return defaultInstance<PatchServiceGroupId200>(
      {url: `/service_group/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: serviceGroup
    },
      );
    }
  


export const getPatchServiceGroupIdMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchServiceGroupId>>, TError,{id: string;data: ServiceGroup}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof patchServiceGroupId>>, TError,{id: string;data: ServiceGroup}, TContext> => {
    
const mutationKey = ['patchServiceGroupId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchServiceGroupId>>, {id: string;data: ServiceGroup}> = (props) => {
          const {id,data} = props ?? {};

          return  patchServiceGroupId(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PatchServiceGroupIdMutationResult = NonNullable<Awaited<ReturnType<typeof patchServiceGroupId>>>
    export type PatchServiceGroupIdMutationBody = ServiceGroup
    export type PatchServiceGroupIdMutationError = void

    /**
 * @summary Partially update a service_group record
 */
export const usePatchServiceGroupId = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchServiceGroupId>>, TError,{id: string;data: ServiceGroup}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patchServiceGroupId>>,
        TError,
        {id: string;data: ServiceGroup},
        TContext
      > => {

      const mutationOptions = getPatchServiceGroupIdMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Deletes a service_group record
 * @summary Delete a service_group record
 */
export const deleteServiceGroupId = (
    id: string,
 ) => {
      
      
      return defaultInstance<DeleteServiceGroupId200>(
      {url: `/service_group/${id}`, method: 'DELETE'
    },
      );
    }
  


export const getDeleteServiceGroupIdMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteServiceGroupId>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteServiceGroupId>>, TError,{id: string}, TContext> => {
    
const mutationKey = ['deleteServiceGroupId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteServiceGroupId>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteServiceGroupId(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteServiceGroupIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteServiceGroupId>>>
    
    export type DeleteServiceGroupIdMutationError = void

    /**
 * @summary Delete a service_group record
 */
export const useDeleteServiceGroupId = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteServiceGroupId>>, TError,{id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteServiceGroupId>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getDeleteServiceGroupIdMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Returns a list of service_status records with pagination
 * @summary Get all service_status records
 */
export const getServiceStatus = (
    params?: GetServiceStatusParams,
 signal?: AbortSignal
) => {
      
      
      return defaultInstance<GetServiceStatus200>(
      {url: `/service_status`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getGetServiceStatusQueryKey = (params?: GetServiceStatusParams,) => {
    return [`/service_status`, ...(params ? [params]: [])] as const;
    }

    
export const getGetServiceStatusQueryOptions = <TData = Awaited<ReturnType<typeof getServiceStatus>>, TError = void>(params?: GetServiceStatusParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getServiceStatus>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetServiceStatusQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getServiceStatus>>> = ({ signal }) => getServiceStatus(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getServiceStatus>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetServiceStatusQueryResult = NonNullable<Awaited<ReturnType<typeof getServiceStatus>>>
export type GetServiceStatusQueryError = void


export function useGetServiceStatus<TData = Awaited<ReturnType<typeof getServiceStatus>>, TError = void>(
 params: undefined |  GetServiceStatusParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getServiceStatus>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getServiceStatus>>,
          TError,
          Awaited<ReturnType<typeof getServiceStatus>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetServiceStatus<TData = Awaited<ReturnType<typeof getServiceStatus>>, TError = void>(
 params?: GetServiceStatusParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getServiceStatus>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getServiceStatus>>,
          TError,
          Awaited<ReturnType<typeof getServiceStatus>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetServiceStatus<TData = Awaited<ReturnType<typeof getServiceStatus>>, TError = void>(
 params?: GetServiceStatusParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getServiceStatus>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get all service_status records
 */

export function useGetServiceStatus<TData = Awaited<ReturnType<typeof getServiceStatus>>, TError = void>(
 params?: GetServiceStatusParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getServiceStatus>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetServiceStatusQueryOptions(params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Creates a new service_status record
 * @summary Create a new service_status record
 */
export const postServiceStatus = (
    serviceStatus: ServiceStatus,
 signal?: AbortSignal
) => {
      
      
      return defaultInstance<PostServiceStatus200>(
      {url: `/service_status`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: serviceStatus, signal
    },
      );
    }
  


export const getPostServiceStatusMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postServiceStatus>>, TError,{data: ServiceStatus}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postServiceStatus>>, TError,{data: ServiceStatus}, TContext> => {
    
const mutationKey = ['postServiceStatus'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postServiceStatus>>, {data: ServiceStatus}> = (props) => {
          const {data} = props ?? {};

          return  postServiceStatus(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostServiceStatusMutationResult = NonNullable<Awaited<ReturnType<typeof postServiceStatus>>>
    export type PostServiceStatusMutationBody = ServiceStatus
    export type PostServiceStatusMutationError = void

    /**
 * @summary Create a new service_status record
 */
export const usePostServiceStatus = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postServiceStatus>>, TError,{data: ServiceStatus}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postServiceStatus>>,
        TError,
        {data: ServiceStatus},
        TContext
      > => {

      const mutationOptions = getPostServiceStatusMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Returns a single service_status record by ID
 * @summary Get a specific service_status record
 */
export const getServiceStatusId = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return defaultInstance<GetServiceStatusId200>(
      {url: `/service_status/${id}`, method: 'GET', signal
    },
      );
    }
  

export const getGetServiceStatusIdQueryKey = (id: string,) => {
    return [`/service_status/${id}`] as const;
    }

    
export const getGetServiceStatusIdQueryOptions = <TData = Awaited<ReturnType<typeof getServiceStatusId>>, TError = void>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getServiceStatusId>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetServiceStatusIdQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getServiceStatusId>>> = ({ signal }) => getServiceStatusId(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getServiceStatusId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetServiceStatusIdQueryResult = NonNullable<Awaited<ReturnType<typeof getServiceStatusId>>>
export type GetServiceStatusIdQueryError = void


export function useGetServiceStatusId<TData = Awaited<ReturnType<typeof getServiceStatusId>>, TError = void>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getServiceStatusId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getServiceStatusId>>,
          TError,
          Awaited<ReturnType<typeof getServiceStatusId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetServiceStatusId<TData = Awaited<ReturnType<typeof getServiceStatusId>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getServiceStatusId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getServiceStatusId>>,
          TError,
          Awaited<ReturnType<typeof getServiceStatusId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetServiceStatusId<TData = Awaited<ReturnType<typeof getServiceStatusId>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getServiceStatusId>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get a specific service_status record
 */

export function useGetServiceStatusId<TData = Awaited<ReturnType<typeof getServiceStatusId>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getServiceStatusId>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetServiceStatusIdQueryOptions(id,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Updates an existing service_status record
 * @summary Update a service_status record
 */
export const putServiceStatusId = (
    id: string,
    serviceStatus: ServiceStatus,
 ) => {
      
      
      return defaultInstance<PutServiceStatusId200>(
      {url: `/service_status/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: serviceStatus
    },
      );
    }
  


export const getPutServiceStatusIdMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putServiceStatusId>>, TError,{id: string;data: ServiceStatus}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof putServiceStatusId>>, TError,{id: string;data: ServiceStatus}, TContext> => {
    
const mutationKey = ['putServiceStatusId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putServiceStatusId>>, {id: string;data: ServiceStatus}> = (props) => {
          const {id,data} = props ?? {};

          return  putServiceStatusId(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutServiceStatusIdMutationResult = NonNullable<Awaited<ReturnType<typeof putServiceStatusId>>>
    export type PutServiceStatusIdMutationBody = ServiceStatus
    export type PutServiceStatusIdMutationError = void

    /**
 * @summary Update a service_status record
 */
export const usePutServiceStatusId = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putServiceStatusId>>, TError,{id: string;data: ServiceStatus}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putServiceStatusId>>,
        TError,
        {id: string;data: ServiceStatus},
        TContext
      > => {

      const mutationOptions = getPutServiceStatusIdMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Partially updates an existing service_status record
 * @summary Partially update a service_status record
 */
export const patchServiceStatusId = (
    id: string,
    serviceStatus: ServiceStatus,
 ) => {
      
      
      return defaultInstance<PatchServiceStatusId200>(
      {url: `/service_status/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: serviceStatus
    },
      );
    }
  


export const getPatchServiceStatusIdMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchServiceStatusId>>, TError,{id: string;data: ServiceStatus}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof patchServiceStatusId>>, TError,{id: string;data: ServiceStatus}, TContext> => {
    
const mutationKey = ['patchServiceStatusId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchServiceStatusId>>, {id: string;data: ServiceStatus}> = (props) => {
          const {id,data} = props ?? {};

          return  patchServiceStatusId(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PatchServiceStatusIdMutationResult = NonNullable<Awaited<ReturnType<typeof patchServiceStatusId>>>
    export type PatchServiceStatusIdMutationBody = ServiceStatus
    export type PatchServiceStatusIdMutationError = void

    /**
 * @summary Partially update a service_status record
 */
export const usePatchServiceStatusId = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchServiceStatusId>>, TError,{id: string;data: ServiceStatus}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patchServiceStatusId>>,
        TError,
        {id: string;data: ServiceStatus},
        TContext
      > => {

      const mutationOptions = getPatchServiceStatusIdMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Deletes a service_status record
 * @summary Delete a service_status record
 */
export const deleteServiceStatusId = (
    id: string,
 ) => {
      
      
      return defaultInstance<DeleteServiceStatusId200>(
      {url: `/service_status/${id}`, method: 'DELETE'
    },
      );
    }
  


export const getDeleteServiceStatusIdMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteServiceStatusId>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteServiceStatusId>>, TError,{id: string}, TContext> => {
    
const mutationKey = ['deleteServiceStatusId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteServiceStatusId>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteServiceStatusId(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteServiceStatusIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteServiceStatusId>>>
    
    export type DeleteServiceStatusIdMutationError = void

    /**
 * @summary Delete a service_status record
 */
export const useDeleteServiceStatusId = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteServiceStatusId>>, TError,{id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteServiceStatusId>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getDeleteServiceStatusIdMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Returns a list of service records with pagination
 * @summary Get all service records
 */
export const getService = (
    params?: GetServiceParams,
 signal?: AbortSignal
) => {
      
      
      return defaultInstance<GetService200>(
      {url: `/service`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getGetServiceQueryKey = (params?: GetServiceParams,) => {
    return [`/service`, ...(params ? [params]: [])] as const;
    }

    
export const getGetServiceQueryOptions = <TData = Awaited<ReturnType<typeof getService>>, TError = void>(params?: GetServiceParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getService>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetServiceQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getService>>> = ({ signal }) => getService(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getService>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetServiceQueryResult = NonNullable<Awaited<ReturnType<typeof getService>>>
export type GetServiceQueryError = void


export function useGetService<TData = Awaited<ReturnType<typeof getService>>, TError = void>(
 params: undefined |  GetServiceParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getService>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getService>>,
          TError,
          Awaited<ReturnType<typeof getService>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetService<TData = Awaited<ReturnType<typeof getService>>, TError = void>(
 params?: GetServiceParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getService>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getService>>,
          TError,
          Awaited<ReturnType<typeof getService>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetService<TData = Awaited<ReturnType<typeof getService>>, TError = void>(
 params?: GetServiceParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getService>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get all service records
 */

export function useGetService<TData = Awaited<ReturnType<typeof getService>>, TError = void>(
 params?: GetServiceParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getService>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetServiceQueryOptions(params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Creates a new service record
 * @summary Create a new service record
 */
export const postService = (
    service: Service,
 signal?: AbortSignal
) => {
      
      
      return defaultInstance<PostService200>(
      {url: `/service`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: service, signal
    },
      );
    }
  


export const getPostServiceMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postService>>, TError,{data: Service}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postService>>, TError,{data: Service}, TContext> => {
    
const mutationKey = ['postService'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postService>>, {data: Service}> = (props) => {
          const {data} = props ?? {};

          return  postService(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostServiceMutationResult = NonNullable<Awaited<ReturnType<typeof postService>>>
    export type PostServiceMutationBody = Service
    export type PostServiceMutationError = void

    /**
 * @summary Create a new service record
 */
export const usePostService = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postService>>, TError,{data: Service}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postService>>,
        TError,
        {data: Service},
        TContext
      > => {

      const mutationOptions = getPostServiceMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Returns a single service record by ID
 * @summary Get a specific service record
 */
export const getServiceId = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return defaultInstance<GetServiceId200>(
      {url: `/service/${id}`, method: 'GET', signal
    },
      );
    }
  

export const getGetServiceIdQueryKey = (id: string,) => {
    return [`/service/${id}`] as const;
    }

    
export const getGetServiceIdQueryOptions = <TData = Awaited<ReturnType<typeof getServiceId>>, TError = void>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getServiceId>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetServiceIdQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getServiceId>>> = ({ signal }) => getServiceId(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getServiceId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetServiceIdQueryResult = NonNullable<Awaited<ReturnType<typeof getServiceId>>>
export type GetServiceIdQueryError = void


export function useGetServiceId<TData = Awaited<ReturnType<typeof getServiceId>>, TError = void>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getServiceId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getServiceId>>,
          TError,
          Awaited<ReturnType<typeof getServiceId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetServiceId<TData = Awaited<ReturnType<typeof getServiceId>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getServiceId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getServiceId>>,
          TError,
          Awaited<ReturnType<typeof getServiceId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetServiceId<TData = Awaited<ReturnType<typeof getServiceId>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getServiceId>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get a specific service record
 */

export function useGetServiceId<TData = Awaited<ReturnType<typeof getServiceId>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getServiceId>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetServiceIdQueryOptions(id,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Updates an existing service record
 * @summary Update a service record
 */
export const putServiceId = (
    id: string,
    service: Service,
 ) => {
      
      
      return defaultInstance<PutServiceId200>(
      {url: `/service/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: service
    },
      );
    }
  


export const getPutServiceIdMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putServiceId>>, TError,{id: string;data: Service}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof putServiceId>>, TError,{id: string;data: Service}, TContext> => {
    
const mutationKey = ['putServiceId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putServiceId>>, {id: string;data: Service}> = (props) => {
          const {id,data} = props ?? {};

          return  putServiceId(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutServiceIdMutationResult = NonNullable<Awaited<ReturnType<typeof putServiceId>>>
    export type PutServiceIdMutationBody = Service
    export type PutServiceIdMutationError = void

    /**
 * @summary Update a service record
 */
export const usePutServiceId = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putServiceId>>, TError,{id: string;data: Service}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putServiceId>>,
        TError,
        {id: string;data: Service},
        TContext
      > => {

      const mutationOptions = getPutServiceIdMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Partially updates an existing service record
 * @summary Partially update a service record
 */
export const patchServiceId = (
    id: string,
    service: Service,
 ) => {
      
      
      return defaultInstance<PatchServiceId200>(
      {url: `/service/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: service
    },
      );
    }
  


export const getPatchServiceIdMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchServiceId>>, TError,{id: string;data: Service}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof patchServiceId>>, TError,{id: string;data: Service}, TContext> => {
    
const mutationKey = ['patchServiceId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchServiceId>>, {id: string;data: Service}> = (props) => {
          const {id,data} = props ?? {};

          return  patchServiceId(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PatchServiceIdMutationResult = NonNullable<Awaited<ReturnType<typeof patchServiceId>>>
    export type PatchServiceIdMutationBody = Service
    export type PatchServiceIdMutationError = void

    /**
 * @summary Partially update a service record
 */
export const usePatchServiceId = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchServiceId>>, TError,{id: string;data: Service}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patchServiceId>>,
        TError,
        {id: string;data: Service},
        TContext
      > => {

      const mutationOptions = getPatchServiceIdMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Deletes a service record
 * @summary Delete a service record
 */
export const deleteServiceId = (
    id: string,
 ) => {
      
      
      return defaultInstance<DeleteServiceId200>(
      {url: `/service/${id}`, method: 'DELETE'
    },
      );
    }
  


export const getDeleteServiceIdMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteServiceId>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteServiceId>>, TError,{id: string}, TContext> => {
    
const mutationKey = ['deleteServiceId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteServiceId>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteServiceId(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteServiceIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteServiceId>>>
    
    export type DeleteServiceIdMutationError = void

    /**
 * @summary Delete a service record
 */
export const useDeleteServiceId = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteServiceId>>, TError,{id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteServiceId>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getDeleteServiceIdMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Returns a list of user_contracts records with pagination
 * @summary Get all user_contracts records
 */
export const getUserContracts = (
    params?: GetUserContractsParams,
 signal?: AbortSignal
) => {
      
      
      return defaultInstance<GetUserContracts200>(
      {url: `/user_contracts`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getGetUserContractsQueryKey = (params?: GetUserContractsParams,) => {
    return [`/user_contracts`, ...(params ? [params]: [])] as const;
    }

    
export const getGetUserContractsQueryOptions = <TData = Awaited<ReturnType<typeof getUserContracts>>, TError = void>(params?: GetUserContractsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserContracts>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUserContractsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUserContracts>>> = ({ signal }) => getUserContracts(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getUserContracts>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetUserContractsQueryResult = NonNullable<Awaited<ReturnType<typeof getUserContracts>>>
export type GetUserContractsQueryError = void


export function useGetUserContracts<TData = Awaited<ReturnType<typeof getUserContracts>>, TError = void>(
 params: undefined |  GetUserContractsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserContracts>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserContracts>>,
          TError,
          Awaited<ReturnType<typeof getUserContracts>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUserContracts<TData = Awaited<ReturnType<typeof getUserContracts>>, TError = void>(
 params?: GetUserContractsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserContracts>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserContracts>>,
          TError,
          Awaited<ReturnType<typeof getUserContracts>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUserContracts<TData = Awaited<ReturnType<typeof getUserContracts>>, TError = void>(
 params?: GetUserContractsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserContracts>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get all user_contracts records
 */

export function useGetUserContracts<TData = Awaited<ReturnType<typeof getUserContracts>>, TError = void>(
 params?: GetUserContractsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserContracts>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetUserContractsQueryOptions(params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Creates a new user_contracts record
 * @summary Create a new user_contracts record
 */
export const postUserContracts = (
    userContracts: UserContracts,
 signal?: AbortSignal
) => {
      
      
      return defaultInstance<PostUserContracts200>(
      {url: `/user_contracts`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: userContracts, signal
    },
      );
    }
  


export const getPostUserContractsMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postUserContracts>>, TError,{data: UserContracts}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postUserContracts>>, TError,{data: UserContracts}, TContext> => {
    
const mutationKey = ['postUserContracts'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postUserContracts>>, {data: UserContracts}> = (props) => {
          const {data} = props ?? {};

          return  postUserContracts(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostUserContractsMutationResult = NonNullable<Awaited<ReturnType<typeof postUserContracts>>>
    export type PostUserContractsMutationBody = UserContracts
    export type PostUserContractsMutationError = void

    /**
 * @summary Create a new user_contracts record
 */
export const usePostUserContracts = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postUserContracts>>, TError,{data: UserContracts}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postUserContracts>>,
        TError,
        {data: UserContracts},
        TContext
      > => {

      const mutationOptions = getPostUserContractsMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Returns a single user_contracts record by ID
 * @summary Get a specific user_contracts record
 */
export const getUserContractsId = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return defaultInstance<GetUserContractsId200>(
      {url: `/user_contracts/${id}`, method: 'GET', signal
    },
      );
    }
  

export const getGetUserContractsIdQueryKey = (id: string,) => {
    return [`/user_contracts/${id}`] as const;
    }

    
export const getGetUserContractsIdQueryOptions = <TData = Awaited<ReturnType<typeof getUserContractsId>>, TError = void>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserContractsId>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUserContractsIdQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUserContractsId>>> = ({ signal }) => getUserContractsId(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getUserContractsId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetUserContractsIdQueryResult = NonNullable<Awaited<ReturnType<typeof getUserContractsId>>>
export type GetUserContractsIdQueryError = void


export function useGetUserContractsId<TData = Awaited<ReturnType<typeof getUserContractsId>>, TError = void>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserContractsId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserContractsId>>,
          TError,
          Awaited<ReturnType<typeof getUserContractsId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUserContractsId<TData = Awaited<ReturnType<typeof getUserContractsId>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserContractsId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserContractsId>>,
          TError,
          Awaited<ReturnType<typeof getUserContractsId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUserContractsId<TData = Awaited<ReturnType<typeof getUserContractsId>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserContractsId>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get a specific user_contracts record
 */

export function useGetUserContractsId<TData = Awaited<ReturnType<typeof getUserContractsId>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserContractsId>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetUserContractsIdQueryOptions(id,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Updates an existing user_contracts record
 * @summary Update a user_contracts record
 */
export const putUserContractsId = (
    id: string,
    userContracts: UserContracts,
 ) => {
      
      
      return defaultInstance<PutUserContractsId200>(
      {url: `/user_contracts/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: userContracts
    },
      );
    }
  


export const getPutUserContractsIdMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putUserContractsId>>, TError,{id: string;data: UserContracts}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof putUserContractsId>>, TError,{id: string;data: UserContracts}, TContext> => {
    
const mutationKey = ['putUserContractsId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putUserContractsId>>, {id: string;data: UserContracts}> = (props) => {
          const {id,data} = props ?? {};

          return  putUserContractsId(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutUserContractsIdMutationResult = NonNullable<Awaited<ReturnType<typeof putUserContractsId>>>
    export type PutUserContractsIdMutationBody = UserContracts
    export type PutUserContractsIdMutationError = void

    /**
 * @summary Update a user_contracts record
 */
export const usePutUserContractsId = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putUserContractsId>>, TError,{id: string;data: UserContracts}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putUserContractsId>>,
        TError,
        {id: string;data: UserContracts},
        TContext
      > => {

      const mutationOptions = getPutUserContractsIdMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Partially updates an existing user_contracts record
 * @summary Partially update a user_contracts record
 */
export const patchUserContractsId = (
    id: string,
    userContracts: UserContracts,
 ) => {
      
      
      return defaultInstance<PatchUserContractsId200>(
      {url: `/user_contracts/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: userContracts
    },
      );
    }
  


export const getPatchUserContractsIdMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchUserContractsId>>, TError,{id: string;data: UserContracts}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof patchUserContractsId>>, TError,{id: string;data: UserContracts}, TContext> => {
    
const mutationKey = ['patchUserContractsId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchUserContractsId>>, {id: string;data: UserContracts}> = (props) => {
          const {id,data} = props ?? {};

          return  patchUserContractsId(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PatchUserContractsIdMutationResult = NonNullable<Awaited<ReturnType<typeof patchUserContractsId>>>
    export type PatchUserContractsIdMutationBody = UserContracts
    export type PatchUserContractsIdMutationError = void

    /**
 * @summary Partially update a user_contracts record
 */
export const usePatchUserContractsId = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchUserContractsId>>, TError,{id: string;data: UserContracts}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patchUserContractsId>>,
        TError,
        {id: string;data: UserContracts},
        TContext
      > => {

      const mutationOptions = getPatchUserContractsIdMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Deletes a user_contracts record
 * @summary Delete a user_contracts record
 */
export const deleteUserContractsId = (
    id: string,
 ) => {
      
      
      return defaultInstance<DeleteUserContractsId200>(
      {url: `/user_contracts/${id}`, method: 'DELETE'
    },
      );
    }
  


export const getDeleteUserContractsIdMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteUserContractsId>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteUserContractsId>>, TError,{id: string}, TContext> => {
    
const mutationKey = ['deleteUserContractsId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteUserContractsId>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteUserContractsId(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteUserContractsIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteUserContractsId>>>
    
    export type DeleteUserContractsIdMutationError = void

    /**
 * @summary Delete a user_contracts record
 */
export const useDeleteUserContractsId = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteUserContractsId>>, TError,{id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteUserContractsId>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getDeleteUserContractsIdMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Returns a list of event_phone_numbers records with pagination
 * @summary Get all event_phone_numbers records
 */
export const getEventPhoneNumbers = (
    params?: GetEventPhoneNumbersParams,
 signal?: AbortSignal
) => {
      
      
      return defaultInstance<GetEventPhoneNumbers200>(
      {url: `/event_phone_numbers`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getGetEventPhoneNumbersQueryKey = (params?: GetEventPhoneNumbersParams,) => {
    return [`/event_phone_numbers`, ...(params ? [params]: [])] as const;
    }

    
export const getGetEventPhoneNumbersQueryOptions = <TData = Awaited<ReturnType<typeof getEventPhoneNumbers>>, TError = void>(params?: GetEventPhoneNumbersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEventPhoneNumbers>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetEventPhoneNumbersQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getEventPhoneNumbers>>> = ({ signal }) => getEventPhoneNumbers(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getEventPhoneNumbers>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetEventPhoneNumbersQueryResult = NonNullable<Awaited<ReturnType<typeof getEventPhoneNumbers>>>
export type GetEventPhoneNumbersQueryError = void


export function useGetEventPhoneNumbers<TData = Awaited<ReturnType<typeof getEventPhoneNumbers>>, TError = void>(
 params: undefined |  GetEventPhoneNumbersParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEventPhoneNumbers>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEventPhoneNumbers>>,
          TError,
          Awaited<ReturnType<typeof getEventPhoneNumbers>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEventPhoneNumbers<TData = Awaited<ReturnType<typeof getEventPhoneNumbers>>, TError = void>(
 params?: GetEventPhoneNumbersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEventPhoneNumbers>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEventPhoneNumbers>>,
          TError,
          Awaited<ReturnType<typeof getEventPhoneNumbers>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEventPhoneNumbers<TData = Awaited<ReturnType<typeof getEventPhoneNumbers>>, TError = void>(
 params?: GetEventPhoneNumbersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEventPhoneNumbers>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get all event_phone_numbers records
 */

export function useGetEventPhoneNumbers<TData = Awaited<ReturnType<typeof getEventPhoneNumbers>>, TError = void>(
 params?: GetEventPhoneNumbersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEventPhoneNumbers>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetEventPhoneNumbersQueryOptions(params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Creates a new event_phone_numbers record
 * @summary Create a new event_phone_numbers record
 */
export const postEventPhoneNumbers = (
    eventPhoneNumbers: EventPhoneNumbers,
 signal?: AbortSignal
) => {
      
      
      return defaultInstance<PostEventPhoneNumbers200>(
      {url: `/event_phone_numbers`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: eventPhoneNumbers, signal
    },
      );
    }
  


export const getPostEventPhoneNumbersMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postEventPhoneNumbers>>, TError,{data: EventPhoneNumbers}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postEventPhoneNumbers>>, TError,{data: EventPhoneNumbers}, TContext> => {
    
const mutationKey = ['postEventPhoneNumbers'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postEventPhoneNumbers>>, {data: EventPhoneNumbers}> = (props) => {
          const {data} = props ?? {};

          return  postEventPhoneNumbers(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostEventPhoneNumbersMutationResult = NonNullable<Awaited<ReturnType<typeof postEventPhoneNumbers>>>
    export type PostEventPhoneNumbersMutationBody = EventPhoneNumbers
    export type PostEventPhoneNumbersMutationError = void

    /**
 * @summary Create a new event_phone_numbers record
 */
export const usePostEventPhoneNumbers = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postEventPhoneNumbers>>, TError,{data: EventPhoneNumbers}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postEventPhoneNumbers>>,
        TError,
        {data: EventPhoneNumbers},
        TContext
      > => {

      const mutationOptions = getPostEventPhoneNumbersMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Returns a single event_phone_numbers record by ID
 * @summary Get a specific event_phone_numbers record
 */
export const getEventPhoneNumbersId = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return defaultInstance<GetEventPhoneNumbersId200>(
      {url: `/event_phone_numbers/${id}`, method: 'GET', signal
    },
      );
    }
  

export const getGetEventPhoneNumbersIdQueryKey = (id: string,) => {
    return [`/event_phone_numbers/${id}`] as const;
    }

    
export const getGetEventPhoneNumbersIdQueryOptions = <TData = Awaited<ReturnType<typeof getEventPhoneNumbersId>>, TError = void>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEventPhoneNumbersId>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetEventPhoneNumbersIdQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getEventPhoneNumbersId>>> = ({ signal }) => getEventPhoneNumbersId(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getEventPhoneNumbersId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetEventPhoneNumbersIdQueryResult = NonNullable<Awaited<ReturnType<typeof getEventPhoneNumbersId>>>
export type GetEventPhoneNumbersIdQueryError = void


export function useGetEventPhoneNumbersId<TData = Awaited<ReturnType<typeof getEventPhoneNumbersId>>, TError = void>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEventPhoneNumbersId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEventPhoneNumbersId>>,
          TError,
          Awaited<ReturnType<typeof getEventPhoneNumbersId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEventPhoneNumbersId<TData = Awaited<ReturnType<typeof getEventPhoneNumbersId>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEventPhoneNumbersId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEventPhoneNumbersId>>,
          TError,
          Awaited<ReturnType<typeof getEventPhoneNumbersId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEventPhoneNumbersId<TData = Awaited<ReturnType<typeof getEventPhoneNumbersId>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEventPhoneNumbersId>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get a specific event_phone_numbers record
 */

export function useGetEventPhoneNumbersId<TData = Awaited<ReturnType<typeof getEventPhoneNumbersId>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEventPhoneNumbersId>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetEventPhoneNumbersIdQueryOptions(id,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Updates an existing event_phone_numbers record
 * @summary Update a event_phone_numbers record
 */
export const putEventPhoneNumbersId = (
    id: string,
    eventPhoneNumbers: EventPhoneNumbers,
 ) => {
      
      
      return defaultInstance<PutEventPhoneNumbersId200>(
      {url: `/event_phone_numbers/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: eventPhoneNumbers
    },
      );
    }
  


export const getPutEventPhoneNumbersIdMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putEventPhoneNumbersId>>, TError,{id: string;data: EventPhoneNumbers}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof putEventPhoneNumbersId>>, TError,{id: string;data: EventPhoneNumbers}, TContext> => {
    
const mutationKey = ['putEventPhoneNumbersId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putEventPhoneNumbersId>>, {id: string;data: EventPhoneNumbers}> = (props) => {
          const {id,data} = props ?? {};

          return  putEventPhoneNumbersId(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutEventPhoneNumbersIdMutationResult = NonNullable<Awaited<ReturnType<typeof putEventPhoneNumbersId>>>
    export type PutEventPhoneNumbersIdMutationBody = EventPhoneNumbers
    export type PutEventPhoneNumbersIdMutationError = void

    /**
 * @summary Update a event_phone_numbers record
 */
export const usePutEventPhoneNumbersId = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putEventPhoneNumbersId>>, TError,{id: string;data: EventPhoneNumbers}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putEventPhoneNumbersId>>,
        TError,
        {id: string;data: EventPhoneNumbers},
        TContext
      > => {

      const mutationOptions = getPutEventPhoneNumbersIdMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Partially updates an existing event_phone_numbers record
 * @summary Partially update a event_phone_numbers record
 */
export const patchEventPhoneNumbersId = (
    id: string,
    eventPhoneNumbers: EventPhoneNumbers,
 ) => {
      
      
      return defaultInstance<PatchEventPhoneNumbersId200>(
      {url: `/event_phone_numbers/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: eventPhoneNumbers
    },
      );
    }
  


export const getPatchEventPhoneNumbersIdMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchEventPhoneNumbersId>>, TError,{id: string;data: EventPhoneNumbers}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof patchEventPhoneNumbersId>>, TError,{id: string;data: EventPhoneNumbers}, TContext> => {
    
const mutationKey = ['patchEventPhoneNumbersId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchEventPhoneNumbersId>>, {id: string;data: EventPhoneNumbers}> = (props) => {
          const {id,data} = props ?? {};

          return  patchEventPhoneNumbersId(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PatchEventPhoneNumbersIdMutationResult = NonNullable<Awaited<ReturnType<typeof patchEventPhoneNumbersId>>>
    export type PatchEventPhoneNumbersIdMutationBody = EventPhoneNumbers
    export type PatchEventPhoneNumbersIdMutationError = void

    /**
 * @summary Partially update a event_phone_numbers record
 */
export const usePatchEventPhoneNumbersId = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchEventPhoneNumbersId>>, TError,{id: string;data: EventPhoneNumbers}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patchEventPhoneNumbersId>>,
        TError,
        {id: string;data: EventPhoneNumbers},
        TContext
      > => {

      const mutationOptions = getPatchEventPhoneNumbersIdMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Deletes a event_phone_numbers record
 * @summary Delete a event_phone_numbers record
 */
export const deleteEventPhoneNumbersId = (
    id: string,
 ) => {
      
      
      return defaultInstance<DeleteEventPhoneNumbersId200>(
      {url: `/event_phone_numbers/${id}`, method: 'DELETE'
    },
      );
    }
  


export const getDeleteEventPhoneNumbersIdMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteEventPhoneNumbersId>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteEventPhoneNumbersId>>, TError,{id: string}, TContext> => {
    
const mutationKey = ['deleteEventPhoneNumbersId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteEventPhoneNumbersId>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteEventPhoneNumbersId(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteEventPhoneNumbersIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteEventPhoneNumbersId>>>
    
    export type DeleteEventPhoneNumbersIdMutationError = void

    /**
 * @summary Delete a event_phone_numbers record
 */
export const useDeleteEventPhoneNumbersId = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteEventPhoneNumbersId>>, TError,{id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteEventPhoneNumbersId>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getDeleteEventPhoneNumbersIdMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Returns a list of event_tickets records with pagination
 * @summary Get all event_tickets records
 */
export const getEventTickets = (
    params?: GetEventTicketsParams,
 signal?: AbortSignal
) => {
      
      
      return defaultInstance<GetEventTickets200>(
      {url: `/event_tickets`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getGetEventTicketsQueryKey = (params?: GetEventTicketsParams,) => {
    return [`/event_tickets`, ...(params ? [params]: [])] as const;
    }

    
export const getGetEventTicketsQueryOptions = <TData = Awaited<ReturnType<typeof getEventTickets>>, TError = void>(params?: GetEventTicketsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEventTickets>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetEventTicketsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getEventTickets>>> = ({ signal }) => getEventTickets(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getEventTickets>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetEventTicketsQueryResult = NonNullable<Awaited<ReturnType<typeof getEventTickets>>>
export type GetEventTicketsQueryError = void


export function useGetEventTickets<TData = Awaited<ReturnType<typeof getEventTickets>>, TError = void>(
 params: undefined |  GetEventTicketsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEventTickets>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEventTickets>>,
          TError,
          Awaited<ReturnType<typeof getEventTickets>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEventTickets<TData = Awaited<ReturnType<typeof getEventTickets>>, TError = void>(
 params?: GetEventTicketsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEventTickets>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEventTickets>>,
          TError,
          Awaited<ReturnType<typeof getEventTickets>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEventTickets<TData = Awaited<ReturnType<typeof getEventTickets>>, TError = void>(
 params?: GetEventTicketsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEventTickets>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get all event_tickets records
 */

export function useGetEventTickets<TData = Awaited<ReturnType<typeof getEventTickets>>, TError = void>(
 params?: GetEventTicketsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEventTickets>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetEventTicketsQueryOptions(params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Creates a new event_tickets record
 * @summary Create a new event_tickets record
 */
export const postEventTickets = (
    eventTickets: EventTickets,
 signal?: AbortSignal
) => {
      
      
      return defaultInstance<PostEventTickets200>(
      {url: `/event_tickets`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: eventTickets, signal
    },
      );
    }
  


export const getPostEventTicketsMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postEventTickets>>, TError,{data: EventTickets}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postEventTickets>>, TError,{data: EventTickets}, TContext> => {
    
const mutationKey = ['postEventTickets'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postEventTickets>>, {data: EventTickets}> = (props) => {
          const {data} = props ?? {};

          return  postEventTickets(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostEventTicketsMutationResult = NonNullable<Awaited<ReturnType<typeof postEventTickets>>>
    export type PostEventTicketsMutationBody = EventTickets
    export type PostEventTicketsMutationError = void

    /**
 * @summary Create a new event_tickets record
 */
export const usePostEventTickets = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postEventTickets>>, TError,{data: EventTickets}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postEventTickets>>,
        TError,
        {data: EventTickets},
        TContext
      > => {

      const mutationOptions = getPostEventTicketsMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Returns a single event_tickets record by ID
 * @summary Get a specific event_tickets record
 */
export const getEventTicketsId = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return defaultInstance<GetEventTicketsId200>(
      {url: `/event_tickets/${id}`, method: 'GET', signal
    },
      );
    }
  

export const getGetEventTicketsIdQueryKey = (id: string,) => {
    return [`/event_tickets/${id}`] as const;
    }

    
export const getGetEventTicketsIdQueryOptions = <TData = Awaited<ReturnType<typeof getEventTicketsId>>, TError = void>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEventTicketsId>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetEventTicketsIdQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getEventTicketsId>>> = ({ signal }) => getEventTicketsId(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getEventTicketsId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetEventTicketsIdQueryResult = NonNullable<Awaited<ReturnType<typeof getEventTicketsId>>>
export type GetEventTicketsIdQueryError = void


export function useGetEventTicketsId<TData = Awaited<ReturnType<typeof getEventTicketsId>>, TError = void>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEventTicketsId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEventTicketsId>>,
          TError,
          Awaited<ReturnType<typeof getEventTicketsId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEventTicketsId<TData = Awaited<ReturnType<typeof getEventTicketsId>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEventTicketsId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEventTicketsId>>,
          TError,
          Awaited<ReturnType<typeof getEventTicketsId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEventTicketsId<TData = Awaited<ReturnType<typeof getEventTicketsId>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEventTicketsId>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get a specific event_tickets record
 */

export function useGetEventTicketsId<TData = Awaited<ReturnType<typeof getEventTicketsId>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEventTicketsId>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetEventTicketsIdQueryOptions(id,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Updates an existing event_tickets record
 * @summary Update a event_tickets record
 */
export const putEventTicketsId = (
    id: string,
    eventTickets: EventTickets,
 ) => {
      
      
      return defaultInstance<PutEventTicketsId200>(
      {url: `/event_tickets/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: eventTickets
    },
      );
    }
  


export const getPutEventTicketsIdMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putEventTicketsId>>, TError,{id: string;data: EventTickets}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof putEventTicketsId>>, TError,{id: string;data: EventTickets}, TContext> => {
    
const mutationKey = ['putEventTicketsId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putEventTicketsId>>, {id: string;data: EventTickets}> = (props) => {
          const {id,data} = props ?? {};

          return  putEventTicketsId(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutEventTicketsIdMutationResult = NonNullable<Awaited<ReturnType<typeof putEventTicketsId>>>
    export type PutEventTicketsIdMutationBody = EventTickets
    export type PutEventTicketsIdMutationError = void

    /**
 * @summary Update a event_tickets record
 */
export const usePutEventTicketsId = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putEventTicketsId>>, TError,{id: string;data: EventTickets}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putEventTicketsId>>,
        TError,
        {id: string;data: EventTickets},
        TContext
      > => {

      const mutationOptions = getPutEventTicketsIdMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Partially updates an existing event_tickets record
 * @summary Partially update a event_tickets record
 */
export const patchEventTicketsId = (
    id: string,
    eventTickets: EventTickets,
 ) => {
      
      
      return defaultInstance<PatchEventTicketsId200>(
      {url: `/event_tickets/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: eventTickets
    },
      );
    }
  


export const getPatchEventTicketsIdMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchEventTicketsId>>, TError,{id: string;data: EventTickets}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof patchEventTicketsId>>, TError,{id: string;data: EventTickets}, TContext> => {
    
const mutationKey = ['patchEventTicketsId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchEventTicketsId>>, {id: string;data: EventTickets}> = (props) => {
          const {id,data} = props ?? {};

          return  patchEventTicketsId(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PatchEventTicketsIdMutationResult = NonNullable<Awaited<ReturnType<typeof patchEventTicketsId>>>
    export type PatchEventTicketsIdMutationBody = EventTickets
    export type PatchEventTicketsIdMutationError = void

    /**
 * @summary Partially update a event_tickets record
 */
export const usePatchEventTicketsId = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchEventTicketsId>>, TError,{id: string;data: EventTickets}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patchEventTicketsId>>,
        TError,
        {id: string;data: EventTickets},
        TContext
      > => {

      const mutationOptions = getPatchEventTicketsIdMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Deletes a event_tickets record
 * @summary Delete a event_tickets record
 */
export const deleteEventTicketsId = (
    id: string,
 ) => {
      
      
      return defaultInstance<DeleteEventTicketsId200>(
      {url: `/event_tickets/${id}`, method: 'DELETE'
    },
      );
    }
  


export const getDeleteEventTicketsIdMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteEventTicketsId>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteEventTicketsId>>, TError,{id: string}, TContext> => {
    
const mutationKey = ['deleteEventTicketsId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteEventTicketsId>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteEventTicketsId(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteEventTicketsIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteEventTicketsId>>>
    
    export type DeleteEventTicketsIdMutationError = void

    /**
 * @summary Delete a event_tickets record
 */
export const useDeleteEventTicketsId = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteEventTicketsId>>, TError,{id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteEventTicketsId>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getDeleteEventTicketsIdMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Returns a list of open_crud_endpoint records with pagination
 * @summary Get all open_crud_endpoint records
 */
export const getOpenCrudEndpoint = (
    params?: GetOpenCrudEndpointParams,
 signal?: AbortSignal
) => {
      
      
      return defaultInstance<GetOpenCrudEndpoint200>(
      {url: `/open_crud_endpoint`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getGetOpenCrudEndpointQueryKey = (params?: GetOpenCrudEndpointParams,) => {
    return [`/open_crud_endpoint`, ...(params ? [params]: [])] as const;
    }

    
export const getGetOpenCrudEndpointQueryOptions = <TData = Awaited<ReturnType<typeof getOpenCrudEndpoint>>, TError = void>(params?: GetOpenCrudEndpointParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOpenCrudEndpoint>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetOpenCrudEndpointQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getOpenCrudEndpoint>>> = ({ signal }) => getOpenCrudEndpoint(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getOpenCrudEndpoint>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetOpenCrudEndpointQueryResult = NonNullable<Awaited<ReturnType<typeof getOpenCrudEndpoint>>>
export type GetOpenCrudEndpointQueryError = void


export function useGetOpenCrudEndpoint<TData = Awaited<ReturnType<typeof getOpenCrudEndpoint>>, TError = void>(
 params: undefined |  GetOpenCrudEndpointParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOpenCrudEndpoint>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOpenCrudEndpoint>>,
          TError,
          Awaited<ReturnType<typeof getOpenCrudEndpoint>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOpenCrudEndpoint<TData = Awaited<ReturnType<typeof getOpenCrudEndpoint>>, TError = void>(
 params?: GetOpenCrudEndpointParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOpenCrudEndpoint>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOpenCrudEndpoint>>,
          TError,
          Awaited<ReturnType<typeof getOpenCrudEndpoint>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOpenCrudEndpoint<TData = Awaited<ReturnType<typeof getOpenCrudEndpoint>>, TError = void>(
 params?: GetOpenCrudEndpointParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOpenCrudEndpoint>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get all open_crud_endpoint records
 */

export function useGetOpenCrudEndpoint<TData = Awaited<ReturnType<typeof getOpenCrudEndpoint>>, TError = void>(
 params?: GetOpenCrudEndpointParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOpenCrudEndpoint>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetOpenCrudEndpointQueryOptions(params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Creates a new open_crud_endpoint record
 * @summary Create a new open_crud_endpoint record
 */
export const postOpenCrudEndpoint = (
    openCrudEndpoint: OpenCrudEndpoint,
 signal?: AbortSignal
) => {
      
      
      return defaultInstance<PostOpenCrudEndpoint200>(
      {url: `/open_crud_endpoint`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: openCrudEndpoint, signal
    },
      );
    }
  


export const getPostOpenCrudEndpointMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postOpenCrudEndpoint>>, TError,{data: OpenCrudEndpoint}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postOpenCrudEndpoint>>, TError,{data: OpenCrudEndpoint}, TContext> => {
    
const mutationKey = ['postOpenCrudEndpoint'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postOpenCrudEndpoint>>, {data: OpenCrudEndpoint}> = (props) => {
          const {data} = props ?? {};

          return  postOpenCrudEndpoint(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostOpenCrudEndpointMutationResult = NonNullable<Awaited<ReturnType<typeof postOpenCrudEndpoint>>>
    export type PostOpenCrudEndpointMutationBody = OpenCrudEndpoint
    export type PostOpenCrudEndpointMutationError = void

    /**
 * @summary Create a new open_crud_endpoint record
 */
export const usePostOpenCrudEndpoint = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postOpenCrudEndpoint>>, TError,{data: OpenCrudEndpoint}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postOpenCrudEndpoint>>,
        TError,
        {data: OpenCrudEndpoint},
        TContext
      > => {

      const mutationOptions = getPostOpenCrudEndpointMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Returns a single open_crud_endpoint record by ID
 * @summary Get a specific open_crud_endpoint record
 */
export const getOpenCrudEndpointId = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return defaultInstance<GetOpenCrudEndpointId200>(
      {url: `/open_crud_endpoint/${id}`, method: 'GET', signal
    },
      );
    }
  

export const getGetOpenCrudEndpointIdQueryKey = (id: string,) => {
    return [`/open_crud_endpoint/${id}`] as const;
    }

    
export const getGetOpenCrudEndpointIdQueryOptions = <TData = Awaited<ReturnType<typeof getOpenCrudEndpointId>>, TError = void>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOpenCrudEndpointId>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetOpenCrudEndpointIdQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getOpenCrudEndpointId>>> = ({ signal }) => getOpenCrudEndpointId(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getOpenCrudEndpointId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetOpenCrudEndpointIdQueryResult = NonNullable<Awaited<ReturnType<typeof getOpenCrudEndpointId>>>
export type GetOpenCrudEndpointIdQueryError = void


export function useGetOpenCrudEndpointId<TData = Awaited<ReturnType<typeof getOpenCrudEndpointId>>, TError = void>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOpenCrudEndpointId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOpenCrudEndpointId>>,
          TError,
          Awaited<ReturnType<typeof getOpenCrudEndpointId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOpenCrudEndpointId<TData = Awaited<ReturnType<typeof getOpenCrudEndpointId>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOpenCrudEndpointId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOpenCrudEndpointId>>,
          TError,
          Awaited<ReturnType<typeof getOpenCrudEndpointId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOpenCrudEndpointId<TData = Awaited<ReturnType<typeof getOpenCrudEndpointId>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOpenCrudEndpointId>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get a specific open_crud_endpoint record
 */

export function useGetOpenCrudEndpointId<TData = Awaited<ReturnType<typeof getOpenCrudEndpointId>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOpenCrudEndpointId>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetOpenCrudEndpointIdQueryOptions(id,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Updates an existing open_crud_endpoint record
 * @summary Update a open_crud_endpoint record
 */
export const putOpenCrudEndpointId = (
    id: string,
    openCrudEndpoint: OpenCrudEndpoint,
 ) => {
      
      
      return defaultInstance<PutOpenCrudEndpointId200>(
      {url: `/open_crud_endpoint/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: openCrudEndpoint
    },
      );
    }
  


export const getPutOpenCrudEndpointIdMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putOpenCrudEndpointId>>, TError,{id: string;data: OpenCrudEndpoint}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof putOpenCrudEndpointId>>, TError,{id: string;data: OpenCrudEndpoint}, TContext> => {
    
const mutationKey = ['putOpenCrudEndpointId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putOpenCrudEndpointId>>, {id: string;data: OpenCrudEndpoint}> = (props) => {
          const {id,data} = props ?? {};

          return  putOpenCrudEndpointId(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutOpenCrudEndpointIdMutationResult = NonNullable<Awaited<ReturnType<typeof putOpenCrudEndpointId>>>
    export type PutOpenCrudEndpointIdMutationBody = OpenCrudEndpoint
    export type PutOpenCrudEndpointIdMutationError = void

    /**
 * @summary Update a open_crud_endpoint record
 */
export const usePutOpenCrudEndpointId = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putOpenCrudEndpointId>>, TError,{id: string;data: OpenCrudEndpoint}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putOpenCrudEndpointId>>,
        TError,
        {id: string;data: OpenCrudEndpoint},
        TContext
      > => {

      const mutationOptions = getPutOpenCrudEndpointIdMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Partially updates an existing open_crud_endpoint record
 * @summary Partially update a open_crud_endpoint record
 */
export const patchOpenCrudEndpointId = (
    id: string,
    openCrudEndpoint: OpenCrudEndpoint,
 ) => {
      
      
      return defaultInstance<PatchOpenCrudEndpointId200>(
      {url: `/open_crud_endpoint/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: openCrudEndpoint
    },
      );
    }
  


export const getPatchOpenCrudEndpointIdMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchOpenCrudEndpointId>>, TError,{id: string;data: OpenCrudEndpoint}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof patchOpenCrudEndpointId>>, TError,{id: string;data: OpenCrudEndpoint}, TContext> => {
    
const mutationKey = ['patchOpenCrudEndpointId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchOpenCrudEndpointId>>, {id: string;data: OpenCrudEndpoint}> = (props) => {
          const {id,data} = props ?? {};

          return  patchOpenCrudEndpointId(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PatchOpenCrudEndpointIdMutationResult = NonNullable<Awaited<ReturnType<typeof patchOpenCrudEndpointId>>>
    export type PatchOpenCrudEndpointIdMutationBody = OpenCrudEndpoint
    export type PatchOpenCrudEndpointIdMutationError = void

    /**
 * @summary Partially update a open_crud_endpoint record
 */
export const usePatchOpenCrudEndpointId = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchOpenCrudEndpointId>>, TError,{id: string;data: OpenCrudEndpoint}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patchOpenCrudEndpointId>>,
        TError,
        {id: string;data: OpenCrudEndpoint},
        TContext
      > => {

      const mutationOptions = getPatchOpenCrudEndpointIdMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Deletes a open_crud_endpoint record
 * @summary Delete a open_crud_endpoint record
 */
export const deleteOpenCrudEndpointId = (
    id: string,
 ) => {
      
      
      return defaultInstance<DeleteOpenCrudEndpointId200>(
      {url: `/open_crud_endpoint/${id}`, method: 'DELETE'
    },
      );
    }
  


export const getDeleteOpenCrudEndpointIdMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteOpenCrudEndpointId>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteOpenCrudEndpointId>>, TError,{id: string}, TContext> => {
    
const mutationKey = ['deleteOpenCrudEndpointId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteOpenCrudEndpointId>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteOpenCrudEndpointId(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteOpenCrudEndpointIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteOpenCrudEndpointId>>>
    
    export type DeleteOpenCrudEndpointIdMutationError = void

    /**
 * @summary Delete a open_crud_endpoint record
 */
export const useDeleteOpenCrudEndpointId = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteOpenCrudEndpointId>>, TError,{id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteOpenCrudEndpointId>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getDeleteOpenCrudEndpointIdMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Returns a list of cap_cana_access_card records with pagination
 * @summary Get all cap_cana_access_card records
 */
export const getCapCanaAccessCard = (
    params?: GetCapCanaAccessCardParams,
 signal?: AbortSignal
) => {
      
      
      return defaultInstance<GetCapCanaAccessCard200>(
      {url: `/cap_cana_access_card`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getGetCapCanaAccessCardQueryKey = (params?: GetCapCanaAccessCardParams,) => {
    return [`/cap_cana_access_card`, ...(params ? [params]: [])] as const;
    }

    
export const getGetCapCanaAccessCardQueryOptions = <TData = Awaited<ReturnType<typeof getCapCanaAccessCard>>, TError = void>(params?: GetCapCanaAccessCardParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCapCanaAccessCard>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCapCanaAccessCardQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCapCanaAccessCard>>> = ({ signal }) => getCapCanaAccessCard(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCapCanaAccessCard>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetCapCanaAccessCardQueryResult = NonNullable<Awaited<ReturnType<typeof getCapCanaAccessCard>>>
export type GetCapCanaAccessCardQueryError = void


export function useGetCapCanaAccessCard<TData = Awaited<ReturnType<typeof getCapCanaAccessCard>>, TError = void>(
 params: undefined |  GetCapCanaAccessCardParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCapCanaAccessCard>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCapCanaAccessCard>>,
          TError,
          Awaited<ReturnType<typeof getCapCanaAccessCard>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCapCanaAccessCard<TData = Awaited<ReturnType<typeof getCapCanaAccessCard>>, TError = void>(
 params?: GetCapCanaAccessCardParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCapCanaAccessCard>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCapCanaAccessCard>>,
          TError,
          Awaited<ReturnType<typeof getCapCanaAccessCard>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCapCanaAccessCard<TData = Awaited<ReturnType<typeof getCapCanaAccessCard>>, TError = void>(
 params?: GetCapCanaAccessCardParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCapCanaAccessCard>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get all cap_cana_access_card records
 */

export function useGetCapCanaAccessCard<TData = Awaited<ReturnType<typeof getCapCanaAccessCard>>, TError = void>(
 params?: GetCapCanaAccessCardParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCapCanaAccessCard>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetCapCanaAccessCardQueryOptions(params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Creates a new cap_cana_access_card record
 * @summary Create a new cap_cana_access_card record
 */
export const postCapCanaAccessCard = (
    capCanaAccessCard: CapCanaAccessCard,
 signal?: AbortSignal
) => {
      
      
      return defaultInstance<PostCapCanaAccessCard200>(
      {url: `/cap_cana_access_card`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: capCanaAccessCard, signal
    },
      );
    }
  


export const getPostCapCanaAccessCardMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCapCanaAccessCard>>, TError,{data: CapCanaAccessCard}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postCapCanaAccessCard>>, TError,{data: CapCanaAccessCard}, TContext> => {
    
const mutationKey = ['postCapCanaAccessCard'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postCapCanaAccessCard>>, {data: CapCanaAccessCard}> = (props) => {
          const {data} = props ?? {};

          return  postCapCanaAccessCard(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostCapCanaAccessCardMutationResult = NonNullable<Awaited<ReturnType<typeof postCapCanaAccessCard>>>
    export type PostCapCanaAccessCardMutationBody = CapCanaAccessCard
    export type PostCapCanaAccessCardMutationError = void

    /**
 * @summary Create a new cap_cana_access_card record
 */
export const usePostCapCanaAccessCard = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCapCanaAccessCard>>, TError,{data: CapCanaAccessCard}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postCapCanaAccessCard>>,
        TError,
        {data: CapCanaAccessCard},
        TContext
      > => {

      const mutationOptions = getPostCapCanaAccessCardMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Returns a single cap_cana_access_card record by ID
 * @summary Get a specific cap_cana_access_card record
 */
export const getCapCanaAccessCardId = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return defaultInstance<GetCapCanaAccessCardId200>(
      {url: `/cap_cana_access_card/${id}`, method: 'GET', signal
    },
      );
    }
  

export const getGetCapCanaAccessCardIdQueryKey = (id: string,) => {
    return [`/cap_cana_access_card/${id}`] as const;
    }

    
export const getGetCapCanaAccessCardIdQueryOptions = <TData = Awaited<ReturnType<typeof getCapCanaAccessCardId>>, TError = void>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCapCanaAccessCardId>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCapCanaAccessCardIdQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCapCanaAccessCardId>>> = ({ signal }) => getCapCanaAccessCardId(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCapCanaAccessCardId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetCapCanaAccessCardIdQueryResult = NonNullable<Awaited<ReturnType<typeof getCapCanaAccessCardId>>>
export type GetCapCanaAccessCardIdQueryError = void


export function useGetCapCanaAccessCardId<TData = Awaited<ReturnType<typeof getCapCanaAccessCardId>>, TError = void>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCapCanaAccessCardId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCapCanaAccessCardId>>,
          TError,
          Awaited<ReturnType<typeof getCapCanaAccessCardId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCapCanaAccessCardId<TData = Awaited<ReturnType<typeof getCapCanaAccessCardId>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCapCanaAccessCardId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCapCanaAccessCardId>>,
          TError,
          Awaited<ReturnType<typeof getCapCanaAccessCardId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCapCanaAccessCardId<TData = Awaited<ReturnType<typeof getCapCanaAccessCardId>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCapCanaAccessCardId>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get a specific cap_cana_access_card record
 */

export function useGetCapCanaAccessCardId<TData = Awaited<ReturnType<typeof getCapCanaAccessCardId>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCapCanaAccessCardId>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetCapCanaAccessCardIdQueryOptions(id,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Updates an existing cap_cana_access_card record
 * @summary Update a cap_cana_access_card record
 */
export const putCapCanaAccessCardId = (
    id: string,
    capCanaAccessCard: CapCanaAccessCard,
 ) => {
      
      
      return defaultInstance<PutCapCanaAccessCardId200>(
      {url: `/cap_cana_access_card/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: capCanaAccessCard
    },
      );
    }
  


export const getPutCapCanaAccessCardIdMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putCapCanaAccessCardId>>, TError,{id: string;data: CapCanaAccessCard}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof putCapCanaAccessCardId>>, TError,{id: string;data: CapCanaAccessCard}, TContext> => {
    
const mutationKey = ['putCapCanaAccessCardId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putCapCanaAccessCardId>>, {id: string;data: CapCanaAccessCard}> = (props) => {
          const {id,data} = props ?? {};

          return  putCapCanaAccessCardId(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutCapCanaAccessCardIdMutationResult = NonNullable<Awaited<ReturnType<typeof putCapCanaAccessCardId>>>
    export type PutCapCanaAccessCardIdMutationBody = CapCanaAccessCard
    export type PutCapCanaAccessCardIdMutationError = void

    /**
 * @summary Update a cap_cana_access_card record
 */
export const usePutCapCanaAccessCardId = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putCapCanaAccessCardId>>, TError,{id: string;data: CapCanaAccessCard}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putCapCanaAccessCardId>>,
        TError,
        {id: string;data: CapCanaAccessCard},
        TContext
      > => {

      const mutationOptions = getPutCapCanaAccessCardIdMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Partially updates an existing cap_cana_access_card record
 * @summary Partially update a cap_cana_access_card record
 */
export const patchCapCanaAccessCardId = (
    id: string,
    capCanaAccessCard: CapCanaAccessCard,
 ) => {
      
      
      return defaultInstance<PatchCapCanaAccessCardId200>(
      {url: `/cap_cana_access_card/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: capCanaAccessCard
    },
      );
    }
  


export const getPatchCapCanaAccessCardIdMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchCapCanaAccessCardId>>, TError,{id: string;data: CapCanaAccessCard}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof patchCapCanaAccessCardId>>, TError,{id: string;data: CapCanaAccessCard}, TContext> => {
    
const mutationKey = ['patchCapCanaAccessCardId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchCapCanaAccessCardId>>, {id: string;data: CapCanaAccessCard}> = (props) => {
          const {id,data} = props ?? {};

          return  patchCapCanaAccessCardId(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PatchCapCanaAccessCardIdMutationResult = NonNullable<Awaited<ReturnType<typeof patchCapCanaAccessCardId>>>
    export type PatchCapCanaAccessCardIdMutationBody = CapCanaAccessCard
    export type PatchCapCanaAccessCardIdMutationError = void

    /**
 * @summary Partially update a cap_cana_access_card record
 */
export const usePatchCapCanaAccessCardId = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchCapCanaAccessCardId>>, TError,{id: string;data: CapCanaAccessCard}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patchCapCanaAccessCardId>>,
        TError,
        {id: string;data: CapCanaAccessCard},
        TContext
      > => {

      const mutationOptions = getPatchCapCanaAccessCardIdMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Deletes a cap_cana_access_card record
 * @summary Delete a cap_cana_access_card record
 */
export const deleteCapCanaAccessCardId = (
    id: string,
 ) => {
      
      
      return defaultInstance<DeleteCapCanaAccessCardId200>(
      {url: `/cap_cana_access_card/${id}`, method: 'DELETE'
    },
      );
    }
  


export const getDeleteCapCanaAccessCardIdMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteCapCanaAccessCardId>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteCapCanaAccessCardId>>, TError,{id: string}, TContext> => {
    
const mutationKey = ['deleteCapCanaAccessCardId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteCapCanaAccessCardId>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteCapCanaAccessCardId(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteCapCanaAccessCardIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteCapCanaAccessCardId>>>
    
    export type DeleteCapCanaAccessCardIdMutationError = void

    /**
 * @summary Delete a cap_cana_access_card record
 */
export const useDeleteCapCanaAccessCardId = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteCapCanaAccessCardId>>, TError,{id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteCapCanaAccessCardId>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getDeleteCapCanaAccessCardIdMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Returns a list of admin_users records with pagination
 * @summary Get all admin_users records
 */
export const getAdminUsers = (
    params?: GetAdminUsersParams,
 signal?: AbortSignal
) => {
      
      
      return defaultInstance<GetAdminUsers200>(
      {url: `/admin_users`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getGetAdminUsersQueryKey = (params?: GetAdminUsersParams,) => {
    return [`/admin_users`, ...(params ? [params]: [])] as const;
    }

    
export const getGetAdminUsersQueryOptions = <TData = Awaited<ReturnType<typeof getAdminUsers>>, TError = void>(params?: GetAdminUsersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminUsers>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdminUsersQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminUsers>>> = ({ signal }) => getAdminUsers(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAdminUsers>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAdminUsersQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminUsers>>>
export type GetAdminUsersQueryError = void


export function useGetAdminUsers<TData = Awaited<ReturnType<typeof getAdminUsers>>, TError = void>(
 params: undefined |  GetAdminUsersParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminUsers>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminUsers>>,
          TError,
          Awaited<ReturnType<typeof getAdminUsers>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminUsers<TData = Awaited<ReturnType<typeof getAdminUsers>>, TError = void>(
 params?: GetAdminUsersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminUsers>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminUsers>>,
          TError,
          Awaited<ReturnType<typeof getAdminUsers>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminUsers<TData = Awaited<ReturnType<typeof getAdminUsers>>, TError = void>(
 params?: GetAdminUsersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminUsers>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get all admin_users records
 */

export function useGetAdminUsers<TData = Awaited<ReturnType<typeof getAdminUsers>>, TError = void>(
 params?: GetAdminUsersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminUsers>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAdminUsersQueryOptions(params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Creates a new admin_users record
 * @summary Create a new admin_users record
 */
export const postAdminUsers = (
    adminUsers: AdminUsers,
 signal?: AbortSignal
) => {
      
      
      return defaultInstance<PostAdminUsers200>(
      {url: `/admin_users`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: adminUsers, signal
    },
      );
    }
  


export const getPostAdminUsersMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAdminUsers>>, TError,{data: AdminUsers}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postAdminUsers>>, TError,{data: AdminUsers}, TContext> => {
    
const mutationKey = ['postAdminUsers'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postAdminUsers>>, {data: AdminUsers}> = (props) => {
          const {data} = props ?? {};

          return  postAdminUsers(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostAdminUsersMutationResult = NonNullable<Awaited<ReturnType<typeof postAdminUsers>>>
    export type PostAdminUsersMutationBody = AdminUsers
    export type PostAdminUsersMutationError = void

    /**
 * @summary Create a new admin_users record
 */
export const usePostAdminUsers = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAdminUsers>>, TError,{data: AdminUsers}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postAdminUsers>>,
        TError,
        {data: AdminUsers},
        TContext
      > => {

      const mutationOptions = getPostAdminUsersMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Returns a single admin_users record by ID
 * @summary Get a specific admin_users record
 */
export const getAdminUsersId = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return defaultInstance<GetAdminUsersId200>(
      {url: `/admin_users/${id}`, method: 'GET', signal
    },
      );
    }
  

export const getGetAdminUsersIdQueryKey = (id: string,) => {
    return [`/admin_users/${id}`] as const;
    }

    
export const getGetAdminUsersIdQueryOptions = <TData = Awaited<ReturnType<typeof getAdminUsersId>>, TError = void>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminUsersId>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdminUsersIdQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminUsersId>>> = ({ signal }) => getAdminUsersId(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAdminUsersId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAdminUsersIdQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminUsersId>>>
export type GetAdminUsersIdQueryError = void


export function useGetAdminUsersId<TData = Awaited<ReturnType<typeof getAdminUsersId>>, TError = void>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminUsersId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminUsersId>>,
          TError,
          Awaited<ReturnType<typeof getAdminUsersId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminUsersId<TData = Awaited<ReturnType<typeof getAdminUsersId>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminUsersId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminUsersId>>,
          TError,
          Awaited<ReturnType<typeof getAdminUsersId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminUsersId<TData = Awaited<ReturnType<typeof getAdminUsersId>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminUsersId>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get a specific admin_users record
 */

export function useGetAdminUsersId<TData = Awaited<ReturnType<typeof getAdminUsersId>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminUsersId>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAdminUsersIdQueryOptions(id,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Updates an existing admin_users record
 * @summary Update a admin_users record
 */
export const putAdminUsersId = (
    id: string,
    adminUsers: AdminUsers,
 ) => {
      
      
      return defaultInstance<PutAdminUsersId200>(
      {url: `/admin_users/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: adminUsers
    },
      );
    }
  


export const getPutAdminUsersIdMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putAdminUsersId>>, TError,{id: string;data: AdminUsers}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof putAdminUsersId>>, TError,{id: string;data: AdminUsers}, TContext> => {
    
const mutationKey = ['putAdminUsersId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putAdminUsersId>>, {id: string;data: AdminUsers}> = (props) => {
          const {id,data} = props ?? {};

          return  putAdminUsersId(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutAdminUsersIdMutationResult = NonNullable<Awaited<ReturnType<typeof putAdminUsersId>>>
    export type PutAdminUsersIdMutationBody = AdminUsers
    export type PutAdminUsersIdMutationError = void

    /**
 * @summary Update a admin_users record
 */
export const usePutAdminUsersId = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putAdminUsersId>>, TError,{id: string;data: AdminUsers}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putAdminUsersId>>,
        TError,
        {id: string;data: AdminUsers},
        TContext
      > => {

      const mutationOptions = getPutAdminUsersIdMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Partially updates an existing admin_users record
 * @summary Partially update a admin_users record
 */
export const patchAdminUsersId = (
    id: string,
    adminUsers: AdminUsers,
 ) => {
      
      
      return defaultInstance<PatchAdminUsersId200>(
      {url: `/admin_users/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: adminUsers
    },
      );
    }
  


export const getPatchAdminUsersIdMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchAdminUsersId>>, TError,{id: string;data: AdminUsers}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof patchAdminUsersId>>, TError,{id: string;data: AdminUsers}, TContext> => {
    
const mutationKey = ['patchAdminUsersId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchAdminUsersId>>, {id: string;data: AdminUsers}> = (props) => {
          const {id,data} = props ?? {};

          return  patchAdminUsersId(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PatchAdminUsersIdMutationResult = NonNullable<Awaited<ReturnType<typeof patchAdminUsersId>>>
    export type PatchAdminUsersIdMutationBody = AdminUsers
    export type PatchAdminUsersIdMutationError = void

    /**
 * @summary Partially update a admin_users record
 */
export const usePatchAdminUsersId = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchAdminUsersId>>, TError,{id: string;data: AdminUsers}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patchAdminUsersId>>,
        TError,
        {id: string;data: AdminUsers},
        TContext
      > => {

      const mutationOptions = getPatchAdminUsersIdMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Deletes a admin_users record
 * @summary Delete a admin_users record
 */
export const deleteAdminUsersId = (
    id: string,
 ) => {
      
      
      return defaultInstance<DeleteAdminUsersId200>(
      {url: `/admin_users/${id}`, method: 'DELETE'
    },
      );
    }
  


export const getDeleteAdminUsersIdMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAdminUsersId>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteAdminUsersId>>, TError,{id: string}, TContext> => {
    
const mutationKey = ['deleteAdminUsersId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteAdminUsersId>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteAdminUsersId(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteAdminUsersIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteAdminUsersId>>>
    
    export type DeleteAdminUsersIdMutationError = void

    /**
 * @summary Delete a admin_users record
 */
export const useDeleteAdminUsersId = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAdminUsersId>>, TError,{id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteAdminUsersId>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getDeleteAdminUsersIdMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Returns a list of transaction records with pagination
 * @summary Get all transaction records
 */
export const getTransaction = (
    params?: GetTransactionParams,
 signal?: AbortSignal
) => {
      
      
      return defaultInstance<GetTransaction200>(
      {url: `/transaction`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getGetTransactionQueryKey = (params?: GetTransactionParams,) => {
    return [`/transaction`, ...(params ? [params]: [])] as const;
    }

    
export const getGetTransactionQueryOptions = <TData = Awaited<ReturnType<typeof getTransaction>>, TError = void>(params?: GetTransactionParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTransaction>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTransactionQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTransaction>>> = ({ signal }) => getTransaction(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getTransaction>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetTransactionQueryResult = NonNullable<Awaited<ReturnType<typeof getTransaction>>>
export type GetTransactionQueryError = void


export function useGetTransaction<TData = Awaited<ReturnType<typeof getTransaction>>, TError = void>(
 params: undefined |  GetTransactionParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTransaction>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTransaction>>,
          TError,
          Awaited<ReturnType<typeof getTransaction>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTransaction<TData = Awaited<ReturnType<typeof getTransaction>>, TError = void>(
 params?: GetTransactionParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTransaction>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTransaction>>,
          TError,
          Awaited<ReturnType<typeof getTransaction>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTransaction<TData = Awaited<ReturnType<typeof getTransaction>>, TError = void>(
 params?: GetTransactionParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTransaction>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get all transaction records
 */

export function useGetTransaction<TData = Awaited<ReturnType<typeof getTransaction>>, TError = void>(
 params?: GetTransactionParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTransaction>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetTransactionQueryOptions(params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Creates a new transaction record
 * @summary Create a new transaction record
 */
export const postTransaction = (
    transaction: Transaction,
 signal?: AbortSignal
) => {
      
      
      return defaultInstance<PostTransaction200>(
      {url: `/transaction`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: transaction, signal
    },
      );
    }
  


export const getPostTransactionMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postTransaction>>, TError,{data: Transaction}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postTransaction>>, TError,{data: Transaction}, TContext> => {
    
const mutationKey = ['postTransaction'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postTransaction>>, {data: Transaction}> = (props) => {
          const {data} = props ?? {};

          return  postTransaction(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostTransactionMutationResult = NonNullable<Awaited<ReturnType<typeof postTransaction>>>
    export type PostTransactionMutationBody = Transaction
    export type PostTransactionMutationError = void

    /**
 * @summary Create a new transaction record
 */
export const usePostTransaction = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postTransaction>>, TError,{data: Transaction}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postTransaction>>,
        TError,
        {data: Transaction},
        TContext
      > => {

      const mutationOptions = getPostTransactionMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Returns a single transaction record by ID
 * @summary Get a specific transaction record
 */
export const getTransactionId = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return defaultInstance<GetTransactionId200>(
      {url: `/transaction/${id}`, method: 'GET', signal
    },
      );
    }
  

export const getGetTransactionIdQueryKey = (id: string,) => {
    return [`/transaction/${id}`] as const;
    }

    
export const getGetTransactionIdQueryOptions = <TData = Awaited<ReturnType<typeof getTransactionId>>, TError = void>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTransactionId>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTransactionIdQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTransactionId>>> = ({ signal }) => getTransactionId(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getTransactionId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetTransactionIdQueryResult = NonNullable<Awaited<ReturnType<typeof getTransactionId>>>
export type GetTransactionIdQueryError = void


export function useGetTransactionId<TData = Awaited<ReturnType<typeof getTransactionId>>, TError = void>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTransactionId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTransactionId>>,
          TError,
          Awaited<ReturnType<typeof getTransactionId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTransactionId<TData = Awaited<ReturnType<typeof getTransactionId>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTransactionId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTransactionId>>,
          TError,
          Awaited<ReturnType<typeof getTransactionId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTransactionId<TData = Awaited<ReturnType<typeof getTransactionId>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTransactionId>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get a specific transaction record
 */

export function useGetTransactionId<TData = Awaited<ReturnType<typeof getTransactionId>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTransactionId>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetTransactionIdQueryOptions(id,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Updates an existing transaction record
 * @summary Update a transaction record
 */
export const putTransactionId = (
    id: string,
    transaction: Transaction,
 ) => {
      
      
      return defaultInstance<PutTransactionId200>(
      {url: `/transaction/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: transaction
    },
      );
    }
  


export const getPutTransactionIdMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putTransactionId>>, TError,{id: string;data: Transaction}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof putTransactionId>>, TError,{id: string;data: Transaction}, TContext> => {
    
const mutationKey = ['putTransactionId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putTransactionId>>, {id: string;data: Transaction}> = (props) => {
          const {id,data} = props ?? {};

          return  putTransactionId(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutTransactionIdMutationResult = NonNullable<Awaited<ReturnType<typeof putTransactionId>>>
    export type PutTransactionIdMutationBody = Transaction
    export type PutTransactionIdMutationError = void

    /**
 * @summary Update a transaction record
 */
export const usePutTransactionId = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putTransactionId>>, TError,{id: string;data: Transaction}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putTransactionId>>,
        TError,
        {id: string;data: Transaction},
        TContext
      > => {

      const mutationOptions = getPutTransactionIdMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Partially updates an existing transaction record
 * @summary Partially update a transaction record
 */
export const patchTransactionId = (
    id: string,
    transaction: Transaction,
 ) => {
      
      
      return defaultInstance<PatchTransactionId200>(
      {url: `/transaction/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: transaction
    },
      );
    }
  


export const getPatchTransactionIdMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchTransactionId>>, TError,{id: string;data: Transaction}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof patchTransactionId>>, TError,{id: string;data: Transaction}, TContext> => {
    
const mutationKey = ['patchTransactionId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchTransactionId>>, {id: string;data: Transaction}> = (props) => {
          const {id,data} = props ?? {};

          return  patchTransactionId(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PatchTransactionIdMutationResult = NonNullable<Awaited<ReturnType<typeof patchTransactionId>>>
    export type PatchTransactionIdMutationBody = Transaction
    export type PatchTransactionIdMutationError = void

    /**
 * @summary Partially update a transaction record
 */
export const usePatchTransactionId = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchTransactionId>>, TError,{id: string;data: Transaction}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patchTransactionId>>,
        TError,
        {id: string;data: Transaction},
        TContext
      > => {

      const mutationOptions = getPatchTransactionIdMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Deletes a transaction record
 * @summary Delete a transaction record
 */
export const deleteTransactionId = (
    id: string,
 ) => {
      
      
      return defaultInstance<DeleteTransactionId200>(
      {url: `/transaction/${id}`, method: 'DELETE'
    },
      );
    }
  


export const getDeleteTransactionIdMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteTransactionId>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteTransactionId>>, TError,{id: string}, TContext> => {
    
const mutationKey = ['deleteTransactionId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteTransactionId>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteTransactionId(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteTransactionIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteTransactionId>>>
    
    export type DeleteTransactionIdMutationError = void

    /**
 * @summary Delete a transaction record
 */
export const useDeleteTransactionId = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteTransactionId>>, TError,{id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteTransactionId>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getDeleteTransactionIdMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Returns a list of business_mapping records with pagination
 * @summary Get all business_mapping records
 */
export const getBusinessMapping = (
    params?: GetBusinessMappingParams,
 signal?: AbortSignal
) => {
      
      
      return defaultInstance<GetBusinessMapping200>(
      {url: `/business_mapping`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getGetBusinessMappingQueryKey = (params?: GetBusinessMappingParams,) => {
    return [`/business_mapping`, ...(params ? [params]: [])] as const;
    }

    
export const getGetBusinessMappingQueryOptions = <TData = Awaited<ReturnType<typeof getBusinessMapping>>, TError = void>(params?: GetBusinessMappingParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBusinessMapping>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetBusinessMappingQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getBusinessMapping>>> = ({ signal }) => getBusinessMapping(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getBusinessMapping>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetBusinessMappingQueryResult = NonNullable<Awaited<ReturnType<typeof getBusinessMapping>>>
export type GetBusinessMappingQueryError = void


export function useGetBusinessMapping<TData = Awaited<ReturnType<typeof getBusinessMapping>>, TError = void>(
 params: undefined |  GetBusinessMappingParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBusinessMapping>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBusinessMapping>>,
          TError,
          Awaited<ReturnType<typeof getBusinessMapping>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBusinessMapping<TData = Awaited<ReturnType<typeof getBusinessMapping>>, TError = void>(
 params?: GetBusinessMappingParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBusinessMapping>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBusinessMapping>>,
          TError,
          Awaited<ReturnType<typeof getBusinessMapping>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBusinessMapping<TData = Awaited<ReturnType<typeof getBusinessMapping>>, TError = void>(
 params?: GetBusinessMappingParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBusinessMapping>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get all business_mapping records
 */

export function useGetBusinessMapping<TData = Awaited<ReturnType<typeof getBusinessMapping>>, TError = void>(
 params?: GetBusinessMappingParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBusinessMapping>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetBusinessMappingQueryOptions(params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Creates a new business_mapping record
 * @summary Create a new business_mapping record
 */
export const postBusinessMapping = (
    businessMapping: BusinessMapping,
 signal?: AbortSignal
) => {
      
      
      return defaultInstance<PostBusinessMapping200>(
      {url: `/business_mapping`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: businessMapping, signal
    },
      );
    }
  


export const getPostBusinessMappingMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postBusinessMapping>>, TError,{data: BusinessMapping}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postBusinessMapping>>, TError,{data: BusinessMapping}, TContext> => {
    
const mutationKey = ['postBusinessMapping'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postBusinessMapping>>, {data: BusinessMapping}> = (props) => {
          const {data} = props ?? {};

          return  postBusinessMapping(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostBusinessMappingMutationResult = NonNullable<Awaited<ReturnType<typeof postBusinessMapping>>>
    export type PostBusinessMappingMutationBody = BusinessMapping
    export type PostBusinessMappingMutationError = void

    /**
 * @summary Create a new business_mapping record
 */
export const usePostBusinessMapping = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postBusinessMapping>>, TError,{data: BusinessMapping}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postBusinessMapping>>,
        TError,
        {data: BusinessMapping},
        TContext
      > => {

      const mutationOptions = getPostBusinessMappingMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Returns a single business_mapping record by ID
 * @summary Get a specific business_mapping record
 */
export const getBusinessMappingId = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return defaultInstance<GetBusinessMappingId200>(
      {url: `/business_mapping/${id}`, method: 'GET', signal
    },
      );
    }
  

export const getGetBusinessMappingIdQueryKey = (id: string,) => {
    return [`/business_mapping/${id}`] as const;
    }

    
export const getGetBusinessMappingIdQueryOptions = <TData = Awaited<ReturnType<typeof getBusinessMappingId>>, TError = void>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBusinessMappingId>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetBusinessMappingIdQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getBusinessMappingId>>> = ({ signal }) => getBusinessMappingId(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getBusinessMappingId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetBusinessMappingIdQueryResult = NonNullable<Awaited<ReturnType<typeof getBusinessMappingId>>>
export type GetBusinessMappingIdQueryError = void


export function useGetBusinessMappingId<TData = Awaited<ReturnType<typeof getBusinessMappingId>>, TError = void>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBusinessMappingId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBusinessMappingId>>,
          TError,
          Awaited<ReturnType<typeof getBusinessMappingId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBusinessMappingId<TData = Awaited<ReturnType<typeof getBusinessMappingId>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBusinessMappingId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBusinessMappingId>>,
          TError,
          Awaited<ReturnType<typeof getBusinessMappingId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBusinessMappingId<TData = Awaited<ReturnType<typeof getBusinessMappingId>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBusinessMappingId>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get a specific business_mapping record
 */

export function useGetBusinessMappingId<TData = Awaited<ReturnType<typeof getBusinessMappingId>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBusinessMappingId>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetBusinessMappingIdQueryOptions(id,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Updates an existing business_mapping record
 * @summary Update a business_mapping record
 */
export const putBusinessMappingId = (
    id: string,
    businessMapping: BusinessMapping,
 ) => {
      
      
      return defaultInstance<PutBusinessMappingId200>(
      {url: `/business_mapping/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: businessMapping
    },
      );
    }
  


export const getPutBusinessMappingIdMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putBusinessMappingId>>, TError,{id: string;data: BusinessMapping}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof putBusinessMappingId>>, TError,{id: string;data: BusinessMapping}, TContext> => {
    
const mutationKey = ['putBusinessMappingId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putBusinessMappingId>>, {id: string;data: BusinessMapping}> = (props) => {
          const {id,data} = props ?? {};

          return  putBusinessMappingId(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutBusinessMappingIdMutationResult = NonNullable<Awaited<ReturnType<typeof putBusinessMappingId>>>
    export type PutBusinessMappingIdMutationBody = BusinessMapping
    export type PutBusinessMappingIdMutationError = void

    /**
 * @summary Update a business_mapping record
 */
export const usePutBusinessMappingId = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putBusinessMappingId>>, TError,{id: string;data: BusinessMapping}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putBusinessMappingId>>,
        TError,
        {id: string;data: BusinessMapping},
        TContext
      > => {

      const mutationOptions = getPutBusinessMappingIdMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Partially updates an existing business_mapping record
 * @summary Partially update a business_mapping record
 */
export const patchBusinessMappingId = (
    id: string,
    businessMapping: BusinessMapping,
 ) => {
      
      
      return defaultInstance<PatchBusinessMappingId200>(
      {url: `/business_mapping/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: businessMapping
    },
      );
    }
  


export const getPatchBusinessMappingIdMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchBusinessMappingId>>, TError,{id: string;data: BusinessMapping}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof patchBusinessMappingId>>, TError,{id: string;data: BusinessMapping}, TContext> => {
    
const mutationKey = ['patchBusinessMappingId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchBusinessMappingId>>, {id: string;data: BusinessMapping}> = (props) => {
          const {id,data} = props ?? {};

          return  patchBusinessMappingId(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PatchBusinessMappingIdMutationResult = NonNullable<Awaited<ReturnType<typeof patchBusinessMappingId>>>
    export type PatchBusinessMappingIdMutationBody = BusinessMapping
    export type PatchBusinessMappingIdMutationError = void

    /**
 * @summary Partially update a business_mapping record
 */
export const usePatchBusinessMappingId = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchBusinessMappingId>>, TError,{id: string;data: BusinessMapping}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patchBusinessMappingId>>,
        TError,
        {id: string;data: BusinessMapping},
        TContext
      > => {

      const mutationOptions = getPatchBusinessMappingIdMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Deletes a business_mapping record
 * @summary Delete a business_mapping record
 */
export const deleteBusinessMappingId = (
    id: string,
 ) => {
      
      
      return defaultInstance<DeleteBusinessMappingId200>(
      {url: `/business_mapping/${id}`, method: 'DELETE'
    },
      );
    }
  


export const getDeleteBusinessMappingIdMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteBusinessMappingId>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteBusinessMappingId>>, TError,{id: string}, TContext> => {
    
const mutationKey = ['deleteBusinessMappingId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteBusinessMappingId>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteBusinessMappingId(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteBusinessMappingIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteBusinessMappingId>>>
    
    export type DeleteBusinessMappingIdMutationError = void

    /**
 * @summary Delete a business_mapping record
 */
export const useDeleteBusinessMappingId = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteBusinessMappingId>>, TError,{id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteBusinessMappingId>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getDeleteBusinessMappingIdMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Returns a list of transactions records with pagination
 * @summary Get all transactions records
 */
export const getTransactions = (
    params?: GetTransactionsParams,
 signal?: AbortSignal
) => {
      
      
      return defaultInstance<GetTransactions200>(
      {url: `/transactions`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getGetTransactionsQueryKey = (params?: GetTransactionsParams,) => {
    return [`/transactions`, ...(params ? [params]: [])] as const;
    }

    
export const getGetTransactionsQueryOptions = <TData = Awaited<ReturnType<typeof getTransactions>>, TError = void>(params?: GetTransactionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTransactions>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTransactionsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTransactions>>> = ({ signal }) => getTransactions(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getTransactions>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetTransactionsQueryResult = NonNullable<Awaited<ReturnType<typeof getTransactions>>>
export type GetTransactionsQueryError = void


export function useGetTransactions<TData = Awaited<ReturnType<typeof getTransactions>>, TError = void>(
 params: undefined |  GetTransactionsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTransactions>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTransactions>>,
          TError,
          Awaited<ReturnType<typeof getTransactions>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTransactions<TData = Awaited<ReturnType<typeof getTransactions>>, TError = void>(
 params?: GetTransactionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTransactions>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTransactions>>,
          TError,
          Awaited<ReturnType<typeof getTransactions>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTransactions<TData = Awaited<ReturnType<typeof getTransactions>>, TError = void>(
 params?: GetTransactionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTransactions>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get all transactions records
 */

export function useGetTransactions<TData = Awaited<ReturnType<typeof getTransactions>>, TError = void>(
 params?: GetTransactionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTransactions>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetTransactionsQueryOptions(params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Creates a new transactions record
 * @summary Create a new transactions record
 */
export const postTransactions = (
    transactions: Transactions,
 signal?: AbortSignal
) => {
      
      
      return defaultInstance<PostTransactions200>(
      {url: `/transactions`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: transactions, signal
    },
      );
    }
  


export const getPostTransactionsMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postTransactions>>, TError,{data: Transactions}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postTransactions>>, TError,{data: Transactions}, TContext> => {
    
const mutationKey = ['postTransactions'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postTransactions>>, {data: Transactions}> = (props) => {
          const {data} = props ?? {};

          return  postTransactions(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostTransactionsMutationResult = NonNullable<Awaited<ReturnType<typeof postTransactions>>>
    export type PostTransactionsMutationBody = Transactions
    export type PostTransactionsMutationError = void

    /**
 * @summary Create a new transactions record
 */
export const usePostTransactions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postTransactions>>, TError,{data: Transactions}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postTransactions>>,
        TError,
        {data: Transactions},
        TContext
      > => {

      const mutationOptions = getPostTransactionsMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Returns a single transactions record by ID
 * @summary Get a specific transactions record
 */
export const getTransactionsId = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return defaultInstance<GetTransactionsId200>(
      {url: `/transactions/${id}`, method: 'GET', signal
    },
      );
    }
  

export const getGetTransactionsIdQueryKey = (id: string,) => {
    return [`/transactions/${id}`] as const;
    }

    
export const getGetTransactionsIdQueryOptions = <TData = Awaited<ReturnType<typeof getTransactionsId>>, TError = void>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTransactionsId>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTransactionsIdQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTransactionsId>>> = ({ signal }) => getTransactionsId(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getTransactionsId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetTransactionsIdQueryResult = NonNullable<Awaited<ReturnType<typeof getTransactionsId>>>
export type GetTransactionsIdQueryError = void


export function useGetTransactionsId<TData = Awaited<ReturnType<typeof getTransactionsId>>, TError = void>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTransactionsId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTransactionsId>>,
          TError,
          Awaited<ReturnType<typeof getTransactionsId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTransactionsId<TData = Awaited<ReturnType<typeof getTransactionsId>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTransactionsId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTransactionsId>>,
          TError,
          Awaited<ReturnType<typeof getTransactionsId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTransactionsId<TData = Awaited<ReturnType<typeof getTransactionsId>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTransactionsId>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get a specific transactions record
 */

export function useGetTransactionsId<TData = Awaited<ReturnType<typeof getTransactionsId>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTransactionsId>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetTransactionsIdQueryOptions(id,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Updates an existing transactions record
 * @summary Update a transactions record
 */
export const putTransactionsId = (
    id: string,
    transactions: Transactions,
 ) => {
      
      
      return defaultInstance<PutTransactionsId200>(
      {url: `/transactions/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: transactions
    },
      );
    }
  


export const getPutTransactionsIdMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putTransactionsId>>, TError,{id: string;data: Transactions}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof putTransactionsId>>, TError,{id: string;data: Transactions}, TContext> => {
    
const mutationKey = ['putTransactionsId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putTransactionsId>>, {id: string;data: Transactions}> = (props) => {
          const {id,data} = props ?? {};

          return  putTransactionsId(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutTransactionsIdMutationResult = NonNullable<Awaited<ReturnType<typeof putTransactionsId>>>
    export type PutTransactionsIdMutationBody = Transactions
    export type PutTransactionsIdMutationError = void

    /**
 * @summary Update a transactions record
 */
export const usePutTransactionsId = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putTransactionsId>>, TError,{id: string;data: Transactions}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putTransactionsId>>,
        TError,
        {id: string;data: Transactions},
        TContext
      > => {

      const mutationOptions = getPutTransactionsIdMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Partially updates an existing transactions record
 * @summary Partially update a transactions record
 */
export const patchTransactionsId = (
    id: string,
    transactions: Transactions,
 ) => {
      
      
      return defaultInstance<PatchTransactionsId200>(
      {url: `/transactions/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: transactions
    },
      );
    }
  


export const getPatchTransactionsIdMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchTransactionsId>>, TError,{id: string;data: Transactions}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof patchTransactionsId>>, TError,{id: string;data: Transactions}, TContext> => {
    
const mutationKey = ['patchTransactionsId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchTransactionsId>>, {id: string;data: Transactions}> = (props) => {
          const {id,data} = props ?? {};

          return  patchTransactionsId(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PatchTransactionsIdMutationResult = NonNullable<Awaited<ReturnType<typeof patchTransactionsId>>>
    export type PatchTransactionsIdMutationBody = Transactions
    export type PatchTransactionsIdMutationError = void

    /**
 * @summary Partially update a transactions record
 */
export const usePatchTransactionsId = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchTransactionsId>>, TError,{id: string;data: Transactions}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patchTransactionsId>>,
        TError,
        {id: string;data: Transactions},
        TContext
      > => {

      const mutationOptions = getPatchTransactionsIdMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Deletes a transactions record
 * @summary Delete a transactions record
 */
export const deleteTransactionsId = (
    id: string,
 ) => {
      
      
      return defaultInstance<DeleteTransactionsId200>(
      {url: `/transactions/${id}`, method: 'DELETE'
    },
      );
    }
  


export const getDeleteTransactionsIdMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteTransactionsId>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteTransactionsId>>, TError,{id: string}, TContext> => {
    
const mutationKey = ['deleteTransactionsId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteTransactionsId>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteTransactionsId(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteTransactionsIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteTransactionsId>>>
    
    export type DeleteTransactionsIdMutationError = void

    /**
 * @summary Delete a transactions record
 */
export const useDeleteTransactionsId = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteTransactionsId>>, TError,{id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteTransactionsId>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getDeleteTransactionsIdMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Returns a list of booking_status records with pagination
 * @summary Get all booking_status records
 */
export const getBookingStatus = (
    params?: GetBookingStatusParams,
 signal?: AbortSignal
) => {
      
      
      return defaultInstance<GetBookingStatus200>(
      {url: `/booking_status`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getGetBookingStatusQueryKey = (params?: GetBookingStatusParams,) => {
    return [`/booking_status`, ...(params ? [params]: [])] as const;
    }

    
export const getGetBookingStatusQueryOptions = <TData = Awaited<ReturnType<typeof getBookingStatus>>, TError = void>(params?: GetBookingStatusParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBookingStatus>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetBookingStatusQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getBookingStatus>>> = ({ signal }) => getBookingStatus(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getBookingStatus>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetBookingStatusQueryResult = NonNullable<Awaited<ReturnType<typeof getBookingStatus>>>
export type GetBookingStatusQueryError = void


export function useGetBookingStatus<TData = Awaited<ReturnType<typeof getBookingStatus>>, TError = void>(
 params: undefined |  GetBookingStatusParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBookingStatus>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBookingStatus>>,
          TError,
          Awaited<ReturnType<typeof getBookingStatus>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBookingStatus<TData = Awaited<ReturnType<typeof getBookingStatus>>, TError = void>(
 params?: GetBookingStatusParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBookingStatus>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBookingStatus>>,
          TError,
          Awaited<ReturnType<typeof getBookingStatus>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBookingStatus<TData = Awaited<ReturnType<typeof getBookingStatus>>, TError = void>(
 params?: GetBookingStatusParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBookingStatus>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get all booking_status records
 */

export function useGetBookingStatus<TData = Awaited<ReturnType<typeof getBookingStatus>>, TError = void>(
 params?: GetBookingStatusParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBookingStatus>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetBookingStatusQueryOptions(params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Creates a new booking_status record
 * @summary Create a new booking_status record
 */
export const postBookingStatus = (
    bookingStatus: BookingStatus,
 signal?: AbortSignal
) => {
      
      
      return defaultInstance<PostBookingStatus200>(
      {url: `/booking_status`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: bookingStatus, signal
    },
      );
    }
  


export const getPostBookingStatusMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postBookingStatus>>, TError,{data: BookingStatus}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postBookingStatus>>, TError,{data: BookingStatus}, TContext> => {
    
const mutationKey = ['postBookingStatus'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postBookingStatus>>, {data: BookingStatus}> = (props) => {
          const {data} = props ?? {};

          return  postBookingStatus(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostBookingStatusMutationResult = NonNullable<Awaited<ReturnType<typeof postBookingStatus>>>
    export type PostBookingStatusMutationBody = BookingStatus
    export type PostBookingStatusMutationError = void

    /**
 * @summary Create a new booking_status record
 */
export const usePostBookingStatus = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postBookingStatus>>, TError,{data: BookingStatus}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postBookingStatus>>,
        TError,
        {data: BookingStatus},
        TContext
      > => {

      const mutationOptions = getPostBookingStatusMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Returns a single booking_status record by ID
 * @summary Get a specific booking_status record
 */
export const getBookingStatusId = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return defaultInstance<GetBookingStatusId200>(
      {url: `/booking_status/${id}`, method: 'GET', signal
    },
      );
    }
  

export const getGetBookingStatusIdQueryKey = (id: string,) => {
    return [`/booking_status/${id}`] as const;
    }

    
export const getGetBookingStatusIdQueryOptions = <TData = Awaited<ReturnType<typeof getBookingStatusId>>, TError = void>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBookingStatusId>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetBookingStatusIdQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getBookingStatusId>>> = ({ signal }) => getBookingStatusId(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getBookingStatusId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetBookingStatusIdQueryResult = NonNullable<Awaited<ReturnType<typeof getBookingStatusId>>>
export type GetBookingStatusIdQueryError = void


export function useGetBookingStatusId<TData = Awaited<ReturnType<typeof getBookingStatusId>>, TError = void>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBookingStatusId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBookingStatusId>>,
          TError,
          Awaited<ReturnType<typeof getBookingStatusId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBookingStatusId<TData = Awaited<ReturnType<typeof getBookingStatusId>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBookingStatusId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBookingStatusId>>,
          TError,
          Awaited<ReturnType<typeof getBookingStatusId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBookingStatusId<TData = Awaited<ReturnType<typeof getBookingStatusId>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBookingStatusId>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get a specific booking_status record
 */

export function useGetBookingStatusId<TData = Awaited<ReturnType<typeof getBookingStatusId>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBookingStatusId>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetBookingStatusIdQueryOptions(id,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Updates an existing booking_status record
 * @summary Update a booking_status record
 */
export const putBookingStatusId = (
    id: string,
    bookingStatus: BookingStatus,
 ) => {
      
      
      return defaultInstance<PutBookingStatusId200>(
      {url: `/booking_status/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: bookingStatus
    },
      );
    }
  


export const getPutBookingStatusIdMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putBookingStatusId>>, TError,{id: string;data: BookingStatus}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof putBookingStatusId>>, TError,{id: string;data: BookingStatus}, TContext> => {
    
const mutationKey = ['putBookingStatusId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putBookingStatusId>>, {id: string;data: BookingStatus}> = (props) => {
          const {id,data} = props ?? {};

          return  putBookingStatusId(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutBookingStatusIdMutationResult = NonNullable<Awaited<ReturnType<typeof putBookingStatusId>>>
    export type PutBookingStatusIdMutationBody = BookingStatus
    export type PutBookingStatusIdMutationError = void

    /**
 * @summary Update a booking_status record
 */
export const usePutBookingStatusId = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putBookingStatusId>>, TError,{id: string;data: BookingStatus}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putBookingStatusId>>,
        TError,
        {id: string;data: BookingStatus},
        TContext
      > => {

      const mutationOptions = getPutBookingStatusIdMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Partially updates an existing booking_status record
 * @summary Partially update a booking_status record
 */
export const patchBookingStatusId = (
    id: string,
    bookingStatus: BookingStatus,
 ) => {
      
      
      return defaultInstance<PatchBookingStatusId200>(
      {url: `/booking_status/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: bookingStatus
    },
      );
    }
  


export const getPatchBookingStatusIdMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchBookingStatusId>>, TError,{id: string;data: BookingStatus}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof patchBookingStatusId>>, TError,{id: string;data: BookingStatus}, TContext> => {
    
const mutationKey = ['patchBookingStatusId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchBookingStatusId>>, {id: string;data: BookingStatus}> = (props) => {
          const {id,data} = props ?? {};

          return  patchBookingStatusId(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PatchBookingStatusIdMutationResult = NonNullable<Awaited<ReturnType<typeof patchBookingStatusId>>>
    export type PatchBookingStatusIdMutationBody = BookingStatus
    export type PatchBookingStatusIdMutationError = void

    /**
 * @summary Partially update a booking_status record
 */
export const usePatchBookingStatusId = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchBookingStatusId>>, TError,{id: string;data: BookingStatus}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patchBookingStatusId>>,
        TError,
        {id: string;data: BookingStatus},
        TContext
      > => {

      const mutationOptions = getPatchBookingStatusIdMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Deletes a booking_status record
 * @summary Delete a booking_status record
 */
export const deleteBookingStatusId = (
    id: string,
 ) => {
      
      
      return defaultInstance<DeleteBookingStatusId200>(
      {url: `/booking_status/${id}`, method: 'DELETE'
    },
      );
    }
  


export const getDeleteBookingStatusIdMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteBookingStatusId>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteBookingStatusId>>, TError,{id: string}, TContext> => {
    
const mutationKey = ['deleteBookingStatusId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteBookingStatusId>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteBookingStatusId(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteBookingStatusIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteBookingStatusId>>>
    
    export type DeleteBookingStatusIdMutationError = void

    /**
 * @summary Delete a booking_status record
 */
export const useDeleteBookingStatusId = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteBookingStatusId>>, TError,{id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteBookingStatusId>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getDeleteBookingStatusIdMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Returns a list of booking records with pagination
 * @summary Get all booking records
 */
export const getBooking = (
    params?: GetBookingParams,
 signal?: AbortSignal
) => {
      
      
      return defaultInstance<GetBooking200>(
      {url: `/booking`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getGetBookingQueryKey = (params?: GetBookingParams,) => {
    return [`/booking`, ...(params ? [params]: [])] as const;
    }

    
export const getGetBookingQueryOptions = <TData = Awaited<ReturnType<typeof getBooking>>, TError = void>(params?: GetBookingParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBooking>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetBookingQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getBooking>>> = ({ signal }) => getBooking(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getBooking>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetBookingQueryResult = NonNullable<Awaited<ReturnType<typeof getBooking>>>
export type GetBookingQueryError = void


export function useGetBooking<TData = Awaited<ReturnType<typeof getBooking>>, TError = void>(
 params: undefined |  GetBookingParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBooking>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBooking>>,
          TError,
          Awaited<ReturnType<typeof getBooking>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBooking<TData = Awaited<ReturnType<typeof getBooking>>, TError = void>(
 params?: GetBookingParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBooking>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBooking>>,
          TError,
          Awaited<ReturnType<typeof getBooking>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBooking<TData = Awaited<ReturnType<typeof getBooking>>, TError = void>(
 params?: GetBookingParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBooking>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get all booking records
 */

export function useGetBooking<TData = Awaited<ReturnType<typeof getBooking>>, TError = void>(
 params?: GetBookingParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBooking>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetBookingQueryOptions(params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Creates a new booking record
 * @summary Create a new booking record
 */
export const postBooking = (
    booking: Booking,
 signal?: AbortSignal
) => {
      
      
      return defaultInstance<PostBooking200>(
      {url: `/booking`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: booking, signal
    },
      );
    }
  


export const getPostBookingMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postBooking>>, TError,{data: Booking}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postBooking>>, TError,{data: Booking}, TContext> => {
    
const mutationKey = ['postBooking'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postBooking>>, {data: Booking}> = (props) => {
          const {data} = props ?? {};

          return  postBooking(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostBookingMutationResult = NonNullable<Awaited<ReturnType<typeof postBooking>>>
    export type PostBookingMutationBody = Booking
    export type PostBookingMutationError = void

    /**
 * @summary Create a new booking record
 */
export const usePostBooking = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postBooking>>, TError,{data: Booking}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postBooking>>,
        TError,
        {data: Booking},
        TContext
      > => {

      const mutationOptions = getPostBookingMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Returns a single booking record by ID
 * @summary Get a specific booking record
 */
export const getBookingId = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return defaultInstance<GetBookingId200>(
      {url: `/booking/${id}`, method: 'GET', signal
    },
      );
    }
  

export const getGetBookingIdQueryKey = (id: string,) => {
    return [`/booking/${id}`] as const;
    }

    
export const getGetBookingIdQueryOptions = <TData = Awaited<ReturnType<typeof getBookingId>>, TError = void>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBookingId>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetBookingIdQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getBookingId>>> = ({ signal }) => getBookingId(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getBookingId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetBookingIdQueryResult = NonNullable<Awaited<ReturnType<typeof getBookingId>>>
export type GetBookingIdQueryError = void


export function useGetBookingId<TData = Awaited<ReturnType<typeof getBookingId>>, TError = void>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBookingId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBookingId>>,
          TError,
          Awaited<ReturnType<typeof getBookingId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBookingId<TData = Awaited<ReturnType<typeof getBookingId>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBookingId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBookingId>>,
          TError,
          Awaited<ReturnType<typeof getBookingId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBookingId<TData = Awaited<ReturnType<typeof getBookingId>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBookingId>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get a specific booking record
 */

export function useGetBookingId<TData = Awaited<ReturnType<typeof getBookingId>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBookingId>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetBookingIdQueryOptions(id,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Updates an existing booking record
 * @summary Update a booking record
 */
export const putBookingId = (
    id: string,
    booking: Booking,
 ) => {
      
      
      return defaultInstance<PutBookingId200>(
      {url: `/booking/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: booking
    },
      );
    }
  


export const getPutBookingIdMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putBookingId>>, TError,{id: string;data: Booking}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof putBookingId>>, TError,{id: string;data: Booking}, TContext> => {
    
const mutationKey = ['putBookingId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putBookingId>>, {id: string;data: Booking}> = (props) => {
          const {id,data} = props ?? {};

          return  putBookingId(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutBookingIdMutationResult = NonNullable<Awaited<ReturnType<typeof putBookingId>>>
    export type PutBookingIdMutationBody = Booking
    export type PutBookingIdMutationError = void

    /**
 * @summary Update a booking record
 */
export const usePutBookingId = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putBookingId>>, TError,{id: string;data: Booking}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putBookingId>>,
        TError,
        {id: string;data: Booking},
        TContext
      > => {

      const mutationOptions = getPutBookingIdMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Partially updates an existing booking record
 * @summary Partially update a booking record
 */
export const patchBookingId = (
    id: string,
    booking: Booking,
 ) => {
      
      
      return defaultInstance<PatchBookingId200>(
      {url: `/booking/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: booking
    },
      );
    }
  


export const getPatchBookingIdMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchBookingId>>, TError,{id: string;data: Booking}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof patchBookingId>>, TError,{id: string;data: Booking}, TContext> => {
    
const mutationKey = ['patchBookingId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchBookingId>>, {id: string;data: Booking}> = (props) => {
          const {id,data} = props ?? {};

          return  patchBookingId(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PatchBookingIdMutationResult = NonNullable<Awaited<ReturnType<typeof patchBookingId>>>
    export type PatchBookingIdMutationBody = Booking
    export type PatchBookingIdMutationError = void

    /**
 * @summary Partially update a booking record
 */
export const usePatchBookingId = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchBookingId>>, TError,{id: string;data: Booking}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patchBookingId>>,
        TError,
        {id: string;data: Booking},
        TContext
      > => {

      const mutationOptions = getPatchBookingIdMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Deletes a booking record
 * @summary Delete a booking record
 */
export const deleteBookingId = (
    id: string,
 ) => {
      
      
      return defaultInstance<DeleteBookingId200>(
      {url: `/booking/${id}`, method: 'DELETE'
    },
      );
    }
  


export const getDeleteBookingIdMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteBookingId>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteBookingId>>, TError,{id: string}, TContext> => {
    
const mutationKey = ['deleteBookingId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteBookingId>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteBookingId(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteBookingIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteBookingId>>>
    
    export type DeleteBookingIdMutationError = void

    /**
 * @summary Delete a booking record
 */
export const useDeleteBookingId = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteBookingId>>, TError,{id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteBookingId>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getDeleteBookingIdMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
